/* MEP / TZB -- assets/configurator-mep.js -- window.MepLib

     THE SERVICES OF THE HOUSE LINE, IN ONE FILE. Electrics, and to come
     heating, cold and hot water and waste, for every product built on
     configurator-house.liquid -- the ADU first, then RANCH and the other forks.
     A product does not carry its own copy any more: it registers its layer as
     before (role 'tzb') and hands this file what it knows.

     WHAT IT IS FOR (Marek, 2026-10-08)
       CALCULATION FIRST. Quantities from rules on what the configurator
       already knows -- the rooms and their names, the fitouts, floor areas,
       perimeters, door positions, storeys -- billed into the BoQ with
       catalogue codes, runs as a distance to the board / manifold / stack
       times a factor. The price must be complete from the start; drawn routes
       come later. Drawn early only where it is simple: underfloor loops and
       the manifold, split heads and the outdoor unit as bodies.

     mep-v1: THE ELECTRICS MOVED HERE WORD FOR WORD from
     configurator-adu-lib.js adu-v1419 (layer adu-elec). The rules, the codes,
     the geometry and every log line are the same text; the only change is
     that the layer id is the product's (LID) instead of the literal
     'adu-elec'. The BoQ is to stay byte-identical (Marek's migration rule).

     THE CONTRACT
       MepLib.elec(env, ctx)   called from the product layer's build3d.
         ctx                   the core's build context, as the layer gets it
         env.layerId           the product's layer id: the bill and the review
                               colour are keyed on it ('adu-elec')
         env.<name>            the product's own objects and helpers under the
                               names they have in the ADU and every fork of it
                               -- NEED below lists them. They are read on every
                               call, so the product builds env fresh each time.
       A name missing from env is a SKIPPED line in the log and nothing billed,
       never a throw and never a quantity in somebody else's row.

     mep-v2: THE HEATING, a multi-split by calculation (MepLib.heat), and the
     electrics leave their board position for it (LAST). Nothing new is drawn.
     mep-v3: the heads are billed as VMI00001, the catalogue's wall split unit
     (the container's head); HM400001 is an air-to-water hydro unit. One
     outdoor unit HM400002 (7 kW, 3 zones) per three heads.
     mep-v4: the rows the trade still lacked are in the catalogue (Marek,
     2026-10-08: dodelat polozky, umistit na spravne misto) -- HMR00002
     electric towel rail (HEATING / EQUIPMENT, after HMR00001) and HMD00751
     line set cover (HEATING / PIPE ACCESSORIES, after HMC00101) -- and are
     billed, with the fixings of every piece from rows already there; the
     line insulation is HMP00202, closed-cell elastomeric (his pick).
     mep-v5: THE BODIES -- heads, outdoor unit(s) with bracket pair and
     isolator, towel rail -- drawn where the calculation puts them, natural
     colours, viz 'heat'; line sets stay calculated. Head 900 x 300 x 215 (the
     VMI00001 row), outdoor unit 870 x 700 x 330 (a 3-zone 24000 BTU unit).
     mep-v6: COLD AND HOT WATER by calculation (MepLib.water): every wet
     piece of the fitout gets its cold and hot, an electric storage heater
     (HMH02501, 200 l, his pick) in the laundry / the closet nearest the
     bathroom / the bathroom, fed from the board; runs Manhattan x 1.2 plus
     the rises. The rows the trade lacked are in the catalogue: SMB00121
     angle stop, SMN00501 seismic strap kit, SMC00151 pipe clip, EEE00003
     10 AWG cable, EEC00011 30 A breaker. Nothing new is drawn.
     mep-v7: WASTE by calculation (MepLib.waste): a trap and a branch for
     every wet piece, a building drain 110 out through the wall nearest the
     wet points, a vent stack 75 through the roof at its far end, an air
     admittance valve on every other wet room, hangers, primer and cement.
     Ten rows the trade lacked are in the catalogue (P-traps 1 1/2 and 2,
     shower drain, air admittance valve, roof flashing, hanger strap, toilet
     flange set, cleanout, PVC primer, PVC cement). Nothing new is drawn.
     mep-v8: the split heads' CONDENSATE is billed: a drain hose with each
     line set (new row HMC00161), straight down the facade outside; a pump
     HMC00101 at a head with no exterior wall; clips and screws.
     mep-v9: THE WATER AND WASTE BODIES in the services view (viz 'water' /
     'waste'): the heater in a corner of its room clear of the fitout (the
     calculation now places it there too) with its expansion tank, the
     entry stub with its two valves, the vent stack in its room's wall (its
     roof height now read there) with the flashing collar, the air
     admittance valves under the sinks. Runs stay calculated.
     mep-v10: the shed, the sauna and the THOW on the shared electrics. The
     shed's own rules are a VARIANT here (env.elecVariant 'surface', ELEC_SURF):
     the surface-mounted range, a junction box on every branch, one 16 A and
     one 10 A breaker for the building. The sauna and the THOW take the line's
     rules with the ADU's fixes (closets, room lines, doors with no room
     beside them, the door in from where people come). A product without
     slanted walls hands over _slantRaw [] and _wedgeRoomAt -1.
     mep-v11: the shed, the sauna and the THOW get the heating, the water and
     the waste WHERE THE PLAN HAS A BATHROOM (Marek, 2026-10-09: "tam kde je
     koupelna room by mely dostat toto vsechno") -- env.onlyWithBath; a
     bathroom is a room keyed bathroom, shower or WC. With it: a shower room
     gets its towel rail like a bathroom; a sauna hot room, a porch, a
     terrace or a technical room never stands in for the living room's head;
     env.outdoorEnds keeps the outdoor unit off the long walls (the THOW's
     road width).
     mep-v12: A SAUNA HOT ROOM IN THE ELECTRICS (env.hotRoom, the sauna):
     no socket, no ceiling light and no switch in it -- the heater set
     brings its own IP65 light EEW00002, switched at the heater's control
     unit -- and the heater on a circuit of its own: the control unit
     FMC00037 drawn outside the hot room's door at 1500, its feed EEE00003
     (10 AWG) from the board by the lamps' route, one EEC00011 30 A double
     pole breaker. Both rows are minted into env.CATALOG when it is given.
     mep-v13: THE THOW ON THE ROAD. env.stackUnderRidge: the vent stack's top
     (300 above the roof) may not rise over the roof's ridge, so it never
     adds to the road height -- of its room's walls the nearest one where it
     clears is taken, else the one with the lowest roof and the stack cut
     at the ridge (logged ***). env.heaterSmall: the 57 l / 15 gal under
     counter heater HMH01501 (the catalogue's row for a kitchen sink and one
     bathroom) on a 16 A circuit (EEE00001 3 x 2.5 / 14 AWG, EEC00003)
     instead of the 200 l one on 30 A.
     mep-v14: THE PERIMETER AS THE WALLS RUN (Marek 2026-10-09, krok 5, the L
     of RANCH and the T house): every trade read the bounding RECTANGLE,
     inset by a wall, as its four exterior faces -- on an L the porch corner
     counted as wall. The faces now come from the outline (API.poly), inset
     by the wall: as many sides as it has, in the same turning order, each
     corner convex or reflex. A rectangle keeps its exact four sides, so
     every rectangular plan comes out unchanged.
     mep-v15: UNDERFLOOR HEATING (MepLib.ufh, the T house first): loops of
     PE-Xa 16 at 150 in every heated room of the ground floor, drawn as
     meanders in the screed, leads to the manifold, foil and clips, the
     manifold(s) with valves, air vent and dew point sensor, an actuator a
     loop and a thermostat a room. The heat pump comes next.
     mep-v16: THE PLANT AND THE FAN COILS (MepLib.hydro = ufh + plant): a
     monobloc air to water heat pump sized by the heated area at 40 W a m2,
     on wall brackets outside the wall nearest the plant room (walked clear
     of doors, low windows, an inside corner and the terrace), its short
     outdoor run in the pre insulated twin pipe; in the plant room the hot
     water tank with its coil (250 l), the 50 l buffer, the diverting and
     mixing valves, the magnetic filter, ball valves, the 18 l expansion
     vessel and the 3 bar safety group; insulated 32 pipe to the manifold; its
     16 A feed from the board; a floor fan coil on every gallery of 10 m2
     or more with its insulated 20 pipes, siphon, condensate and thermostat.
     mep-v17: THE WATER OF A HOUSE WITH A HEAT PUMP AND STOREYS (the T
     house, step T4). env.dhwFrom names the heating layer whose plant hands
     over its hot water tank (MepLib.hydro leaves it in LAST): the hot comes
     from that tank -- no electric heater, no heater feed; the tank's T&P
     valve, its expansion tank, the straps and the two hoses stay with the
     water. env.storeyY(st) gives a storey's finished floor: a wet piece on
     an upper storey is no longer left out, its room's group is fed by a
     riser (cold, and hot where it takes hot) from the ground floor's trunk.
     env.wallThrough(), where given, is the way out through the wall for the
     T&P discharge. Without these three nothing changes.
     mep-v18: THE WASTE OF A HOUSE WITH STOREYS (the T house, step T5).
     env.storeyY(st): a wet piece on an upper storey is no longer left out;
     its room's pieces drain in that storey's floor to a drop -- 110 when
     the room has a WC, else 50 -- down to the ground floor's drain, a bend
     at its foot; the room is on the drain like any other (a WC room is a
     head, the others join by a collector) and is vented by an air
     admittance valve on its storey unless the stack rises there (the stack
     then is its drop). Without env.storeyY nothing changes.
     mep-v19: THE ELECTRICS OF AN UPPER STOREY (the T house's storey 2).
     env.riserFrom names the electrics layer whose board feeds this storey:
     no board here, no RCD, no grounding set -- every circuit (a socket
     circuit and a lighting circuit a room, as below) is its own cable from
     that board up the exterior wall to this floor (the riser, billed a
     circuit and drawn once), its breaker in that board. env.floorY() is
     the storey's finished floor. env.ceilAt(x, z), where given, is the
     ceiling over a lamp (a roof slope): the lamp hangs there, its cable
     rises to it from the wall top. env.switchNear() gives the point a room
     with no door and no room line takes its switch nearest to (a gallery:
     the stair opening) -- on its exterior wall beside its socket nearest
     that point. Without env.riserFrom nothing changes.
     mep-v20 (Marek 2026-10-09, the T house): env.extraSockets() -- points
     that need a socket of their own (a fan coil on a gallery): each one on
     the exterior wall nearest it, on the circuit of the room it faces,
     billed with the others. env.stackOuter (a house of two storeys): the
     vent stack goes into an EXTERIOR wall of its room -- a partition below
     may have no wall over it upstairs, the outer wall runs to the roof --
     or, with no exterior wall in its room, into the exterior wall nearest
     it, the drain carried on to it. Without these nothing changes.
     mep-v21 (Marek 2026-10-09 "Ano, muze"): A ROOM'S SOCKET RUN HOLDS ALL
     ITS SOCKETS, on every storey of every product. The run went the
     shorter way between the room's two end sockets (sorted from the
     board); a room the board stands in -- the entrance room -- or one round
     more than half the house had that shorter way cross the board's gap
     and leave its other sockets off the cable. Now the run is the
     perimeter less the widest gap between two of the room's sockets, fed
     at whichever end of it is nearer the board.
     mep-v22 (the barndo's loft, barndo-v20): env.ceilLowAt(x, z) -- a
     LOWER ceiling over a point (a room under a loft: its ceiling 8 ft up
     while the walls run on to 16 ft). A lamp there hangs at that ceiling
     and its run -- up from the board, along the walls, across to it, and
     the switch's drop -- goes at that height; a split head there sits
     under that ceiling and its line set drops from there. Accepted only
     under the wall top and 1.8 m over the floor. Without it nothing
     changes.
     mep-v23 (the barndo's loft, barndo-v21): THE HEATING OF AN UPPER
     STOREY ON THE SAME UNIT. env.roomsUp() -- the rooms of storey 2 -- with
     env.storeyY(1), its finished floor: a bedroom up there gets a head and
     a bathroom a towel rail like the ground floor's, on the same outdoor
     unit (one more unit past three heads, as before); a head's stretch is
     kept clear only of the openings of that storey (their top over its
     floor), it hangs under the ceiling over that storey (the wall top, not
     env.ceilLowAt), a rail stands 600 over that floor. Rooms named by the
     product's _roomLabel. Without env.roomsUp nothing changes.
     mep-v24 (the barndo's slab, barndo-v22): UNDER A SLAB ON GRADE.
     env.underSlab() -> { ySub (the subgrade under the gravel base), yGrade,
     dig, bed, trapBox (the product's codes) }. WASTE: the drain, the
     branches and the collectors lie in trenches under the slab -- the
     drain 110 at 1/8 in./ft, the 50s at 1/4 in./ft (IRC P3005.3), the
     drain's high end with its crown at the subgrade, a trench 300 wide
     with 100 of pea gravel under the pipe, bedded and filled with it to
     the subgrade (dig and bed billed by volume); every pipe through the
     slab a stub-up, a floor drain (tub, shower) in a trap blockout box;
     no hangers under the slab, only on the pipe above it; the cleanout
     outside on a riser to grade. WATER: no joint under the slab -- one
     continuous run of 20 from the entry to each wet room's wall and to the
     heater, one from the heater to each room with hot, laid on the
     subgrade, bent not jointed; the tees above the slab (a header at the
     entry and at the heater, the rest in the room's wall); a cold run
     through the slab in a 300 foam sleeve at each end (the hot is lagged
     all the way); clips only above the slab. Both drawn under the slab
     (names '*-slab-*'). Without env.underSlab nothing changes.
     mep-v33 (RANCH thread, ranch-v54): THE WAY OUT THROUGH THE FOOTING.
     env.underSlab() may carry edge: { w } -- the width of the footing at
     the slab's edge the runs cross on their way out (a slab's thickened
     edge, a block house's stem). The drain leaves through it in a sleeve
     two pipe sizes over it (IRC P2603.4: a 4 in. drain in a 6 in. sleeve,
     the pending row mep.sleeve160; edge.drain overrides), the water
     service in a PVC 110 sleeve SMR01102 (edge.service overrides), each
     the footing's width + 50 past each face, the annulus sealed. Without
     edge nothing changes. The board drawn under env.nec is marked with the
     panel billed (EED00002), not EED00001. And env.sillBase(): how far the finished floor
     stands over the base an opening's sill is measured from (a masonry wall
     on the slab, its doors at +150) -- the electrics' entrance, the heating
     and the plant read the sill over the floor. Without it nothing changes.
     mep-v34 (RANCH thread, ranch-v56; Marek 2026-10-13: dalsi krok -- the
     line sets drawn): env.lineSets on MepLib.heat. Every head's line set is
     DRAWN where the calculation runs it -- down the stud bay in its sleeve
     behind the head, out through the wall at the unit's top, along the
     facade in its cover round the corners to the unit, and its condensate
     straight down the facade -- and the cover HOPS OVER every door or
     window it would cross on its way (up to the opening's head + 100, over
     and down again: the length and 4 elbows a line each, in the bill; it
     ran through the doorways). With it env.wallThrough, when given, is the
     wall's real thickness (frame + facade) for the heating too. Without
     env.lineSets nothing changes.
     mep-v35 (RANCH thread, ranch-v57): with env.lineSets a head past the
     first unit's three runs to its own unit (the second, beside the first)
     -- measured and drawn; and a head with no exterior wall has its line set
     drawn from where it hangs on its interior wall, up through the ceiling,
     across the attic to the nearest exterior wall, down its bay and on as
     the others (its condensate pumped along it).
     mep-v25 (the barndo, barndo-v25; Marek 2026-10-11: do posledniho
     sroubku): THE US CODE ON TOP OF THE ELECTRICS, env.nec. The line's
     rules (a socket circuit and a lighting circuit a room, sockets on the
     exterior walls) stay as they are; with env.nec the same layer adds what
     the NEC / IRC ask for: receptacles on the interior walls (6 ft rule),
     a hallway's, the kitchen counters' on two small-appliance circuits, an
     island's pop-up towers, the refrigerator, dishwasher, microwave / hood
     and cooktop circuits, a receptacle by every basin, the washer's and the
     dryer's (30 A 240 V) circuits, the garage door openers' receptacles,
     weatherproof GFCI receptacles and lights by the people doors, smoke
     alarms (bedrooms, outside the sleeping areas, a storey) hardwired and
     interconnected, smoke + CO where env.attachedGarage / env.fuel; the
     breakers by what they feed (AFCI, dual function, GFCI, 15 A lighting)
     instead of the line's count, no whole-house RCD, a surge protector, the
     main breaker and the meter socket. Devices drawn, the new runs
     calculated. Rows the sheet lacks are billed as mep.* pending (minted
     into env.CATALOG). env.wallThrough, where given, is the way through
     the wall for the outdoor devices. Without env.nec nothing changes.
     mep-v26 (the barndo, barndo-v26): VENTILATION, MepLib.vent(env, ctx) --
     called by a product after MepLib.heat with the same env (its rows join
     the heating's layer, nothing is reset): an exhaust fan in every
     bathroom ducted outside (roof cap, or a wall hood under a lower ceiling),
     the kitchen hood's 6 in. duct, the dryer's 4 in. rigid vent with its
     developed length checked, whole-house exhaust-only ventilation at the
     IRC table's rate through the largest bathroom's fan on a control.
     env._roofPlaneYAt, env.wallThrough, env.frostDepth, env.ceilLowAt,
     env.roomsUp + env.storeyY are read where given. A product that does not
     call it gets nothing new. And env.hoseBibs on the water: two frost-free
     sillcocks (beside the entry and on the opposite wall) on 16 from the
     entry's header, lagged, a stop inside each.
     mep-v27 (the barndo, barndo-v27), all opt-in: env.lightGrid(room, i,
     box) lights a room in a grid under the product's code (the shop: an LED
     shop light every 100 sq ft, chained); under env.nec the board is billed
     once its spaces are counted -- the 40-space 200 A main-breaker panel
     EED00002 (mep-v29: always, in place of EED00001); env.hrvCold: a balanced heat recovery
     ventilator (VMM00001, its hoods, ducts, diffusers and extract valves)
     in place of exhaust-only where the frost goes V.coldFrost deep;
     env.outdoorPad: the multi-split's outdoor unit on the ground 12 in. off
     the wall, on a cast pad 3 in. over grade on stone, on riser feet (a snow
     stand in a cold climate), anchored and bolted -- no wall bracket.

     LOADING. configurator-house.liquid loads this file. A lib that builds
     before it has arrived bills no electrics, says so, and pushes a rebuild
     into window.__mepWait; this file runs those callbacks once it is here.

     mep-v29 (2026-10-12, the catalogue rows made): every mep.* alias of
     mep-v25..v27 is its sheet code -- AFCI EEC00012, AFCI/GFCI EEC00013,
     40 A 2 pole EEC00014, NM-B 8/3 10/3 14/3 EEE00004-06, SER EEE00007,
     the island's conduit EET00002 with 3 x EEE00008 THWN 12, dryer
     receptacle EES00006, smoke + CO EES00007, outdoor light EEW00003, meter
     socket EEM00001, panel EED00002 (the main breaker alias gone), bath fan
     VMM00003, its control VMM00004, dryer transition duct VMF01001, the
     caps by the duct's size (wall VMG01001 4 in. / VMG01601 6 in., roof
     VMG01002 / VMG01602 on a pipe flashing VMG01003), sillcock SMB00122,
     riser feet HMW00002, the snow stand HMW00003 at its stock 18 in.

     mep-v31 (RANCH thread, Marek 2026-10-12: rohoze urcite pridame): opt-in
     env.floorMats on the heating -- an electric floor-warming mat under the
     tile of every bathroom, a programmable thermostat with its floor sensor
     and its own GFCI (NEC 424.44), fed off the bathroom circuit; the primer
     and a 1/4 in. self-leveling pour over it. The mat and the thermostat
     have no sheet row yet: billed as mep.floorMat / mep.floorStat pending.

     mep-v32 (2026-10-12, THOW thread): THE TRAILER'S HOOKUPS, env.trailer
     (opt-in; without it nothing changes). env.trailer(what) -- what is
     'water' or 'waste' -- answers null, or { side, clear, water, drain,
     keep, under }: side, the perimeter's side key the hookups go on (a US
     RV: the road side); the entry and the drain's exit then stand on that
     side, nearest the middle of the wet points, and clear(x, z, k) may move
     them off what stands there (wheel wells, a crossmember, a door) ->
     { x, z, why }; water(EN, ctx) bills and draws the inlet on the outside
     of the wall and answers the log's words in place of "the service line
     from the meter is site work"; drain(EX, ctx) bills and draws the way
     down and the outlet under the trailer and answers { len, b110, r11075,
     note } -- len replaces the 1.0 m of sewer pipe outside, b110 and r11075
     add 90 bends 110 and reducers 110/75 to the tally (their joints primed
     and cemented with the rest), note replaces "outside to the site
     connection"; the drain's sealant is then for its way through the
     floor. TR.keep (waste, optional): [{ x, z, r, nx, nz, depth, what }]
     -- a hookup in a wall (its inner face, its normal); a vent stack within
     r of it along that wall, depth across it, slides along to r. TR.under
     (waste, optional): the drain's centre under the finished floor where
     the floor is shallower than WASTE.under (a trailer's: the drain under
     its belly pan) -- the branches' drops, the vent stack's foot and the
     AAV pipes go to it.
     mep-v36 (THOW thread, thow-v30: the hookups' freeze protection): after
     MepLib.waste the waste leaves MepLib._last[env.layerId] = { under110,
     under50, yUnder, trailer } -- the metres of drain (110) and of branch /
     collector pipe (50) that lie flat under the floor at the drain's level
     (the drops, the vents and the stack not counted; 0 under a slab, whose
     runs are in the ground), for a product that keeps them from freezing (a
     trailer's lie under its belly pan, outside the insulation). Read-only;
     nothing billed or drawn changes.

     mep-v37 (THOW thread, thow-v33: the services over a gooseneck's neck),
     opt-in: env.floorAt(x, z) -> the finished floor level at a plan point
     (null = the storey's y0): the electrics' sockets and switches stand on
     the floor under them, the socket line and its feeds climb at a raised
     floor's edge, the board stays on the main floor (the other side of the
     entrance when its hinge side is raised). env.outdoorOk(sideKey) ===
     false keeps the heating's outdoor unit off that wall (with outdoorEnds
     too). Without them nothing changes.

     mep-v39 (GARAGE APARTMENT thread, garageapt-v16: a dwelling that is all
     on storey 2, over a garage), opt-in, without the hooks nothing changes:
     env.upLiving -- in MepLib.heat a living room of storey 2 (env.roomsUp)
     gets a head like a bedroom there, and the stand-in rule (no room named
     living room: the biggest dry room) looks at storey 2 too; env.fxUp --
     in MepLib.vent a kitchen or a dryer placed on storey 2 (fixture st 1)
     is vented from that storey's floor (env.storeyY(1)): the hood's duct
     to the roof cap, the dryer's to the nearest wall or the roof.
     mep-v40 (GARAGE APARTMENT thread, garageapt-v17: the dwelling's water
     and waste all on storey 2, over an unheated garage), opt-in, without
     the hooks nothing changes:
     env.roomsUp on MepLib.water / MepLib.waste (with env.storeyY) -- the
     pieces up there are grouped by THEIR room (the bathroom and the
     kitchen are two groups, not one 'storey 2 over GARAGE'), named
     'storey 2 <room>';
     env.riserAt(x, z) on the water -- ONE riser to storey 2 where the
     product says (a heated wall: the stair hall), not one per room up a
     wall of the garage; the rooms up there fed from its top by a trunk in
     that storey's floor; { entry: true } puts the entry's valves at its
     foot (the service comes in there under the slab); the cold riser is
     lagged;
     env.heaterUp on the water -- every hot piece upstairs: the heater goes
     up there (the laundry / the closet nearest the bathroom / the bathroom
     of storey 2, env.facesUp(x, z) its room's faces), in a drain pan
     (IRC P2801.6, the pending row mep.heaterPan) whose 32 drain runs out
     through the nearest exterior wall and down the facade to 300 over
     grade (P2801.6.2), the T&P discharging over the pan (P2804.6.1); its
     feed from the board up to that floor;
     env.dropWall on the waste -- an upstairs room's drop stands in a wall
     of the room under it (with env.stackOuter: an exterior wall), not in
     the middle of the garage; the run in the upper floor from the room's
     pieces to it billed and drawn, the drop drawn;
     env.segmentsUp() -- the storey above's walls: a drop, the stack and a
     hose bib keep clear of the openings of both storeys (a hose bib in
     the middle of an overhead door). And on every product: the hose bibs
     slide off an opening they would stand in (unchanged where none does).
     MepLib._last[water/waste].ups -- the pipes from the ground storey up
     through the floor between, for the product's fireblocking.
     mep-v47 (GARAGE APARTMENT thread, garageapt-v23): with env.hrvUp the
     heat recovery ventilator up there also supplies a lived-in room of the
     ground floor (env.headRoom), its 4 in. branch down through storey 2's
     floor, across in the floor between and out of that room's ceiling (not
     in the attic, not insulated). Without env.hrvUp + env.headRoom nothing
     changes.
     mep-v45 (GARAGE APARTMENT thread, garageapt-v22): env.headRoom(key,
     name) on MepLib.heat -- a ground-floor room the product calls habitable
     (an office, a gym, a workshop under a dwelling) gets a head as a
     bedroom does (IRC R303.10: heat in every habitable room); the head log
     names them. Without it nothing changes. And a ground room's head is
     no longer kept off storey 2's windows on the same wall (they are
     handed over in the wall's openings with their sill over storey 2's
     floor) -- only the products with env.roomsUp see a difference.
     mep-v43 (GARAGE APARTMENT thread, garageapt-v21): env.upDraw() ->
     { y, axis, lines } -- STOREY 2's PIPES DRAWN IN THE FLOOR BETWEEN: the
     water riser on up to y (the runs' level under the subfloor), the cold
     and hot trunks node to node and every piece's branch up there, the
     drains' runs at their fall (1/4 in. a ft for 2 in., 1/8 in. for 3 / 4
     in., IRC P3005.3) from the drop up to the room's middle and on to each
     piece. A run keeps to a bay between two joists (axis: the way the
     joists run, lines: their centres across) and crosses the joists only
     where it has to, through their webs -- the holes counted in the log and
     in MepLib._last[layer].upHoles; avoid: [plan rects] (a stairwell) no
     run crosses -- the other order is tried, CHECK in the log if both do.
     Drawing only: no quantity changes.
     Without env.upDraw nothing changes.
     mep-v42 (GARAGE APARTMENT thread, garageapt-v19): env.hrvUp on
     MepLib.vent (with env.hrvCold, env.roomsUp, env.storeyY) -- the heat
     recovery ventilator of a cold climate goes into a room of storey 2 (its
     laundry first, a closet allowed), high under that storey's ceiling, its
     two 6 in. ducts straight out through the room's nearest exterior wall at
     the unit's height to the hoods, the branches in the attic over storey
     2's ceiling to storey 2's rooms only. Without it nothing changes.
     env.upName -- what the vent's lines call storey 2 (the barndo's 'loft'
     is the default).
     mep-v41 (GARAGE APARTMENT thread, garageapt-v18): env.dropWall reads
     storey 2's openings (env.segmentsUp) only for a drop that may go on up
     as the stack -- a room with a WC, or every room when none has one; a
     kitchen's drop below its own window no longer slides off it.

     mep-v51 (THOW thread, thow-v35): env.necService === false under
     env.nec -- a building with no service of its own (a trailer on its
     shore-power cord: the product bills the inlet, the cord and the main):
     no meter socket EEM00001, no SER cable EEE00007, and the board is the
     line's ELEC.board (a main-lug board, its main back-fed by the product,
     2 spaces counted for it) instead of the 200 A 40-space panel EED00002;
     its spaces counted against env.necSpaces (24 if not given). The surge
     protector stays. Without it nothing changes.
     mep-v52 (RANCH thread, ranch-v78): env.floorDraw on MepLib.water -- a
     raised floor over a crawl space hands over its joists' level and lines
     ({ y, axis, lines }, as env.upDraw): the ground floor's trunks, the
     heater's ups and the branches DRAWN in the joist bays, through the
     joists where they cross (names 'water-floor-*'). env.waterRest: the
     rest of the billed water drawn on the calculation's way -- the T&P
     discharge, the hose bibs' feeds over the ceiling, on a slab the
     heater's ups, the branches from the room's stub round its walls in
     the studs and the service's sleeve through the edge footing
     ('water-tp-discharge', 'water-hosebib-feed', 'water-heater-up',
     'water-wall-branch', 'water-service-sleeve'). Drawn only: every
     quantity unchanged.
     Without them nothing changes.
     mep-v53 (RANCH thread, ranch-v79): env.crawlDrain on MepLib.waste --
     a raised floor over a crawl space too low for a 110 under its joists
     ({ yGrade, cover, dig, bed }): the building drain, the WC's branch, the
     stack's foot and the way out BURIED as under a slab (the far end's
     crown cover under grade, 1/8 in./ft, the trench from grade on a gravel
     bed 100 under / 150 over the pipe, the rest the dug soil, billed as
     env.crawlDrain().dig / .bed), the 50s in the floor between the joists
     down to it -- billed so: the 50s' and the valves' drop to the buried
     drain, the stack from it; drawn 'waste-crawl-*' (buried) and
     'waste-floor-*' (in the floor, env.floorDraw's bays, the joists'
     middle third). env.wasteRest: every air admittance valve's pipe drawn
     ('waste-aav-pipe'), on a slab a wall outlet's pipe on up in the wall
     ('waste-wall-drop'); drawn only. Without them nothing changes.
     mep-v54 (RANCH thread, ranch-v80): with env.wasteRest the pea gravel
     billed as env.underSlab() / crawlDrain().bed is drawn in every trench
     piece ('waste-slab-gravel' / 'waste-crawl-gravel', userData.qtyV =
     the fill less the pipe) -- the whole trench under a slab, the bed in
     a crawl space's. Drawn only; without the flag nothing changes.
     mep-v55 (RANCH thread, ranch-v82): env.fanLeg on MepLib.vent -- the
     300 every bathroom fan's duct is billed for its collar is drawn: across
     from the fan over the ceiling toward the room's middle, the duct
     rising from there. Drawn only; without it nothing changes.
     mep-v56 (RANCH thread, ranch-v83): env.unitTags on MepLib.heat -- every
     outdoor unit's bodies (the unit, its bracket or pad, its feet or stand,
     its isolator) marked with their codes, not the first unit's only (the
     second unit stood under the first isolator's code), and each unit,
     pad and set of feet a piece (userData.qtyPiece) for the qty audit's
     count (core-v687). Tags only; without it nothing changes.
     mep-v57 (RANCH thread, ranch-v84): env.pieceTags on MepLib.elec /
     heat / vent -- every billed switch drawn and every device body saying
     what comes with it, for the qty audit's piece count (core-v687):
     a socket's, switch's and light's body carries its box EEJ00001 and
     the box's three connectors EES00003 (userData.qtyWith), the cooktop's
     drawn box its connectors; under the US code the exterior light's
     switch, billed in the room's switch box, is drawn there as the box's
     second gang -- or, the room's switch not beside that door, in a box
     of its own beside it, the box and its connectors billed (the one
     change to the bill); the bathroom fan's switch -- or the whole-house control
     VMM00004 in its place -- a gang in the bathroom's switch box (the
     electrics hand their switches on, LAST.switches); the floor mat's
     thermostat counted under its own code with its box. Every switch a
     piece (userData.qtyPiece), so a two-gang box counts two. Without the
     flag nothing changes. And env.doorSeam on
     MepLib.elec: a door whose middle falls on the seam between two of a
     room's rects is that room's door (RANCH's second bathroom had none,
     so no switch, billed or drawn); without it nothing changes.
     mep-v58 (RANCH thread, ranch-v86): env.devFace on MepLib.elec / heat
     -- every wall device was placed on the wall's structural face, so with
     the walls on it stood inside the lining: the switches 7 mm into the
     partitions' board, every socket and switch on an exterior wall 36-54
     mm behind the board (the service cavity), a bathroom's behind the
     tile. The product answers env.devFace(x, z, nx, nz, y): how far in
     front of that point (along the normal) the finished face stands --
     board, cavity, tile in a wet room's band -- or null where it does not
     know (outdoors). A socket, switch or junction box then has its plate
     5 mm proud of the finished face and the rest of its body in the wall
     (a flush box); the gangs follow their switch; a towel rail and a mat
     thermostat stand ON the finished face; and a switch beside a door
     keeps 100 clear of the shell's frame along its wall (the room's rects
     reach the outline: a block house's bedroom had its switch inside the
     outer wall) -- the other hand or the next way is tried. Drawn only:
     nothing billed changes. Without the hook nothing changes.
     mep-v60 (newsletter / path-to-goal thread, thow-v47): two opt-ins on MepLib.waste for a
     product that draws the runs under its floor itself (a trailer: its
     beams, crossmembers, belly pan and axles are the product's). With
     env.runsOut === true, and no slab or crawl space, the waste hands its
     plan route over as data in LAST[layerId].runs -- the drain's nodes from
     the exit in their order, the stack's foot, every room's pieces (outlet,
     diameter, wall or floor, height) with the node it joins (a room on the
     drain: its own node; a collector: the node it runs to) and every air
     admittance valve with the outlet it sits by. env.stackFoot(x, z) may
     answer the y the stack's body starts from (above the floor, where the
     product cannot take it down there -- over a beam); the product draws
     the rest. Data and one start height only: nothing billed changes, and
     without the flags nothing changes.

     LOG. The electrics keep their prefix ELEC, the heating is HEAT, the
     water WATER, the waste WASTE; this file's own lines are MEP.
     Status and hand-over: status/mep.md in the leva-theme repo. */
(function (global) {
  'use strict';

  var VERSION = 'mep-v68';   /* mep-v68: env.ufhDryNote -- the product says how it built the dry system's floor, in place of the CHECK; env.ufhKeepOut -- no loop over a stairwell's hole (TWO STORY thread); mep-v67: opt-in env.innerSide(k) -- a party wall is no exterior wall: no socket, head, outdoor unit or way out on it (DUPLEX thread); mep-v66: the HRV in every climate (env.hrvAlways) and from the ground floor's technical room through the floor between (env.hrvBetween) (TWO STORY thread); mep-v65: storey 2's floor loops on the heat pump (env.ufhUp, the dry system env.ufhDry), towel rails in a hydronic house (env.hydroRails) (TWO STORY thread); mep-v64: two openings closer than twice the keep-off hopped as one by the socket line (TWO STORY thread) */

  /* WHAT ONE TRADE LEAVES FOR THE NEXT, per layer id, set on every build:
     the electrics write where the board went, the heating reads it for its
     feed. Layers build in the order they are registered, electrics first. */
  var LAST = {};

  /* what a product must hand over for the electrics -- the free names of the
     moved body, no more */
  var NEED = ['API', 'STATE', 'FINISH', 'PART', 'MAGENTA',
              '_P', '_add', '_billReset', '_asmCode', '_buildRect', 'wallThickness', 'isNew',
              '_onRoomLine', '_roomLabel', '_sharedEdge', '_slantRaw', '_spaceFree', '_wedgeRoomAt'];
  function _missing(env) {
    var out = [], i;
    if (!env) return ['env'];
    if (typeof env.layerId !== 'string' || !env.layerId) out.push('layerId');
    for (i = 0; i < NEED.length; i++) if (env[NEED[i]] == null) out.push(NEED[i]);
    return out;
  }

  /* =========================================================================
     THE PERIMETER AS THE WALLS RUN (mep-v14, Marek 2026-10-09: krok 5).

     Every trade read the building's bounding RECTANGLE, inset by a wall, as
     its four exterior faces: on an L the porch corner counted as wall and on
     a T the faces round the wing were missing. The faces now come from the
     outline itself (env.API.poly), inset by the wall thickness: as many
     sides as the outline has, each with its inward normal, turning the same
     way as the rectangle always did and starting at the corner nearest
     x0,z0 along +x; each side knows whether the corner at its end is convex
     (the outside goes round it) or reflex (the inside corner of an L). A
     side's key says which way its wall faces (z0 x1 z1 x0, a slanted one
     d + its number). A RECTANGLE KEEPS THE EXACT FOUR SIDES IT HAD -- the
     same numbers in the same order -- so the ADU, the forks and every
     rectangular plan come out unchanged.
     ========================================================================= */
  function _polyClean(P) {
    var out = [], i, n;
    for (i = 0; i < P.length; i++) {
      var p = P[i];
      if (!p || !(isFinite(p[0]) && isFinite(p[1]))) continue;
      var q = out.length ? out[out.length - 1] : null;
      if (q && Math.abs(q[0] - p[0]) < 1e-6 && Math.abs(q[1] - p[1]) < 1e-6) continue;
      out.push([p[0], p[1]]);
    }
    if (out.length > 1 && Math.abs(out[0][0] - out[out.length - 1][0]) < 1e-6 && Math.abs(out[0][1] - out[out.length - 1][1]) < 1e-6) out.pop();
    var changed = true;
    while (changed && out.length > 3) {
      changed = false;
      for (i = 0; i < out.length; i++) {
        n = out.length;
        var a = out[(i - 1 + n) % n], b = out[i], c = out[(i + 1) % n];
        if (Math.abs((b[0] - a[0]) * (c[1] - b[1]) - (b[1] - a[1]) * (c[0] - b[0])) < 1e-9) { out.splice(i, 1); changed = true; break; }
      }
    }
    return out;
  }
  function _insetSides(C0, wt) {
    var C = C0.slice(), n = C.length, ar = 0, i;
    if (n < 3) return null;
    for (i = 0; i < n; i++) { var p = C[i], q = C[(i + 1) % n]; ar += p[0] * q[1] - q[0] * p[1]; }
    if (!(Math.abs(ar) > 1e-9)) return null;
    if (ar < 0) C.reverse();
    var st = 0, bv = null;
    for (i = 0; i < n; i++) {
      var v0 = C[i];
      if (!bv || v0[1] < bv[1] - 1e-9 || (Math.abs(v0[1] - bv[1]) < 1e-9 && v0[0] < bv[0])) { bv = v0; st = i; }
    }
    C = C.slice(st).concat(C.slice(0, st));
    var E = [];
    for (i = 0; i < n; i++) {
      var a = C[i], b = C[(i + 1) % n], dx = b[0] - a[0], dz = b[1] - a[1], L = Math.hypot(dx, dz);
      if (!(L > 1e-6)) return null;
      E.push({ a: a, ux: dx / L, uz: dz / L, nx: -dz / L, nz: dx / L });
    }
    var V = [];
    for (i = 0; i < n; i++) {
      var A = E[(i - 1 + n) % n], Bq = E[i], v = C[i];
      if (Math.abs(A.ux) < 1e-12 && Math.abs(Bq.uz) < 1e-12) { V.push([v[0] + A.nx * wt, v[1] + Bq.nz * wt]); continue; }
      if (Math.abs(A.uz) < 1e-12 && Math.abs(Bq.ux) < 1e-12) { V.push([v[0] + Bq.nx * wt, v[1] + A.nz * wt]); continue; }
      var pax = A.a[0] + A.nx * wt, paz = A.a[1] + A.nz * wt, pbx = Bq.a[0] + Bq.nx * wt, pbz = Bq.a[1] + Bq.nz * wt;
      var den = A.ux * Bq.uz - A.uz * Bq.ux;
      if (Math.abs(den) < 1e-9) { V.push([v[0] + Bq.nx * wt, v[1] + Bq.nz * wt]); continue; }
      var t = ((pbx - pax) * Bq.uz - (pbz - paz) * Bq.ux) / den;
      V.push([pax + A.ux * t, paz + A.uz * t]);
    }
    var S = [];
    for (i = 0; i < n; i++) {
      var Ei = E[i];
      var k = (Math.abs(Ei.uz) < 1e-9) ? (Ei.ux > 0 ? 'z0' : 'z1') : ((Math.abs(Ei.ux) < 1e-9) ? (Ei.uz > 0 ? 'x1' : 'x0') : ('d' + i));
      S.push({ k: k, a: V[i], b: V[(i + 1) % n], n: [Ei.nx === 0 ? 0 : Ei.nx, Ei.nz === 0 ? 0 : Ei.nz] });
    }
    return S;
  }
  function _ptInPoly(P, x, z) {
    var c = false, i, j;
    for (i = 0, j = P.length - 1; i < P.length; j = i++) {
      var a = P[i], b = P[j];
      if (((a[1] > z) !== (b[1] > z)) && (x < (b[0] - a[0]) * (z - a[1]) / (b[1] - a[1]) + a[0])) c = !c;
    }
    return c;
  }
  function _perim(env, B0, wt) {
    var IN = { x0: B0.x0 + wt, x1: B0.x1 - wt, z0: B0.z0 + wt, z1: B0.z1 - wt };
    var P = null, C = null, sides = null, rect = true, i;
    try { P = (env && env.API && typeof env.API.poly === 'function') ? env.API.poly() : null; } catch (eP) { P = null; }
    if (P && P.length >= 3) {
      C = _polyClean(P);
      var box = (C.length === 4);
      for (i = 0; box && i < 4; i++) {
        var onX = Math.abs(C[i][0] - B0.x0) < 1e-6 || Math.abs(C[i][0] - B0.x1) < 1e-6;
        var onZ = Math.abs(C[i][1] - B0.z0) < 1e-6 || Math.abs(C[i][1] - B0.z1) < 1e-6;
        if (!onX || !onZ) box = false;
      }
      if (!box) { sides = _insetSides(C, wt); if (sides) rect = false; }
    }
    if (!sides) {
      sides = [
        { k: 'z0', a: [IN.x0, IN.z0], b: [IN.x1, IN.z0], n: [0, 1] },
        { k: 'x1', a: [IN.x1, IN.z0], b: [IN.x1, IN.z1], n: [-1, 0] },
        { k: 'z1', a: [IN.x1, IN.z1], b: [IN.x0, IN.z1], n: [0, -1] },
        { k: 'x0', a: [IN.x0, IN.z1], b: [IN.x0, IN.z0], n: [1, 0] }
      ];
    }
    for (i = 0; i < sides.length; i++) {
      var sd = sides[i];
      sd.len = Math.hypot(sd.b[0] - sd.a[0], sd.b[1] - sd.a[1]);
      sd.u = [(sd.b[0] - sd.a[0]) / sd.len, (sd.b[1] - sd.a[1]) / sd.len];
    }
    for (i = 0; i < sides.length; i++) {
      var s1 = sides[i], s2 = sides[(i + 1) % sides.length];
      s1.cvx = (s1.u[0] * s2.u[1] - s1.u[1] * s2.u[0]) >= 0;
    }
    var nRef = 0;
    for (i = 0; i < sides.length; i++) if (!sides[i].cvx) nRef++;
    /* mep-v67 (DUPLEX thread, opt-in env.innerSide(k)): a side that is a
       party wall, not an exterior wall -- no socket, no head, no outdoor
       unit and no way out (water, waste, ducts) on it; cables still run
       along it. Without the hook nothing changes. */
    if (env && typeof env.innerSide === 'function') {
      for (i = 0; i < sides.length; i++) { try { sides[i].inner = !!env.innerSide(sides[i].k, sides[i]); } catch (eIS) { sides[i].inner = false; } }
    }
    return { sides: sides, IN: IN, rect: rect, outline: rect ? null : C, reflex: nRef,
             note: rect ? 'the rectangle' : ('the outline, ' + sides.length + ' sides, ' + nRef + ' inside corner(s)') };
  }
  /* the side nearest a point, as the water and the waste ask it: the side's
     key, the distance, the point on it and the room's normal there */
  /* mep-v32: the nearest point on the side(s) keyed k, or null */
  function _sideAt(PER, k, x, z) {
    var best = null, q;
    for (q = 0; q < PER.sides.length; q++) {
      var S = PER.sides[q];
      if (S.k !== k) continue;
      var u = (x - S.a[0]) * S.u[0] + (z - S.a[1]) * S.u[1];
      u = Math.max(0, Math.min(S.len, u));
      var px = S.a[0] + S.u[0] * u, pz = S.a[1] + S.u[1] * u, d = Math.hypot(px - x, pz - z);
      if (!best || d < best.d) best = { k: S.k, d: d, x: px, z: pz, n: S.n, side: q, u: u };
    }
    return best;
  }
  /* mep-v32: THE TRAILER'S HOOKUP (env.trailer): the point on its side
     nearest P, moved clear by the product; null without it */
  function _trailerAt(env, PER, P, what) {
    if (!env || typeof env.trailer !== 'function') return null;
    var TR = null;
    try { TR = env.trailer(what); } catch (eT) { TR = null; }
    if (!TR || !TR.side) return null;
    var S = _sideAt(PER, TR.side, P.x, P.z);
    if (!S) return null;
    if (typeof TR.clear === 'function') {
      try {
        var NC = TR.clear(S.x, S.z, S.k, what);
        if (NC && isFinite(NC.x) && isFinite(NC.z)) { S.x = NC.x; S.z = NC.z; if (NC.why) S.moved = NC.why; }
      } catch (eC) {}
    }
    S.TR = TR;
    return S;
  }
  /* mep-v57 (env.pieceTags): ONE MORE GANG IN A SWITCH'S BOX -- beside the
     switch, on the side away from its door, 85 on a gang; a piece of its
     own (qtyPiece). S is a switch the electrics handed on (LAST.switches). */
  function _gang(T, g, S, m, nm, viz) {
    var off = S.s * 0.085 * S.n, b = new T.Mesh(new T.BoxGeometry(0.08, 0.08, 0.012), m);
    b.position.set(S.x + S.nz * off + S.nx * 0.006, S.y, S.z - S.nx * off + S.nz * 0.006);
    b.rotation.y = Math.atan2(S.nx, S.nz);
    b.name = nm; b.userData.viz = viz; b.userData.qtyPiece = S.id + 'g' + S.n; g.add(b);
    S.n++;
    return b;
  }
  /* mep-v58 (opt-in env.devFace): THE FINISHED FACE A WALL DEVICE SITS ON.
     _faceAt: how far in front of the point the product says the finished
     face is (0 where it does not say); _faceShift: how far to move a
     device's back so its plate is DEV_PROUD in front of that face, its
     body of depth t in the wall behind -- 0 where the product says nothing. */
  var DEV_PROUD = 0.005;
  function _faceD(env, x, z, nx, nz, y) {
    if (!env || typeof env.devFace !== 'function') return null;
    var d = null;
    try { d = env.devFace(x, z, nx, nz, y); } catch (eF) { d = null; }
    return (typeof d === 'number' && isFinite(d) && d > -0.05 && d < 0.30) ? d : null;
  }
  function _faceAt(env, x, z, nx, nz, y) { var d = _faceD(env, x, z, nx, nz, y); return (d == null) ? 0 : d; }
  function _faceShift(env, x, z, nx, nz, y, t) { var d = _faceD(env, x, z, nx, nz, y); return (d == null) ? 0 : (d + DEV_PROUD - t); }
  /* the switch of the room a point is in, else (not strict) the nearest within 3 m */
  function _swAt(SW, x, z, strict) {
    if (!SW || !SW.length) return null;
    var q, r, best = null, bd = 3.0;
    for (q = 0; q < SW.length; q++) {
      var RS = SW[q].rects || [];
      for (r = 0; r < RS.length; r++) if (x > RS[r].x0 - 0.01 && x < RS[r].x1 + 0.01 && z > RS[r].z0 - 0.01 && z < RS[r].z1 + 0.01) return SW[q];
    }
    if (strict) return null;
    for (q = 0; q < SW.length; q++) { var d = Math.hypot(SW[q].x - x, SW[q].z - z); if (d < bd) { bd = d; best = SW[q]; } }
    return best;
  }
  function _nearSide(PER, x, z) {
    var IN = PER.IN;
    if (PER.rect) {
      var c = [{ k: 'z0', d: Math.abs(z - IN.z0), x: Math.max(IN.x0, Math.min(IN.x1, x)), z: IN.z0, n: [0, 1] },
               { k: 'x1', d: Math.abs(IN.x1 - x), x: IN.x1, z: Math.max(IN.z0, Math.min(IN.z1, z)), n: [-1, 0] },
               { k: 'z1', d: Math.abs(IN.z1 - z), x: Math.max(IN.x0, Math.min(IN.x1, x)), z: IN.z1, n: [0, -1] },
               { k: 'x0', d: Math.abs(x - IN.x0), x: IN.x0, z: Math.max(IN.z0, Math.min(IN.z1, z)), n: [1, 0] }], b = null, s;
      /* mep-v67: never out through a party wall (env.innerSide) */
      for (s = 0; s < 4; s++) { if (PER.sides[s] && PER.sides[s].inner) continue; if (!b || c[s].d < b.d) b = c[s]; }
      return b || c[0];
    }
    var best = null, q;
    for (q = 0; q < PER.sides.length; q++) {
      var S = PER.sides[q], u = (x - S.a[0]) * S.u[0] + (z - S.a[1]) * S.u[1];
      if (S.inner) continue;   /* mep-v67 */
      u = Math.max(0, Math.min(S.len, u));
      var px = S.a[0] + S.u[0] * u, pz = S.a[1] + S.u[1] * u, d = Math.hypot(px - x, pz - z);
      if (!best || d < best.d) best = { k: S.k, d: d, x: px, z: pz, n: S.n, side: q, u: u };
    }
    return best;
  }

  /* =========================================================================
     ELECTRICS -- adu-elec. Ported from tiny's rules, on this line's data
     (rooms from the floorplan asset, exterior segments with their openings,
     partitions with their doors). One board, a socket radial per room, a
     light and a switch per room, every run billed by the metre.

     THE RULES (tiny, kept as they are): the board goes beside the entrance
     door on the hinge side, 150 clear of the reveal, else on the longest
     wall of the largest room; sockets 300 to centre above the finished floor,
     no more than 2.2 m apart along a wall, 150 off a corner, 200 off any
     opening, one within 900 of every door; the bathroom gets one socket 900
     past its door and nothing else; feeds run from the bottom of the board at
     head height (2150), which clears every opening, and drop into each room's
     ring; the ring runs round the room's inner faces at socket height and
     hops over a door at head height. A light in the middle of every room
     (two in a room over 20 m2), its switch beside the way in on the handle
     side at 1100, inside the room. Circuits by colour: sockets cyan, lights
     lime; devices white.
     ========================================================================= */
  var ELEC = { cable: 'EEE00001', socket: 'EES00001', light: 'EEC00002', sw: 'EEL00001',
               board: 'EED00001', brk: 'EEC00003', rcd: 'EER00001',
               box: 'EEJ00001', conn: 'EES00003', earth: 'EEG00001',
               heavy: 'EEE00003', brkHeavy: 'EEC00011', ctrlW: 0.200, ctrlH: 0.250, ctrlT: 0.060, ctrlY: 1.500,
               h: 0.300, step: 3.000, corner: 0.150, keepOff: 0.200, headUp: 2.150,
               doorIn: 0.900, swH: 1.100, swOff: 0.150,
               cableR: 0.006, boxW: 0.130, boxH: 0.130, boxT: 0.045,
               brdW: 0.500, brdH: 0.360, brdT: 0.110, brdY: 1.400 };
  var ELEC_BASE = ELEC;
  /* the rows the hot room's heater circuit bills (mep-v12), minted into the
     product's map when it hands one over -- the same rows the water heater
     uses */
  var ELEC_HOT_CAT = {
    'EEE00003': { unit: 'm',   label: 'Cable 3x6 (10 AWG)' },
    'EEC00011': { unit: 'pcs', label: '30 A double pole circuit breaker' }
  };

  /* THE SURFACE VARIANT (mep-v10, Marek 2026-10-09: the shed onto the shared
     electrics, its own rules kept as a variant here) -- env.elecVariant
     'surface'. A building with no lining to bury anything in: every box,
     socket, switch and the board itself SURFACE MOUNTED on the frame, the
     catalogue's external range (EES00005, EEL00002, EED04001), not the flush
     range a lined wall takes. AND A JUNCTION BOX ON EVERY BRANCH: a back box
     behind each device as everywhere, and a box wherever a cable LEAVES a
     run -- the tap that starts each room's circuit, the tap-off to each
     lamp, the point the switch drop joins the lighting run -- drawn where it
     is billed, the log naming each one. ONE socket circuit and ONE lighting
     circuit for the building, on different breakers: 16 A (EEC00003) for
     the sockets, 10 A (EEC00004) for the lights. The rest of the rules are
     the line's, as below. Moved word for word from shed-v113. */
  var ELEC_SURF = { cable: 'EEE00001', socket: 'EES00005', light: 'EEC00002', sw: 'EEL00002',
                    board: 'EED04001', brk: 'EEC00003', brkLight: 'EEC00004', rcd: 'EER00001',
                    box: 'EEJ00001', conn: 'EES00003', earth: 'EEG00001',
                    heavy: 'EEE00003', brkHeavy: 'EEC00011', ctrlW: 0.200, ctrlH: 0.250, ctrlT: 0.060, ctrlY: 1.500,
                    h: 0.300, step: 3.000, corner: 0.150, keepOff: 0.200, headUp: 2.150,
                    doorIn: 0.900, swH: 1.100, swOff: 0.150,
                    cableR: 0.006, boxW: 0.130, boxH: 0.130, boxT: 0.045, jbW: 0.085, jbT: 0.040,
                    brdW: 0.500, brdH: 0.360, brdT: 0.110, brdY: 1.400 };

  /* THE US CODE KIT (mep-v25, env.nec): the rule figures and the rows */
  var NEC_KIT = { six: 6 * 0.3048, minSpace: 2 * 0.3048, hall: 10 * 0.3048, doorOff: 0.10,
                  counter: 4 * 0.3048, counterMin: 12 * 0.0254, counterY: 42 * 0.0254, hoodY: 1.95,
                  fridgeY: 44 * 0.0254, washerY: 1.10, dryerY: 0.75, stackY: 1.65, vanityY: 1.05,
                  basin: 3 * 0.3048, opener: 11 * 0.3048, outY: 0.30, lightY: 1.95, through: 0.15,
                  extLightM: 3.5, vicinity: 21 * 0.3048, outside: 0.90, cookMin: 6 * 0.3048,
                  slack: 1.15, seM: 2.0, spaces: 40, panel: 'EED00002',
                  smoke: 'EES00004', tower: 'EEC00009', outRcpt: 'EES00005', surge: 'EES00002',
                  gfci: 'EER00001', brk20: 'EEC00003', brk15: 'EEC00004', brk30: 'EEC00011' };
  /* the sheet's rows the kit bills that a product's map may not carry */
  var NEC_CAT = {
    'EES00004': { unit: 'pcs', label: 'Smoke detector fire alarm sensor' },
    'EES00005': { unit: 'pcs', label: 'Electric socket external' },
    'EES00002': { unit: 'pcs', label: 'Surge protection' },
    'EEC00009': { unit: 'pcs', label: 'Pop-up socket tower' },
    'EEC00004': { unit: 'pcs', label: '10 A lighting circuit breakers' },
    'EEC00011': { unit: 'pcs', label: '30 A double pole circuit breaker' }
  };
  var NEC_MADE = {
    'EEC00012':     { unit: 'pcs', label: 'Combination AFCI circuit breaker, 15 / 20 A single pole (NEC 210.12)' },
    'EEC00013':     { unit: 'pcs', label: 'Dual function AFCI / GFCI circuit breaker, 20 A single pole (kitchen, laundry)' },
    'EEC00014':       { unit: 'pcs', label: '40 A double pole circuit breaker (cooktop)' },
    'EEE00004':    { unit: 'm',   label: 'NM-B cable 8/3 with ground (cooktop)' },
    'EEE00005':   { unit: 'm',   label: 'NM-B cable 10/3 with ground (dryer)' },
    'EEE00006':   { unit: 'm',   label: 'NM-B cable 14/3 with ground (smoke alarm interconnect)' },
    'EES00006':      { unit: 'pcs', label: 'Dryer receptacle 30 A 240 V NEMA 14-30R' },
    'EES00007':     { unit: 'pcs', label: 'Combination smoke and CO alarm, hardwired, battery backup' },
    'EEW00003':    { unit: 'pcs', label: 'Outdoor wall light, LED, wet rated' },
    'EEM00001':   { unit: 'pcs', label: 'Meter socket 200 A, outdoor' },
    'EEE00007':     { unit: 'm',   label: 'Service entrance cable SER 4/0 aluminum (meter to panel)' },
    'EET00002':        { unit: 'm',   label: 'PVC conduit 3/4 in. schedule 40 (under the slab)' },
    'EEE00008':        { unit: 'm',   label: 'Building wire THHN/THWN-2 12 AWG' },
    'EED00002':     { unit: 'pcs', label: 'Main breaker load center 200 A 40 spaces' }
  };

  /* the body below is the ADU's _buildElec as it was in adu-v1419, indented
     four spaces less; these names are bound back to locals so it reads the
     same text */
  function _buildElec(env, ctx) {
    var LID = env.layerId,
        API = env.API, STATE = env.STATE, FINISH = env.FINISH, PART = env.PART, MAGENTA = env.MAGENTA,
        _P = env._P, _add = env._add, _billReset = env._billReset, _asmCode = env._asmCode,
        _buildRect = env._buildRect, wallThickness = env.wallThickness, isNew = env.isNew,
        _onRoomLine = env._onRoomLine, _roomLabel = env._roomLabel, _sharedEdge = env._sharedEdge,
        _slantRaw = env._slantRaw, _spaceFree = env._spaceFree, _wedgeRoomAt = env._wedgeRoomAt;
    /* the variant (mep-v10): 'surface' is the shed's, anything else the line's */
    var SURF = env.elecVariant === 'surface', ELEC = SURF ? ELEC_SURF : ELEC_BASE;
    var NEC = !SURF && !!env.nec;   /* mep-v25: the US code on top */
    var NSVC = NEC && env.necService === false;   /* mep-v51: no service of its own (a trailer on its cord) */
    _billReset(LID);
    LAST[LID] = null;   /* mep-v2: the board for the heating feed, set below */
    var T = ctx.THREE, g = ctx.group, i, j, k;
    var PL = _P();
    if (!PL || !PL.rooms || !PL.roomFaces) { ctx.log('ELEC none -- floorplan asset without rooms (needs v79)'); return; }
    var rooms = PL.rooms() || [];
    if (!rooms.length) { ctx.log('ELEC none -- no room'); return; }
    var SEG = API.segments ? API.segments() : [];
    var B0 = _buildRect(), wt = wallThickness();
    /* the perimeter's inner faces, the line the sockets and the ring live on --
       from the outline as the walls run (mep-v14), a rectangle as it was */
    var PER = _perim(env, B0, wt), IN = PER.IN;
    var y0 = API.storeys()[0].y0 + FINISH.dry.h;
    /* AN UPPER STOREY (mep-v19, env.riserFrom): fed from the board below */
    var UPS = !!env.riserFrom, UPB = null, riserL = 0, nRise = 0;
    if (UPS) {
      UPB = LAST[env.riserFrom] || null;
      if (!UPB || !UPB.board || UPB.board.x == null) { ctx.log('ELEC none -- no board on ' + env.riserFrom + ' to feed this storey from (its electrics were not built)'); return; }
      var yF9 = null;
      try { yF9 = (typeof env.floorY === 'function') ? env.floorY() : null; } catch (eF9) { yF9 = null; }
      if (!(typeof yF9 === 'number' && isFinite(yF9) && yF9 > UPB.yBrd)) { ctx.log('ELEC none -- no floor level for this storey (env.floorY)'); return; }
      y0 = yF9;
    }
    var yLine = y0 + ELEC.h, yHead = y0 + ELEC.headUp, ySw = y0 + ELEC.swH;
    var yCeil = API.wallTop() - 0.02, nLow = 0;
    /* mep-v59 (TAURUS thread, Marek 2026-10-20: elektroinstalace -- kabely
       vedou vzduchem, maji vest po strope). env.ceilLift(x, z) -- the surface
       the runs 'at the ceiling' follow where a building has no ceiling (the
       underside of the rafters): every point of a run at the ceiling height is
       lifted to it (30 under), a run along it is laid in pieces that follow it,
       a branch box at the ceiling sits on it. Without the hook nothing changes. */
    var CLF = (typeof env.ceilLift === 'function') ? env.ceilLift : null, nLift = 0;
    function liftAt(x, y, z) {
      if (!CLF || Math.abs(y - yCeil) > 0.004) return y;
      var v = null;
      try { v = CLF(x, z); } catch (eCF) { v = null; }
      return (typeof v === 'number' && isFinite(v) && v > yCeil + 0.005 && v < yCeil + 6) ? (v - 0.03) : y;
    }
    /* mep-v37 (THOW thread, env.floorAt): A FLOOR LEVEL PER POINT -- a
       gooseneck's neck floor 1.1 m over the main one. Sockets and switches
       stand on the floor under them, the socket line climbs at the raised
       floor's edge, the board stays on the main floor. Without the hook
       every point is y0, as before. */
    var FLA = (typeof env.floorAt === 'function') ? env.floorAt : null, RAISE = { sk: 0, sw: 0, jogs: 0, brd: '' };
    function floorUnder(x, z) {
      if (!FLA) return y0;
      var f = null;
      try { f = FLA(x, z); } catch (eFA) { f = null; }
      return (typeof f === 'number' && isFinite(f)) ? f : y0;
    }
    function raisedAt(x, z) { return !!FLA && floorUnder(x, z) > y0 + 0.02; }
    /* a run at the socket line, lifted where the floor under it is raised,
       with a jog up at the edge (found to a few mm) */
    function lifted(pts) {
      if (!FLA || !pts || pts.length < 2) return pts;
      var out = [], q;
      function onLine(p) { return Math.abs(p[1] - yLine) < 1e-6; }
      for (q = 0; q < pts.length; q++) {
        var p = pts[q];
        if (q > 0 && onLine(pts[q - 1]) && onLine(p)) {
          var a = pts[q - 1], fa = floorUnder(a[0], a[2]), fb = floorUnder(p[0], p[2]);
          if (Math.abs(fa - fb) > 0.005) {
            var t0 = 0, t1 = 1, it;
            for (it = 0; it < 14; it++) {
              var tm = (t0 + t1) / 2;
              if (Math.abs(floorUnder(a[0] + (p[0] - a[0]) * tm, a[2] + (p[2] - a[2]) * tm) - fa) < 0.005) t0 = tm; else t1 = tm;
            }
            var xb = a[0] + (p[0] - a[0]) * t0, zb = a[2] + (p[2] - a[2]) * t0;
            out.push([xb, fa + ELEC.h, zb], [xb, fb + ELEC.h, zb]);
            RAISE.jogs++;
          }
        }
        out.push(onLine(p) ? [p[0], floorUnder(p[0], p[2]) + ELEC.h, p[2]] : p);
      }
      return out;
    }
    var mag = isNew(LID);
    /* the lighting circuit cyan (Marek), the socket circuit blue so the two
       can be told apart where they share a wall */
    /* real colours (Marek): black cable, white devices and lights */
    var mCab = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0x1A1C1D, roughness: 0.6, metalness: 0.1 });
    var mLit = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0x1A1C1D, roughness: 0.6, metalness: 0.1 });
    var mDev = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0xF7F7F5, roughness: 0.5, metalness: 0.0 });
    var mBrd = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0xF7F7F5, roughness: 0.5, metalness: 0.1 });
    /* the lighting is cyan throughout: lamps, switches and the circuit */
    var mLamp = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0xF7F7F5, roughness: 0.4, metalness: 0.0 });
    var mSw = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0xF7F7F5, roughness: 0.5, metalness: 0.0 });
    var tally = { cable: 0, sockets: 0, lights: 0, switches: 0, rooms: 0, boxes: 0 };
    var vizTag = 'elec';
    /* mep-v57 (opt-in env.pieceTags): a device's body says its box and the
       box's three connectors; the room switches kept for the gangs */
    var PTG = env.pieceTags === true, SWP = [], nGang = 0, gangIn = [];
    function withBox(b) { if (PTG && b) b.userData.qtyWith = [ELEC.box, ELEC.conn, ELEC.conn, ELEC.conn]; return b; }
    /* mep-v58 (opt-in env.devFace): a wall device with its plate on the
       finished face; lastSh = how far the last one moved out */
    var FCE = { n: 0, max: 0, sum: 0, left: [], shell: 0 }, lastSh = 0;
    function wdev(x, z, nx, nz, y, m, nm, w, h, t) {
      var sh = _faceShift(env, x, z, nx, nz, y, t);
      lastSh = sh;
      if (!sh && typeof env.devFace === 'function') FCE.left.push(nm.replace(/^elec-/, '') + ' ' + x.toFixed(2) + ',' + z.toFixed(2));
      if (sh) { FCE.n++; FCE.sum += sh + t - DEV_PROUD; FCE.max = Math.max(FCE.max, sh + t - DEV_PROUD); }
      return device(x + nx * sh, z + nz * sh, nx, nz, y, m, nm, w, h, t);
    }
    var NECSK = [];   /* mep-v49: the code's own receptacles, handed on with the room sockets */
    /* what every branch box is for, so the log can say it item by item (surface variant) */
    var boxLog = [];

    function tube(a, b, r, m) {
      /* mep-v59: a run at the ceiling follows env.ceilLift */
      if (CLF) {
        var aC = Math.abs(a[1] - yCeil) <= 0.004, bC = Math.abs(b[1] - yCeil) <= 0.004;
        if (aC && bC) {
          var Lh = Math.hypot(b[0] - a[0], b[2] - a[2]), nS = Math.max(1, Math.ceil(Lh / 0.6)), tot = 0, s9;
          var prev = [a[0], liftAt(a[0], a[1], a[2]), a[2]];
          for (s9 = 1; s9 <= nS; s9++) {
            var f9 = s9 / nS, xq = a[0] + (b[0] - a[0]) * f9, zq = a[2] + (b[2] - a[2]) * f9;
            var cur = [xq, liftAt(xq, yCeil, zq), zq];
            tot += tube0(prev, cur, r, m); prev = cur;
          }
          nLift++;
          return tot;
        }
        if (aC) a = [a[0], liftAt(a[0], a[1], a[2]), a[2]];
        if (bC) b = [b[0], liftAt(b[0], b[1], b[2]), b[2]];
      }
      return tube0(a, b, r, m);
    }
    function tube0(a, b, r, m) {
      var dx = b[0] - a[0], dy = b[1] - a[1], dz = b[2] - a[2], L = Math.hypot(dx, dy, dz);
      if (!(L > 0.005)) return 0;
      var mesh = new T.Mesh(new T.CylinderGeometry(r, r, L, 8), m);
      mesh.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), new T.Vector3(dx / L, dy / L, dz / L));
      mesh.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2);
      mesh.name = 'elec-cable'; mesh.userData.viz = vizTag;
      g.add(mesh);
      return L;
    }
    function run(pts, m) { var t = 0, q; for (q = 0; q + 1 < pts.length; q++) t += tube(pts[q], pts[q + 1], ELEC.cableR, m); return t; }
    function device(x, z, nx, nz, y, m, nm, w, h, t) {
      var b = new T.Mesh(new T.BoxGeometry(w, h, t), m);
      b.position.set(x + nx * t / 2, y, z + nz * t / 2);
      b.rotation.y = Math.atan2(nx, nz);
      b.name = nm; b.userData.viz = vizTag; g.add(b); return b;
    }
    /* A JUNCTION BOX AT A BRANCH (surface variant). Wherever a cable leaves a
       run -- a tap to a lamp, a switch drop joining the lighting circuit, the
       tap that starts a room's circuit -- there is a box, and it is drawn
       where it is billed so the model and the bill cannot disagree (Marek). */
    function branchBox(x, y, z, what) {
      if (!SURF) return null;
      y = liftAt(x, y, z);   /* mep-v59 */
      var b = new T.Mesh(new T.BoxGeometry(ELEC.jbW, ELEC.jbW, ELEC.jbT), mDev);
      b.position.set(x, y, z);
      b.name = 'elec-junction'; b.userData.viz = vizTag; g.add(b);
      tally.boxes++;
      boxLog.push(what + ' at ' + x.toFixed(2) + ',' + z.toFixed(2) + ' (' + Math.round(y * 1000) + ' above grade)');
      return b;
    }

    /* THE PERIMETER as four sides, each a run along an inner face with its
       inward normal; a point on the perimeter is (side, u) */
    var sides = PER.sides, NS = sides.length;
    if (!PER.rect) ctx.log('ELEC perimeter: ' + PER.note + ' (mep-v14) -- sides ' + sides.map(function (s9) { return s9.k + ' ' + (Math.round(s9.len * 100) / 100); }).join(', '));
    function onSide(x, z) {
      /* the side a point is nearest to, and its u along it */
      var best = null, bd = 1e9, q;
      for (q = 0; q < NS; q++) {
        var s = sides[q], u = (x - s.a[0]) * s.u[0] + (z - s.a[1]) * s.u[1];
        u = Math.max(0, Math.min(s.len, u));
        var px = s.a[0] + s.u[0] * u, pz = s.a[1] + s.u[1] * u, d = Math.hypot(px - x, pz - z);
        if (d < bd) { bd = d; best = { side: q, u: u, x: px, z: pz }; }
      }
      return best;
    }

    /* EXTERIOR DOORS on the perimeter, and the entrance (the first of them) */
    var extDoors = [];
    for (i = 0; i < SEG.length; i++) {
      var sg = SEG[i]; if (!sg || !sg.openings) continue;
      var ux = (sg.x1 - sg.x0) / sg.len, uz = (sg.z1 - sg.z0) / sg.len;
      for (j = 0; j < sg.openings.length; j++) {
        var o = sg.openings[j];
        /* EVERY OPENING THE SOCKET LINE WOULD CROSS (adu-v1359), not only the ones
           standing on the floor: a window whose sill is below the line, a
           full-height pane, a glazed wall -- the cable went straight through
           them (Marek: elektroinstalace vede pres otvor). Each is hopped over
           its own head, or through the ceiling where it reaches the plate. */
        var oSill = _sillOf(env, o), oTop = oSill + (o.h || 2.1);
        if (!(oSill < ELEC.h + 0.05 && oTop > ELEC.h - 0.05)) continue;
        var wx = sg.x0 + ux * o.at, wz = sg.z0 + uz * o.at, ps = onSide(wx, wz);
        extDoors.push({ side: ps.side, u: ps.u, x: ps.x, z: ps.z, w: o.w || 0.9, hand: o.hand || 'left',
                        door: (o.kind === 'door' || o.kind === 'french') && oSill <= 0.05, top: oTop });
      }
      /* the entrance is a door you walk through, not a pane that happens to reach the floor */
      extDoors.sort(function (d1, d2) { return (d2.door ? 1 : 0) - (d1.door ? 1 : 0); });
    }
    if (!UPS && (!extDoors.length || !extDoors[0].door)) {
      ctx.log('ELEC none -- no entrance door yet; the board goes beside the entrance, on the exterior wall, and there is no electrics before there is a board (Marek)');
      return;
    }
    ctx.log('ELEC socket line at ' + Math.round(ELEC.h * 1000) + ' hops ' + extDoors.length + ' opening(s) it would cross: ' +
            extDoors.map(function (d) { return (d.door ? 'door' : 'window') + ' to ' + Math.round(d.top * 1000); }).join(', ') +
            ' -- over each head, or through the ceiling where it reaches the plate');
    var B, yBrd, uB, ent, eS;
    if (UPS) {
      /* THE RISER (mep-v19): up the exterior wall over the board below, from
         the board's top to this floor; the circuits leave it here */
      var oR = onSide(UPB.board.x, UPB.board.z), sR = sides[oR.side];
      uB = Math.max(0.30, Math.min(sR.len - 0.30, oR.u));
      B = { side: oR.side, u: uB, x: sR.a[0] + sR.u[0] * uB, z: sR.a[1] + sR.u[1] * uB, nx: sR.n[0], nz: sR.n[1] };
      yBrd = y0; riserL = y0 - UPB.yBrd;
      LAST[LID] = null;
      _asmCode(ctx, ELEC.cable, 'top');
      run([[B.x, UPB.yBrd, B.z], [B.x, y0, B.z]], mCab);
      ctx.log('ELEC this storey is fed from the board of ' + env.riserFrom + ': every circuit up the exterior wall ' + sR.k + ' at ' + B.x.toFixed(2) + ',' + B.z.toFixed(2) +
              ', ' + (Math.round(riserL * 100) / 100) + ' m from the board\'s top to this floor a circuit; no board, no RCD, no grounding set here -- the breakers sit in that board');
    } else {
    ent = extDoors[0]; eS = sides[ent.side];
    /* THE BOARD beside the entrance on the hinge side: hand right = further
       along the side, left = back along it; a hand's clearance past the
       reveal; on the exterior wall's inner face */
    var sgnH = (ent.hand === 'right') ? 1 : -1;
    uB = ent.u + sgnH * (ent.w / 2 + ELEC.brdW / 2 + 0.15);
    uB = Math.max(ELEC.brdW / 2 + 0.15, Math.min(eS.len - ELEC.brdW / 2 - 0.15, uB));
    /* mep-v37: on the main floor -- over a raised one (env.floorAt) the
       other side of the door */
    if (FLA) {
      var brdOn = function (u) {
        var hw = ELEC.brdW / 2, xa = eS.a[0] + eS.u[0] * (u - hw), za = eS.a[1] + eS.u[1] * (u - hw), xb2 = eS.a[0] + eS.u[0] * (u + hw), zb2 = eS.a[1] + eS.u[1] * (u + hw);
        return !raisedAt(xa, za) && !raisedAt(xb2, zb2);
      };
      if (!brdOn(uB)) {
        var uB2 = Math.max(ELEC.brdW / 2 + 0.15, Math.min(eS.len - ELEC.brdW / 2 - 0.15, ent.u - sgnH * (ent.w / 2 + ELEC.brdW / 2 + 0.15)));
        if (brdOn(uB2)) { uB = uB2; RAISE.brd = 'on the other side of the door -- the hinge side stands over the raised floor'; }
        else RAISE.brd = '*** over the raised floor -- no place beside the entrance on the main floor';
      }
    }
    B = { side: ent.side, u: uB, x: eS.a[0] + eS.u[0] * uB, z: eS.a[1] + eS.u[1] * uB, nx: eS.n[0], nz: eS.n[1] };
    /* mep-v62: opt-in placement BEFORE circuits, meter and LAST are built.
       Products with a sloping envelope can choose another real inner face.
       No hook: retain the existing placement and quantities exactly. */
    var boardChoice = null;
    if (typeof env.boardPlacement === 'function') {
      boardChoice = env.boardPlacement({ proposed: B, sides: sides,
        width: ELEC.brdW, height: ELEC.brdH, depth: ELEC.brdT,
        centreY: y0 + ELEC.brdY, floorY: y0 });
      if (boardChoice && boardChoice.clear === true) {
        var bs = sides[boardChoice.side], bu = boardChoice.u;
        if (!bs || !Number.isFinite(bu) || bu < ELEC.brdW / 2 || bu > bs.len - ELEC.brdW / 2) throw new Error('Invalid electrical board placement');
        uB = bu; eS = bs;
        B = { side: boardChoice.side, u: bu, x: bs.a[0] + bs.u[0] * bu, z: bs.a[1] + bs.u[1] * bu, nx: bs.n[0], nz: bs.n[1] };
      } else {
        ctx.log('ELEC board CHECK: no verified mounting position; original position retained for review');
      }
    }
    /* mep-v33: under the US code the board drawn is the panel billed
       (EED00002, mep-v29) -- it was marked EED00001, a body with no row */
    _asmCode(ctx, (NEC && !NSVC) ? NEC_KIT.panel : ELEC.board, 'top');
    var boardMesh = device(B.x, B.z, B.nx, B.nz, y0 + ELEC.brdY, mBrd, 'elec-board', ELEC.brdW, ELEC.brdH, ELEC.brdT);
    if (boardChoice) boardMesh.userData.boardPlacement = boardChoice;
    yBrd = y0 + ELEC.brdY - ELEC.brdH / 2;
    LAST[LID] = { board: B, yBrd: yBrd };   /* mep-v2: read by the heating */
    /* mep-v27: under the US code the board is billed by the kit, once the
       spaces it needs are counted (EED00001, or the 40-space panel) */
    if (!NEC) _add(LID, ELEC.board, 1);
    if (!NEC) _add(LID, ELEC.rcd, 1);   /* mep-v25: no whole-house RCD under the US code -- GFCI breakers by circuit */
    ctx.log('ELEC board ' + ((NEC && !NSVC) ? NEC_KIT.panel : ELEC.board) + ' on the exterior wall ' + eS.k +
            (boardChoice ? ' (product placement: ' + (boardChoice.clear ? 'geometric clearance checked' : 'CHECK required') + ')' : ' beside the entrance (' + ent.hand + ' hand, ' + Math.round(Math.abs(uB - ent.u) * 1000) + ' mm from the door centre)') +
            ' at ' + B.x.toFixed(2) + ',' + B.z.toFixed(2) + (RAISE.brd ? (' -- ' + RAISE.brd + ' (mep-v37, env.floorAt)') : ''));
    }

    /* PARTITION CROSSINGS on the perimeter: a socket cannot sit where a
       partition meets the exterior wall */
    var parts = STATE.parts || [], cross = [];
    for (i = 0; i < parts.length; i++) {
      if (parts[i] && parts[i].sep) continue;     /* a room line is no wall in the way (adu-v1403) */
      var p = parts[i], spn = API.partSpan ? API.partSpan(p) : null;
      var lo = spn ? spn[0] : Math.min(p.a, p.b), hi = spn ? spn[1] : Math.max(p.a, p.b);
      var pv = (p.dir || p.o) === 'v', pc = (p.at != null) ? p.at : p.c;
      var ends = pv ? [[pc, lo], [pc, hi]] : [[lo, pc], [hi, pc]], e;
      for (e = 0; e < 2; e++) {
        var ps2 = onSide(ends[e][0], ends[e][1]);
        var dd2 = Math.hypot(ps2.x - ends[e][0], ps2.z - ends[e][1]);
        if (dd2 < 0.25) cross.push({ side: ps2.side, u: ps2.u });
      }
    }

    /* and where a SLANTED wall meets the exterior wall (adu-v1411): its
       footprint along the face is wider by the slant */
    var SLc = _slantRaw(), qc, ec;
    for (qc = 0; qc < SLc.length; qc++) {
      var gC = SLc[qc], endsC = [gC.a, gC.b];
      for (ec = 0; ec < 2; ec++) {
        var psC = onSide(endsC[ec][0], endsC[ec][1]);
        if (Math.hypot(psC.x - endsC[ec][0], psC.z - endsC[ec][1]) >= 0.25) continue;
        var cC = Math.abs(gC.ux * sides[psC.side].n[0] + gC.uz * sides[psC.side].n[1]);
        cross.push({ side: psC.side, u: psC.u, hw: (PART.d / 2) / Math.max(0.2, cC), slant: gC.id });
      }
    }

    /* A PATH ALONG THE PERIMETER, at height y, from one point on it to
       another, the shorter way round, hopping exterior doors when y is the
       socket line -- this is how every feed travels: on the walls, never
       through the air (Marek) */
    var perimLen = 0; for (i = 0; i < NS; i++) perimLen += sides[i].len;
    function uAbs(side, u) { var t = 0, q; for (q = 0; q < side; q++) t += sides[q].len; return t + u; }
    function ptAt(uA, y) {
      uA = ((uA % perimLen) + perimLen) % perimLen;
      var q, t = 0;
      for (q = 0; q < NS; q++) { if (uA <= t + sides[q].len + 1e-9) { var s = sides[q], u = uA - t; return [s.a[0] + s.u[0] * u, y, s.a[1] + s.u[1] * u]; } t += sides[q].len; }
      return [sides[NS - 1].b[0], y, sides[NS - 1].b[1]];
    }
    function perimPath(uFrom, uTo, y, hopDoors, forceDir) {
      var fwd = ((uTo - uFrom) % perimLen + perimLen) % perimLen, back = perimLen - fwd;
      /* forceDir (mep-v19): the way round a room's sockets that holds them all */
      var dir = forceDir || ((fwd <= back) ? 1 : -1), dist = (forceDir === 1) ? fwd : ((forceDir === -1) ? back : Math.min(fwd, back)), pts = [ptAt(uFrom, y)], t = 0;
      /* corners and doors on the way, in order */
      var marks = [], q;
      for (q = 0; q < NS; q++) marks.push({ u: uAbs(q, 0), kind: 'corner' });
      /* mep-v64 (TWO STORY thread, Marek 2026-11-03: the terrace doors):
         TWO OPENINGS CLOSER THAN TWICE THE KEEP-OFF ARE HOPPED AS ONE. Each
         was hopped on its own, so between a pair of doors 100 apart the line
         came down past the first door's edge and went up again inside its
         opening -- a cable through the glass. On one side, their hops merged,
         over the higher head. */
      if (hopDoors) {
        var hopI = [];
        for (q = 0; q < extDoors.length; q++) {
          var hU = uAbs(extDoors[q].side, extDoors[q].u), hH = extDoors[q].w / 2 + ELEC.keepOff;
          hopI.push({ a: hU - hH, b: hU + hH, top: extDoors[q].top || 2.1, side: extDoors[q].side });
        }
        hopI.sort(function (h1, h2) { return h1.a - h2.a; });
        var hopM = [];
        for (q = 0; q < hopI.length; q++) {
          var hL = hopM.length ? hopM[hopM.length - 1] : null;
          if (hL && hL.side === hopI[q].side && hopI[q].a <= hL.b + 0.001) { hL.b = Math.max(hL.b, hopI[q].b); hL.top = Math.max(hL.top, hopI[q].top); hL.n++; }
          else hopM.push({ a: hopI[q].a, b: hopI[q].b, top: hopI[q].top, side: hopI[q].side, n: 1 });
        }
        for (q = 0; q < hopM.length; q++) marks.push({ u: (hopM[q].a + hopM[q].b) / 2, kind: 'door', half: (hopM[q].b - hopM[q].a) / 2, top: hopM[q].top, n: hopM[q].n });
      }
      marks.sort(function (m1, m2) {
        var d1 = ((m1.u - uFrom) * dir % perimLen + perimLen) % perimLen, d2 = ((m2.u - uFrom) * dir % perimLen + perimLen) % perimLen;
        return d1 - d2;
      });
      for (q = 0; q < marks.length; q++) {
        var m = marks[q], dm = ((m.u - uFrom) * dir % perimLen + perimLen) % perimLen;
        if (dm <= 0.001 || dm >= dist - 0.001) continue;
        if (m.kind === 'corner') pts.push(ptAt(m.u, y));
        else {
          var half = (m.half != null) ? m.half : (m.w / 2 + ELEC.keepOff);
          /* over its own head, 100 above it, and never higher than the ceiling line */
          var yHop = Math.min(yCeil, Math.max(yHead, y0 + (m.top || 2.1) + 0.10));
          pts.push(ptAt(m.u - dir * half, y)); pts.push(ptAt(m.u - dir * half, yHop));
          pts.push(ptAt(m.u + dir * half, yHop)); pts.push(ptAt(m.u + dir * half, y));
        }
      }
      pts.push(ptAt(uTo, y));
      return pts;
    }
    var uBoard = uAbs(B.side, B.u);

    /* SOCKETS along every side: free runs between corners, exterior doors,
       partition crossings and the board; evenly within a run at no more than
       2.2 m; then the wet room keeps one */
    var socketsAll = [], nInner = 0;
    for (i = 0; i < NS; i++) {
      if (sides[i].inner) { nInner++; continue; }   /* mep-v67: no box in a party wall (env.innerSide) */
      var s3 = sides[i], blocks = [[-1, ELEC.corner], [s3.len - ELEC.corner, s3.len + 1]], q2;
      var dsS = extDoors.filter(function (d) { return d.side === i; });
      for (q2 = 0; q2 < dsS.length; q2++) blocks.push([dsS[q2].u - dsS[q2].w / 2 - ELEC.keepOff, dsS[q2].u + dsS[q2].w / 2 + ELEC.keepOff]);
      var crS = cross.filter(function (c) { return c.side === i; });
      for (q2 = 0; q2 < crS.length; q2++) blocks.push([crS[q2].u - (crS[q2].hw || PART.d / 2) - ELEC.corner, crS[q2].u + (crS[q2].hw || PART.d / 2) + ELEC.corner]);
      if (B.side === i) blocks.push([B.u - ELEC.brdW / 2 - 0.1, B.u + ELEC.brdW / 2 + 0.1]);
      blocks.sort(function (p1, p2) { return p1[0] - p2[0]; });
      var runs = [], cur = 0, bq;
      for (bq = 0; bq < blocks.length; bq++) { if (blocks[bq][0] > cur + 0.25) runs.push([cur, blocks[bq][0]]); cur = Math.max(cur, blocks[bq][1]); }
      if (s3.len > cur + 0.25) runs.push([cur, s3.len]);
      var rq;
      for (rq = 0; rq < runs.length; rq++) {
        var rl = runs[rq][1] - runs[rq][0], nS = Math.max(1, Math.round(rl / ELEC.step)), stp = rl / (nS + 1), sq;
        for (sq = 1; sq <= nS; sq++) {
          var u = runs[rq][0] + stp * sq;
          socketsAll.push({ side: i, u: u, uA: uAbs(i, u), x: s3.a[0] + s3.u[0] * u, z: s3.a[1] + s3.u[1] * u, nx: s3.n[0], nz: s3.n[1] });
        }
      }
    }
    /* SOCKETS THE PRODUCT ASKS FOR (mep-v20, env.extraSockets -- a fan coil):
       on the exterior wall nearest each point, kept off a doorway */
    var extraLog = [];
    if (typeof env.extraSockets === 'function') {
      var XS = [];
      try { XS = env.extraSockets() || []; } catch (eXS) { XS = []; }
      for (i = 0; i < XS.length; i++) {
        var xp = XS[i]; if (!xp || xp.x == null) continue;
        var psX = onSide(xp.x, xp.z), sX = sides[psX.side], uX = Math.max(ELEC.corner, Math.min(sX.len - ELEC.corner, psX.u)), dX;
        for (dX = 0; dX < extDoors.length; dX++) {
          var eD = extDoors[dX];
          if (eD.side === psX.side && Math.abs(uX - eD.u) < eD.w / 2 + ELEC.keepOff) uX = eD.u + ((uX >= eD.u) ? 1 : -1) * (eD.w / 2 + ELEC.keepOff + 0.05);
        }
        uX = Math.max(ELEC.corner, Math.min(sX.len - ELEC.corner, uX));
        socketsAll.push({ side: psX.side, u: uX, uA: uAbs(psX.side, uX), x: sX.a[0] + sX.u[0] * uX, z: sX.a[1] + sX.u[1] * uX, nx: sX.n[0], nz: sX.n[1], extra: xp.what || 'the product' });
        extraLog.push((xp.what || 'a point') + ' at ' + (sX.a[0] + sX.u[0] * uX).toFixed(2) + ',' + (sX.a[1] + sX.u[1] * uX).toFixed(2) + ' on wall ' + sX.k);
      }
    }
    /* which room each socket faces, and the wet room's single socket */
    var R = [];
    for (i = 0; i < rooms.length; i++) {
      var rc = null, bA = -1;
      for (j = 0; j < (rooms[i].rects || []).length; j++) { var r0 = rooms[i].rects[j], a0 = (r0.x1 - r0.x0) * (r0.z1 - r0.z0); if (a0 > bA) { bA = a0; rc = r0; } }
      if (!rc) continue;
      var nm = PL.roomName ? PL.roomName(rooms[i], i) : '';
      /* a closet goes by what it is, not by a name it borrowed (adu-v1415) */
      var clo = !!rooms[i].closet;
      if (clo) nm = _roomLabel(rooms[i], i);
      /* a sauna hot room, as the product names it (mep-v12, env.hotRoom) */
      var hot = false;
      if (!clo && typeof env.hotRoom === 'function') { try { hot = !!env.hotRoom(rooms[i], i); } catch (eHot) { hot = false; } }
      R.push({ i: i, name: nm, rects: rooms[i].rects, big: rc, area: bA, wet: !clo && !hot && /bath|shower|toilet|wc/i.test(nm), closet: clo, hot: hot, sockets: [], doors: [] });
    }
    function roomOf(x, z) {
      var q3, j3;
      for (q3 = 0; q3 < R.length; q3++) for (j3 = 0; j3 < R[q3].rects.length; j3++) {
        var rr = R[q3].rects[j3];
        if (x >= rr.x0 - 0.01 && x <= rr.x1 + 0.01 && z >= rr.z0 - 0.01 && z <= rr.z1 + 0.01) return R[q3];
      }
      return null;
    }
    /* the same, but a point in a wedge a slanted wall cut off is in the
       room it really belongs to, not the rectangle it lies in (adu-v1414) */
    function roomOfS(x, z) {
      var wq = _wedgeRoomAt(x, z), q3;
      if (wq >= 0) for (q3 = 0; q3 < R.length; q3++) if (R[q3].i === wq) return R[q3];
      return roomOf(x, z);
    }
    for (i = 0; i < socketsAll.length; i++) {
      var sk = socketsAll[i], rm0 = roomOfS(sk.x + sk.nx * 0.05, sk.z + sk.nz * 0.05);
      /* a closet has no socket circuit of its own (adu-v1415) */
      if (rm0 && rm0.closet) { tally.closetSk = (tally.closetSk || 0) + 1; continue; }
      /* nor a sauna hot room: no socket where it is 90 degrees (mep-v12) */
      if (rm0 && rm0.hot) { tally.hotSk = (tally.hotSk || 0) + 1; continue; }
      if (rm0) rm0.sockets.push(sk);
    }
    if (extraLog.length) ctx.log('ELEC extra socket(s) ' + extraLog.length + ' (mep-v20, on the room\'s socket circuit): ' + extraLog.join('; '));
    for (i = 0; i < R.length; i++) {
      if (R[i].wet && R[i].sockets.length > 1) {
        /* keep the one nearest the middle of its run */
        R[i].sockets.sort(function (p1, p2) { return p1.u - p2.u; });
        var keep = R[i].sockets[Math.floor(R[i].sockets.length / 2)];
        R[i].sockets = [keep];
      }
      for (j = 0; j < R[i].sockets.length; j++) {
        var sk2 = R[i].sockets[j];
        _asmCode(ctx, ELEC.socket, 'top');
        var ySk = floorUnder(sk2.x, sk2.z) + ELEC.h;   /* mep-v37 */
        if (ySk > yLine + 0.02) RAISE.sk++;
        withBox(wdev(sk2.x, sk2.z, sk2.nx, sk2.nz, ySk, mDev, 'elec-socket', ELEC.boxW, ELEC.boxH, ELEC.boxT));
        tally.sockets++;
      }
      /* THE ROOM'S OWN CIRCUIT: from the board along the perimeter at head
         height to the room's first socket, down to the line, then socket to
         socket along the room's exterior walls (doors hopped); nothing joins
         the next room (Marek) */
      if (R[i].sockets.length) {
        R[i].sockets.sort(function (p1, p2) { return ((p1.uA - uBoard) % perimLen + perimLen) % perimLen - ((p2.uA - uBoard) % perimLen + perimLen) % perimLen; });
        var first = R[i].sockets[0], last = R[i].sockets[R[i].sockets.length - 1];
        /* the nearer end of the room's run is the entry */
        var dF = Math.min(((first.uA - uBoard) % perimLen + perimLen) % perimLen, ((uBoard - first.uA) % perimLen + perimLen) % perimLen);
        var dL = Math.min(((last.uA - uBoard) % perimLen + perimLen) % perimLen, ((uBoard - last.uA) % perimLen + perimLen) % perimLen);
        var entryS = (dF <= dL) ? first : last, farS = (dF <= dL) ? last : first, runDir = 0, twoLeg = false, aS = null, zS = null;
        /* THE RUN HOLDS ALL THE ROOM'S SOCKETS (mep-v19 upstairs, mep-v21
           everywhere): the perimeter less the widest gap between two of them,
           fed at its end nearer the board; the shorter way between the ends
           sorted from the board crossed the board's own gap in the entrance
           room and in a room round most of the house */
        if (R[i].sockets.length > 2) {
          var srt = R[i].sockets.slice().sort(function (p1, p2) { return p1.uA - p2.uA; }), gMax = -1, gK = 0, gq;
          for (gq = 0; gq < srt.length; gq++) {
            var nxtS = srt[(gq + 1) % srt.length], gap = ((nxtS.uA - srt[gq].uA) % perimLen + perimLen) % perimLen;
            if (gq === srt.length - 1 && gap < 1e-9) gap = perimLen;
            if (gap > gMax) { gMax = gap; gK = gq; }
          }
          aS = srt[(gK + 1) % srt.length]; zS = srt[gK];
          /* THE BOARD IN THE ROOM'S OWN RUN (the entrance room): two legs leave
             the board, one each way to the run's ends -- no metre twice */
          var Larc = ((zS.uA - aS.uA) % perimLen + perimLen) % perimLen, offB = ((uBoard - aS.uA) % perimLen + perimLen) % perimLen;
          if (offB > 0.001 && offB < Larc - 0.001) twoLeg = true;
          else {
            var dA = Math.min(((aS.uA - uBoard) % perimLen + perimLen) % perimLen, ((uBoard - aS.uA) % perimLen + perimLen) % perimLen);
            var dZ = Math.min(((zS.uA - uBoard) % perimLen + perimLen) % perimLen, ((uBoard - zS.uA) % perimLen + perimLen) % perimLen);
            if (dA <= dZ) { entryS = aS; farS = zS; runDir = 1; } else { entryS = zS; farS = aS; runDir = -1; }
          }
        }
        if (twoLeg) {
          _asmCode(ctx, ELEC.cable, 'top');
          var cL2 = run(lifted([[B.x, yBrd, B.z], [B.x, yLine, B.z]].concat(perimPath(uBoard, aS.uA, yLine, true, -1))), mCab) +
                    run(lifted([[B.x, yBrd, B.z], [B.x, yLine, B.z]].concat(perimPath(uBoard, zS.uA, yLine, true, 1))), mCab) + 2 * riserL;
          if (UPS) nRise += 2;
          branchBox(B.x + B.nx * 0.03, yLine + 0.16, B.z + B.nz * 0.03, 'circuit tap for ' + (R[i].name || ('room ' + i)) + ' (two legs, the board stands in its run)');
          tally.cable += cL2;
          R[i].feedM = cL2; R[i].runM = 0; R[i].twoLeg = true;
          continue;
        }
        /* the feed at the socket line too: 300 above the floor sits under
           every sill, so no cable crosses a window; doors are hopped (Marek) */
        var feedPts = [[B.x, yBrd, B.z], [B.x, yLine, B.z]].concat(perimPath(uBoard, entryS.uA, yLine, true));
        _asmCode(ctx, ELEC.cable, 'top');
        var cF = run(lifted(feedPts), mCab) + riserL;
        if (UPS) nRise++;
        /* the tap that starts this room's circuit, on the wall where the feed
           reaches its first socket (surface variant) */
        branchBox(entryS.x + entryS.nx * 0.03, yLine + 0.16, entryS.z + entryS.nz * 0.03,
                  'circuit tap for ' + (R[i].name || ('room ' + i)));
        var cR = (R[i].sockets.length > 1) ? run(lifted(perimPath(entryS.uA, farS.uA, yLine, true, runDir)), mCab) : 0;
        tally.cable += cF + cR;
        R[i].feedM = cF; R[i].runM = cR;
      }
    }

    /* DOORS per room, interior first: the switch goes beside the interior
       door on the handle side inside the room; a room with no interior door
       takes its exterior door */
    var doors = STATE.doors || [];
    /* mep-v57 (RANCH thread, opt-in env.doorSeam): a door whose middle falls
       on the seam between two of a room's rects was on neither -- the strict
       test left RANCH's second bathroom with no door, so no switch (billed
       or drawn) and nowhere for its fan's switch. With the flag the seam
       counts. */
    var dSeam = (env.doorSeam === true) ? 1e-4 : 0;
    for (i = 0; i < doors.length; i++) {
      var d = doors[i], pp = null;
      for (j = 0; j < parts.length; j++) if (parts[j].id === d.pid) pp = parts[j];
      if (!pp) continue;
      var vert = (pp.dir || pp.o) === 'v', pcD = (pp.at != null) ? pp.at : pp.c;
      var dx = vert ? pcD : d.u, dz = vert ? d.u : pcD, hitsD = [];
      for (k = 0; k < R.length; k++) {
        /* the door lies on the edge of ANY of this room's rects -- the
           largest one alone missed the doors of every shaped room (Marek:
           no switches beyond the first room) */
        var rq2, hit = false, intoD = 1;
        for (rq2 = 0; rq2 < R[k].rects.length && !hit; rq2++) {
          var rb = R[k].rects[rq2];
          var onEdge = vert ? (Math.abs(dx - rb.x0) < 0.06 || Math.abs(dx - rb.x1) < 0.06) && dz > rb.z0 - dSeam && dz < rb.z1 + dSeam
                            : (Math.abs(dz - rb.z0) < 0.06 || Math.abs(dz - rb.z1) < 0.06) && dx > rb.x0 - dSeam && dx < rb.x1 + dSeam;
          if (onEdge) { hit = true; intoD = vert ? (dx <= rb.x0 + 0.06 ? 1 : -1) : (dz <= rb.z0 + 0.06 ? 1 : -1); }
        }
        if (hit) hitsD.push({ r: R[k], into: intoD });
      }
      /* each side knows the room on the other (adu-v1414): the door IN is
         the one from the hall, not the one into a closet. A door with the
         same room on both sides stands inside it. */
      for (k = 0; k < hitsD.length; k++)
        hitsD[k].r.doors.push({ x: dx, z: dz, w: d.w || 0.9, vert: vert, ext: false, into: hitsD[k].into, other: (hitsD.length === 2) ? hitsD[1 - k].r : ((hitsD.length === 1) ? hitsD[0].r : null) });
    }
    /* AND THE DOORS IN THE SLANTED WALLS (adu-v1411): a way into the room
       on each side of it -- unless both sides are the same room, when the
       door only leads into a corner of it. The rooms either side are
       named in the log: two names is a wall between two rooms, one name
       twice is a wall standing inside one room. */
    var SLd = _slantRaw(), gq, gk;
    for (gq = 0; gq < SLd.length; gq++) {
      var gD = SLd[gq], pqD = PART.d / 2 + 0.15, saidD = [];
      var rPm = roomOfS(gD.mx + gD.nx * pqD, gD.mz + gD.nz * pqD), rMm = roomOfS(gD.mx - gD.nx * pqD, gD.mz - gD.nz * pqD);
      var endsD = [{ x: gD.a[0], z: gD.a[1], ox: -gD.ux, oz: -gD.uz }, { x: gD.b[0], z: gD.b[1], ox: gD.ux, oz: gD.uz }];
      for (gk = 0; gk < gD.doors.length; gk++) {
        var gdr = gD.doors[gk], gxD = gD.a[0] + gD.ux * gdr.u, gzD = gD.a[1] + gD.uz * gdr.u, wD = gdr.w || 0.8;
        /* the rooms the WALL sees, asked at its middle: at a door near an
           end the corner it cuts off narrows to nothing, and a probe a hand
           away lands in the room next door */
        var sPD = rPm, sMD = rMm;
        if (sPD && sMD && sPD === sMD) { saidD.push('door ' + Math.round(wD * 1000) + ' inside ' + (sPD.name || 'one room') + ' -- not a way in'); continue; }
        /* the latch side is the hand: a leaf hinged at b (sw bit 0) closes
           on a, so the switch is looked for toward a first */
        var kdD = String(gdr.kind || 'hinged'), handD = (kdD === 'hinged') ? (((gdr.sw | 0) & 1) ? 'left' : 'right') : undefined;
        if (sPD) sPD.doors.push({ x: gxD, z: gzD, w: wD, slant: true, ux: gD.ux, uz: gD.uz, nx: gD.nx, nz: gD.nz, ext: false, into: 1, u: gdr.u, len: gD.len, ends: endsD, hand: handD, other: sMD });
        if (sMD) sMD.doors.push({ x: gxD, z: gzD, w: wD, slant: true, ux: gD.ux, uz: gD.uz, nx: -gD.nx, nz: -gD.nz, ext: false, into: 1, u: gdr.u, len: gD.len, ends: endsD, hand: handD, other: sPD });
        saidD.push('door ' + Math.round(wD * 1000) + ' between ' + (sMD ? (sMD.name || 'a room') : 'no room') + ' and ' + (sPD ? (sPD.name || 'a room') : 'no room'));
      }
      ctx.log('ELEC slanted wall ' + gD.id + ': ' + (rMm ? (rMm.name || 'a room') : 'no room') + ' on one side, ' + (rPm ? (rPm.name || 'a room') : 'no room') + ' on the other' +
              ((rMm && rMm === rPm) ? ' -- the same room both sides: the rooms are cut by the square walls only, and this one stands inside a room' : '') +
              (saidD.length ? (' | ' + saidD.join(' | ')) : ' | no door'));
    }
    for (i = 0; i < extDoors.length; i++) {
      var ed = extDoors[i], rmE = roomOfS(ed.x + sides[ed.side].n[0] * 0.05, ed.z + sides[ed.side].n[1] * 0.05);
      if (rmE) rmE.doors.push({ x: ed.x, z: ed.z, w: ed.w, vert: (sides[ed.side].k === 'x0' || sides[ed.side].k === 'x1'), ext: true, into: (sides[ed.side].k === 'x0' || sides[ed.side].k === 'z0') ? 1 : -1, hand: ed.hand });
    }

    /* THE ROOM LINES EACH ROOM IS OPEN ACROSS (adu-v1414) -- with its doors,
       how many ways a room has: a hall has several, a closet one. A line
       with the same room both sides (a hall and its own corner past a
       slanted wall) is no way anywhere. */
    for (i = 0; i < parts.length; i++) {
      var pl9 = parts[i], spl = null;
      if (!pl9 || !pl9.sep) continue;
      try { spl = API.partSpan ? API.partSpan(pl9) : null; } catch (eL9) { spl = null; }
      if (!spl) continue;
      var vl9 = (pl9.dir || pl9.o) === 'v', cl9 = (pl9.at != null) ? pl9.at : pl9.c, ml9 = (spl[0] + spl[1]) / 2;
      var rA9 = roomOfS(vl9 ? cl9 - 0.06 : ml9, vl9 ? ml9 : cl9 - 0.06), rB9 = roomOfS(vl9 ? cl9 + 0.06 : ml9, vl9 ? ml9 : cl9 + 0.06);
      if (rA9 && rB9 && rA9 !== rB9) { rA9.lines = (rA9.lines || 0) + 1; rB9.lines = (rB9.lines || 0) + 1; }
    }

    /* A ROOM OPEN TO THE NEXT ONE HAS NO DOOR, AND ITS WAY IN IS THE ROOM LINE
       (adu-v1405). The kitchen open to the living room used to get its switch
       beside the doorway the import closed it with; with a room line there is
       no doorway and it came out NO SWITCH. The switch goes where the line
       runs into a wall: on that wall's face, just beside the line, in the
       room -- one spot for each end and each side, tried after the doors. */
    var SEPW = [];
    for (i = 0; i < parts.length; i++) {
      var ps9 = parts[i];
      if (!ps9 || !ps9.sep) continue;
      var sp9 = API.partSpan ? API.partSpan(ps9) : null;
      if (!sp9) continue;
      var v9 = (ps9.dir || ps9.o) === 'v', c9 = (ps9.at != null) ? ps9.at : ps9.c, e9, s9;
      for (e9 = 0; e9 < 2; e9++) {
        var end9 = e9 ? sp9[1] : sp9[0], inw = e9 ? -1 : 1, crossed = false, q9;
        /* the wall it meets: a partition across it (face half a stud in), or the shell (its face is the end) */
        for (q9 = 0; q9 < parts.length; q9++) {
          var o9 = parts[q9];
          if (!o9 || o9.sep || ((o9.dir || o9.o) === 'v') === v9) continue;
          if (Math.abs(((o9.at != null) ? o9.at : o9.c) - end9) < 0.06) { crossed = true; break; }
        }
        var face = end9 + inw * ((crossed ? PART.d / 2 : 0) + 0.005);
        for (s9 = -1; s9 <= 1; s9 += 2) {
          SEPW.push({ x: v9 ? c9 + s9 * (ELEC.swOff + 0.04) : face, z: v9 ? face : c9 + s9 * (ELEC.swOff + 0.04),
                      nx: v9 ? 0 : inw, nz: v9 ? inw : 0 });
        }
      }
    }

    /* A SAUNA HOT ROOM (mep-v12): no socket, no ceiling light, no switch --
       the heater set brings its IP65 light, switched at the heater's control
       unit. The heater has a circuit of its own: the control unit outside
       the hot room's door, on its latch side if that side is in the next
       room, 1500 up; the feed from the board by the lamps' route (up the
       board's wall, along the perimeter at the ceiling, across to it, down);
       a 30 A double pole breaker. No interior door: the control unit beside
       the board. The silicone cable on from the control unit to the heater
       is in the heater set. */
    function hotCircuit(rmH) {
      var dI = null, q8, sg8, best8 = null;
      for (q8 = 0; q8 < rmH.doors.length && !dI; q8++) if (!rmH.doors[q8].ext) dI = rmH.doors[q8];
      var cxH, czH, nxH, nzH, where;
      if (dI) {
        var intoH = dI.into || 1;
        var Nx = dI.slant ? dI.nx : (dI.vert ? intoH : 0), Nz = dI.slant ? dI.nz : (dI.vert ? 0 : intoH);
        var Ax = dI.slant ? dI.ux : (dI.vert ? 0 : 1), Az = dI.slant ? dI.uz : (dI.vert ? 1 : 0);
        var off = PART.d / 2 + 0.005, along = (dI.w || 0.8) / 2 + 0.15 + ELEC.ctrlW / 2;
        for (sg8 = -1; sg8 <= 1; sg8 += 2) {
          var px8 = dI.x - Nx * off + Ax * sg8 * along, pz8 = dI.z - Nz * off + Az * sg8 * along;
          var r8 = roomOfS(px8 - Nx * 0.10, pz8 - Nz * 0.10);
          var ok8 = !!(r8 && !r8.hot && (!dI.other || r8 === dI.other));
          if (!best8 || (ok8 && !best8.ok)) best8 = { x: px8, z: pz8, ok: ok8, r: r8 };
        }
        cxH = best8.x; czH = best8.z; nxH = -Nx; nzH = -Nz;
        where = 'outside its door in ' + (best8.r ? (best8.r.name || 'the next room') : 'no room') + (best8.ok ? '' : ' (*** neither side of the door is in the next room)');
      } else {
        var sB = sides[B.side], aB = (B.u + ELEC.brdW / 2 + 0.10 + ELEC.ctrlW / 2 <= sB.len) ? 1 : -1;
        cxH = B.x + sB.u[0] * aB * (ELEC.brdW / 2 + 0.10 + ELEC.ctrlW / 2);
        czH = B.z + sB.u[1] * aB * (ELEC.brdW / 2 + 0.10 + ELEC.ctrlW / 2);
        nxH = B.nx; nzH = B.nz;
        where = 'beside the board (no interior door into the hot room)';
      }
      var yCtl = y0 + ELEC.ctrlY;
      device(cxH, czH, nxH, nzH, yCtl, mDev, 'elec-sauna-control', ELEC.ctrlW, ELEC.ctrlH, ELEC.ctrlT);
      var nearH = onSide(cxH, czH), uNH = uAbs(nearH.side, nearH.u);
      var fpH = [[B.x, yBrd, B.z], [B.x, yCeil, B.z]].concat(perimPath(uBoard, uNH, yCeil, false));
      fpH.push([cxH, yCeil, czH]); fpH.push([cxH, yCtl + ELEC.ctrlH / 2, czH]);
      _asmCode(ctx, ELEC.heavy, 'top');
      var LH = run(fpH, mCab) + riserL;
      if (UPS) nRise++;
      tally.heavy += LH; tally.hotFed++;
      hotLog.push((rmH.name || 'the hot room') + ': control unit ' + where + ' at ' + cxH.toFixed(2) + ',' + czH.toFixed(2) + ', ' + Math.round(ELEC.ctrlY * 1000) + ' up; feed ' + (Math.round(LH * 10) / 10) + ' m ' + ELEC.heavy);
    }

    /* LIGHTS in the middle, SWITCHES beside the door in, cable by the ceiling */
    var hotLog = [], gridLog = [];
    tally.heavy = 0; tally.hotFed = 0;
    for (i = 0; i < R.length; i++) {
      if (R[i].hot) { hotCircuit(R[i]); tally.rooms++; continue; }
      var rm = R[i], F = PL.roomFaces((rm.big.x0 + rm.big.x1) / 2, (rm.big.z0 + rm.big.z1) / 2) || rm.big;
      /* over the room's centroid -- all its rects, area weighted -- not the
         middle of its largest rect (Marek) */
      var cxA = 0, czA = 0, aA = 0, rq3;
      for (rq3 = 0; rq3 < rm.rects.length; rq3++) {
        var rr3 = rm.rects[rq3], a3 = (rr3.x1 - rr3.x0) * (rr3.z1 - rr3.z0);
        cxA += a3 * (rr3.x0 + rr3.x1) / 2; czA += a3 * (rr3.z0 + rr3.z1) / 2; aA += a3;
      }
      var cx = aA > 0 ? cxA / aA : (F.x0 + F.x1) / 2, cz = aA > 0 ? czA / aA : (F.z0 + F.z1) / 2, nL = aA > 20 ? 2 : 1, lq;
      /* mep-v27 (env.lightGrid, BARNDO thread): A ROOM LIT BY ITS AREA -- the
         product hands back { cols, rows, code, len } for a room it lights in
         a grid (the barndo's shop: an LED shop light every 100 sq ft); the
         lamps stand at the grid's centres, the first fed as any lamp, the
         rest chained lamp to lamp at the ceiling, serpentine, billed under
         the product's code. A product without the hook: as before. */
      var GRD = null;
      if (typeof env.lightGrid === 'function') {
        try { GRD = env.lightGrid(rooms[rm.i], rm.i, { x0: F.x0, x1: F.x1, z0: F.z0, z1: F.z1, area: aA }); } catch (eGr) { GRD = null; }
        if (GRD && (GRD.cols | 0) >= 1 && (GRD.rows | 0) >= 1 && GRD.code) nL = (GRD.cols | 0) * (GRD.rows | 0); else GRD = null;
      }
      var lampAt = [], lampRun = [], gPrev = null;
      for (lq = 0; lq < nL; lq++) {
        var lx = nL === 1 ? cx : (cx + (lq ? 1 : -1) * (F.x1 - F.x0) * 0.25), lz = cz;
        if (GRD) {
          var gr = Math.floor(lq / GRD.cols), gc = lq % GRD.cols;
          if (gr % 2) gc = GRD.cols - 1 - gc;
          lx = F.x0 + (F.x1 - F.x0) * (gc + 0.5) / GRD.cols;
          lz = F.z0 + (F.z1 - F.z0) * (gr + 0.5) / GRD.rows;
        }
        _asmCode(ctx, GRD ? GRD.code : ELEC.light, 'top');
        /* the ceiling over the lamp (mep-v19, env.ceilAt): a roof slope over
           an upper storey */
        var yLp = yCeil, yRunL = yCeil;
        if (typeof env.ceilAt === 'function') {
          var yC9 = null;
          try { yC9 = env.ceilAt(lx, lz); } catch (eC9) { yC9 = null; }
          if (typeof yC9 === 'number' && isFinite(yC9) && yC9 > yCeil && yC9 < yCeil + 6) yLp = yC9;
        }
        /* mep-v22: a lower ceiling over the lamp (env.ceilLowAt, under a loft):
           the lamp and its whole run at that ceiling */
        if (typeof env.ceilLowAt === 'function') {
          var yL9 = null;
          try { yL9 = env.ceilLowAt(lx, lz); } catch (eL9) { yL9 = null; }
          if (typeof yL9 === 'number' && isFinite(yL9) && yL9 < yCeil - 0.05 && yL9 > y0 + 1.8) { yLp = yL9; yRunL = yL9; nLow++; }
        }
        var lamp;
        if (GRD) {
          /* a 4 ft shop light along the room's longer side, hung a little under the ceiling line */
          var gLen = GRD.len || 1.22, alongX = (F.x1 - F.x0) >= (F.z1 - F.z0);
          lamp = new T.Mesh(new T.BoxGeometry(alongX ? gLen : 0.16, 0.06, alongX ? 0.16 : gLen), mLamp);
          lamp.position.set(lx, yLp - 0.10, lz);
        } else {
          lamp = new T.Mesh(new T.CylinderGeometry(0.14, 0.14, 0.04, 20), mLamp);
          lamp.position.set(lx, yLp - 0.02, lz);
        }
        lamp.name = 'elec-light'; lamp.userData.viz = vizTag; g.add(lamp); withBox(lamp);
        lampAt.push([lx, lz]); lampRun.push(yRunL);
        if (GRD && gPrev) {
          /* chained from the lamp before it, at the ceiling */
          _asmCode(ctx, ELEC.cable, 'top');
          tally.cable += run([[gPrev[0], yRunL, gPrev[1]], [lx, yRunL, gPrev[1]], [lx, yRunL, lz]], mLit);
          tally.lights++; tally.grid = tally.grid || {}; tally.grid[GRD.code] = (tally.grid[GRD.code] || 0) + 1;
          gPrev = [lx, lz];
          continue;
        }
        /* up the board's wall to the ceiling, along the perimeter at the
           ceiling to the point nearest the lamp, then across the ceiling void
           to it */
        var near = onSide(lx, lz), uN = uAbs(near.side, near.u);
        var lp = [[B.x, yBrd, B.z], [B.x, yRunL, B.z]].concat(perimPath(uBoard, uN, yRunL, false));
        lp.push([lx, yRunL, lz]);
        if (yLp > yCeil + 0.005) lp.push([lx, yLp - 0.04, lz]);
        /* the tap-off: the lighting run leaves the wall here and crosses to
           the lamp, so the branch is made in a box and not in mid-air (surface variant) */
        branchBox(near.x, yRunL, near.z, 'lamp tap ' + (lq + 1) + ' in ' + (rm.name || ('room ' + i)));
        _asmCode(ctx, ELEC.cable, 'top');
        tally.cable += run(lp, mLit) + riserL;
        if (UPS) nRise++;
        tally.lights++;
        if (GRD) { tally.grid = tally.grid || {}; tally.grid[GRD.code] = (tally.grid[GRD.code] || 0) + 1; gPrev = [lx, lz]; }
      }
      if (GRD) gridLog.push((rm.name || ('room ' + i)) + ' ' + Math.round(aA * 10) / 10 + ' m2: ' + nL + ' x ' + GRD.code + ' (' + GRD.cols + ' x ' + GRD.rows + '), chained');
      /* ONE SWITCH, ONE LIGHT, IN ITS OWN ROOM. The door in is tried
         interior first; the spot beside it is checked to lie in this room
         (a door is shared by two rooms and the side was read off the wrong
         rect once), the other side is tried, then the next door (Marek). */
      var din = null, sx = 0, sz = 0, nx = 0, nz = 0, placed = false, order = [], dq;
      /* the way in: the entrance where the room has one, else the interior door (Marek) */
      for (j = 0; j < rm.doors.length; j++) if (rm.doors[j].ext) order.push(rm.doors[j]);
      /* THE INTERIOR DOOR IN IS THE ONE FROM WHERE PEOPLE COME (adu-v1414):
         a door from a room with more ways than this door -- a hall, the
         living space -- before a door into a dead end like a closet, and a
         door standing inside the room itself last. The bedroom's switch
         went to its closet door. The names are not asked: the plan's
         reading calls a closet an entry as readily as a hall. */
      var intO = [];
      for (j = 0; j < rm.doors.length; j++) {
        var dO = rm.doors[j];
        if (dO.ext) continue;
        var oO = dO.other, rkO = 1;
        if (oO === rm) rkO = 3;
        else if (oO) rkO = (((oO.doors || []).length + (oO.lines || 0)) >= 2) ? 0 : 2;
        intO.push({ d: dO, k: j, r: rkO });
      }
      intO.sort(function (o1, o2) { return (o1.r - o2.r) || (o1.k - o2.k); });
      for (j = 0; j < intO.length; j++) order.push(intO[j].d);
      /* mep-v58 (opt-in env.devFace): A SWITCH BESIDE A DOOR BY A CORNER IS
         IN THE ROOM, NOT IN THE OUTER WALL. The room's rects reach the
         outline, so a door 300 from the shell left the handle side's switch
         inside the wall (a block house's bedroom, 45 mm from the outline):
         along its wall it keeps 100 clear of the shell's frame, or the other
         hand / the next way is tried */
      function clearShell(x, z, ax, az) {
        if (typeof env.devFace !== 'function') return true;
        for (var q5 = 0; q5 < sides.length; q5++) {
          var S5 = sides[q5];
          if (Math.abs(S5.n[0] * ax + S5.n[1] * az) < 0.8) continue;
          var u5 = (x - S5.a[0]) * S5.u[0] + (z - S5.a[1]) * S5.u[1];
          if (u5 < -0.05 || u5 > S5.len + 0.05) continue;
          if ((x - S5.a[0]) * S5.n[0] + (z - S5.a[1]) * S5.n[1] < 0.10) { FCE.shell++; return false; }
        }
        return true;
      }
      function inOwn(x, z) {
        var q4, wq4 = _wedgeRoomAt(x, z);
        /* a wedge past a slanted wall is the room it opens into (adu-v1414) */
        if (wq4 >= 0) return wq4 === rm.i;
        for (q4 = 0; q4 < rm.rects.length; q4++) {
          var r4 = rm.rects[q4];
          if (x >= r4.x0 - 0.01 && x <= r4.x1 + 0.01 && z >= r4.z0 - 0.01 && z <= r4.z1 + 0.01) return true;
        }
        return false;
      }
      /* A DOOR WITH NO ROOM BESIDE IT (adu-v1413). A narrow room with a wide
         door -- a 0.81 door in a 1.13 bathroom -- left no 150 mm beside the
         opening on either hand, and the room went without a switch. The
         doors are tried again tight to the frame: the lining's 60 mm and
         half the box. Then the wall square to the door's, just round the
         corner from it. */
      /* DOOR BY DOOR, IN THAT ORDER (adu-v1414): beside it, tight to the
         frame, then round the corner from it -- before the next door is
         tried at all, so the way in keeps its switch even when a closet
         door further down the list has room to spare beside it */
      var swOffs = [ELEC.swOff, 0.10], swPass, swHow = '';
      for (dq = 0; dq < order.length && !placed; dq++) {
      var dd = order[dq], sgn0 = (dd.hand === 'right') ? 1 : -1, tryS, tryH;
      for (swPass = 0; swPass < swOffs.length && !placed; swPass++) {
        var swO = swOffs[swPass];
        /* the handle side first, the other hand when the handle side is a
           corner; the side into the room first, the other when the rect
           said otherwise */
        for (tryH = 0; tryH < 2 && !placed; tryH++) {
          var sgn = sgn0 * (tryH ? -1 : 1);
          for (tryS = 0; tryS < 2 && !placed; tryS++) {
            var into = dd.into * (tryS ? -1 : 1);
            var alx = dd.vert ? 0 : 1, alz = dd.vert ? 1 : 0;
            if (dd.slant) {
              /* a door in a slanted wall: beside it along the wall, on its face (adu-v1411) */
              alx = dd.ux; alz = dd.uz;
              nx = dd.nx * into; nz = dd.nz * into;
              sx = dd.x + nx * (PART.d / 2 + 0.005) + alx * sgn * (dd.w / 2 + swO);
              sz = dd.z + nz * (PART.d / 2 + 0.005) + alz * sgn * (dd.w / 2 + swO);
            }
            else if (dd.vert) { sx = dd.x + into * (PART.d / 2 + 0.005); sz = dd.z + sgn * (dd.w / 2 + swO); nx = into; nz = 0; }
            else { sz = dd.z + into * (PART.d / 2 + 0.005); sx = dd.x + sgn * (dd.w / 2 + swO); nx = 0; nz = into; }
            if (dd.ext) { if (dd.vert) sx = dd.x + into * 0.005; else sz = dd.z + into * 0.005; }
            /* and on a slanted wall the box has to be ON the wall: a door
               that fills it left the switch hanging past its end (adu-v1414) */
            var onSl = true;
            if (dd.slant && typeof dd.u === 'number' && dd.len) {
              var uSw = dd.u + sgn * (dd.w / 2 + swO);
              onSl = (uSw - 0.04 >= 0.14) && (uSw + 0.04 <= dd.len - 0.14);
            }
            if (onSl && inOwn(sx + nx * 0.12, sz + nz * 0.12) && inOwn(sx + nx * 0.12 + alx * sgn * 0.05, sz + nz * 0.12 + alz * sgn * 0.05) && clearShell(sx, sz, alx, alz)) { placed = true; din = dd; }
          }
        }
        if (placed && swPass) swHow = 'tight to the frame, ' + Math.round(swO * 1000) + ' mm from the opening';
      }
      if (placed) break;
      /* A DOOR THAT FILLS ITS SLANTED WALL (adu-v1414) leaves no wall beside
         it on either hand. The switch goes round the corner: on the wall
         the slanted one runs into, 300 mm along it from the joint, on this
         room's side -- the latch end first -- checked to stand on that
         wall, clear of its doorways and of the next wall, and in this room */
      if (dd.slant) {
        if (!dd.ends) continue;
        var eOrd = (sgn0 < 0) ? [0, 1] : [1, 0], eq, dv, DIRS = [[1, 0], [-1, 0], [0, 1], [0, -1]];
        for (eq = 0; eq < 2 && !placed; eq++) {
          var EG = dd.ends[eOrd[eq]];
          for (dv = 0; dv < 4 && !placed; dv++) {
            var DxG = DIRS[dv][0], DzG = DIRS[dv][1];
            /* the wall runs on AWAY from the slanted one */
            if (DxG * EG.ox + DzG * EG.oz < 0.2) continue;
            var hzG = DxG !== 0, ecG = hzG ? EG.z : EG.x, eaG = hzG ? EG.x : EG.z, sgD = hzG ? DxG : DzG;
            var fsG = hzG ? dd.nz : dd.nx;
            if (Math.abs(fsG) < 0.2) continue;
            fsG = (fsG > 0) ? 1 : -1;
            /* that wall: a partition on the end's line, or the shell's inside face */
            var lineG = null, offG = 0, pidG = null, wq5;
            for (wq5 = 0; wq5 < parts.length && lineG === null; wq5++) {
              var pG = parts[wq5];
              if (!pG || pG.sep || (((pG.dir || pG.o) === 'h') !== hzG)) continue;
              var cG = (pG.at != null) ? pG.at : pG.c, spG = null;
              try { spG = API.partSpan ? API.partSpan(pG) : null; } catch (eSp) { spG = null; }
              if (!spG) spG = [Math.min(pG.a, pG.b), Math.max(pG.a, pG.b)];
              if (Math.abs(cG - ecG) > PART.d / 2 + 0.05) continue;
              var rG1 = eaG + sgD * 0.05, rG2 = eaG + sgD * 0.50;
              if (Math.min(rG1, rG2) < spG[0] - 0.02 || Math.max(rG1, rG2) > spG[1] + 0.02) continue;
              lineG = cG; offG = PART.d / 2; pidG = pG.id;
            }
            if (lineG === null) {
              var shG = hzG ? [[IN.z0, 1], [IN.z1, -1]] : [[IN.x0, 1], [IN.x1, -1]], s5;
              for (s5 = 0; s5 < 2; s5++) if (Math.abs(shG[s5][0] - ecG) < 0.06 && shG[s5][1] === fsG) { lineG = shG[s5][0]; offG = 0; }
            }
            if (lineG === null) continue;
            var aG = eaG + sgD * 0.30, pG2 = lineG + fsG * (offG + 0.005);
            var sxG = hzG ? aG : pG2, szG = hzG ? pG2 : aG, nxG = hzG ? 0 : fsG, nzG = hzG ? fsG : 0;
            var inDoorG = false, dq6;
            if (pidG != null) for (dq6 = 0; dq6 < doors.length; dq6++) { var d6 = doors[dq6]; if (d6.pid === pidG && Math.abs(d6.u - aG) < (d6.w || 0.8) / 2 + 0.06) inDoorG = true; }
            if (inDoorG) continue;
            if (!inOwn(sxG + nxG * 0.12, szG + nzG * 0.12)) continue;
            var axG = hzG ? 1 : 0, azG = hzG ? 0 : 1;
            if (!_spaceFree(sxG + nxG * 0.06 + axG * 0.06, szG + nzG * 0.06 + azG * 0.06) ||
                !_spaceFree(sxG + nxG * 0.06 - axG * 0.06, szG + nzG * 0.06 - azG * 0.06)) continue;
            placed = true; sx = sxG; sz = szG; nx = nxG; nz = nzG; din = dd;
            swHow = 'round the corner, on the wall it runs into, 300 mm from the joint';
          }
        }
        continue;
      }
      /* the wall square to the door's, 250 mm into the room from the corner */
      var dS = dd;
      var rqS, rbS = null, tolS = PART.d / 2 + 0.03;
      for (rqS = 0; rqS < rm.rects.length && !rbS; rqS++) {
        var rS = rm.rects[rqS];
        var onS = dS.vert ? ((Math.abs(dS.x - rS.x0) < tolS || Math.abs(dS.x - rS.x1) < tolS) && dS.z > rS.z0 - 0.01 && dS.z < rS.z1 + 0.01)
                          : ((Math.abs(dS.z - rS.z0) < tolS || Math.abs(dS.z - rS.z1) < tolS) && dS.x > rS.x0 - 0.01 && dS.x < rS.x1 + 0.01);
        if (onS) rbS = { r: rS, i: rqS };
      }
      if (!rbS) continue;
      var RB = rbS.r, hzS = !dS.vert;
      var eAt = hzS ? ((Math.abs(dS.z - RB.z0) <= Math.abs(dS.z - RB.z1)) ? RB.z0 : RB.z1) : ((Math.abs(dS.x - RB.x0) <= Math.abs(dS.x - RB.x1)) ? RB.x0 : RB.x1);
      var inS = hzS ? ((eAt === RB.z0) ? 1 : -1) : ((eAt === RB.x0) ? 1 : -1);
      var candS = hzS ? [{ at: RB.x0, n: 1, d: Math.abs(dS.x - RB.x0) }, { at: RB.x1, n: -1, d: Math.abs(dS.x - RB.x1) }]
                      : [{ at: RB.z0, n: 1, d: Math.abs(dS.z - RB.z0) }, { at: RB.z1, n: -1, d: Math.abs(dS.z - RB.z1) }];
      candS.sort(function (c1, c2) { return c1.d - c2.d; });
      for (var cS = 0; cS < candS.length && !placed; cS++) {
        var CS = candS[cS], lo2 = hzS ? RB.z0 : RB.x0, hi2 = hzS ? RB.z1 : RB.x1;
        /* that side has to be a wall: not open to the room's next rectangle, not a room line */
        if (hzS ? (_sharedEdge(rm.rects, rbS.i, CS.at, CS.at, lo2, hi2, false) || _onRoomLine(CS.at, CS.at, lo2, hi2, false))
                : (_sharedEdge(rm.rects, rbS.i, lo2, hi2, CS.at, CS.at, true) || _onRoomLine(lo2, hi2, CS.at, CS.at, true))) continue;
        var pxS = hzS ? CS.at + CS.n * 0.005 : eAt + inS * 0.25, pzS = hzS ? eAt + inS * 0.25 : CS.at + CS.n * 0.005;
        var nxS = hzS ? CS.n : 0, nzS = hzS ? 0 : CS.n;
        if (!inOwn(pxS + nxS * 0.12, pzS + nzS * 0.12)) continue;
        placed = true; sx = pxS; sz = pzS; nx = nxS; nz = nzS; din = dS;
        swHow = 'on the wall square to the door, 250 mm in from the corner';
      }
      }
      /* no door at all: beside the room line it is open to (adu-v1405) */
      for (dq = 0; dq < SEPW.length && !placed; dq++) {
        var sw9 = SEPW[dq];
        if (inOwn(sw9.x + sw9.nx * 0.12, sw9.z + sw9.nz * 0.12) && inOwn(sw9.x + sw9.nx * 0.05, sw9.z + sw9.nz * 0.05)) {
          placed = true; sx = sw9.x; sz = sw9.z; nx = sw9.nx; nz = sw9.nz; din = { ext: false, line: true };
        }
      }
      /* NO DOOR, NO ROOM LINE (mep-v19, env.switchNear -- a gallery): on its
         exterior wall beside its socket nearest the point the product names
         (the stair opening), 250 along the wall */
      if (!placed && typeof env.switchNear === 'function' && rm.sockets.length) {
        var pN = null;
        try { pN = env.switchNear(rm); } catch (eSN) { pN = null; }
        if (pN && pN.x != null) {
          var bS = null, bSd = 1e9, sq9;
          for (sq9 = 0; sq9 < rm.sockets.length; sq9++) { var dS9 = Math.abs(rm.sockets[sq9].x - pN.x) + Math.abs(rm.sockets[sq9].z - pN.z); if (dS9 < bSd) { bSd = dS9; bS = rm.sockets[sq9]; } }
          var sdN = sides[bS.side], sgN;
          for (sgN = 1; sgN >= -1 && !placed; sgN -= 2) {
            var uN9 = bS.u + sgN * 0.25;
            if (uN9 < 0.15 || uN9 > sdN.len - 0.15) continue;
            var xN9 = sdN.a[0] + sdN.u[0] * uN9, zN9 = sdN.a[1] + sdN.u[1] * uN9;
            if (!inOwn(xN9 + sdN.n[0] * 0.12, zN9 + sdN.n[1] * 0.12)) continue;
            placed = true; sx = xN9; sz = zN9; nx = sdN.n[0]; nz = sdN.n[1]; din = { ext: false, near: true };
            swHow = 'beside its socket nearest ' + (pN.what || 'the point the product names');
          }
        }
      }
      if (placed) {
        _asmCode(ctx, ELEC.sw, 'top');
        var ySwR = (lampRun.length && lampRun[0] != null) ? lampRun[0] : yCeil;   /* mep-v22 */
        /* mep-v37: on the floor under it, kept 150 under the lamp's run */
        var ySwP = ySw;
        if (FLA) { ySwP = Math.min(floorUnder(sx, sz) + ELEC.swH, ySwR - 0.15); if (ySwP > ySw + 0.02) RAISE.sw++; }
        var swB = withBox(wdev(sx, sz, nx, nz, ySwP, mSw, 'elec-switch', 0.08, 0.08, 0.012)), swSh = lastSh;
        if (PTG) {
          /* mep-v57: kept for the gangs -- the side away from its door */
          var sgS = 1;
          if (din && din.x != null && din.z != null && ((sx - din.x) * nz - (sz - din.z) * nx) < 0) sgS = -1;
          SWP.push({ id: 'esw' + SWP.length, x: sx + nx * swSh, z: sz + nz * swSh, nx: nx, nz: nz, y: ySwP, s: sgS, n: 1, rects: rm.rects, room: rm.name || ('room ' + i) });
          swB.userData.qtyPiece = 'esw' + (SWP.length - 1);
        }
        _asmCode(ctx, ELEC.cable, 'top');
        tally.cable += run([[sx, ySwP, sz], [sx, ySwR, sz], [lampAt[0][0], ySwR, sz], [lampAt[0][0], ySwR, lampAt[0][1]]], mLit);
        /* the switch drop meets the lamp's run here -- a three-way joint (surface variant) */
        branchBox(lampAt[0][0], ySwR, sz, 'switch joint in ' + (rm.name || ('room ' + i)));
        tally.switches++;
      }
      tally.rooms++;
      ctx.log('ELEC ' + (rm.name || ('room ' + i)) + (rm.wet ? ' (wet: one socket)' : '') + (rm.closet ? ' (a closet: no socket circuit, the light only)' : '') + ': ' + rm.sockets.length + ' socket(s) on its exterior wall(s), own circuit ' +
              (rm.twoLeg ? ('in two legs from the board, which stands in its run: ' + (Math.round((rm.feedM || 0) * 10) / 10) + ' m; ') :
              ('feed ' + (Math.round((rm.feedM || 0) * 10) / 10) + ' m along the perimeter + ' + (Math.round((rm.runM || 0) * 10) / 10) + ' m round the room; ')) +
              nL + ' light(s), ' + (din ? ('switch by the ' + (din.ext ? 'entrance' : (din.line ? 'room line' : (din.near ? 'exterior wall (no door, no room line)' : (din.slant ? 'door in a slanted wall' : 'interior door')))) + ' at ' + sx.toFixed(2) + ',' + sz.toFixed(2) + ' (in this room' + (swHow ? (', ' + swHow) : '') + ')')
                                       : ('NO SWITCH -- ' + rm.doors.length + ' door(s) seen: ' + rm.doors.map(function (d9) { return (d9.ext ? 'ext ' : 'int ') + d9.x.toFixed(2) + ',' + d9.z.toFixed(2) + ' into ' + d9.into; }).join('; ') +
                                          ' | rects ' + rm.rects.map(function (r9) { return '[' + r9.x0.toFixed(2) + '..' + r9.x1.toFixed(2) + ' x ' + r9.z0.toFixed(2) + '..' + r9.z1.toFixed(2) + ']'; }).join(' '))));
    }
    /* THE US CODE ON TOP (mep-v25, env.nec -- the barndo first; Marek
       2026-10-11: detailni konfigurator do posledniho sroubku v rozpoctu).
       What the line's rules above leave out and the NEC / IRC ask for, added
       to the same layer, CALCULATED (devices drawn, the new runs measured):
         210.52(A) a receptacle on every wall of a habitable room so that no
           point along the floor line is more than 6 ft from one -- the
           interior walls too (the line puts them on the exterior walls only);
           wall spaces under 2 ft and the walls behind counters left out;
         210.52(H) a hallway of 10 ft or more: one;
         210.52(C) kitchen counters: every 4 ft (no point more than 2 ft from
           one) at 42 in., on two small-appliance 20 A circuits; an island
           a pop-up tower per its first 9 sq ft and one per 18 sq ft more, fed
           in conduit under the slab; dedicated circuits for the refrigerator,
           the dishwasher (under the sink), the microwave / hood over the
           cooktop, and the cooktop itself (240 V, 40 A, 8/3, hardwired in a
           box under it);
         210.52(D) a bathroom: a receptacle within 3 ft of every basin, at
           the vanity, on the room's 20 A GFCI circuit;
         210.11(C)(2) / 210.52(F) laundry: the washer's receptacle on its own
           20 A circuit, the dryer's 30 A 240 V receptacle on 10/3;
         210.52(G) garage: the opener's receptacle on the ceiling 11 ft in
           from each overhead door, on the garage circuit;
         210.52(E) / 210.70(A)(2) outside: a weatherproof GFCI receptacle by
           every people door (and one at the back if there is one door), an
           exterior light at each, switched inside beside the door;
         IRC R314 / R315 smoke alarms in every bedroom and outside each
           sleeping area, at least one a storey, hardwired and interconnected
           (14/3), combination smoke + CO outside the sleeping areas where the
           house has an attached garage or a fuel appliance (env.attachedGarage
           / env.fuel);
         210.12 / 210.8 the breakers by what they feed: combination AFCI for
           the living spaces and bedrooms, dual-function AFCI + GFCI for the
           kitchen and the laundry, GFCI for baths and the garage, plain
           15 A for their lighting; no whole-house RCD (that is the European
           board); 230.67 a surge protector at the service; the main breaker
           and the meter socket.
       Rows the sheet does not have yet are billed under mep.* (pending, never
       in the budget) and named in the log. Without env.nec nothing changes. */
    function _necKit() {
      var NK = NEC_KIT, stN = UPS ? ((env.storey != null) ? (env.storey | 0) : 1) : 0;
      var CAT = env.CATALOG || null, kP;
      if (CAT) for (kP in NEC_MADE) if (NEC_MADE.hasOwnProperty(kP) && !CAT[kP]) CAT[kP] = { code: kP, unit: NEC_MADE[kP].unit, label: NEC_MADE[kP].label };
      if (CAT) for (kP in NEC_CAT) if (NEC_CAT.hasOwnProperty(kP) && !CAT[kP]) CAT[kP] = { code: kP, unit: NEC_CAT[kP].unit, label: NEC_CAT[kP].label };
      var bill = {}, said = [], warn = [], q, r, k2;
      function add(code, n) { if (n) bill[code] = (bill[code] || 0) + n; }
      function man(a, b) { return Math.abs(a.x - b.x) + Math.abs(a.z - b.z); }
      function mm(v) { return Math.round(v * 1000); }
      function m1(v) { return Math.round(v * 10) / 10; }
      var cat = (PL.fixtures && PL.fixtures.catalog) ? (PL.fixtures.catalog() || {}) : {};
      var FXA = ((STATE.product && STATE.product.fixtures) || []).filter(function (f) { return f && f.kind && (((f.st != null) ? (f.st | 0) : 0) === stN); });
      function fxSize(f) {
        var D = cat[f.kind] || {}, w = D.w || 0.6, d = D.d || 0.6;
        try { var SZ = PL.fixtures.size ? PL.fixtures.size(f) : null; if (SZ && SZ.w > 0 && SZ.d > 0) { w = SZ.w; d = SZ.d; } } catch (eS) {}
        return { w: w, d: d, D: D };
      }
      function fxRot(f, lx, lz) {
        var ro = (f.rot | 0) % 4, cs = Math.cos(ro * Math.PI / 2), sn = Math.sin(ro * Math.PI / 2), mir = f.mirror ? -1 : 1;
        lx *= mir;
        return { x: lx * cs - lz * sn, z: lx * sn + lz * cs };
      }
      function fxPt(f, lx, lz) { var p = fxRot(f, lx, lz); return { x: f.x + p.x, z: f.z + p.z }; }
      function cls(rm) {
        var n = String(rm.name || '');
        if (rm.closet || /wardrobe|closet|pantry|storage|w\.?i\.?c/i.test(n)) return 'closet';
        if (rm.hot) return 'hot';
        if (rm.wet) return 'bath';
        if (/garage|workshop|\bshop\b|carport/i.test(n)) return 'garage';
        if (/laundry|utility|mud/i.test(n)) return 'laundry';
        if (/hall|corridor|foyer|entry/i.test(n)) return 'hall';
        if (/bed|kid|guest|nursery|sleep/i.test(n)) return 'bed';
        if (/porch|terrace|deck|patio/i.test(n)) return 'out';
        return 'living';
      }
      for (q = 0; q < R.length; q++) R[q].nec = cls(R[q]);
      var yRun = yCeil;   /* the new runs go up to the ceiling void and across */
      /* a circuit's cable: from the board up to the ceiling, across, down to
         its first device, then device to device -- along a wall at the same
         height through the studs, else over the ceiling -- plus 300 a box to
         make up, plus 15 per cent */
      /* mep-v46 (RANCH thread, opt-in env.necDraw): with a code the run is
         DRAWN along the very route it is measured on -- up to the ceiling
         void, across (x, then z), down to the device; device to device along
         the wall at their height -- tagged that cable's code. The bill keeps
         its 300 a box and 15 per cent on top. */
      var necDraw = !!env.necDraw, necDrawn = {};
      function circLen(pts, from, code) {
        if (!pts.length) return 0;
        var left = pts.slice(), cur = from || { x: B.x, z: B.z, y: yBrd }, L = 0, first = !from, dr = necDraw && code;
        if (dr) _asmCode(ctx, code, 'top');
        while (left.length) {
          var bi = 0, bd = 1e9, j9;
          for (j9 = 0; j9 < left.length; j9++) { var d9 = man(cur, left[j9]); if (d9 < bd) { bd = d9; bi = j9; } }
          var nx9 = left.splice(bi, 1)[0], cy = (cur.y != null) ? cur.y : yRun, ny = (nx9.y != null) ? nx9.y : yRun, dl = 0;
          if (!first && Math.abs((cur.y || 0) - nx9.y) < 0.05 && bd < 4.0) {
            L += bd;
            if (dr) dl = run([[cur.x, cy, cur.z], [nx9.x, cy, cur.z], [nx9.x, ny, nx9.z]], mCab);
          } else {
            L += Math.max(0, yRun - (cur.y || yRun)) + bd + Math.max(0, yRun - nx9.y);
            if (dr) dl = run([[cur.x, cy, cur.z], [cur.x, yRun, cur.z], [nx9.x, yRun, cur.z], [nx9.x, yRun, nx9.z], [nx9.x, ny, nx9.z]], mCab);
          }
          if (dr) necDrawn[code] = (necDrawn[code] || 0) + dl;
          first = false; cur = nx9;
        }
        return (L + 0.30 * pts.length) * NK.slack + (from ? 0 : riserL);
      }
      var DEV = [];   /* every device the kit adds: { x, z, y, code, box } */
      function dev(x, z, nx, nz, y, code, nm, box) {
        if (code === ELEC.socket) NECSK.push({ x: x, z: z, y: y });
        _asmCode(ctx, code, 'top');
        var bD = wdev(x, z, nx, nz, y, mDev, nm, ELEC.boxW, ELEC.boxH, ELEC.boxT);
        if (box !== false) withBox(bD);
        var o = { x: x, z: z, y: y, code: code, box: box !== false };
        DEV.push(o); add(code, 1);
        return o;
      }
      function disc(x, z, y, code, nm) {
        _asmCode(ctx, code, 'top');
        var m9 = new T.Mesh(new T.CylinderGeometry(0.07, 0.07, 0.04, 20), mDev);
        m9.position.set(x, y - 0.02, z); m9.name = nm; m9.userData.viz = vizTag; g.add(m9); withBox(m9);
        var o = { x: x, z: z, y: y, code: code, box: true };
        DEV.push(o); add(code, 1);
        return o;
      }
      var CIR = [];   /* the circuits the kit adds: { what, brk, poles, cable, pts, from } */
      function circ(what, brk, poles, cable) { var c = { what: what, brk: brk, poles: poles, cable: cable, pts: [], from: null }; CIR.push(c); return c; }
      /* the room circuits of the line, by type (one socket and one lighting
         circuit a room, a closet its lighting only, a hot room neither) */
      var RB = [];
      for (q = 0; q < R.length; q++) {
        var c0 = R[q].nec;
        if (c0 === 'hot') continue;
        if (!R[q].closet) RB.push({ what: (R[q].name || 'room') + ' receptacles', brk: (c0 === 'bath' || c0 === 'garage') ? NK.gfci : (c0 === 'laundry' ? 'EEC00013' : (c0 === 'out' ? NK.brk20 : 'EEC00012')) });
        RB.push({ what: (R[q].name || 'room') + ' lighting', brk: (c0 === 'bath' || c0 === 'garage' || c0 === 'out') ? NK.brk15 : 'EEC00012' });
      }

      /* PARTITIONS OF THIS STOREY and their doors */
      var PP = (STATE.parts || []).filter(function (p) { return p && !p.sep && ((p.st | 0) === stN); });
      var DD = STATE.doors || [];
      /* the kitchen pieces on this storey, their plan rects */
      var KF = FXA.filter(function (f) { return /^kitchen|^island/.test(f.kind); });
      var KR = [];
      for (q = 0; q < KF.length; q++) { try { var kr = PL.fixtures.rect ? PL.fixtures.rect(KF[q]) : null; if (kr) KR.push(kr); } catch (eKR) {} }

      /* 210.52(A) / (H): THE INTERIOR WALLS */
      function stretches(rm) {
        var out = [], ri, e9, p9;
        for (ri = 0; ri < rm.rects.length; ri++) {
          var c9 = rm.rects[ri];
          var E9 = [{ v: false, at: c9.z0, lo: c9.x0, hi: c9.x1, n: 1 }, { v: false, at: c9.z1, lo: c9.x0, hi: c9.x1, n: -1 },
                    { v: true, at: c9.x0, lo: c9.z0, hi: c9.z1, n: 1 }, { v: true, at: c9.x1, lo: c9.z0, hi: c9.z1, n: -1 }];
          for (e9 = 0; e9 < 4; e9++) {
            var ed = E9[e9];
            for (p9 = 0; p9 < PP.length; p9++) {
              var P9 = PP[p9];
              if ((((P9.dir || P9.o) === 'v')) !== ed.v) continue;
              var pc9 = (P9.at != null) ? P9.at : P9.c;
              if (Math.abs(pc9 - ed.at) > PART.d / 2 + 0.06) continue;
              var sp9 = null;
              try { sp9 = API.partSpan ? API.partSpan(P9) : null; } catch (eSp) { sp9 = null; }
              if (!sp9) sp9 = [Math.min(P9.a, P9.b), Math.max(P9.a, P9.b)];
              var a9 = Math.max(ed.lo, sp9[0]), b9 = Math.min(ed.hi, sp9[1]);
              if (b9 - a9 < 0.3) continue;
              var face = pc9 + ed.n * PART.d / 2, cut = [[a9 - 1, a9 + ELEC.corner], [b9 - ELEC.corner, b9 + 1]], dq9;
              for (dq9 = 0; dq9 < DD.length; dq9++) if (DD[dq9] && DD[dq9].pid === P9.id) cut.push([DD[dq9].u - (DD[dq9].w || 0.9) / 2 - NK.doorOff, DD[dq9].u + (DD[dq9].w || 0.9) / 2 + NK.doorOff]);
              /* a counter backed on this wall: its receptacles are the counter's */
              for (var kq = 0; kq < KR.length; kq++) {
                var K9 = KR[kq], acr = ed.v ? Math.min(Math.abs(K9.x0 - face), Math.abs(K9.x1 - face)) : Math.min(Math.abs(K9.z0 - face), Math.abs(K9.z1 - face));
                var inside = ed.v ? ((K9.x0 + K9.x1) / 2 - face) * ed.n > 0 : ((K9.z0 + K9.z1) / 2 - face) * ed.n > 0;
                if (acr < 0.75 && inside) cut.push(ed.v ? [K9.z0 - 0.05, K9.z1 + 0.05] : [K9.x0 - 0.05, K9.x1 + 0.05]);
              }
              cut.sort(function (x1, x2) { return x1[0] - x2[0]; });
              var cur9 = a9, c8;
              for (c8 = 0; c8 < cut.length; c8++) {
                if (cut[c8][0] > cur9 + NK.minSpace && Math.min(cut[c8][0], b9) - cur9 >= NK.minSpace) out.push({ v: ed.v, at: face, n: ed.n, a: cur9, b: Math.min(cut[c8][0], b9) });
                cur9 = Math.max(cur9, cut[c8][1]);
              }
              if (b9 - cur9 >= NK.minSpace) out.push({ v: ed.v, at: face, n: ed.n, a: cur9, b: b9 });
            }
          }
        }
        return out;
      }
      function stPt(st, u) { return st.v ? { x: st.at, z: u } : { x: u, z: st.at }; }
      var addedRm = 0, rmLog = [];
      for (q = 0; q < R.length; q++) {
        var rm = R[q], cR = rm.nec;
        if (cR !== 'living' && cR !== 'bed' && cR !== 'hall') continue;
        var have = rm.sockets.map(function (s) { return { x: s.x, z: s.z, y: yLine }; }), added = [];
        var STs = stretches(rm), s9;
        if (cR === 'hall') {
          /* a hallway of 10 ft or more: one receptacle, on its longest stretch */
          var bbx = 0; for (r = 0; r < rm.rects.length; r++) bbx = Math.max(bbx, rm.rects[r].x1 - rm.rects[r].x0, rm.rects[r].z1 - rm.rects[r].z0);
          if (bbx < NK.hall || have.length) continue;
          STs.sort(function (s1, s2) { return (s2.b - s2.a) - (s1.b - s1.a); });
          if (STs.length) { var Ph = stPt(STs[0], (STs[0].a + STs[0].b) / 2); dev(Ph.x, Ph.z, STs[0].v ? STs[0].n : 0, STs[0].v ? 0 : STs[0].n, yLine, ELEC.socket, 'elec-socket'); added.push({ x: Ph.x, z: Ph.z, y: yLine }); }
        } else {
          for (s9 = 0; s9 < STs.length; s9++) {
            var ST = STs[s9], u9 = ST.a, edge = Math.min(0.15, (ST.b - ST.a) / 2);
            while (u9 <= ST.b + 1e-6) {
              var P0 = stPt(ST, u9), ok = false, h9;
              for (h9 = 0; h9 < have.length && !ok; h9++) if (man(P0, have[h9]) <= NK.six + 1e-6) ok = true;
              if (!ok) {
                var uR = Math.max(ST.a + edge, Math.min(u9 + NK.six, ST.b - edge)), PR = stPt(ST, uR);
                dev(PR.x, PR.z, ST.v ? ST.n : 0, ST.v ? 0 : ST.n, yLine, ELEC.socket, 'elec-socket');
                var hv = { x: PR.x, z: PR.z, y: yLine };
                have.push(hv); added.push(hv);
              }
              u9 += 0.15;
            }
          }
        }
        if (added.length) {
          /* on the room's own circuit: chained on from its nearest receptacle */
          var fromR = rm.sockets.length ? { x: rm.sockets[0].x, z: rm.sockets[0].z, y: yLine } : null;
          var Lr = circLen(added, fromR, ELEC.cable);
          add(ELEC.cable, Lr);
          addedRm += added.length;
          rmLog.push((rm.name || 'room') + ' +' + added.length + ' (' + STs.length + ' interior wall stretch(es), ' + m1(Lr) + ' m)');
        }
      }
      if (rmLog.length) said.push('210.52(A) walls: ' + addedRm + ' receptacle(s) on the interior walls -- ' + rmLog.join('; '));

      /* 210.52(C): THE KITCHEN */
      var hobs = [], nCounter = 0, nTower = 0, slabM = 0;
      var SA = [circ('small appliances 1', 'EEC00013', 1, ELEC.cable), circ('small appliances 2', 'EEC00013', 1, ELEC.cable)], saI = 0;
      var CF = null, CD = null, CM = null, CK = null;
      for (q = 0; q < KF.length; q++) {
        var f = KF[q], S0 = fxSize(f), w = S0.w, d = S0.d, leg = 0.6;
        if (/^island/.test(f.kind)) {
          var tw = S0.D.tw || w, td = S0.D.td || d, A9 = tw * td, nT = 1 + Math.ceil(Math.max(0, A9 - 0.836) / 1.672 - 1e-9), t9;
          for (t9 = 0; t9 < nT; t9++) {
            var Pt = fxPt(f, -tw / 2 + tw * (t9 + 0.5) / nT, 0);
            disc(Pt.x, Pt.z, y0 + 0.93, NK.tower, 'elec-tower');
            SA[1].pts.push({ x: Pt.x, z: Pt.z, y: y0 });
            nTower++;
          }
          /* fed in conduit under the slab from the nearest wall */
          var nsI = onSide(f.x, f.z);
          slabM += Math.hypot(nsI.x - f.x, nsI.z - f.z) + 1.0;
          continue;
        }
        var lines9 = [{ ax: -w / 2, az: -d / 2, bx: w / 2, bz: -d / 2, nx: 0, nz: 1 }], hob, sink;
        if (f.kind === 'kitchenL' || f.kind === 'kitchenU') {
          lines9.push({ ax: -w / 2, az: -d / 2 + leg, bx: -w / 2, bz: d / 2, nx: 1, nz: 0 });
          if (f.kind === 'kitchenU') lines9.push({ ax: w / 2, az: -d / 2 + leg, bx: w / 2, bz: d / 2, nx: -1, nz: 0 });
          hob = { x: -w / 2 + leg / 2, z: d / 2 - 0.5 }; sink = { x: 0, z: -d / 2 + leg / 2 };
        } else { hob = { x: w / 2 - 0.55, z: -d / 2 + 0.3 }; sink = { x: -w / 2 + 0.45, z: -d / 2 + 0.3 }; }
        var hobW = fxPt(f, hob.x, hob.z);
        hobs.push(hobW);
        for (r = 0; r < lines9.length; r++) {
          var Ln = lines9[r], LL = Math.hypot(Ln.bx - Ln.ax, Ln.bz - Ln.az), ux9 = (Ln.bx - Ln.ax) / LL, uz9 = (Ln.bz - Ln.az) / LL;
          /* the cooktop's place on this run is not counter */
          var th = (hob.x - Ln.ax) * ux9 + (hob.z - Ln.az) * uz9, dh = Math.abs((hob.x - Ln.ax) * (-uz9) + (hob.z - Ln.az) * ux9);
          var segs9 = [[0, LL]];
          if (dh < 0.45 && th > -0.4 && th < LL + 0.4) segs9 = [[0, th - 0.38], [th + 0.38, LL]];
          for (k2 = 0; k2 < segs9.length; k2++) {
            var a8 = Math.max(0, segs9[k2][0]), b8 = Math.min(LL, segs9[k2][1]), Ls = b8 - a8;
            if (Ls < NK.counterMin) continue;
            var nC = Math.max(1, Math.ceil(Ls / NK.counter - 1e-9)), j8;
            for (j8 = 0; j8 < nC; j8++) {
              /* on the wall behind the counter, at 42 in. */
              var tt = a8 + Ls * (j8 + 0.5) / nC, Nc = fxRot(f, Ln.nx, Ln.nz), Pw = fxPt(f, Ln.ax + ux9 * tt, Ln.az + uz9 * tt);
              dev(Pw.x, Pw.z, Nc.x, Nc.z, y0 + NK.counterY, ELEC.socket, 'elec-socket');
              SA[saI % 2].pts.push({ x: Pw.x, z: Pw.z, y: y0 + NK.counterY }); saI++;
              nCounter++;
            }
          }
        }
        /* the appliances on the run: the dishwasher under the sink, the
           microwave / hood over the cooktop, the cooktop's own box */
        var LU = (f.kind === 'kitchenL' || f.kind === 'kitchenU');
        var Nb = fxRot(f, 0, 1), Psk = fxPt(f, sink.x, -d / 2), Phb = LU ? fxPt(f, -w / 2, hob.z) : fxPt(f, hob.x, -d / 2), Nh = LU ? fxRot(f, 1, 0) : Nb;
        if (!CD) CD = circ('dishwasher', 'EEC00013', 1, ELEC.cable);
        CD.pts.push(dev(Psk.x, Psk.z, Nb.x, Nb.z, y0 + 0.30, ELEC.socket, 'elec-socket'));
        if (!CM) CM = circ('microwave / hood', 'EEC00013', 1, ELEC.cable);
        CM.pts.push(dev(Phb.x, Phb.z, Nh.x, Nh.z, y0 + NK.hoodY, ELEC.socket, 'elec-socket'));
        if (!CK) CK = circ('cooktop 240 V', 'EEC00014', 2, 'EEE00004');
        _asmCode(ctx, ELEC.box, 'top');
        var bJ = wdev(Phb.x, Phb.z, Nh.x, Nh.z, y0 + 0.50, mDev, 'elec-junction', ELEC.boxW, ELEC.boxH, ELEC.boxT);
        if (PTG) bJ.userData.qtyWith = [ELEC.conn, ELEC.conn, ELEC.conn];   /* mep-v57: the box is drawn, its connectors with it */
        DEV.push({ x: Phb.x, z: Phb.z, y: y0 + 0.50, code: ELEC.box, box: true });
        CK.pts.push({ x: Phb.x, z: Phb.z, y: y0 + 0.50 });
      }
      for (q = 0; q < FXA.length; q++) {
        if (FXA[q].kind !== 'fridge') continue;
        var Sf = fxSize(FXA[q]), Pf = fxPt(FXA[q], 0, -Sf.d / 2), Nf = fxRot(FXA[q], 0, 1);
        if (!CF) CF = circ('refrigerator', 'EEC00013', 1, ELEC.cable);
        CF.pts.push(dev(Pf.x, Pf.z, Nf.x, Nf.z, y0 + NK.fridgeY, ELEC.socket, 'elec-socket'));
      }
      if (!nCounter && !nTower) { SA[0].pts = []; SA[1].pts = []; }
      if (nCounter || nTower || CF || CK) {
        said.push('210.52(C) kitchen: ' + nCounter + ' counter receptacle(s) at ' + mm(NK.counterY) + ' no more than ' + mm(NK.counter) + ' apart' +
                  (nTower ? (', ' + nTower + ' pop-up tower(s) ' + NK.tower + ' in the island, fed ' + m1(slabM) + ' m in conduit under the slab') : '') +
                  ' on 2 small-appliance circuits; dedicated: ' + [CF ? 'refrigerator' : '', CD ? 'dishwasher (under the sink)' : '', CM ? 'microwave / hood' : '', CK ? 'cooktop 240 V 40 A, 8/3, a box under it' : ''].filter(Boolean).join(', '));
      }
      /* mep-v29: the conduit and its three conductors (hot, neutral, ground) */
      if (slabM) { add('EET00002', slabM); add('EEE00008', 3 * slabM); }

      /* 210.52(D): A RECEPTACLE BY EVERY BASIN */
      var nBas = 0;
      for (q = 0; q < FXA.length; q++) {
        var fb = FXA[q];
        if (!/^basin/.test(fb.kind)) continue;
        var Sb = fxSize(fb), Pc0 = fxPt(fb, 0, 0), rmB = roomOfS(Pc0.x, Pc0.z);
        var near9 = false;
        if (rmB) for (r = 0; r < rmB.sockets.length; r++) if (man(rmB.sockets[r], Pc0) <= Sb.w / 2 + NK.basin) near9 = true;
        if (near9) continue;
        var Pb = fxPt(fb, Sb.w / 2 + 0.15, -Sb.d / 2), Nb2 = fxRot(fb, 0, 1);
        var ob = dev(Pb.x, Pb.z, Nb2.x, Nb2.z, y0 + NK.vanityY, ELEC.socket, 'elec-socket');
        var fromB = (rmB && rmB.sockets.length) ? { x: rmB.sockets[0].x, z: rmB.sockets[0].z, y: yLine } : null;
        add(ELEC.cable, circLen([ob], fromB, ELEC.cable));
        nBas++;
      }
      if (nBas) said.push('210.52(D) bath: ' + nBas + ' receptacle(s) beside the basin(s) at ' + mm(NK.vanityY) + ', on the bathroom\'s 20 A GFCI circuit');

      /* 210.11(C)(2): THE LAUNDRY */
      var CW = null, CY = null;
      for (q = 0; q < FXA.length; q++) {
        var fl = FXA[q];
        if (fl.kind !== 'washer' && fl.kind !== 'dryer') continue;
        var Sl = fxSize(fl), Pl = fxPt(fl, 0, -Sl.d / 2), Nl = fxRot(fl, 0, 1);
        if (fl.kind === 'washer') {
          if (!CW) CW = circ('washer', 'EEC00013', 1, ELEC.cable);
          CW.pts.push(dev(Pl.x, Pl.z, Nl.x, Nl.z, y0 + NK.washerY, ELEC.socket, 'elec-socket'));
        }
        if (fl.kind === 'dryer' || fl.stack === 'dryer') {
          if (!CY) CY = circ('dryer 240 V', NK.brk30, 2, 'EEE00005');
          CY.pts.push(dev(Pl.x + (fl.kind === 'washer' ? 0.10 * Nl.z : 0), Pl.z, Nl.x, Nl.z, y0 + ((fl.kind === 'washer') ? NK.stackY : NK.dryerY), 'EES00006', 'elec-socket'));
        }
      }
      if (CW || CY) said.push('210.11(C)(2) laundry: ' + (CW ? (CW.pts.length + ' washer receptacle(s) on their own 20 A circuit') : 'no washer') + (CY ? ('; ' + CY.pts.length + ' dryer receptacle(s) 30 A 240 V (NEMA 14-30) on 10/3') : ''));

      /* 210.52(G): THE GARAGE DOOR OPENERS */
      var nOp = 0;
      for (q = 0; q < SEG.length; q++) {
        var sgO = SEG[q]; if (!sgO || !sgO.openings || (sgO.storey | 0) !== stN) continue;
        for (r = 0; r < sgO.openings.length; r++) {
          var oO = sgO.openings[r];
          if (oO.kind !== 'garage') continue;
          var uxO = (sgO.x1 - sgO.x0) / sgO.len, uzO = (sgO.z1 - sgO.z0) / sgO.len;
          var wxO = sgO.x0 + uxO * oO.at, wzO = sgO.z0 + uzO * oO.at, psO = onSide(wxO, wzO), sO = sides[psO.side];
          var xO = psO.x + sO.n[0] * NK.opener, zO = psO.z + sO.n[1] * NK.opener, yO = Math.min(yCeil, y0 + (oO.h || 2.44) + 0.40);
          var rmO = roomOfS(xO, zO);
          var oo = disc(xO, zO, yO, ELEC.socket, 'elec-socket');
          var fromO = (rmO && rmO.sockets.length) ? { x: rmO.sockets[0].x, z: rmO.sockets[0].z, y: yLine } : null;
          add(ELEC.cable, circLen([oo], fromO, ELEC.cable));
          nOp++;
        }
      }
      if (nOp) said.push('210.52(G) garage: ' + nOp + ' opener receptacle(s) on the ceiling ' + mm(NK.opener) + ' in from the overhead door(s), on the garage\'s 20 A GFCI circuit');

      /* R314 / R315: THE ALARMS */
      var AL = [], coNeed = !!(env.attachedGarage || env.fuel);
      function centroid(rm) {
        var cx = 0, cz = 0, aa = 0, rq;
        for (rq = 0; rq < rm.rects.length; rq++) { var rr = rm.rects[rq], a7 = (rr.x1 - rr.x0) * (rr.z1 - rr.z0); cx += a7 * (rr.x0 + rr.x1) / 2; cz += a7 * (rr.z0 + rr.z1) / 2; aa += a7; }
        return aa > 0 ? { x: cx / aa, z: cz / aa } : { x: (rm.big.x0 + rm.big.x1) / 2, z: (rm.big.z0 + rm.big.z1) / 2 };
      }
      function ceilY(x, z) {
        var yC = yCeil;
        if (typeof env.ceilLowAt === 'function') {
          var yL = null;
          try { yL = env.ceilLowAt(x, z); } catch (eCL) { yL = null; }
          if (typeof yL === 'number' && isFinite(yL) && yL < yCeil - 0.05 && yL > y0 + 1.8) yC = yL;
        }
        return yC;
      }
      function alarmAt(P, combo, why, kind, ref) {
        var j7;
        /* outside a sleeping area: one serves every bedroom door within 21 ft of it (NFPA 72 29.8.3) */
        if (kind === 'out') for (j7 = 0; j7 < AL.length; j7++) if (AL[j7].kind === 'out' && man(AL[j7], ref || P) <= NK.vicinity) { AL[j7].why += ' + ' + why.replace(/^outside /, ''); return null; }
        for (j7 = 0; j7 < hobs.length; j7++) {
          var dH = Math.hypot(P.x - hobs[j7].x, P.z - hobs[j7].z);
          if (dH < NK.cookMin) {
            var kx = (P.x - hobs[j7].x) / (dH || 1), kz = (P.z - hobs[j7].z) / (dH || 1);
            P = { x: hobs[j7].x + kx * NK.cookMin, z: hobs[j7].z + kz * NK.cookMin };
            warn.push(why + ': moved to ' + mm(NK.cookMin) + ' from the cooktop (R314.3.3, photoelectric)');
          }
        }
        var o = disc(P.x, P.z, ceilY(P.x, P.z), combo ? 'EES00007' : NK.smoke, 'elec-alarm');
        o.combo = combo; o.why = why; o.kind = kind; AL.push(o);
        return o;
      }
      var nBed = 0;
      for (q = 0; q < R.length; q++) {
        if (R[q].nec !== 'bed') continue;
        var Cb = centroid(R[q]);
        alarmAt({ x: Cb.x + 0.6, z: Cb.z }, false, (R[q].name || 'bedroom'), 'bed');
        nBed++;
      }
      /* outside the sleeping areas: the bedroom doors' outside points gathered,
         then as few alarms as cover them -- each within 21 ft of every door
         it serves (NFPA 72 29.8.3), at the middle of the doors it serves */
      var OUTS = [];
      for (q = 0; q < R.length; q++) {
        if (R[q].nec !== 'bed') continue;
        for (r = 0; r < R[q].doors.length; r++) {
          var dB = R[q].doors[r], oR = dB.other;
          if (dB.ext || !oR || oR === R[q] || oR.nec === 'bed' || oR.nec === 'closet' || oR.nec === 'bath') continue;
          var into = dB.into || 1, Po = dB.slant ? { x: dB.x - (dB.nx || 0) * NK.outside, z: dB.z - (dB.nz || 0) * NK.outside }
                                                : (dB.vert ? { x: dB.x - into * NK.outside, z: dB.z } : { x: dB.x, z: dB.z - into * NK.outside });
          OUTS.push({ door: { x: dB.x, z: dB.z }, p: Po, room: oR, bed: R[q].name || 'a bedroom' });
        }
      }
      while (OUTS.length) {
        var c0o = OUTS[0], cl = OUTS.filter(function (o9) { return o9.room === c0o.room; }), cen = null, guard = 0;
        while (cl.length && guard++ < 20) {
          cen = { x: 0, z: 0 };
          cl.forEach(function (o9) { cen.x += o9.p.x / cl.length; cen.z += o9.p.z / cl.length; });
          var far = -1, fd = -1;
          cl.forEach(function (o9, i9) { var d9 = man(o9.door, cen); if (d9 > fd) { fd = d9; far = i9; } });
          if (fd <= NK.vicinity || cl.length === 1) break;
          if (cl[far] === c0o) cl.splice(cl.length - 1 === far ? 0 : cl.length - 1, 1); else cl.splice(far, 1);
        }
        if (cl.length === 1) cen = cl[0].p;
        /* the middle of the doors may stand in another room: then the first door's point */
        var rC = roomOfS(cen.x, cen.z);
        if (rC !== c0o.room) cen = c0o.p;
        alarmAt(cen, coNeed, 'outside ' + cl.map(function (o9) { return o9.bed; }).join(' + ') + ' in ' + (c0o.room.name || 'the next room'), 'out');
        OUTS = OUTS.filter(function (o9) { return cl.indexOf(o9) < 0; });
      }
      if (!AL.length) {
        /* a storey with no bedroom still has one (R314.3(3)), in its largest living space */
        var big9 = null;
        for (q = 0; q < R.length; q++) if ((R[q].nec === 'living' || R[q].nec === 'hall') && (!big9 || R[q].area > big9.area)) big9 = R[q];
        /* smoke only: CO goes outside the sleeping areas (R315.3) */
        if (big9) { var Cg = centroid(big9); alarmAt({ x: Cg.x + 0.6, z: Cg.z }, false, 'the storey\'s (' + (big9.name || 'living space') + ')', 'storey'); }
      }
      var interM = 0;
      if (AL.length) {
        interM = circLen(AL.map(function (a) { return { x: a.x, z: a.z, y: a.y }; }), null, 'EEE00006');
        add('EEE00006', interM);
        var nCo = AL.filter(function (a) { return a.combo; }).length;
        said.push('R314 / R315 alarms: ' + (AL.length - nCo) + ' x ' + NK.smoke + ' smoke' + (nCo ? (', ' + nCo + ' x EES00007 smoke + CO (' + (env.attachedGarage ? 'an attached garage' : 'a fuel appliance') + ': R315.2)') : '') +
                  ' -- ' + AL.map(function (a) { return a.why; }).join('; ') + '; hardwired off the lighting, interconnected, ' + m1(interM) + ' m 14/3' + (UPS ? ' (on from the alarms below by the riser)' : ''));
      }

      /* 210.52(E) / 210.70(A)(2): OUTSIDE, BY EVERY PEOPLE DOOR (the ground storey) */
      var CO2 = null, nExtL = 0;
      if (!UPS) {
        var thr = wt + NK.through;
        try { if (typeof env.wallThrough === 'function') { var tW = +env.wallThrough(); if (tW > 0 && tW < 1) thr = tW + 0.02; } } catch (eTW) {}
        var PDs = extDoors.filter(function (d7) { return d7.door; }), ptsO = [];
        for (q = 0; q < PDs.length; q++) {
          var e7 = PDs[q], s7 = sides[e7.side], sg7 = (e7.hand === 'right') ? -1 : 1;
          var uR7 = e7.u + sg7 * (e7.w / 2 + 0.35), uL7 = e7.u + sg7 * (e7.w / 2 + 0.25);
          uR7 = Math.max(0.2, Math.min(s7.len - 0.2, uR7)); uL7 = Math.max(0.2, Math.min(s7.len - 0.2, uL7));
          var xr = s7.a[0] + s7.u[0] * uR7 - s7.n[0] * thr, zr = s7.a[1] + s7.u[1] * uR7 - s7.n[1] * thr;
          ptsO.push(dev(xr, zr, -s7.n[0], -s7.n[1], y0 + NK.outY, NK.outRcpt, 'elec-socket'));
          var xl = s7.a[0] + s7.u[0] * uL7 - s7.n[0] * thr, zl = s7.a[1] + s7.u[1] * uL7 - s7.n[1] * thr;
          dev(xl, zl, -s7.n[0], -s7.n[1], y0 + NK.lightY, 'EEW00003', 'elec-light');
          /* its switch inside beside the door, in the room's switch box (two-gang) */
          add(ELEC.sw, 1);
          if (PTG) {
            /* mep-v57: drawn -- inside beside the door, on the latch side 150
               off it: the next gang of the room's switch when that switch
               stands there (the entrance's), else a switch in a box of its
               own, the box and its three connectors billed with it (a back
               door across a great room is not switched from the front) */
            var uS7 = Math.max(0.15, Math.min(s7.len - 0.15, e7.u + sg7 * (e7.w / 2 + 0.15)));
            var xs7 = s7.a[0] + s7.u[0] * uS7, zs7 = s7.a[1] + s7.u[1] * uS7, S7 = _swAt(SWP, xs7 + s7.n[0] * 0.30, zs7 + s7.n[1] * 0.30, true);
            _asmCode(ctx, ELEC.sw, 'top');
            if (S7 && Math.hypot(S7.x - xs7, S7.z - zs7) < 1.5) { _gang(T, g, S7, mSw, 'elec-switch', vizTag); nGang++; gangIn.push(s7.k + ' in the ' + S7.room + ' switch box'); }
            else {
              var bS7 = withBox(wdev(xs7, zs7, s7.n[0], s7.n[1], y0 + ELEC.swH, mSw, 'elec-switch', 0.08, 0.08, 0.012));
              bS7.userData.qtyPiece = 'esx' + q;
              DEV.push({ x: xs7, z: zs7, y: y0 + ELEC.swH, code: ELEC.sw, box: true });
              nGang++; gangIn.push(s7.k + ' beside its door, a box of its own');
            }
          }
          add(ELEC.cable, NK.extLightM * NK.slack);
          nExtL++;
        }
        if (PDs.length === 1) {
          /* one people door: a second receptacle at the back -- the longest side farthest from it */
          var e8 = PDs[0], best8 = -1, bl = -1;
          for (q = 0; q < NS; q++) if (q !== e8.side && sides[q].len > bl) { bl = sides[q].len; best8 = q; }
          if (best8 >= 0) {
            var s8 = sides[best8], u8 = s8.len / 2;
            ptsO.push(dev(s8.a[0] + s8.u[0] * u8 - s8.n[0] * thr, s8.a[1] + s8.u[1] * u8 - s8.n[1] * thr, -s8.n[0], -s8.n[1], y0 + NK.outY, NK.outRcpt, 'elec-socket'));
          }
        }
        if (ptsO.length) {
          CO2 = circ('outdoor receptacles', NK.brk20, 1, ELEC.cable);
          CO2.pts = ptsO.map(function (p) { return { x: p.x, z: p.z, y: p.y }; });
          CO2.extra = ptsO.length * (thr + 0.30);
          said.push('210.52(E) outside: ' + ptsO.length + ' x ' + NK.outRcpt + ' (weatherproof GFCI, in-use cover) by the people door(s)' + (PDs.length === 1 ? ' and at the back' : '') +
                    ' on their own 20 A circuit; ' + nExtL + ' exterior light(s) EEW00003 beside the door(s), switched inside (+' + nExtL + ' x ' + ELEC.sw + ' in the two-gang box' + (PTG ? (', ' + nGang + ' drawn, mep-v57: ' + gangIn.join(', ')) : '') + ')');
        }
      }

      /* THE NEW CIRCUITS' CABLES AND BREAKERS */
      var brkN = {}, polesN = 0, cabL = {};
      for (q = 0; q < RB.length; q++) { brkN[RB[q].brk] = (brkN[RB[q].brk] || 0) + 1; polesN++; }
      for (q = 0; q < CIR.length; q++) {
        var C9 = CIR[q];
        if (!C9.pts.length) continue;
        var Lc = circLen(C9.pts, null, C9.cable) + (C9.extra || 0);
        cabL[C9.cable] = (cabL[C9.cable] || 0) + Lc;
        brkN[C9.brk] = (brkN[C9.brk] || 0) + 1; polesN += C9.poles;
        C9.L = Lc;
      }
      var kc;
      for (kc in cabL) if (cabL.hasOwnProperty(kc)) add(kc, cabL[kc]);
      for (kc in brkN) if (brkN.hasOwnProperty(kc)) add(kc, brkN[kc]);
      /* a box behind every device the kit drew, three connectors in it */
      var nBx = DEV.filter(function (o) { return o.box; }).length;
      add(ELEC.box, nBx); add(ELEC.conn, nBx * 3);
      /* the service (the ground storey's board) */
      if (!UPS && NSVC) {
        /* mep-v51 (env.necService false): no service here -- the product
           bills its inlet, cord and main; the line's main-lug board, its
           back-fed main's 2 spaces counted */
        add(NK.surge, 1);
        polesN += 2 + 2;   /* the surge protector, the back-fed main */
        NK.lastNeed = polesN + 4;
        add(ELEC.board, 1);
      } else if (!UPS) {
        add(NK.surge, 1); add('EEM00001', 1); add('EEE00007', NK.seM);
        polesN += 2;   /* the surge protector */
        /* mep-v27 (BARNDO thread, the panel's spaces): the heat pump's and
           the water heater's 2-pole breakers come in their own layers -- 4
           spaces more, counted against the panel's 40. */
        /* mep-v29 (the sheet has the row now): the US service is ONE panel,
           the 200 A main-breaker load center of 40 spaces EED00002 -- a
           200 A main breaker is not added to a main-lug board (EED00001) */
        NK.lastNeed = polesN + 4;
        add(NK.panel, 1);
      }
      for (kc in bill) if (bill.hasOwnProperty(kc)) _add(LID, kc, Math.round(bill[kc] * 100) / 100);
      ctx.log('ELEC nec  US code (mep-v25, env.nec): ' + said.length + ' rule group(s) applied on ' + (UPS ? ('storey ' + (stN + 1)) : 'the ground storey') + ' -- devices drawn, the new runs ' +
              (necDraw ? ('DRAWN on the routes they are billed on (mep-v46, env.necDraw): ' + Object.keys(necDrawn).map(function (k9) { return m1(necDrawn[k9]) + ' m ' + k9; }).join(', ') + ' -- the bill adds 300 a box and 15 per cent') : 'calculated (not drawn)'));
      for (q = 0; q < said.length; q++) ctx.log('ELEC nec  ' + said[q]);
      var CIRu = CIR.filter(function (c) { return c.pts.length; });
      ctx.log('ELEC nec  circuits added: ' + (CIRu.length ? CIRu.map(function (c) { return c.what + ' ' + c.brk + (c.poles === 2 ? ' (2 pole)' : '') + ' ' + m1(c.L) + ' m ' + c.cable; }).join('; ') : 'none on this storey'));
      ctx.log('ELEC nec  breakers by what they feed (210.12 AFCI, 210.8 GFCI): ' + Object.keys(brkN).map(function (k9) { return brkN[k9] + ' x ' + k9; }).join(', ') +
              ' -- the line\'s ' + RB.length + ' room circuit(s) among them' + (UPS ? ', in the board below' : (NSVC ? ('; no whole-house RCD (European); ' + NK.surge + ' surge protector; NO SERVICE HERE (mep-v51, env.necService false): no meter socket, no SER -- the product\'s inlet, cord and back-fed main') : ('; no whole-house RCD (European); ' + NK.surge + ' surge protector (230.67), ' + '' + 'EEM00001 meter socket, ' + NK.seM + ' m EEE00007 through the wall to it'))) +
              '; ' + polesN + ' space(s) in the board' + (UPS ? '' : (NSVC ? (' + 4 for the heat pump and the water heater = ' + NK.lastNeed + ' of the ' + (env.necSpaces || 24) + ' of ' + ELEC.board + ', the line\'s main-lug board' + ((NK.lastNeed > (env.necSpaces || 24)) ? ' -- MORE THAN IT HAS: a bigger board' : ''))
                                                                         : (' + 4 for the heat pump and the water heater = ' + NK.lastNeed + ' of the ' + NK.spaces + ' of ' + NK.panel + ', the 200 A main-breaker load center (mep-v29)' + ((NK.lastNeed > NK.spaces) ? ' -- MORE THAN IT HAS: a sub-panel needed' : '')))));
      var pendN = Object.keys(bill).filter(function (k9) { return /^mep\./.test(k9); });
      ctx.log('ELEC nec  boxes ' + nBx + ' x ' + ELEC.box + ', ' + (nBx * 3) + ' x ' + ELEC.conn + (pendN.length ? ('; pending (no sheet row yet): ' + pendN.join(', ')) : '; every row in the sheet'));
      for (q = 0; q < warn.length; q++) ctx.log('ELEC nec  CHECK ' + warn[q]);
    }

    _add(LID, ELEC.cable, tally.cable);
    _add(LID, ELEC.socket, tally.sockets);
    /* a junction box behind every socket, switch and light, three quick
       connectors in each, and the grounding set at the board (Marek). The
       surface variant adds its branch boxes: the same catalogue item,
       counted together, which is what the electrician buys. */
    var nDev = (tally.sockets || 0) + (tally.switches || 0) + (tally.lights || 0);
    var nBox = nDev + (tally.boxes || 0);
    if (nBox) { _add(LID, ELEC.box, nBox); _add(LID, ELEC.conn, nBox * 3); }
    if (!UPS) _add(LID, ELEC.earth, 1);
    /* mep-v27: the lamps a room was lit with in a grid under the product's code */
    var nGrid = 0, kG;
    if (tally.grid) for (kG in tally.grid) if (tally.grid.hasOwnProperty(kG)) { _add(LID, kG, tally.grid[kG]); nGrid += tally.grid[kG]; }
    if (gridLog.length) ctx.log('ELEC lights by area (mep-v27, env.lightGrid): ' + gridLog.join('; '));
    _add(LID, ELEC.light, tally.lights - nGrid);
    _add(LID, ELEC.sw, tally.switches);
    /* a socket circuit and a lighting circuit a room, a closet only the lighting (adu-v1415) */
    var nCloE = 0, qc, nHot = 0;
    for (qc = 0; qc < R.length; qc++) { if (R[qc].closet) nCloE++; if (R[qc].hot) nHot++; }
    /* the hot room's heater circuit (mep-v12) -- its rows minted first */
    if (tally.hotFed) {
      if (env.CATALOG) { var kH; for (kH in ELEC_HOT_CAT) { if (ELEC_HOT_CAT.hasOwnProperty(kH) && !env.CATALOG[kH]) env.CATALOG[kH] = { code: kH, unit: ELEC_HOT_CAT[kH].unit, label: ELEC_HOT_CAT[kH].label }; } }
      _add(LID, ELEC.heavy, tally.heavy);
      _add(LID, ELEC.brkHeavy, tally.hotFed);
    }
    /* the surface variant: ONE socket circuit and ONE lighting circuit for
       the building, on different breakers -- 16 A for the sockets, 10 A for
       the lights (shed) */
    if (SURF) { _add(LID, ELEC.brk, 1); _add(LID, ELEC.brkLight, 1); }
    else if (!NEC) _add(LID, ELEC.brk, 2 * R.length - nCloE - 2 * nHot);
    if (NEC) { try { _necKit(); } catch (eNK) { ctx.log('ELEC nec  THREW ' + ((eNK && eNK.message) || eNK)); } }
    /* mep-v49: every receptacle of the storey handed on with the board --
       the heating's rail and mat feeds start at their room's (env.heatCables) */
    if (LAST[LID]) {
      var SKH = [], qs, rs;
      for (rs = 0; rs < R.length; rs++) for (qs = 0; qs < R[rs].sockets.length; qs++) { var sh = R[rs].sockets[qs]; SKH.push({ x: sh.x, z: sh.z, y: (sh.y != null) ? sh.y : yLine }); }
      for (qs = 0; qs < NECSK.length; qs++) SKH.push(NECSK[qs]);
      LAST[LID].sockets = SKH;
      if (PTG) LAST[LID].switches = SWP;   /* mep-v57: the ventilation's gangs */
    }
    if (nHot) {
      ctx.log('ELEC sauna hot room(s) ' + nHot + ': no socket (' + (tally.hotSk || 0) + ' the walls would have had left out), no ceiling light, no switch -- the heater set brings its IP65 light EEW00002, switched at the control unit; the heater on its own circuit, ' +
              tally.hotFed + ' x ' + ELEC.brkHeavy + ' (30 A double pole), ' + (Math.round(tally.heavy * 10) / 10) + ' m ' + ELEC.heavy + ' (10 AWG); the silicone cable on to the heater is in the heater set');
      for (qc = 0; qc < hotLog.length; qc++) ctx.log('ELEC hot room ' + hotLog[qc]);
    }
    ctx.log('ELEC ' + extDoors.length + ' exterior door(s) hopped at ' + Math.round(ELEC.headUp * 1000) + '; ' + cross.length +
            ' partition crossing(s) kept clear; every feed runs on the perimeter walls');
    if (typeof env.devFace === 'function') ctx.log('ELEC on the finished face (mep-v58, env.devFace): ' + FCE.n + ' socket(s) / switch(es) / box(es) moved out to the board or the tile, the plate ' + Math.round(DEV_PROUD * 1000) + ' mm proud, the box in the wall -- the face ' +
                                                 (FCE.n ? (Math.round(FCE.sum / FCE.n * 1000) + ' mm out from the frame on average, ' + Math.round(FCE.max * 1000) + ' at the most') : 'nowhere') +
                                                 (FCE.shell ? ('; ' + FCE.shell + ' place(s) beside a door refused -- in the outer wall') : '') +
                                                 '; ' + FCE.left.length + ' left where they were (outdoors, or no wall the product knows)' + (FCE.left.length ? (': ' + FCE.left.slice(0, 8).join('; ')) : ''));
    if (FLA) ctx.log('ELEC raised floor (mep-v37, env.floorAt): ' + RAISE.sk + ' socket(s) and ' + RAISE.sw + ' switch(es) on it at its own height, the socket line climbing at its edge ' +
                     RAISE.jogs + ' time(s)' + (RAISE.brd ? ('; the board ' + RAISE.brd) : '; the board on the main floor'));
    if (nLow) ctx.log('ELEC ' + nLow + ' lamp(s) under a lower ceiling (env.ceilLowAt -- a loft over them, mep-v22): hung at it, their runs and switch drops at that height');
    if (CLF) ctx.log('ELEC no ceiling: the runs at the ceiling follow the roof\'s underside (env.ceilLift, mep-v59) -- ' + nLift + ' run(s) laid along it, the drops and the branch boxes up to it');
    if (SURF) {
      ctx.log('ELEC ' + tally.rooms + ' room(s): ' + Math.round(tally.cable) + ' m ' + ELEC.cable + ', ' + tally.sockets + ' x ' + ELEC.socket + ', ' +
              tally.lights + ' x ' + ELEC.light + ', ' + tally.switches + ' x ' + ELEC.sw + ', board ' + ELEC.board +
              ' + 1 x ' + ELEC.brk + ' (sockets 16 A) + 1 x ' + ELEC.brkLight + ' (lights 10 A) + RCD ' + ELEC.rcd +
              ' -- surface-mounted throughout, there is no lining to bury it in (viz: Electrics)');
      ctx.log('ELEC boxes ' + nBox + ' x ' + ELEC.box + ' = ' + nDev + ' behind devices + ' + tally.boxes +
              ' on branches, ' + (nBox * 3) + ' x ' + ELEC.conn + ' connectors, earth ' + ELEC.earth + ' x 1');
      for (i = 0; i < boxLog.length; i++) ctx.log('ELEC box ' + (i + 1) + ': ' + boxLog[i]);
      if (nCloE) ctx.log('ELEC closets ' + nCloE + ': no socket circuit, ' + (tally.closetSk || 0) + ' socket(s) the walls would have had left out; each keeps its light and its switch (adu-v1415)');
      return;
    }
    if (UPS) ctx.log('ELEC riser: ' + nRise + ' circuit run(s) x ' + (Math.round(riserL * 100) / 100) + ' m = ' + (Math.round(nRise * riserL * 10) / 10) + ' m of the ' + Math.round(tally.cable) + ' m below');
    if (UPS) {
      ctx.log('ELEC ' + tally.rooms + ' room(s) on this storey: ' + Math.round(tally.cable) + ' m ' + ELEC.cable + ', ' + tally.sockets + ' x ' + ELEC.socket + ', ' +
              tally.lights + ' x ' + ELEC.light + ', ' + tally.switches + ' x ' + ELEC.sw + ' + ' + (2 * R.length - nCloE - 2 * nHot) +
              ' breakers ' + ELEC.brk + ' in the board of ' + env.riserFrom + ' (a socket circuit and a lighting circuit per room' + (nCloE ? (', the lighting only in ' + nCloE + ' closet(s)') : '') + ')');
      if (nCloE) ctx.log('ELEC closets ' + nCloE + ': no socket circuit, ' + (tally.closetSk || 0) + ' socket(s) the walls would have had left out; each keeps its light and its switch (adu-v1415)');
      return;
    }
    ctx.log('ELEC ' + tally.rooms + ' room(s): ' + Math.round(tally.cable) + ' m ' + ELEC.cable + ', ' + tally.sockets + ' x ' + ELEC.socket + ', ' +
            tally.lights + ' x ' + ELEC.light + ', ' + tally.switches + ' x ' + ELEC.sw + ', board ' + ELEC.board + ' + ' + (2 * R.length - nCloE - 2 * nHot) +
            (NEC ? ' room circuits (their breakers by type: ELEC nec)' : (' breakers ' + ELEC.brk)) + ' (a socket circuit and a lighting circuit per room' + (nCloE ? (', the lighting only in ' + nCloE + ' closet(s)') : '') + (nHot ? (', none in ' + nHot + ' hot room(s)') : '') + ')' + (NEC ? '' : (' + RCD ' + ELEC.rcd)) + ' -- sockets cyan, lights lime (viz: Electrics)');
    if (nCloE) ctx.log('ELEC closets ' + nCloE + ': no socket circuit, ' + (tally.closetSk || 0) + ' socket(s) the walls would have had left out; each keeps its light and its switch (adu-v1415)');
  }

  /* =========================================================================
     HEATING -- A MULTI-SPLIT, BY CALCULATION (mep-v2)

     WHAT IS BUILT (Marek, 2026-10-08): ONE outdoor unit and an indoor head
     in the living room and in every bedroom; the bathroom gets an electric
     towel rail. Calculation first: where each piece goes is worked out, the
     quantities are billed; the heads, the outdoor unit and the towel rail
     are drawn as bodies (mep-v5), the line sets stay calculated.

     COPIED FROM TINY (configurator-tiny-lib.js, the third circuit), with the
     same codes, sizes and rules -- except the head's code (mep-v3, below):
       the head on the room's EXTERIOR wall, on a clear stretch 200 clear of
       every opening and a metre of a door -- tried at 1000, then 600, then
       200, never a hard gate; its top 100 under the ceiling;
       the outdoor unit DIRECTLY BEHIND the living-room head, and if a door
       or the terrace deck is there, walked round the outside in 100 mm
       steps, both ways, to the first clear place;
       the line set DROPS INSIDE THE WALL in a corrugated sleeve and travels
       OUTSIDE at the top of the unit; liquid 3/8 and suction 5/8 over the
       whole run, both insulated, an elbow on each line at every bend;
       the feed runs WITH THE SOCKET CIRCUIT from the board, through the wall
       to the isolator 600 beside the unit at 1400; cable = (feed + the
       interconnect in each line set) plus 15 per cent; a 16 A heat pump
       breaker, the isolator and one bracket pair.
     ADAPTED for the multi-split and for calculation:
       THE HEAD IS VMI00001, the catalogue's wall-mounted split unit (3.5 kW,
       12000 BTU), which the container bills too. Tiny's HM400001 is, by its
       own row, an air-to-water HYDRO unit and is priced as one (Marek,
       2026-10-08: na splity na ADU nejde pouzit); tiny keeps the mistake
       until it is moved onto this asset;
       THE OUTDOOR UNIT HM400002 is a multi-zone unit, 7 kW / 24000 BTU for
       three heads (his catalogue fix, 2026-10-08); more than three heads
       take a second one, as the container does -- the line sets are still
       measured to the first unit's place;
       a head per heated room instead of one in the biggest room (the biggest
       room stands in only where no room is named living room);
       of the room's exterior walls the LONGEST clear stretch takes the head,
       its middle; tiny's finer choice between walls (no deck outside, no
       door on it, nearest the board) comes with the bodies, where it shows;
       every head has its own line set to the one unit -- its length is the
       drop + the wall + the walk round the outside, a corner of the outside
       walk costing two wall depths more than the inside one; elbows = 3 a
       line (into the bay, out through the wall, along the facade) + one at
       every corner;
       a head with no exterior wall to stand on is still billed, its line set
       running from the room's middle to the nearest exterior wall first;
       the feed hops every opening on its way at head height, as the socket
       circuit does (2 x 1850 each);
       NOT A STAND-IN (mep-v11): a sauna hot room (heated by its stove), a
       porch, a terrace or a technical room never takes the living room's
       head; a SHOWER room gets its towel rail as a bathroom does;
       env.outdoorEnds (the THOW): the outdoor unit only on the two short
       walls -- on a long one it would stick out past the road width;
       the towel rail is HMR00002 (its row made in mep-v4), its feed half the
       bathroom's perimeter off the bathroom circuit, plus 15 per cent.
     THE CONDENSATE (mep-v8). Cooling makes water at every head. Its drain
     hose travels with the line set, as tiny has it (one wrapped bundle),
     down the stud bay in the same sleeve and out through the wall, and then
     STRAIGHT DOWN the facade to 100 above the ground -- never along the
     facade to the unit, where it would have no fall. A head with no
     exterior wall drains across the ceiling only with a pump: HMC00101 at
     the head (the container's rule for a run that cannot fall), its drain
     going the line set's whole way. The pump takes its power from the head.
     A clip every 500 on the facade drop, a screw each.
     Log prefix HEAT.
     ========================================================================= */
  var HEAT = { outU: 'HM400002', inU: 'VMI00001', perOut: 3, liq: 'HMS00081', suc: 'HMS00161',
               ins: 'HMP00202', cable: 'EEE00001', brk: 'EEC00010', iso: 'EEI00001',
               cover: 'HMD00751', screw: 'FAS50060', lag: 'FAS80260', seal: 'FEC00038',
               screwHead: 6, screwIso: 2, lagUnit: 4, screwCoverM: 2, sealUnit: 1,
               elbL: 'HME00081', elbS: 'HME00161', slv: 'HMF01101', brac: 'HMW00001',
               inW: 0.900, inH: 0.300, inD: 0.215, inDrop: 0.100,
               outW: 0.870, outH: 0.700, outD: 0.330, outY: 0.600,
               isoY: 1.400, isoBy: 0.600, clear: 0.200, doorClear: 1.000,
               facade: 0.100, socketH: 0.300, hopH: 2.150, extra: 1.15, walkMax: 14.0,
               /* mep-v28: a space smaller than this takes no head */
               minArea: 4.0 };
  var TWR = { code: 'HMR00002', what: 'electric towel rail 400 W', cable: 'EEE00001', screws: 4 };
  var COND = { hose: 'HMC00161', pump: 'HMC00101', clip: 'SMC00151', end: 0.10, clipEvery: 0.5 };
  /* mep-v34 (env.lineSets): the drawn line set -- its cover 75 square on the
     facade, the sleeve in the stud bay, the condensate hose; a hop 100 past
     an opening's sides and 100 over its head, never above the wall's top */
  var LSET = { cover: 0.075, sleeveR: 0.025, condR: 0.008, hopSide: 0.10, hopOver: 0.10, under: 0.05,
               colCover: 0xEDEDE6, colSleeve: 0x3A3D40, colCond: 0x8F9498 };
  /* ELECTRIC FLOOR-WARMING MATS (mep-v31, env.floorMats; RANCH thread,
     Marek 2026-10-12: rohoze urcite pridame). US practice for a bathroom:
     a 120 V mat of about 12 W / sq ft taped to the primed subfloor, under
     a 1/4 in. self-leveling pour and the tile; never under the tub, the
     shower, the toilet or a vanity -- 4 in. off the walls and the pieces,
     6 in. off the toilet's flange; a programmable thermostat with a floor
     sensor and a built-in GFCI (NEC 424.44(E)) by the door side of the
     towel rail at 48 in., in a box, fed off the bathroom's 20 A circuit
     (NEC 210.11(C)(3) -- a mat over 100 sq ft wants a circuit of its own:
     a CHECK). The heated area is counted on a 100 mm grid of the room's
     floor. */
  var MAT = { mat: 'mep.floorMat', stat: 'mep.floorStat', cable: 'EEE00001', box: 'EEJ00001', primer: 'PEN00001', slu: 'FFC00007',
              wall: 0.10, piece: 0.10, wc: 0.15, cell: 0.10, min: 0.50, wpm2: 129, sluMm: 6.35, sluKg: 1.7,
              statY: 1.22, statW: 0.08, statH: 0.12, statD: 0.03, dedicated: 100 * 0.3048 * 0.3048 };
  var MAT_CAT = {
    'PEN00001': { unit: 'm2', label: 'Penetrating primer' },
    'FFC00007': { unit: 'kg', label: 'Self-leveling underlayment' },
    'EEJ00001': { unit: 'pcs', label: 'Junction box' }
  };
  var MAT_PENDING = {
    'mep.floorMat':  { unit: 'm2',  label: 'Electric floor heating mat 120 V about 12 W/sq ft, under tile (pending row)' },
    'mep.floorStat': { unit: 'pcs', label: 'Floor heating thermostat, programmable, GFCI, with floor sensor (pending row)' }
  };
  /* the rows this trade bills, minted into the product's catalogue map the
     way the ADU's wall zone mints its own -- a code the map has never heard
     of is refused by _add */
  var HEAT_CAT = {
    'VMI00001': { unit: 'pcs', label: 'Indoor air-conditioning unit (wall split)' },
    'HM400002': { unit: 'pcs', label: 'Outdoor unit of heat pump (multi-zone)' },
    'HMS00081': { unit: 'm',   label: 'Copper refrigeration pipe 3/8' },
    'HMS00161': { unit: 'm',   label: 'Copper air conditioning pipe 5/8' },
    'HMP00202': { unit: 'm',   label: 'Closed cell elastomeric pipe insulation 20/13' },
    'HMR00002': { unit: 'pcs', label: 'Electric towel rail 400 W' },
    'HMD00751': { unit: 'm',   label: 'Line set cover 75' },
    'FAS50060': { unit: 'pcs', label: 'Wood screw 5x60' },
    'FAS80260': { unit: 'pcs', label: 'Washer head screw 8x260' },
    'FEC00038': { unit: 'pcs', label: 'Polyurethane construction sealant 290 ml' },
    'HMF01101': { unit: 'm',   label: 'Corrugated protective pipe 110' },
    'HME00081': { unit: 'pcs', label: 'Copper press elbow 3/8' },
    'HME00161': { unit: 'pcs', label: 'Copper press elbow 5/8' },
    'EEC00010': { unit: 'pcs', label: '16 A heat pump circuit breaker' },
    'EEI00001': { unit: 'pcs', label: 'Outdoor isolator switch IP65' },
    'HMW00001': { unit: 'pcs', label: 'Outdoor unit wall bracket' },
    'EEE00001': { unit: 'm',   label: 'Cable 3x2.5' },
    'HMC00161': { unit: 'm',   label: 'Condensate drain hose 5/8' },
    'HMC00101': { unit: 'pcs', label: 'Condensate pump' },
    'SMC00151': { unit: 'pcs', label: 'Pipe clip 20' }
  };
  /* mep-v27 (env.outdoorPad, BARNDO thread; Marek 2026-10-11: jak je praxe
     -- byvaji na fasade, nebo na samostatnych konzolach kousek od steny?
     chtelo by to i jejich zalozeni a ukotveni). US practice, and the rule on
     a post-frame steel wall that carries no bracket: THE OUTDOOR UNIT STANDS
     ON THE GROUND, 12 in. off the wall (its rear clearance and the air it
     draws), on a cast concrete pad 3 in. over grade (IRC M1305.1.4.1: level,
     on a slab 3 in. above the adjoining ground) on 4 in. of compacted stone;
     the unit on four anti-vibration riser feet 4 in. -- in a cold climate
     (frost V.coldFrost deep or more) on a 16 in. galvanized snow stand
     instead -- the feet or the stand anchored to the pad (4 concrete screw
     anchors) and the unit bolted to them (4 hex bolts). No wall bracket, no
     lag through the facade. The isolator stays on the wall beside it. */
  var HEAT_PAD = { gap: 12 * 0.0254, top: 3 * 0.0254, t: 4 * 0.0254, stone: 4 * 0.0254, edge: 3 * 0.0254,
                   feetH: 4 * 0.0254, standH: 18 * 0.0254, coldFrost: 0.60,
                   feet: 'HMW00002', stand: 'HMW00003', anchor: 'FAS10075', anchors: 4, bolt: 'FAT10001', bolts: 4 };
  var HEAT_PAD_CAT = {
    'FAS10075': { unit: 'pcs', label: 'Concrete screw anchor 10x75' },
    'FAT10001': { unit: 'pcs', label: 'Hex bolt with nut and washers M10x30' }
  };
  var HEAT_PAD_MADE = {
    'HMW00002': { unit: 'pcs', label: 'Anti-vibration riser feet for a condensing unit, set of 4, 4 in. (rubber, with bolts)' },
    'HMW00003': { unit: 'pcs', label: 'Condensing unit stand 16 in., galvanized steel, for snow, to anchor to a pad' }
  };
  var HEAT_NEED = ['API', 'STATE', 'CATALOG', 'FINISH', '_P', '_add', '_billReset', '_buildRect',
                   'wallThickness', '_roomKey', '_roomLabel', '_terraceRect'];
  function _heatMissing(env) {
    var out = [], i;
    if (!env) return ['env'];
    if (typeof env.layerId !== 'string' || !env.layerId) out.push('layerId');
    for (i = 0; i < HEAT_NEED.length; i++) if (env[HEAT_NEED[i]] == null) out.push(HEAT_NEED[i]);
    return out;
  }

  function _buildHeat(env, ctx) {
    var LID = env.layerId, API = env.API, CATALOG = env.CATALOG, FINISH = env.FINISH,
        _P = env._P, _add = env._add, _billReset = env._billReset, _buildRect = env._buildRect,
        wallThickness = env.wallThickness, _roomKey = env._roomKey, _roomLabel = env._roomLabel,
        _terraceRect = env._terraceRect;
    _billReset(LID);
    var i, j, k, q;
    function m2(v) { return Math.round(v * 100) / 100; }
    function mm(v) { return Math.round(v * 1000); }
    for (k in HEAT_CAT) {
      if (!HEAT_CAT.hasOwnProperty(k) || CATALOG[k]) continue;
      CATALOG[k] = { code: k, unit: HEAT_CAT[k].unit, label: HEAT_CAT[k].label };
    }
    var PL = _P();
    if (!PL || !PL.rooms) { ctx.log('HEAT none -- floorplan asset without rooms'); return; }
    var rooms = PL.rooms() || [];
    if (!rooms.length) { ctx.log('HEAT none -- no room'); return; }

    /* THE PERIMETER, the same inner faces the electrics use (mep-v14: the
       outline as the walls run, a rectangle as it was) */
    var B0 = _buildRect(), wt = wallThickness();
    var PER = _perim(env, B0, wt), IN = PER.IN, sides = PER.sides, NS = sides.length;
    if (!PER.rect) ctx.log('HEAT perimeter: ' + PER.note + ' (mep-v14)');
    var perim = 0; for (q = 0; q < NS; q++) perim += sides[q].len;
    function onSide(x, z) {
      var best = null, bd = 1e9, s;
      for (s = 0; s < NS; s++) {
        var S = sides[s], u = (x - S.a[0]) * S.u[0] + (z - S.a[1]) * S.u[1];
        u = Math.max(0, Math.min(S.len, u));
        var px = S.a[0] + S.u[0] * u, pz = S.a[1] + S.u[1] * u, d = Math.hypot(px - x, pz - z);
        if (d < bd) { bd = d; best = { side: s, u: u, x: px, z: pz, d: d }; }
      }
      return best;
    }
    function uAbs(side, u) { var t = 0, s; for (s = 0; s < side; s++) t += sides[s].len; return t + u; }
    /* the shorter way round from one point on the perimeter to another, and
       how many corners it turns */
    function walk(s1, u1, s2, u2) {
      if (s1 === s2) return { len: Math.abs(u2 - u1), corners: 0, reflex: 0, dir: u2 >= u1 ? 1 : -1 };
      var a1 = uAbs(s1, u1), a2 = uAbs(s2, u2);
      var fwd = ((a2 - a1) % perim + perim) % perim, back = perim - fwd;
      var cF = ((s2 - s1) % NS + NS) % NS, cB = NS - cF;
      /* the inside corners of an L or a T on the way (mep-v14): outside, the
         line set goes round them SHORTER, not longer */
      var rF = 0, rB = 0, w9;
      for (w9 = 0; w9 < cF; w9++) if (!sides[(s1 + w9) % NS].cvx) rF++;
      for (w9 = 1; w9 <= cB; w9++) if (!sides[((s1 - w9) % NS + NS) % NS].cvx) rB++;
      return fwd <= back ? { len: fwd, corners: cF, reflex: rF, dir: 1 } : { len: back, corners: cB, reflex: rB, dir: -1 };
    }
    /* the openings on each side, from the wall segments */
    var SEG = API.segments ? API.segments() : [], OPS = [];
    for (q = 0; q < NS; q++) OPS.push([]);
    for (i = 0; i < SEG.length; i++) {
      var sg = SEG[i]; if (!sg || !sg.openings || !(sg.len > 0)) continue;
      var ux = (sg.x1 - sg.x0) / sg.len, uz = (sg.z1 - sg.z0) / sg.len;
      for (j = 0; j < sg.openings.length; j++) {
        var o = sg.openings[j], ps = onSide(sg.x0 + ux * o.at, sg.z0 + uz * o.at);
        var oSill = _sillOf(env, o);
        OPS[ps.side].push({ u: ps.u, w: o.w || 0.9, sill: oSill, top: oSill + (o.h || 2.1), door: oSill < 0.05 });
      }
    }

    var y0 = API.storeys()[0].y0 + FINISH.dry.h;
    var yCeil = API.wallTop() - 0.02;
    var yHeadLo = yCeil - HEAT.inDrop - HEAT.inH;          /* the head's underside */
    /* mep-v27 (env.outdoorPad): the unit on the ground, on its pad and its
       feet or snow stand; its centre's height over the floor follows */
    var PAD = env.outdoorPad === true, padCold = false, padRaise = 0, outY = HEAT.outY, padGap = 0;
    if (PAD) {
      var frP = null;
      try { frP = (typeof env.frostDepth === 'function') ? env.frostDepth() : null; } catch (eFP) { frP = null; }
      padCold = (frP != null && frP >= HEAT_PAD.coldFrost);
      padRaise = padCold ? HEAT_PAD.standH : HEAT_PAD.feetH;
      outY = HEAT_PAD.top + padRaise + HEAT.outH / 2 - y0;
      padGap = HEAT_PAD.gap;
      var kPd;
      for (kPd in HEAT_PAD_CAT) if (HEAT_PAD_CAT.hasOwnProperty(kPd) && !CATALOG[kPd]) CATALOG[kPd] = { code: kPd, unit: HEAT_PAD_CAT[kPd].unit, label: HEAT_PAD_CAT[kPd].label };
      for (kPd in HEAT_PAD_MADE) if (HEAT_PAD_MADE.hasOwnProperty(kPd) && !CATALOG[kPd]) CATALOG[kPd] = { code: kPd, unit: HEAT_PAD_MADE[kPd].unit, label: HEAT_PAD_MADE[kPd].label };
    }
    var yLow = y0 + outY + HEAT.outH / 2;              /* the outside run, at the unit's top */
    var through = wt + HEAT.facade;                         /* frame + facade, the hole through the wall */
    /* mep-v34: with env.lineSets the wall's real thickness, when the product gives it */
    var LSON = env.lineSets === true;
    if (LSON && typeof env.wallThrough === 'function') { try { var thW = +env.wallThrough(); if (thW > 0.05 && thW < 1.0) through = thW; } catch (eTW) {} }
    var drop = Math.max(0, yHeadLo - yLow);
    /* mep-v22: a lower ceiling over a head (env.ceilLowAt, under a loft) */
    function headCeil(x, z) {
      if (typeof env.ceilLowAt !== 'function') return yCeil;
      var yL = null;
      try { yL = env.ceilLowAt(x, z); } catch (eL) { yL = null; }
      return (typeof yL === 'number' && isFinite(yL) && yL < yCeil - 0.05 && yL > y0 + 1.8) ? yL : yCeil;
    }

    /* THE ROOMS: living room and bedrooms get a head, the bathroom a rail */
    var R = [], living = 0, HRn = [];
    /* mep-v45: a room the product calls habitable (env.headRoom) as a bedroom */
    var HRf = (typeof env.headRoom === 'function') ? function (k9, n9) { try { return !!env.headRoom(k9, n9); } catch (eHR) { return false; } } : null;
    for (i = 0; i < rooms.length; i++) {
      var rm = rooms[i]; if (!rm || !rm.rects || !rm.rects.length) continue;
      var key = '', nm = '';
      try { key = _roomKey(rm, i) || ''; } catch (eK) { key = ''; }
      try { nm = rm.closet ? _roomLabel(rm, i) : (PL.roomName ? PL.roomName(rm, i) : _roomLabel(rm, i)); } catch (eN) { nm = ''; }
      nm = nm || ('room ' + i);
      var area = 0, big = null, bA = -1;
      for (j = 0; j < rm.rects.length; j++) {
        var r0 = rm.rects[j], a0 = (r0.x1 - r0.x0) * (r0.z1 - r0.z0);
        area += a0; if (a0 > bA) { bA = a0; big = r0; }
      }
      var kind = rm.closet ? 'closet'
               : (key === 'rooms.livingroom' || (!key && /living/i.test(nm))) ? 'living'
               : (key === 'rooms.bedroom' || (!key && /bed/i.test(nm))) ? 'bed'
               : (key === 'rooms.bathroom' || key === 'rooms.shower' || (!key && /bath|shower/i.test(nm))) ? 'bath'
               : (HRf && HRf(key, nm)) ? 'bed' : 'other';
      if (kind === 'living') living++;
      if (kind === 'bed' && HRf && key !== 'rooms.bedroom' && !(!key && /bed/i.test(nm))) HRn.push(nm);
      R.push({ i: i, name: nm, key: key, kind: kind, rects: rm.rects, big: big, area: area });
    }
    /* mep-v23: THE ROOMS OF STOREY 2 (env.roomsUp + env.storeyY): on the same
       unit; a living room up there is no stand-in for the ground floor's */
    var UPR = [], dyUp = null, nUpHeads = 0, nUpRails = 0;
    if (typeof env.roomsUp === 'function' && typeof env.storeyY === 'function') {
      try { var yUp9 = env.storeyY(1); if (typeof yUp9 === 'number' && isFinite(yUp9) && yUp9 > y0 + 1.0) dyUp = yUp9 - y0; } catch (eY9) { dyUp = null; }
      if (dyUp != null) { try { UPR = env.roomsUp() || []; } catch (eU9) { UPR = []; } }
    }
    for (i = 0; i < UPR.length; i++) {
      var rmU = UPR[i]; if (!rmU || !rmU.rects || !rmU.rects.length) continue;
      var keyU = '', nmU = '';
      try { keyU = _roomKey(rmU, i) || ''; } catch (eKU) { keyU = ''; }
      try { nmU = _roomLabel(rmU, i); } catch (eNU) { nmU = ''; }
      nmU = 'storey 2 ' + (nmU || ('room ' + i));
      var areaU = 0, bigU = null, bAU = -1;
      for (j = 0; j < rmU.rects.length; j++) {
        var rU = rmU.rects[j], aU = (rU.x1 - rU.x0) * (rU.z1 - rU.z0);
        areaU += aU; if (aU > bAU) { bAU = aU; bigU = rU; }
      }
      var kindU = rmU.closet ? 'closet'
                /* mep-v39 (env.upLiving): the living room up there too, when the dwelling is up there */
                : (env.upLiving && (keyU === 'rooms.livingroom' || (!keyU && /living/i.test(nmU)))) ? 'living'
                : (keyU === 'rooms.bedroom' || (!keyU && /bed/i.test(nmU))) ? 'bed'
                : (keyU === 'rooms.bathroom' || keyU === 'rooms.shower' || (!keyU && /bath|shower/i.test(nmU))) ? 'bath' : 'other';
      R.push({ i: -1 - i, name: nmU, key: keyU, kind: kindU, rects: rmU.rects, big: bigU, area: areaU, up: true });
      if (kindU === 'living') living++;
      if (kindU === 'bed' || kindU === 'living') nUpHeads++; else if (kindU === 'bath') nUpRails++;
    }
    /* ONE SPACE, ONE HEAD (mep-v28, RANCH thread; Marek 2026-10-11: upravoval
       jsem plan a vygenerovalo se velke mnozstvi klimatizaci -- a ranch whose
       plan the separators had cut into 99 rooms got 64 heads and 22 outdoor
       units). Rooms that meet with no wall between them -- across a separator
       (a sep partition, the open plan's room line) or where nothing stands --
       are one air space, and a head serves the space, not each piece of it:
       among its living rooms / bedrooms the head goes into the biggest one
       with an exterior wall (the biggest if none has one), the rest are pieces
       of that space. A space under HEAT.minArea (4 m2) takes no head (slivers
       between walls). Should that leave no head where there were candidates,
       the biggest living room / bedroom keeps its own. */
    var spaceSaid = '';
    (function () {
      var G = [], g, h;
      for (g = 0; g < R.length; g++) if (!R[g].up) G.push(R[g]);
      if (!G.length) return;
      var WALLS = [], PS0 = (env.STATE && env.STATE.parts) || [];
      for (g = 0; g < PS0.length; g++) {
        var p0 = PS0[g]; if (!p0 || p0.sep || ((p0.st | 0) !== 0)) continue;
        var pa = (p0.a != null) ? p0.a : ((p0.s != null) ? p0.s : -1e9), pb = (p0.b != null) ? p0.b : ((p0.e != null) ? p0.e : 1e9);
        WALLS.push({ o: p0.o || p0.dir, c: (p0.c != null) ? p0.c : p0.at, a: Math.min(pa, pb), b: Math.max(pa, pb) });
      }
      /* how much of the line o = c from lo to hi no wall covers */
      function openLen(o, c, lo, hi) {
        var iv = [], q;
        for (q = 0; q < WALLS.length; q++) {
          var w = WALLS[q]; if (w.o !== o || !(Math.abs(w.c - c) <= 0.03)) continue;
          var a = Math.max(lo, w.a), b = Math.min(hi, w.b); if (b > a) iv.push([a, b]);
        }
        iv.sort(function (u, v) { return u[0] - v[0]; });
        var cov = 0, end = lo;
        for (q = 0; q < iv.length; q++) { if (iv[q][1] <= end) continue; cov += iv[q][1] - Math.max(end, iv[q][0]); end = iv[q][1]; }
        return (hi - lo) - cov;
      }
      function joined(A, B) {
        var p, q, tol = 0.02;
        for (p = 0; p < A.rects.length; p++) for (q = 0; q < B.rects.length; q++) {
          var a = A.rects[p], b = B.rects[q], lo, hi;
          if (Math.abs(a.x1 - b.x0) < tol || Math.abs(b.x1 - a.x0) < tol) {
            lo = Math.max(a.z0, b.z0); hi = Math.min(a.z1, b.z1);
            if (hi - lo > 0.10 && openLen('v', Math.abs(a.x1 - b.x0) < tol ? a.x1 : a.x0, lo, hi) > 0.25) return true;
          }
          if (Math.abs(a.z1 - b.z0) < tol || Math.abs(b.z1 - a.z0) < tol) {
            lo = Math.max(a.x0, b.x0); hi = Math.min(a.x1, b.x1);
            if (hi - lo > 0.10 && openLen('h', Math.abs(a.z1 - b.z0) < tol ? a.z1 : a.z0, lo, hi) > 0.25) return true;
          }
        }
        return false;
      }
      var up = [];
      for (g = 0; g < G.length; g++) up.push(g);
      function root(x) { while (up[x] !== x) { up[x] = up[up[x]]; x = up[x]; } return x; }
      for (g = 0; g < G.length; g++) for (h = g + 1; h < G.length; h++) {
        if (root(g) === root(h)) continue;
        if (joined(G[g], G[h])) up[root(h)] = root(g);
      }
      var SP = {}, cand = 0;
      for (g = 0; g < G.length; g++) { var rt = root(g); (SP[rt] = SP[rt] || []).push(G[g]); if (G[g].kind === 'living' || G[g].kind === 'bed') cand++; }
      if (!cand) return;
      /* the longest stretch of exterior wall a room has, and what a head needs */
      var NEED = HEAT.inW + 0.20 + 2 * HEAT.clear;
      function runOf(r) { var S9 = [], q9, L0 = 0; try { S9 = stretches(r); } catch (eX) { S9 = []; } for (q9 = 0; q9 < S9.length; q9++) L0 = Math.max(L0, S9[q9].b - S9[q9].a); return L0; }
      var DRY_NO = /bath|shower|wc|toilet|closet|wardrobe|garage|technical|container_room_6|sauna|steam|porch|terrace|laundry|storage|pantry/i;
      var nSp = 0, folded = [], small = [], hosted = [], k9, best9 = null;
      for (k9 in SP) {
        if (!SP.hasOwnProperty(k9)) continue;
        var L9 = SP[k9], aS = 0, hasLiv = false, pick = null, pScore = -1, m;
        for (m = 0; m < L9.length; m++) aS += L9[m].area;
        /* the biggest living room / bedroom whose exterior wall holds a head */
        for (m = 0; m < L9.length; m++) {
          var r9 = L9[m]; if (r9.kind !== 'living' && r9.kind !== 'bed') continue;
          if (r9.kind === 'living') hasLiv = true;
          if (!best9 || r9.area > best9.area) best9 = r9;
          var run9 = runOf(r9), sc = (run9 >= NEED ? 2e6 : 0) + r9.area * 1e3 + run9;
          if (sc > pScore) { pScore = sc; pick = r9; }
        }
        if (!pick) continue;
        /* none holds one: the head hangs on the space's exterior wall in a dry
           piece of the same space (the kitchen end of an open plan, a hall
           piece), in the name of the space's living room / bedroom */
        if (runOf(pick) < NEED && aS >= HEAT.minArea) {
          var host = null, hRun = NEED - 1e-6;
          for (m = 0; m < L9.length; m++) {
            var r7 = L9[m]; if (r7.kind !== 'other' || DRY_NO.test(r7.key + ' ' + r7.name)) continue;
            var run7 = runOf(r7); if (run7 > hRun) { hRun = run7; host = r7; }
          }
          if (host) {
            hosted.push(pick.name + ' on the wall of ' + host.name);
            host.kind0 = 'other'; host.name = pick.name + ' (on the ' + host.name + ' wall)';
            pick.kind0 = pick.kind; pick.kind = 'piece'; folded.push(pick.name + ' ' + m2(pick.area));
            pick = host; pick.kind = hasLiv ? 'living' : 'bed';
          }
        }
        for (m = 0; m < L9.length; m++) {
          var r8 = L9[m]; if (r8.kind !== 'living' && r8.kind !== 'bed') continue;
          if (r8.kind0 == null) r8.kind0 = r8.kind;
          if (aS < HEAT.minArea) { r8.kind = 'small'; small.push(r8.name + ' ' + m2(r8.area)); continue; }
          if (r8 !== pick) { r8.kind = 'piece'; folded.push(r8.name + ' ' + m2(r8.area)); }
        }
        if (aS >= HEAT.minArea) {
          nSp++;
          if (hasLiv) pick.kind = 'living';
          pick.space = { area: aS, rooms: L9.length };
        }
      }
      if (!nSp && best9) { best9.kind = best9.kind0 || 'living'; nSp = 1; small = small.filter(function (s) { return s.indexOf(best9.name + ' ') !== 0; }); }
      living = 0;
      for (g = 0; g < R.length; g++) if (R[g].kind === 'living') living++;
      spaceSaid = 'HEAT one head a space (mep-v28): ' + G.length + ' room(s) on the ground floor in ' + Object.keys(SP).length + ' space(s) (rooms that meet with no wall between them are one), ' +
                  nSp + ' of them with a living room / bedroom get a head' +
                  (folded.length ? ('; ' + folded.length + ' living room / bedroom piece(s) served by their space\'s head: ' + folded.slice(0, 12).join(', ') + (folded.length > 12 ? ', ...' : '')) : '') +
                  (hosted.length ? ('; on a dry piece\'s exterior wall: ' + hosted.join(', ')) : '') +
                  (small.length ? ('; ' + small.length + ' under ' + HEAT.minArea + ' m2, no head: ' + small.slice(0, 12).join(', ') + (small.length > 12 ? ', ...' : '')) : '');
    })();
    if (spaceSaid) ctx.log(spaceSaid);
    /* NO ROOM NAMED LIVING ROOM: the biggest dry room stands in (tiny's rule) */
    if (!living) {
      var bestR = null;
      for (i = 0; i < R.length; i++) {
        if ((R[i].up && !env.upLiving) || R[i].kind !== 'other' || /kitchen|hall|entry|store|storage|pantry|laundry|wc|garage|mud/i.test(R[i].key + ' ' + R[i].name)) continue;
        /* nor a sauna hot room, a porch, a terrace, a technical room (mep-v11) */
        if (/sauna|steam|porch|terrace|technical|container_room_6/i.test(R[i].key + ' ' + R[i].name)) continue;
        if (!bestR || R[i].area > bestR.area) bestR = R[i];
      }
      if (bestR) { bestR.kind = 'living'; bestR.stand = true; if (bestR.up) nUpHeads++; }
    }
    var heads = [], rails = [], cold = [], nCl = 0;
    for (i = 0; i < R.length; i++) {
      if (R[i].kind === 'living') heads.unshift(R[i]);
      else if (R[i].kind === 'bed') heads.push(R[i]);
      else if (R[i].kind === 'bath') rails.push(R[i]);
      else if (R[i].kind === 'closet') nCl++;
      else cold.push(R[i].name);
    }
    if (!heads.length) {
      ctx.log('HEAT none -- no living room and no bedroom in the plan, so no head and no outdoor unit' +
              (rails.length ? (' (' + rails.length + ' bathroom rail(s) below)') : ''));
    }

    /* WHERE EACH HEAD GOES: the longest clear stretch of its room's exterior
       wall; doors kept 1000 clear, then 600, then 200 */
    /* mep-v28: a room made of several cells (a plan cut by separators) has
       its exterior wall in as many pieces, each too short for a head though
       the wall runs on -- the pieces that meet on one side are one stretch */
    function stretches(rm) {
      /* mep-v67: no head on a party wall (env.innerSide) */
      var L = stretches0(rm).filter(function (st0) { return !(sides[st0.side] && sides[st0.side].inner); }), out = [], q;
      L.sort(function (p1, p2) { return (p1.side - p2.side) || (p1.a - p2.a); });
      for (q = 0; q < L.length; q++) {
        var cur = out.length ? out[out.length - 1] : null;
        if (cur && cur.side === L[q].side && L[q].a <= cur.b + 0.02) cur.b = Math.max(cur.b, L[q].b);
        else out.push({ side: L[q].side, a: L[q].a, b: L[q].b });
      }
      return out;
    }
    function stretches0(rm) {
      /* mep-v28: a room drawn to the outline (RANCH) has its edge a wall's
         thickness off the inner face -- 160 there, over the 150 this allowed,
         so every head of the RANCH hung on an inner wall with a pump */
      var out = [], tol = Math.max(0.15, wt + 0.05), r, s;
      if (!PER.rect) {
        /* the outline (mep-v14): every rect edge lying on a side, as a stretch along it */
        for (r = 0; r < rm.rects.length; r++) {
          var cR = rm.rects[r], EG = [[cR.x0, cR.z0, cR.x1, cR.z0], [cR.x1, cR.z0, cR.x1, cR.z1], [cR.x0, cR.z1, cR.x1, cR.z1], [cR.x0, cR.z0, cR.x0, cR.z1]], e9, s9;
          for (e9 = 0; e9 < 4; e9++) for (s9 = 0; s9 < NS; s9++) {
            var S9 = sides[s9], G = EG[e9];
            var dA = (G[0] - S9.a[0]) * S9.n[0] + (G[1] - S9.a[1]) * S9.n[1], dB = (G[2] - S9.a[0]) * S9.n[0] + (G[3] - S9.a[1]) * S9.n[1];
            if (Math.abs(dA) > tol || Math.abs(dB) > tol) continue;
            var uA9 = (G[0] - S9.a[0]) * S9.u[0] + (G[1] - S9.a[1]) * S9.u[1], uB9 = (G[2] - S9.a[0]) * S9.u[0] + (G[3] - S9.a[1]) * S9.u[1];
            var a9 = Math.max(0, Math.min(uA9, uB9)), b9 = Math.min(S9.len, Math.max(uA9, uB9));
            if (b9 > a9 + 0.05) out.push({ side: s9, a: a9, b: b9 });
          }
        }
        return out;
      }
      for (r = 0; r < rm.rects.length; r++) {
        var c = rm.rects[r];
        if (Math.abs(c.z0 - IN.z0) < tol) out.push({ side: 0, a: c.x0 - IN.x0, b: c.x1 - IN.x0 });
        if (Math.abs(c.x1 - IN.x1) < tol) out.push({ side: 1, a: c.z0 - IN.z0, b: c.z1 - IN.z0 });
        if (Math.abs(c.z1 - IN.z1) < tol) out.push({ side: 2, a: IN.x1 - c.x1, b: IN.x1 - c.x0 });
        if (Math.abs(c.x0 - IN.x0) < tol) out.push({ side: 3, a: IN.z1 - c.z1, b: IN.z1 - c.z0 });
      }
      for (s = 0; s < out.length; s++) {
        out[s].a = Math.max(0, out[s].a); out[s].b = Math.min(sides[out[s].side].len, out[s].b);
      }
      return out;
    }
    function freeRun(st, dClear, up) {
      var free = [{ a: st.a + HEAT.clear, b: st.b - HEAT.clear }], ops = OPS[st.side], o2, f, doors = 0;
      for (o2 = 0; o2 < ops.length; o2++) {
        if (up && !(ops[o2].top > dyUp + 0.05)) continue;   /* mep-v23: an opening under storey 2 */
        /* mep-v45: and a ground room's head is not kept off storey 2's windows */
        if (!up && dyUp != null && ops[o2].sill != null && ops[o2].sill > dyUp - 0.05) continue;
        var cl = ops[o2].door ? dClear : HEAT.clear;
        var oa = ops[o2].u - ops[o2].w / 2 - cl, ob = ops[o2].u + ops[o2].w / 2 + cl;
        if (ob <= st.a || oa >= st.b) continue;
        if (ops[o2].door) doors++;
        var kept = [];
        for (f = 0; f < free.length; f++) {
          if (ob <= free[f].a || oa >= free[f].b) { kept.push(free[f]); continue; }
          if (oa > free[f].a) kept.push({ a: free[f].a, b: oa });
          if (ob < free[f].b) kept.push({ a: ob, b: free[f].b });
        }
        free = kept;
      }
      var best = null;
      for (f = 0; f < free.length; f++) if (free[f].b > free[f].a && (!best || free[f].b - free[f].a > best.b - best.a)) best = free[f];
      return best ? { a: best.a, b: best.b, len: best.b - best.a, doors: doors } : null;
    }
    var need = HEAT.inW + 0.20, tries = [HEAT.doorClear, 0.600, HEAT.clear];
    for (i = 0; i < heads.length; i++) {
      var H = heads[i], ST = stretches(H), t, pick = null, used = 0;
      for (t = 0; t < tries.length && !pick; t++) {
        for (j = 0; j < ST.length; j++) {
          var FR = freeRun(ST[j], tries[t], H.up);
          if (FR && FR.len >= need && (!pick || FR.len > pick.len)) { pick = FR; pick.side = ST[j].side; used = tries[t]; }
        }
      }
      if (pick) {
        H.side = pick.side; H.u = (pick.a + pick.b) / 2; H.run = pick.len; H.clearUsed = used;
      } else {
        /* no exterior wall holds a head: billed all the same, the line set
           crossing the ceiling from the room's middle to the nearest wall */
        var cx = (H.big.x0 + H.big.x1) / 2, cz = (H.big.z0 + H.big.z1) / 2, ns = onSide(cx, cz);
        H.side = ns.side; H.u = ns.u; H.noWall = ns.d; H.exts = ST.length;
      }
    }

    /* THE OUTDOOR UNIT: behind the living-room head, walked round the outside
       off a doorway and off the terrace deck */
    var DK = null;
    try { DK = _terraceRect ? _terraceRect() : null; } catch (eD) { DK = null; }
    function unitAt(s, u) {
      var S = sides[s], off = through + HEAT.outD / 2;
      return { x: S.a[0] + S.u[0] * u - S.n[0] * off, z: S.a[1] + S.u[1] * u - S.n[1] * off };
    }
    /* THE ROAD WIDTH (mep-v11, env.outdoorEnds -- the THOW): the unit only on
       the two short walls; on a long one it would stick out past the width */
    var ENDS = !!env.outdoorEnds, shortLen = Math.min(IN.x1 - IN.x0, IN.z1 - IN.z0);
    var OKW = (typeof env.outdoorOk === 'function') ? function (k) { try { return env.outdoorOk(k) !== false; } catch (eOK) { return true; } } : null;
    function unitClear(s, u) {
      var S = sides[s], half = HEAT.outW / 2 + 0.10, o3;
      if (ENDS && S.len > shortLen + 0.01) return false;
      /* mep-v37 (env.outdoorOk): a wall the product keeps the unit off (a gooseneck's front, over the pickup) */
      if (OKW && !OKW(S.k)) return false;
      if (S.inner) return false;   /* mep-v67: not on a party wall (env.innerSide) */
      if (u < half || u > S.len - half) return false;
      if (!PER.rect && PER.outline) {
        /* outside the outline, all of it: by an inside corner it would stand in the other wing (mep-v14) */
        var cU = unitAt(s, u), hwU = HEAT.outW / 2, hdU = HEAT.outD / 2 + 0.02, k9;
        var CU = [[cU.x + S.u[0] * hwU + S.n[0] * hdU, cU.z + S.u[1] * hwU + S.n[1] * hdU], [cU.x - S.u[0] * hwU + S.n[0] * hdU, cU.z - S.u[1] * hwU + S.n[1] * hdU],
                  [cU.x + S.u[0] * hwU - S.n[0] * hdU, cU.z + S.u[1] * hwU - S.n[1] * hdU], [cU.x - S.u[0] * hwU - S.n[0] * hdU, cU.z - S.u[1] * hwU - S.n[1] * hdU]];
        for (k9 = 0; k9 < 4; k9++) if (_ptInPoly(PER.outline, CU[k9][0], CU[k9][1])) return false;
      }
      for (o3 = 0; o3 < OPS[s].length; o3++) {
        if (!OPS[s][o3].door) continue;
        if (Math.abs(u - OPS[s][o3].u) < OPS[s][o3].w / 2 + HEAT.outW / 2 + HEAT.doorClear) return false;
      }
      if (DK) {
        var c = unitAt(s, u), alx = Math.abs(S.u[0]) >= Math.abs(S.u[1]);
        var hw = alx ? HEAT.outW / 2 : HEAT.outD / 2, hd = alx ? HEAT.outD / 2 : HEAT.outW / 2, m = 0.30;
        if (c.x + hw > DK.x0 - m && c.x - hw < DK.x1 + m && c.z + hd > DK.z0 - m && c.z - hd < DK.z1 + m) return false;
      }
      return true;
    }
    var U = null;
    if (heads.length) {
      var h0 = heads[0], dirs = [1, -1], d2;
      for (d2 = 0; d2 < 2; d2++) {
        var s0 = h0.side, u0 = h0.u, trav = 0, guard = 0, corners = 0;
        while (guard++ < 400 && trav <= HEAT.walkMax) {
          if (unitClear(s0, u0)) {
            if (!U || trav < U.travel) U = { side: s0, u: u0, travel: trav, corners: corners };
            break;
          }
          u0 += dirs[d2] * 0.10; trav += 0.10;
          if (u0 > sides[s0].len || u0 < 0) {
            s0 = ((s0 + dirs[d2]) % NS + NS) % NS; corners++;
            u0 = dirs[d2] > 0 ? 0 : sides[s0].len;
          }
        }
      }
      if (!U && ENDS) {
        /* no clear place on a short wall: the middle of the nearer one all the same */
        var eP = -1, wE = null, e9b;
        for (e9b = 0; e9b < NS; e9b++) {
          if (sides[e9b].len > shortLen + 0.01) continue;
          if (OKW && !OKW(sides[e9b].k)) continue;   /* mep-v37 */
          var wEq = walk(h0.side, h0.u, e9b, sides[e9b].len / 2);
          if (!wE || wEq.len < wE.len) { wE = wEq; eP = e9b; }
        }
        if (eP >= 0) U = { side: eP, u: sides[eP].len / 2, travel: wE.len, corners: wE.corners, forced: true };
      }
      if (!U) {
        U = { side: h0.side, u: h0.u, travel: 0, corners: 0, forced: true };
      }
      var UP = unitAt(U.side, U.u);
      U.x = UP.x; U.z = UP.z;
    }

    /* mep-v34: THE ROUTE ON THE FACADE, side by side from a head's point to
       the unit's, the way walk() went: [{ side, uA, uB }] in the walking
       direction. And the hops: on each piece the openings the cover would
       cross at its height (a door, a window reaching below it), merged
       where they touch, each { side, u0, u1, y }. */
    function _lsRoute(s1, u1, s2, u2, dir) {
      var out = [], s = s1, u = u1, guard = 0;
      if (s1 === s2 && (dir > 0 ? u2 >= u1 : u2 <= u1)) return [{ side: s1, uA: u1, uB: u2 }];
      while (guard++ < NS + 2) {
        var end = dir > 0 ? sides[s].len : 0;
        if (s === s2 && guard > 1) { out.push({ side: s, uA: u, uB: u2 }); return out; }
        out.push({ side: s, uA: u, uB: end });
        s = ((s + dir) % NS + NS) % NS;
        u = dir > 0 ? 0 : sides[s].len;
      }
      return out;
    }
    function _lsHops(route) {
      var H = [], hRun = yLow - y0, yTopMax = yCeil - 0.05, q, k;
      for (q = 0; q < route.length; q++) {
        var R = route[q], lo = Math.min(R.uA, R.uB), hi = Math.max(R.uA, R.uB), L = [];
        for (k = 0; k < OPS[R.side].length; k++) {
          var o = OPS[R.side][k], a = o.u - o.w / 2 - LSET.hopSide, b = o.u + o.w / 2 + LSET.hopSide;
          if (b <= lo || a >= hi) continue;
          if (!(o.sill < hRun + LSET.cover && o.top > hRun - LSET.cover)) continue;
          L.push({ side: R.side, u0: Math.max(lo, a), u1: Math.min(hi, b), y: Math.min(yTopMax, y0 + o.top + LSET.hopOver) });
        }
        L.sort(function (p1, p2) { return p1.u0 - p2.u0; });
        for (k = 0; k < L.length; k++) {
          var last = H.length ? H[H.length - 1] : null;
          if (last && last.side === L[k].side && L[k].u0 <= last.u1 + 0.05) { last.u1 = Math.max(last.u1, L[k].u1); last.y = Math.max(last.y, L[k].y); }
          else H.push(L[k]);
        }
      }
      return H;
    }

    /* EACH HEAD'S LINE SET to the unit */
    var tot = { L: 0, sleeve: 0, elb: 0, out: 0 };
    var fix = { screw: 0, lag: 0, seal: 0, cover: 0 };
    for (i = 0; i < heads.length; i++) {
      /* mep-v35 (env.lineSets): a head past the first unit's three goes to its
         own unit, the second beside the first (a unit's width + 300 on) */
      var uT = LSON ? (U.u + Math.floor(i / HEAT.perOut) * (HEAT.outW + 0.30)) : U.u;
      var Hh = heads[i], W2 = walk(Hh.side, Hh.u, U.side, uT);
      Hh.unitN = LSON ? Math.floor(i / HEAT.perOut) : 0;
      var outside = W2.len + (W2.corners - 2 * W2.reflex) * 2 * through;
      var inside = Hh.noWall != null ? Hh.noWall : 0;
      /* mep-v22: the head's own ceiling, and its drop from there */
      Hh.yC = yCeil;
      if (Hh.noWall == null && !Hh.up) { try { var PH9 = onFace(Hh.side, Hh.u); if (PH9) Hh.yC = headCeil(PH9.x, PH9.z); } catch (eH9) {} }
      Hh.drop = Math.max(0, Hh.yC - HEAT.inDrop - HEAT.inH - yLow);
      outside += padGap;   /* mep-v27: off the wall to the unit standing on its pad */
      /* mep-v34 (env.lineSets): the route on the facade and its hops over the openings */
      var hopL = 0, nHop = 0;
      if (LSON) {
        Hh.route = _lsRoute(Hh.side, Hh.u, U.side, uT, W2.dir);
        Hh.hops = _lsHops(Hh.route);
        for (var hq = 0; hq < Hh.hops.length; hq++) { hopL += 2 * (Hh.hops[hq].y - yLow); nHop++; }
        outside += hopL;
      }
      Hh.L = Hh.drop + through + outside + inside;
      Hh.elb = 3 + W2.corners + (Hh.noWall != null ? 1 : 0) + 4 * nHop;
      Hh.hopL = hopL; Hh.nHop = nHop;
      Hh.corners = W2.corners; Hh.outside = outside;
      tot.L += Hh.L; tot.sleeve += Hh.drop; tot.elb += Hh.elb; tot.out += outside;
    }

    /* THE CONDENSATE of every head (mep-v8): with the line set to the wall,
       then straight down the facade; a head with no wall of its own pumps */
    var cond = { L: 0, pumps: 0, clips: 0 }, dropOut = Math.max(0, yLow - COND.end);
    for (i = 0; i < heads.length; i++) {
      var Hc = heads[i];
      Hc.cond = (Hc.noWall != null) ? (Hc.L + dropOut) : ((Hc.drop != null ? Hc.drop : drop) + through + dropOut);
      if (Hc.noWall != null) cond.pumps++;
      cond.L += Hc.cond;
      cond.clips += Math.ceil(dropOut / COND.clipEvery);
    }

    /* WHERE THE ISOLATOR GOES (mep-v30, THOW thread): 600 past the unit on
       the wall's run, or past its other side when that would run off the
       wall's end -- it was drawn past the corner, in the air (on a THOW's short
       wall it stood 300 out past the house and took the frame 81 narrower) */
    function _isoAt(len, uc) {
      var a = uc + HEAT.outW / 2 + HEAT.isoBy, b = uc - HEAT.outW / 2 - HEAT.isoBy;
      if (a <= len - 0.10) return a;
      if (b >= 0.10) return b;
      return Math.max(0.10, Math.min(len - 0.10, uc + HEAT.outW / 2 + 0.10));
    }
    /* THE FEED from the board, with the socket circuit, to the isolator */
    var EL = LAST[env.elecId || ''] || null, feed = 0, hops = 0, feedNote = '';
    if (heads.length && EL && EL.board) {
      var BD = EL.board, uIso = _isoAt(sides[U.side].len, U.u);
      var W3 = walk(BD.side, BD.u, U.side, uIso), o4, s4;
      /* the openings the socket line would cross on the way, each hopped at head height */
      var aB = uAbs(BD.side, BD.u), aI = uAbs(U.side, uIso);
      for (s4 = 0; s4 < NS; s4++) for (o4 = 0; o4 < OPS[s4].length; o4++) {
        var oo = OPS[s4][o4];
        if (!(oo.sill < HEAT.socketH + 0.05 && oo.top > HEAT.socketH - 0.05)) continue;
        var aO = uAbs(s4, oo.u);
        var rel = W3.dir > 0 ? (((aO - aB) % perim) + perim) % perim : (((aB - aO) % perim) + perim) % perim;
        if (rel > 0 && rel < W3.len) hops++;
      }
      feed = (EL.yBrd - (y0 + HEAT.socketH)) + W3.len + hops * 2 * (HEAT.hopH - HEAT.socketH) +
             (HEAT.isoY - HEAT.socketH) + through + Math.abs(HEAT.isoY - outY) + (HEAT.outW / 2 + HEAT.isoBy) + padGap;
      feedNote = m2(feed) + ' m from the board on wall ' + sides[BD.side].k + ' along the socket circuit, ' +
                 m2(W3.len) + ' m round ' + W3.corners + ' corner(s), ' + hops + ' opening(s) hopped at ' + mm(HEAT.hopH) +
                 ', through the wall to the isolator ' + mm(HEAT.isoBy) + ' beside the unit at ' + mm(HEAT.isoY);
    } else if (heads.length) {
      feedNote = 'NOT BILLED -- no board yet (the electrics put it beside the entrance door, and there is none), so the feed waits for it';
    }

    /* THE BILL */
    var nOut = heads.length ? Math.ceil(heads.length / HEAT.perOut) : 0;
    if (heads.length) {
      _add(LID, HEAT.outU, nOut);
      _add(LID, HEAT.inU, heads.length);
      _add(LID, HEAT.liq, m2(tot.L));
      _add(LID, HEAT.suc, m2(tot.L));
      _add(LID, HEAT.ins, m2(tot.L * 2));
      if (tot.sleeve > 0.05) _add(LID, HEAT.slv, m2(tot.sleeve));
      _add(LID, HEAT.elbL, tot.elb);
      _add(LID, HEAT.elbS, tot.elb);
      /* a feed, a breaker, an isolator and a bracket pair per outdoor unit;
         a second unit stands beside the first, so its feed is taken as long */
      _add(LID, HEAT.cable, m2((feed * nOut + tot.L) * HEAT.extra));
      _add(LID, HEAT.brk, nOut);
      _add(LID, HEAT.iso, nOut);
      if (!PAD) _add(LID, HEAT.brac, nOut);
      else {
        /* mep-v27: the pad -- dug, stone, concrete -- the feet or the stand, anchored, the unit bolted */
        var pW = HEAT.outW + 2 * HEAT_PAD.edge, pD = HEAT.outD + 2 * HEAT_PAD.edge, pDig = HEAT_PAD.t - HEAT_PAD.top + HEAT_PAD.stone;
        _add(LID, 'grd.excavation', Math.round(nOut * (pW + 0.20) * (pD + 0.20) * pDig * 1000) / 1000);
        _add(LID, 'grd.gravel', Math.round(nOut * (pW + 0.10) * (pD + 0.10) * HEAT_PAD.stone * 1000) / 1000);
        _add(LID, 'grd.concrete', Math.round(nOut * pW * pD * HEAT_PAD.t * 1000) / 1000);
        _add(LID, padCold ? HEAT_PAD.stand : HEAT_PAD.feet, nOut);
        _add(LID, HEAT_PAD.anchor, nOut * HEAT_PAD.anchors);
        _add(LID, HEAT_PAD.bolt, nOut * HEAT_PAD.bolts);
      }
      /* THE OUTSIDE RUN IN ITS COVER, and what fixes every piece: the
         bracket pair through the facade into the studs (8 x 260 clears a
         contact facade and still bites 80 into the stud), the head's
         mounting plate and the isolator into the frame or the battens,
         the cover to the facade every 500, one cartridge of sealant per
         unit for the wall penetrations */
      if (tot.out > 0.05) {
        _add(LID, HEAT.cover, m2(tot.out));
        fix.cover = Math.ceil(tot.out * HEAT.screwCoverM);
      }
      fix.screw = heads.length * HEAT.screwHead + nOut * HEAT.screwIso + fix.cover;
      fix.lag = PAD ? 0 : nOut * HEAT.lagUnit;
      fix.seal = nOut * HEAT.sealUnit;
    }
    var railCable = 0;
    for (i = 0; i < rails.length; i++) {
      var bb = rails[i].big, half = (bb.x1 - bb.x0) + (bb.z1 - bb.z0);
      rails[i].feed = half; railCable += half;
    }
    if (rails.length) {
      _add(LID, TWR.code, rails.length);
      fix.screw += rails.length * TWR.screws;
    }
    /* mep-v49 (env.heatCables): the rail's and the mat's feeds are drawn from
       their room's receptacle and billed as drawn, after the bodies */
    var hcDefer = env.heatCables === true;
    if (railCable > 0 && !hcDefer) _add(LID, TWR.cable, m2(railCable * HEAT.extra));
    /* mep-v31: THE FLOOR MATS (env.floorMats) in every bathroom the rails went to */
    var MATS = [];
    if (env.floorMats === true && rails.length) {
      var kM;
      for (kM in MAT_CAT) if (MAT_CAT.hasOwnProperty(kM) && !CATALOG[kM]) CATALOG[kM] = { code: kM, unit: MAT_CAT[kM].unit, label: MAT_CAT[kM].label };
      for (kM in MAT_PENDING) if (MAT_PENDING.hasOwnProperty(kM) && !CATALOG[kM]) CATALOG[kM] = { code: null, pending: true, unit: MAT_PENDING[kM].unit, label: MAT_PENDING[kM].label };
      var FXM = (env.STATE && env.STATE.product && env.STATE.product.fixtures) || [];
      var catM = (PL.fixtures && PL.fixtures.catalog) ? (PL.fixtures.catalog() || {}) : {};
      var inRects = function (RS, x, z) { for (var q9 = 0; q9 < RS.length; q9++) { var r9 = RS[q9]; if (x >= r9.x0 - 1e-6 && x <= r9.x1 + 1e-6 && z >= r9.z0 - 1e-6 && z <= r9.z1 + 1e-6) return true; } return false; };
      for (i = 0; i < rails.length; i++) {
        var RmM = rails[i], RS = RmM.rects || [], stM = RmM.up ? 1 : 0, cut = [], wetCut = [], nPc = 0;
        for (j = 0; j < FXM.length; j++) {
          var fM = FXM[j];
          if (!fM || !fM.kind || ((fM.st != null ? (fM.st | 0) : 0) !== stM) || !inRects(RS, fM.x, fM.z)) continue;
          var DM = catM[fM.kind] || {}, wM = DM.w || 0.6, dM = DM.d || 0.6;
          try { var SZM = PL.fixtures.size ? PL.fixtures.size(fM) : null; if (SZM && SZM.w > 0 && SZM.d > 0) { wM = SZM.w; dM = SZM.d; } } catch (eSZ) {}
          if ((fM.rot | 0) % 2) { var tM = wM; wM = dM; dM = tM; }
          var wc = /^wc|toilet/i.test(fM.kind), wet = /bath|tub|shower/i.test(fM.kind), clr = wc ? MAT.wc : MAT.piece;
          cut.push({ x0: fM.x - wM / 2 - clr, x1: fM.x + wM / 2 + clr, z0: fM.z - dM / 2 - clr, z1: fM.z + dM / 2 + clr });
          if (wet) wetCut.push({ x0: fM.x - wM / 2, x1: fM.x + wM / 2, z0: fM.z - dM / 2, z1: fM.z + dM / 2 });
          nPc++;
        }
        /* the grid: a cell is heated when the room's floor reaches MAT.wall
           past it every way and no piece (with its clearance) stands on it */
        var cs = MAT.cell, cells = [], floorA = 0, wetA = 0, r8, cx, cz;
        for (r8 = 0; r8 < RS.length; r8++) {
          var Rr8 = RS[r8];
          floorA += (Rr8.x1 - Rr8.x0) * (Rr8.z1 - Rr8.z0);
          for (cx = Rr8.x0 + cs / 2; cx < Rr8.x1; cx += cs) {
            for (cz = Rr8.z0 + cs / 2; cz < Rr8.z1; cz += cs) {
              var okC = inRects(RS, cx - cs / 2 - MAT.wall, cz) && inRects(RS, cx + cs / 2 + MAT.wall, cz) &&
                        inRects(RS, cx, cz - cs / 2 - MAT.wall) && inRects(RS, cx, cz + cs / 2 + MAT.wall);
              for (j = 0; okC && j < cut.length; j++) { var cu = cut[j]; if (cx + cs / 2 > cu.x0 && cx - cs / 2 < cu.x1 && cz + cs / 2 > cu.z0 && cz - cs / 2 < cu.z1) okC = false; }
              if (okC) cells.push([cx, cz]);
            }
          }
        }
        for (j = 0; j < wetCut.length; j++) wetA += (wetCut[j].x1 - wetCut[j].x0) * (wetCut[j].z1 - wetCut[j].z0);
        var aMat = cells.length * cs * cs;
        if (aMat < MAT.min) { RmM.matNote = RmM.name + ': no mat -- ' + m2(aMat) + ' m2 free of its ' + nPc + ' piece(s), under ' + MAT.min; continue; }
        var aSlu = Math.max(aMat, floorA - wetA), bbM = RmM.big, feedM = (bbM.x1 - bbM.x0) + (bbM.z1 - bbM.z0);
        _add(LID, MAT.mat, m2(aMat));
        _add(LID, MAT.stat, 1);
        _add(LID, MAT.box, 1);
        if (!hcDefer) _add(LID, MAT.cable, m2(feedM * HEAT.extra));
        _add(LID, MAT.primer, m2(aSlu));
        _add(LID, MAT.slu, m2(aSlu * MAT.sluMm * MAT.sluKg));
        MATS.push({ R: RmM, cells: cells, area: aMat, slu: aSlu, feed: feedM, pieces: nPc,
                    big: aMat > MAT.dedicated });
      }
    }
    if (heads.length) {
      if (!hcDefer) _add(LID, COND.hose, m2(cond.L));   /* mep-v50: with env.heatCables billed as drawn */
      if (cond.pumps) _add(LID, COND.pump, cond.pumps);
      if (cond.clips) { _add(LID, COND.clip, cond.clips); fix.screw += cond.clips; }
    }
    if (fix.screw) _add(LID, HEAT.screw, fix.screw);
    if (fix.lag) _add(LID, HEAT.lag, fix.lag);
    if (fix.seal) _add(LID, HEAT.seal, fix.seal);

    /* THE LOG */
    if (heads.length) {
      ctx.log('HEAT multi-split: ' + nOut + ' outdoor unit(s) ' + HEAT.outU + ' (7 kW, 3 zones each), ' + heads.length + ' head(s) ' + HEAT.inU +
              ' (wall split 3.5 kW) -- the living room and every bedroom (Marek 2026-10-08)' + (HRn.length ? (' + the habitable room(s) the product names (env.headRoom, mep-v45): ' + HRn.join(', ')) : '') + '; calculated; heads and units drawn, line sets ' + (LSON ? 'drawn (mep-v34)' : 'not') +
              (nOut > 1 ? ('; more than ' + HEAT.perOut + ' heads: a second unit beside the first, ' + (LSON ? 'the heads past the third to it (mep-v35)' : 'the line sets measured to the first')) : ''));
      for (i = 0; i < heads.length; i++) {
        var Hl = heads[i];
        ctx.log('HEAT ' + Hl.name + ' ' + m2(Hl.area) + ' m2' + (Hl.stand ? ' (no room named living room: the biggest dry room stands in)' : '') + ': head on wall ' + sides[Hl.side].k +
                (Hl.noWall != null
                  ? (' -- NO exterior wall of the room holds ' + mm(need) + ' mm (' + Hl.exts + ' stretch(es) tried); billed all the same, ' + m2(Hl.noWall) + ' m across the ceiling to the nearest wall')
                  : (' at u=' + m2(Hl.u) + ', ' + mm(Hl.run) + ' mm of clear face, doors kept ' + mm(Hl.clearUsed) + ' clear')) +
                '; line set ' + m2(Hl.L) + ' m (drop ' + m2(Hl.drop != null ? Hl.drop : drop) + ' in the stud bay' + (Hl.yC != null && Hl.yC < yCeil - 0.05 ? ' from the lower ceiling over it' : '') + ', wall ' + m2(through) + ', outside ' + m2(Hl.outside) +
                ' round ' + Hl.corners + ' corner(s)' + (Hl.nHop ? (', ' + Hl.nHop + ' hop(s) over doors / windows +' + m2(Hl.hopL) + ' m') : '') + '), ' + Hl.elb + ' elbow(s) a line');
      }
      ctx.log('HEAT outdoor unit on wall ' + sides[U.side].k + ' at ' + U.x.toFixed(2) + ',' + U.z.toFixed(2) + ', ' + mm(U.travel) +
              ' mm round the outside from behind the ' + heads[0].name + ' head' +
              (ENDS ? ' -- on a short wall, the road width (outdoorEnds)' : '') +
              (U.forced ? (ENDS ? ' -- *** no short wall is clear of the doors, so the middle of the nearer one' : ' -- *** nowhere outside is clear of the deck and the doors, so it stays behind the head') :
               (U.travel < 0.05 ? ' -- straight through' : ' -- it had to walk, a doorway or the deck is behind the head')) +
              (DK ? '' : ' (no terrace)'));
      ctx.log('HEAT feed ' + feedNote);
      ctx.log('HEAT billed: ' + nOut + ' x ' + HEAT.outU + ', ' + heads.length + ' x ' + HEAT.inU + ', ' + m2(tot.L) + ' m ' + HEAT.liq + ' + ' + m2(tot.L) + ' m ' + HEAT.suc +
              ', ' + m2(tot.L * 2) + ' m ' + HEAT.ins + ', ' + m2(tot.sleeve) + ' m ' + HEAT.slv + ', ' + tot.elb + ' x ' + HEAT.elbL + ' + ' + tot.elb + ' x ' + HEAT.elbS +
              ', ' + m2((feed * nOut + tot.L) * HEAT.extra) + ' m ' + HEAT.cable + ' (feed ' + m2(feed) + (nOut > 1 ? (' x ' + nOut) : '') + ' + interconnect ' + m2(tot.L) + ', plus 15 per cent), ' + nOut + ' x ' +
              HEAT.brk + ', ' + nOut + ' x ' + HEAT.iso + ', ' + (PAD ? ('no wall bracket -- ' + nOut + ' pad(s) (env.outdoorPad, mep-v27)') : (nOut + ' x ' + HEAT.brac)));
      if (PAD) ctx.log('HEAT outdoor unit on the ground (mep-v27, env.outdoorPad, IRC M1305.1.4.1): ' + mm(HEAT_PAD.gap) + ' off the wall, a cast pad ' + mm(HEAT.outW + 2 * HEAT_PAD.edge) + ' x ' + mm(HEAT.outD + 2 * HEAT_PAD.edge) +
                       ' x ' + mm(HEAT_PAD.t) + ' (' + mm(HEAT_PAD.top) + ' over grade, grd.concrete) on ' + mm(HEAT_PAD.stone) + ' stone grd.gravel; the unit on ' +
                       (padCold ? ('a ' + mm(HEAT_PAD.standH) + ' snow stand ' + HEAT_PAD.stand + ' (a cold climate: frost ' + HEAT_PAD.coldFrost + ' m or more)') : ('riser feet ' + HEAT_PAD.feet + ' ' + mm(HEAT_PAD.feetH))) +
                       ', anchored ' + HEAT_PAD.anchors + ' x ' + HEAT_PAD.anchor + ', bolted ' + HEAT_PAD.bolts + ' x ' + HEAT_PAD.bolt + ' -- a unit, x ' + nOut + '; no bracket, no lag through the facade');
    }
    if (heads.length) {
      ctx.log('HEAT cover and fixings: ' + m2(tot.out) + ' m ' + HEAT.cover + ' over the outside runs (one cover a line set); ' + fix.screw + ' x ' + HEAT.screw +
              ' (' + HEAT.screwHead + ' a head, ' + HEAT.screwIso + ' an isolator, ' + HEAT.screwCoverM + ' a metre of cover = ' + fix.cover +
              (rails.length ? (', ' + TWR.screws + ' a rail') : '') + (cond.clips ? (', 1 a condensate clip') : '') + '), ' + fix.lag + ' x ' + HEAT.lag + ' through the facade for the bracket(s), ' +
              fix.seal + ' x ' + HEAT.seal + ' for the wall penetrations');
      ctx.log('HEAT condensate: ' + m2(cond.L) + ' m ' + COND.hose + ' -- with each line set down the stud bay and through the wall, then ' + m2(dropOut) +
              ' m straight down the facade to ' + mm(COND.end) + ' above the ground (' + heads.map(function (h) { return h.name + ' ' + m2(h.cond) + (h.noWall != null ? ' pumped' : ''); }).join(', ') + '); ' +
              (cond.pumps ? (cond.pumps + ' x ' + COND.pump + ' pump at a head with no exterior wall (powered from the head)') : 'no pump -- every head drains by gravity') +
              '; ' + cond.clips + ' x ' + COND.clip + ' clip(s) on the facade drops');
    }
    for (i = 0; i < rails.length; i++) {
      ctx.log('HEAT ' + rails[i].name + ': ' + TWR.what + ' ' + TWR.code + ', its feed ' +
              (hcDefer ? 'drawn from the room\'s receptacle and billed as drawn (see HEAT rail / mat feeds, mep-v49)' : (m2(rails[i].feed) + ' m (half the room\'s perimeter, off the bathroom circuit) billed in ' + TWR.cable + ' plus 15 per cent')) +
              ', ' + TWR.screws + ' x ' + HEAT.screw);
    }
    if (cold.length || nCl) ctx.log('HEAT no heater by the rule: ' + (cold.length ? cold.join(', ') : '') + (nCl ? ((cold.length ? ', ' : '') + nCl + ' closet(s)') : ''));

    /* =======================================================================
       THE BODIES (mep-v5). The heads, the outdoor unit on its bracket pair,
       the isolator beside it and the towel rail are drawn where the
       calculation put them, in their natural colours (a head looks like a
       head; the strong colours are for runs, and the runs stay calculated,
       not drawn -- Marek, 2026-10-08). Everything carries viz 'heat' and
       sits in the layer's own group, so the services view keeps it solid
       with the electrics. Nothing here changes a quantity.
       ======================================================================= */
    var T = ctx.THREE, g = ctx.group;
    if (!T || !g || !T.Mesh) {
      /* the deferred feeds billed by the old measure when nothing is drawn */
      if (hcDefer) { if (railCable > 0) _add(LID, TWR.cable, m2(railCable * HEAT.extra)); MATS.forEach(function (M0) { _add(LID, MAT.cable, m2(M0.feed * HEAT.extra)); }); if (heads.length) _add(LID, COND.hose, m2(cond.L)); }
      ctx.log('HEAT bodies none -- no THREE or no group handed over'); return;
    }
    var mag = (typeof env.isNew === 'function') ? !!env.isNew(LID) : false, MAG = env.MAGENTA || 0xFF00FF;
    function mat(col, rough, metal) {
      return new T.MeshStandardMaterial({ color: mag ? MAG : col, roughness: rough, metalness: metal });
    }
    var mHead = mat(0xF4F4F2, 0.45, 0.0), mOut = mat(0xE4E5E3, 0.55, 0.1), mBrac = mat(0x8F9498, 0.5, 0.6),
        mIso = mat(0xD8D9D6, 0.6, 0.0), mRail = mat(0xF2F2F0, 0.3, 0.2);
    var asm = (typeof env._asmCode === 'function') ? env._asmCode : null;
    var nBody = 0;
    function box(cx, y, cz, w, h, d, nx, nz, m, name) {
      var b = new T.Mesh(new T.BoxGeometry(w, h, d), m);
      b.position.set(cx, y, cz);
      b.rotation.y = Math.atan2(nx, nz);
      b.name = name; b.userData.viz = 'heat'; g.add(b); nBody++;
      return b;
    }
    function rod(cx, y, cz, r, len, theta, lying, m, name) {
      var c = new T.Mesh(new T.CylinderGeometry(r, r, len, 10), m);
      c.position.set(cx, y, cz);
      if (lying) c.rotation.set(0, theta, Math.PI / 2);
      c.name = name; c.userData.viz = 'heat'; g.add(c); nBody++;
      return c;
    }
    /* a point on the inner face of a side, and the room's normal there */
    function onFace(s, u) {
      var S = sides[s];
      return { x: S.a[0] + S.u[0] * u, z: S.a[1] + S.u[1] * u, nx: S.n[0], nz: S.n[1] };
    }
    /* THE INTERIOR WALL OF A ROOM, where its exterior walls have no room: the
       room's faces (the floorplan asset's own), the longest free run along
       one of them, clear of its interior doors by 200 -- for a rail always
       tried after the exterior walls, for a head only when it had none */
    var DOORS = [], q2, q3, parts0 = env.STATE && env.STATE.parts ? env.STATE.parts : [];
    var drs = env.STATE && env.STATE.doors ? env.STATE.doors : [];
    for (q2 = 0; q2 < drs.length; q2++) {
      var dd = drs[q2], pp = null;
      for (q3 = 0; q3 < parts0.length; q3++) if (parts0[q3] && parts0[q3].id === dd.pid) pp = parts0[q3];
      if (!pp) continue;
      var vv = (pp.dir || pp.o) === 'v', pcc = (pp.at != null) ? pp.at : pp.c;
      DOORS.push({ x: vv ? pcc : dd.u, z: vv ? dd.u : pcc, w: dd.w || 0.9, vert: vv });
    }
    function innerSpot(rm, need2) {
      var b = rm.big, F = null;
      try { F = PL.roomFaces ? PL.roomFaces((b.x0 + b.x1) / 2, (b.z0 + b.z1) / 2) : null; } catch (eF) { F = null; }
      F = F || b;
      var E = [
        { horiz: true,  c: b.z0, f: F.z0, a: F.x0, b: F.x1, nx: 0, nz: 1 },
        { horiz: true,  c: b.z1, f: F.z1, a: F.x0, b: F.x1, nx: 0, nz: -1 },
        { horiz: false, c: b.x0, f: F.x0, a: F.z0, b: F.z1, nx: 1, nz: 0 },
        { horiz: false, c: b.x1, f: F.x1, a: F.z0, b: F.z1, nx: -1, nz: 0 }
      ], best = null, e2, k2;
      for (e2 = 0; e2 < 4; e2++) {
        var ed = E[e2], free = [{ a: ed.a + HEAT.clear, b: ed.b - HEAT.clear }];
        for (k2 = 0; k2 < DOORS.length; k2++) {
          var D = DOORS[k2];
          if (D.vert === ed.horiz) continue;
          if (Math.abs((ed.horiz ? D.z : D.x) - ed.c) > 0.08) continue;
          var dc = ed.horiz ? D.x : D.z, oa = dc - D.w / 2 - HEAT.clear, ob = dc + D.w / 2 + HEAT.clear, kept = [], f2;
          for (f2 = 0; f2 < free.length; f2++) {
            if (ob <= free[f2].a || oa >= free[f2].b) { kept.push(free[f2]); continue; }
            if (oa > free[f2].a) kept.push({ a: free[f2].a, b: oa });
            if (ob < free[f2].b) kept.push({ a: ob, b: free[f2].b });
          }
          free = kept;
        }
        for (k2 = 0; k2 < free.length; k2++) {
          var L2 = free[k2].b - free[k2].a;
          if (L2 >= need2 && (!best || L2 > best.len)) best = { len: L2, mid: (free[k2].a + free[k2].b) / 2, ed: ed };
        }
      }
      if (!best) return null;
      var ed2 = best.ed;
      return { x: ed2.horiz ? best.mid : ed2.f, z: ed2.horiz ? ed2.f : best.mid, nx: ed2.nx, nz: ed2.nz, len: best.len };
    }

    /* THE HEADS: on the inner face, the top 100 under the ceiling */
    var yHead = yCeil - HEAT.inDrop - HEAT.inH / 2, hNotes = [];
    if (heads.length && asm) asm(ctx, HEAT.inU, 'top');
    for (i = 0; i < heads.length; i++) {
      var Hd = heads[i], P0 = null;
      if (Hd.noWall == null) P0 = onFace(Hd.side, Hd.u);
      else {
        P0 = innerSpot(Hd, HEAT.inW + 0.20);
        hNotes.push(Hd.name + (P0 ? ' on an interior wall (no exterior wall holds it)' : ' NOT DRAWN -- no wall of the room holds it'));
      }
      if (!P0) continue;
      Hd.P0 = P0;   /* mep-v35: where the drawn head is, for its line set */
      var yHd = (Hd.up ? yCeil : headCeil(P0.x, P0.z)) - HEAT.inDrop - HEAT.inH / 2;   /* mep-v22 / v23 */
      box(P0.x + P0.nx * HEAT.inD / 2, yHd, P0.z + P0.nz * HEAT.inD / 2, HEAT.inW, HEAT.inH, HEAT.inD, P0.nx, P0.nz, mHead, 'heat-head');
    }

    /* THE OUTDOOR UNIT on its bracket pair, outside the facade, and the
       isolator 600 beside it at 1400 */
    if (heads.length && U) {
      var SU = sides[U.side], OF = onFace(U.side, U.u), onx = -SU.n[0], onz = -SU.n[1];
      var yOutC = y0 + outY;
      if (asm) asm(ctx, HEAT.outU, 'side');
      var nUnits = nOut, uu, du;
      /* mep-v56 (RANCH thread, opt-in env.unitTags): every unit's bodies under
         their own codes -- the marks were set for the first unit only, so the
         second unit, its pad and its feet stood under the first isolator's
         code -- and each unit, pad, set of feet a piece (qtyPiece) for the
         qty audit's count. Without it nothing changes. */
      var tagAllU = env.unitTags === true;
      var pcU = function (me, id) { if (tagAllU && me) me.userData.qtyPiece = id; return me; };
      for (uu = 0; uu < nUnits; uu++) {
        /* a second unit stands beside the first, a unit's width plus 300 further on */
        du = uu * (HEAT.outW + 0.30);
        var ux2 = OF.x + SU.u[0] * du, uz2 = OF.z + SU.u[1] * du;
        var off = through + padGap + HEAT.outD / 2;
        if (asm && tagAllU && uu > 0) asm(ctx, HEAT.outU, 'side');
        pcU(box(ux2 + onx * off, yOutC, uz2 + onz * off, HEAT.outW, HEAT.outH, HEAT.outD, onx, onz, mOut, 'heat-outdoor'), 'unit' + uu);
        var arm;
        if (!PAD) {
          if (asm && (uu === 0 || tagAllU)) asm(ctx, HEAT.brac, 'side');
          var offB = through + (HEAT.outD + 0.08) / 2;
          for (arm = -1; arm <= 1; arm += 2) {
            var ua = arm * (HEAT.outW / 2 - 0.08);
            box(ux2 + SU.u[0] * ua + onx * offB, yOutC - HEAT.outH / 2 - 0.025, uz2 + SU.u[1] * ua + onz * offB,
                0.05, 0.05, HEAT.outD + 0.08, onx, onz, mBrac, 'heat-bracket');
          }
        } else {
          /* mep-v27: the pad, and the feet or the snow stand on it */
          var mPadC = new T.MeshStandardMaterial({ color: mag ? MAG : 0x9E9B93, roughness: 0.95 });
          if (asm && (uu === 0 || tagAllU)) asm(ctx, 'grd.concrete', 'side');
          pcU(box(ux2 + onx * off, HEAT_PAD.top - HEAT_PAD.t / 2, uz2 + onz * off, HEAT.outW + 2 * HEAT_PAD.edge, HEAT_PAD.t, HEAT.outD + 2 * HEAT_PAD.edge, onx, onz, mPadC, 'heat-pad'), 'pad' + uu);
          if (asm && (uu === 0 || tagAllU)) asm(ctx, padCold ? HEAT_PAD.stand : HEAT_PAD.feet, 'side');
          for (arm = -1; arm <= 1; arm += 2) {
            var uaP = arm * (HEAT.outW / 2 - 0.10), q8;
            for (q8 = -1; q8 <= 1; q8 += 2) {
              var oq = off + q8 * (HEAT.outD / 2 - 0.06);
              pcU(box(ux2 + SU.u[0] * uaP + onx * oq, HEAT_PAD.top + padRaise / 2, uz2 + SU.u[1] * uaP + onz * oq,
                  padCold ? 0.04 : 0.07, padRaise, padCold ? 0.04 : 0.07, onx, onz, mBrac, padCold ? 'heat-stand' : 'heat-feet'), 'feet' + uu);
            }
            if (padCold) pcU(box(ux2 + SU.u[0] * uaP + onx * off, HEAT_PAD.top + padRaise - 0.02, uz2 + SU.u[1] * uaP + onz * off,
                             0.05, 0.04, HEAT.outD + 0.04, onx, onz, mBrac, 'heat-stand'), 'feet' + uu);
          }
        }
        if (asm && (uu === 0 || tagAllU)) asm(ctx, HEAT.iso, 'side');
        var uIso2 = _isoAt(SU.len, U.u + du) - (U.u + du), offI = through + 0.045;
        box(ux2 + SU.u[0] * uIso2 + onx * offI, y0 + HEAT.isoY, uz2 + SU.u[1] * uIso2 + onz * offI,
            0.12, 0.15, 0.09, onx, onz, mIso, 'heat-isolator');
      }
    }

    /* mep-v34 (env.lineSets): THE LINE SETS DRAWN -- the sleeve down the stud
       bay behind the head, out through the wall at the unit's top, the cover
       along the facade round the corners and over the openings to the unit,
       the condensate straight down the facade */
    var lsN = 0, lsNot = [], slvDrawn = 0;
    if (LSON && heads.length && U) {
      var mCov = mat(LSET.colCover, 0.55, 0.0), mSlv = mat(LSET.colSleeve, 0.8, 0.0), mCnd = mat(LSET.colCond, 0.6, 0.0);
      var V3 = T.Vector3, AX = new V3(1, 0, 0), AY = new V3(0, 1, 0);
      var piece = function (A, B, m, name, r) {
        var d = new V3(B[0] - A[0], B[1] - A[1], B[2] - A[2]), L = d.length();
        if (!(L > 0.004)) return;
        d.normalize();
        var me = r ? new T.Mesh(new T.CylinderGeometry(r, r, L, 8), m) : new T.Mesh(new T.BoxGeometry(L, LSET.cover, LSET.cover), m);
        me.quaternion.setFromUnitVectors(r ? AY : AX, d);
        me.position.set((A[0] + B[0]) / 2, (A[1] + B[1]) / 2, (A[2] + B[2]) / 2);
        me.name = name; me.userData.viz = 'heat'; g.add(me); nBody++;
      };
      /* mep-v44 (RANCH thread): the sleeve's pieces measured as drawn */
      var slv = function (A, B) {
        slvDrawn += Math.hypot(B[0] - A[0], B[1] - A[1], B[2] - A[2]);
        piece(A, B, mSlv, 'heat-lineset-sleeve', LSET.sleeveR);
        ICS.push([A, B]);
        CDP.push([A, B]);
      };
      /* mep-v50 (env.heatCables): the condensate rides in the sleeve too --
         each head's sleeve pieces kept, the hose drawn along them */
      var CDP = [], cdDrawn = 0, cdIn = 0, cdMiss = 0;
      /* mep-v48 (env.heatCables): the interconnect cable rides in the sleeve
         and the cover -- its pieces kept here, drawn after the line sets */
      var ICS = [];
      var offC = through + LSET.cover / 2;
      var fP = function (s9, u9, y9, o9) { var S9 = sides[s9]; return [S9.a[0] + S9.u[0] * u9 - S9.n[0] * o9, y9, S9.a[1] + S9.u[1] * u9 - S9.n[1] * o9]; };
      /* the corner of two sides on the cover's line: both offsets out */
      var cP = function (sA, sB, y9) {
        var SA = sides[sA], SB = sides[sB], C = (((sB - sA) % NS + NS) % NS === 1) ? SB.a : SA.a;
        return [C[0] - (SA.n[0] + SB.n[0]) * offC, y9, C[1] - (SA.n[1] + SB.n[1]) * offC];
      };
      for (i = 0; i < heads.length; i++) {
        var Hs = heads[i];
        if (!Hs.route || (Hs.noWall != null && !Hs.P0)) { lsNot.push(Hs.name + ' (no wall holds the head)'); cdMiss += Hs.cond || 0; continue; }
        CDP = [];
        var yTopH = (Hs.up ? yCeil : (Hs.yC != null ? Hs.yC : yCeil)) - HEAT.inDrop - HEAT.inH;
        /* the sleeve: down the bay behind the head, then out through the wall */
        if (asm) asm(ctx, HEAT.slv, 'side');
        var bay = fP(Hs.side, Hs.u, yTopH, wt / 2), bot = fP(Hs.side, Hs.u, yLow, wt / 2), exitP = fP(Hs.side, Hs.u, yLow, through);
        if (Hs.noWall != null) {
          /* mep-v35: a head on an interior wall -- its line set up through the
             ceiling, across the attic over the joists to the nearest exterior
             wall, and down that wall's bay (its condensate pumped along it) */
          var yAt = yCeil + 0.20, hx = Hs.P0.x + Hs.P0.nx * 0.05, hz = Hs.P0.z + Hs.P0.nz * 0.05;
          bay = fP(Hs.side, Hs.u, yAt, wt / 2);
          slv([hx, yTopH + HEAT.inH, hz], [hx, yAt, hz]);
          slv([hx, yAt, hz], bay);
          lsNot.push(Hs.name + ' (on an interior wall: through the ceiling and across the attic to wall ' + sides[Hs.side].k + ', pumped)');
        }
        slv(bay, bot);
        slv(bot, exitP);
        /* the cover: the route's pieces, the corners met on the cover's line, the hops */
        if (asm) asm(ctx, HEAT.cover, 'side');
        var pts = [], rq, R9;
        for (rq = 0; rq < Hs.route.length; rq++) {
          R9 = Hs.route[rq];
          var HP = Hs.hops.filter(function (h) { return h.side === R9.side; });
          if (R9.uB < R9.uA) HP = HP.slice().reverse();
          pts.push(rq ? cP(Hs.route[rq - 1].side, R9.side, yLow) : fP(R9.side, R9.uA, yLow, offC));
          HP.forEach(function (h) {
            var ua = (R9.uB >= R9.uA) ? h.u0 : h.u1, ub = (R9.uB >= R9.uA) ? h.u1 : h.u0;
            pts.push(fP(R9.side, ua, yLow, offC), fP(R9.side, ua, h.y, offC), fP(R9.side, ub, h.y, offC), fP(R9.side, ub, yLow, offC));
          });
        }
        R9 = Hs.route[Hs.route.length - 1];
        pts.push(fP(R9.side, R9.uB, yLow, offC));
        var pq;
        for (pq = 0; pq + 1 < pts.length; pq++) { piece(pts[pq], pts[pq + 1], mCov, 'heat-lineset-cover', 0); ICS.push([pts[pq], pts[pq + 1]]); }
        /* down to the unit's valves and out to its back */
        var endP = pts[pts.length - 1], yV = yLow - 0.20, endQ = fP(R9.side, R9.uB, yV, through + padGap + 0.01);
        piece(endP, [endP[0], yV, endP[2]], mCov, 'heat-lineset-cover', 0);
        piece([endP[0], yV, endP[2]], endQ, mCov, 'heat-lineset-cover', 0);
        ICS.push([endP, [endP[0], yV, endP[2]]], [[endP[0], yV, endP[2]], endQ]);
        /* the condensate: from the hole straight down the facade */
        var uC = Hs.u + ((Hs.route[0].uB >= Hs.route[0].uA) ? -0.08 : 0.08);
        if (yLow > COND.end + 0.10) {
          if (asm) asm(ctx, COND.hose, 'side');
          piece(fP(Hs.side, uC, yLow, through + 0.012), fP(Hs.side, uC, COND.end, through + 0.012), mCnd, 'heat-condensate', LSET.condR);
          cdDrawn += yLow - COND.end;
        }
        /* mep-v50 (env.heatCables): and inside, from the head along its
           sleeve to the hole, then across to the drop -- the rest of what the
           bill counts (a pumped head's hose leaves with its line set at the
           wall it reaches, and drops there) */
        if (env.heatCables === true && CDP.length) {
          if (asm) asm(ctx, COND.hose, 'side');
          var cq9, lastQ = CDP[CDP.length - 1][1];
          for (cq9 = 0; cq9 < CDP.length; cq9++) {
            var cA = CDP[cq9][0], cB = CDP[cq9][1], cLq = Math.hypot(cB[0] - cA[0], cB[1] - cA[1], cB[2] - cA[2]);
            piece(cA, cB, mCnd, 'heat-condensate', LSET.condR); cdDrawn += cLq; cdIn += cLq;
          }
          var cTo = fP(Hs.side, uC, yLow, through + 0.012);
          piece(lastQ, cTo, mCnd, 'heat-condensate', LSET.condR); cdDrawn += Math.hypot(cTo[0] - lastQ[0], cTo[1] - lastQ[1], cTo[2] - lastQ[2]);
        }
        lsN++;
      }
      /* THE SLEEVE BILLED AS DRAWN (mep-v44, RANCH thread): the bill took
         each head's drop down its bay only; the drawn sleeve also runs out
         through the wall to the cover, and a head on an interior wall has
         its run up through the ceiling and across the attic to the wall
         (mep-v35) -- on a RANCH with a garage 14 m drawn against 6.8 m
         billed. What was drawn over the drops is billed on top of them. */
      if (env.heatCables === true) {
        _add(LID, COND.hose, m2(cdDrawn + cdMiss));
        ctx.log('HEAT condensate drawn (mep-v50, env.heatCables): ' + m2(cdDrawn) + ' m ' + COND.hose + ' -- ' + m2(cdIn) + ' m inside the sleeves from the heads to the holes, the rest down the facade; billed as drawn' +
                (cdMiss ? (' + ' + m2(cdMiss) + ' m of heads not drawn, by the calculation') : '') + ' (the calculation said ' + m2(cond.L) + ' m: a pumped head counted its whole line set)');
      }
      var slvMore = m2(slvDrawn) - m2(tot.sleeve);
      if (slvMore > 0.05) _add(LID, HEAT.slv, m2(slvMore));
      ctx.log('HEAT line set sleeves (mep-v44): ' + m2(slvDrawn) + ' m ' + HEAT.slv + ' drawn = ' + m2(tot.sleeve) + ' m down the bays + ' +
              m2(Math.max(0, slvMore)) + ' m out through the walls and across the attic, all billed');
      /* THE HEATING'S CABLES DRAWN (mep-v48, RANCH thread, opt-in
         env.heatCables): the interconnect from each head to its unit in the
         sleeve and the cover, as the line set goes; the feed from the board
         to each unit's isolator the way the bill measures it -- down the
         board's wall to socket height, round the perimeter in the wall over
         the openings it meets (at the hop height), up to the isolator,
         through the wall, then to the unit's side. Billed as before. */
      if (env.heatCables === true) {
        if (asm) asm(ctx, HEAT.cable, 'side');
        var mHC = mat(0x1A1C1D, 0.6, 0.1), hcIc = 0, hcFd = 0, hcN = 0, rC = 0.006, iq;
        var cab = function (A, B) { var L = Math.hypot(B[0] - A[0], B[1] - A[1], B[2] - A[2]); if (L > 0.004) piece(A, B, mHC, 'heat-cable', rC); return L; };
        for (iq = 0; iq < ICS.length; iq++) hcIc += cab(ICS[iq][0], ICS[iq][1]);
        var BDf = EL && EL.board;
        if (BDf && BDf.side != null) {
          var oW = wt / 2, ysF = y0 + HEAT.socketH, yHop = y0 + HEAT.hopH, SUf = sides[U.side];
          /* a corner in the wall's middle */
          var cIn = function (sA, sB, y9) {
            var SA = sides[sA], SB = sides[sB], C = (((sB - sA) % NS + NS) % NS === 1) ? SB.a : SA.a;
            return [C[0] - (SA.n[0] + SB.n[0]) * oW, y9, C[1] - (SA.n[1] + SB.n[1]) * oW];
          };
          var uu9;
          for (uu9 = 0; uu9 < nOut; uu9++) {
            var ucF = U.u + uu9 * (HEAT.outW + 0.30), uIF = _isoAt(SUf.len, ucF), Wf = walk(BDf.side, BDf.u, U.side, uIF);
            var RF = _lsRoute(BDf.side, BDf.u, U.side, uIF, Wf.dir), FP = [fP(BDf.side, BDf.u, EL.yBrd, oW), fP(BDf.side, BDf.u, ysF, oW)], rf;
            for (rf = 0; rf < RF.length; rf++) {
              var Rf = RF[rf], loF = Math.min(Rf.uA, Rf.uB), hiF = Math.max(Rf.uA, Rf.uB), HF = [], kf;
              if (rf) FP.push(cIn(RF[rf - 1].side, Rf.side, ysF));
              for (kf = 0; kf < OPS[Rf.side].length; kf++) {
                var of9 = OPS[Rf.side][kf];
                if (!(of9.sill < HEAT.socketH + 0.05 && of9.top > HEAT.socketH - 0.05)) continue;
                var a9 = Math.max(loF, of9.u - of9.w / 2 - 0.05), b9 = Math.min(hiF, of9.u + of9.w / 2 + 0.05);
                if (b9 - a9 > 0.02) HF.push({ a: a9, b: b9, y: Math.min(yCeil - 0.05, Math.max(yHop, y0 + of9.top + 0.05)) });
              }
              HF.sort(function (h1, h2) { return h1.a - h2.a; });
              if (Rf.uB < Rf.uA) HF.reverse();
              HF.forEach(function (h) {
                var ua9 = (Rf.uB >= Rf.uA) ? h.a : h.b, ub9 = (Rf.uB >= Rf.uA) ? h.b : h.a;
                FP.push(fP(Rf.side, ua9, ysF, oW), fP(Rf.side, ua9, h.y, oW), fP(Rf.side, ub9, h.y, oW), fP(Rf.side, ub9, ysF, oW));
              });
            }
            var oI = through + 0.045, sgF = (uIF >= ucF) ? 1 : -1, uEdge = ucF + sgF * HEAT.outW / 2;
            FP.push(fP(U.side, uIF, ysF, oW), fP(U.side, uIF, y0 + HEAT.isoY, oW), fP(U.side, uIF, y0 + HEAT.isoY, oI),
                    fP(U.side, uIF, y0 + outY, oI), fP(U.side, uEdge, y0 + outY, oI), fP(U.side, uEdge, y0 + outY, through + padGap + 0.01));
            for (rf = 0; rf + 1 < FP.length; rf++) hcFd += cab(FP[rf], FP[rf + 1]);
            hcN++;
          }
        }
        ctx.log('HEAT cables drawn (mep-v48, env.heatCables): interconnect ' + m2(hcIc) + ' m in the sleeves and covers, ' + hcN + ' feed(s) ' + m2(hcFd) + ' m from the board to the isolators, ' +
                HEAT.cable + ' -- billed ' + m2((feed * nOut + tot.L) * HEAT.extra) + ' m (feed ' + m2(feed) + (nOut > 1 ? (' x ' + nOut) : '') + ' + interconnect ' + m2(tot.L) + ', plus 15 per cent)' + (BDf ? '' : '; NO board yet, no feed drawn'));
      }
    }

    /* THE TOWEL RAIL, a ladder and not a slab (tiny: a slab on a bathroom
       wall reads as a radiator or a mirror): the longest clear stretch of the
       bathroom's exterior wall, else of its interior walls; bottom at 600 */
    var RW = 0.50, RH = 1.10, RB = 0.60, RD = 0.07, rNotes = [];
    var FCH = { n: 0, max: 0 };   /* mep-v58: rails and mat thermostats moved onto the finished face */
    if (rails.length && asm) asm(ctx, TWR.code, 'top');
    for (i = 0; i < rails.length; i++) {
      var Rm = rails[i], STr = stretches(Rm), pick2 = null, jj;
      for (jj = 0; jj < STr.length; jj++) {
        var FR2 = freeRun(STr[jj], 0.600, Rm.up);
        if (FR2 && FR2.len >= RW + 0.20 && (!pick2 || FR2.len > pick2.len)) { pick2 = FR2; pick2.side = STr[jj].side; }
      }
      var RP = null, where = '';
      if (pick2) { RP = onFace(pick2.side, (pick2.a + pick2.b) / 2); where = 'exterior wall ' + sides[pick2.side].k + ', ' + mm(pick2.len) + ' mm clear'; }
      else {
        RP = innerSpot(Rm, RW + 0.20);
        where = RP ? ('interior wall, ' + mm(RP.len) + ' mm clear of its doors') : '';
      }
      Rm.railRP = RP;   /* mep-v31: the mat's thermostat goes beside it */
      if (!RP) { rNotes.push(Rm.name + ': NOT DRAWN -- no wall holds ' + mm(RW + 0.20) + ' mm (still billed)'); continue; }
      rNotes.push(Rm.name + ': on the ' + where);
      var th = Math.atan2(RP.nx, RP.nz), tx = RP.nz, tz = -RP.nx;   /* local x along the wall */
      var yR0 = y0 + (Rm.up ? dyUp : 0);   /* mep-v23: a rail on storey 2 stands on its floor */
      /* mep-v58 (opt-in env.devFace): on the finished face (board, tile) */
      var dRl = _faceAt(env, RP.x, RP.z, RP.nx, RP.nz, yR0 + RB + RH / 2);
      if (dRl) { FCH.n++; FCH.max = Math.max(FCH.max, dRl); }
      var cxR = RP.x + RP.nx * (RD / 2 + dRl), czR = RP.z + RP.nz * (RD / 2 + dRl), yMid = yR0 + RB + RH / 2, sgn, bar;
      for (sgn = -1; sgn <= 1; sgn += 2) {
        var ax = sgn * (RW / 2 - 0.02);
        rod(cxR + tx * ax, yMid, czR + tz * ax, 0.014, RH, 0, false, mRail, 'heat-rail-post');
      }
      for (bar = 0; bar < 11; bar++) {
        var yb = yR0 + RB + 0.05 + bar * ((RH - 0.10) / 10);
        rod(cxR, yb, czR, 0.009, RW - 0.04, th, true, mRail, 'heat-rail-bar');
      }
    }

    /* mep-v31: THE MATS, drawn just under the finished floor (the services
       view shows them through the tile), row by row; the thermostat beside
       the rail on the door side, 48 in. up */
    if (MATS.length) {
      var mMat = mat(0xE2793A, 0.8, 0.0), mStat = mat(0xF6F6F4, 0.4, 0.0), csD = MAT.cell;
      if (asm) asm(ctx, MAT.slu, 'top');
      for (i = 0; i < MATS.length; i++) {
        var MS = MATS[i], yM = y0 + (MS.R.up ? dyUp : 0) - 0.006, rowsM = {}, kk;
        MS.cells.forEach(function (c) { var key = Math.round(c[1] / csD); (rowsM[key] = rowsM[key] || []).push(c[0]); });
        for (kk in rowsM) {
          if (!rowsM.hasOwnProperty(kk)) continue;
          var xs = rowsM[kk].sort(function (a, b) { return a - b; }), st0 = xs[0], prev = xs[0], zz = (+kk) * csD, xi;
          for (xi = 1; xi <= xs.length; xi++) {
            if (xi < xs.length && xs[xi] - prev < csD * 1.5) { prev = xs[xi]; continue; }
            var bm = new T.Mesh(new T.BoxGeometry(prev - st0 + csD - 0.01, 0.003, csD - 0.01), mMat);
            bm.position.set((st0 + prev) / 2, yM, zz); bm.name = 'heat-floor-mat'; bm.userData.viz = 'heat'; g.add(bm); nBody++;
            if (xi < xs.length) { st0 = xs[xi]; prev = xs[xi]; }
          }
        }
        var RPm = MS.R.railRP;
        if (RPm) {
          var txm = RPm.nz, tzm = -RPm.nx, offm = RW / 2 + 0.25;
          /* mep-v58 (opt-in env.devFace): on the finished face */
          var dSt = _faceAt(env, RPm.x + txm * offm, RPm.z + tzm * offm, RPm.nx, RPm.nz, y0 + (MS.R.up ? dyUp : 0) + MAT.statY);
          if (dSt) { FCH.n++; FCH.max = Math.max(FCH.max, dSt); }
          var bSt = box(RPm.x + txm * offm + RPm.nx * (MAT.statD / 2 + dSt), y0 + (MS.R.up ? dyUp : 0) + MAT.statY, RPm.z + tzm * offm + RPm.nz * (MAT.statD / 2 + dSt),
                        MAT.statW, MAT.statH, MAT.statD, RPm.nx, RPm.nz, mStat, 'heat-floor-stat');
          /* mep-v57 (opt-in env.pieceTags): counted under its own code (it is
             drawn under the mats' levelling mark), its box with it */
          if (env.pieceTags === true) { bSt.userData.qtyCode = MAT.stat; bSt.userData.qtyWith = [MAT.box]; }
        }
      }
    }
    /* mep-v49 (RANCH thread, env.heatCables): THE RAILS' AND THE MATS' FEEDS
       DRAWN -- from the room's nearest receptacle (the bathroom's circuit) up
       into the ceiling void, across, and down the wall to the rail's top
       corner or to the mat's thermostat, the way the code's runs go
       (mep-v46); billed as drawn plus 15 per cent. They were billed as half
       the room's perimeter and never drawn. A rail or a mat with nowhere
       to start keeps the old measure. */
    if (hcDefer && (rails.length || MATS.length)) {
      var SKs = (EL && EL.sockets) || [], mFd = mat(0x1A1C1D, 0.6, 0.1), fdR = 0, fdM = 0, fdOld = 0, fdNote = [];
      var segF = function (A, B) {
        var dx = B[0] - A[0], dy = B[1] - A[1], dz = B[2] - A[2], L = Math.hypot(dx, dy, dz);
        if (!(L > 0.004)) return 0;
        var me = new T.Mesh(new T.CylinderGeometry(0.006, 0.006, L, 8), mFd);
        me.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), new T.Vector3(dx / L, dy / L, dz / L));
        me.position.set((A[0] + B[0]) / 2, (A[1] + B[1]) / 2, (A[2] + B[2]) / 2);
        me.name = 'heat-feed'; me.userData.viz = 'heat'; g.add(me); nBody++;
        return L;
      };
      var inRm = function (Rm, x, z) { var RS = Rm.rects || [], q9; for (q9 = 0; q9 < RS.length; q9++) if (x >= RS[q9].x0 - 0.2 && x <= RS[q9].x1 + 0.2 && z >= RS[q9].z0 - 0.2 && z <= RS[q9].z1 + 0.2) return true; return false; };
      var fromSk = function (Rm, x, z) {
        var best = null, bd = 1e9, bIn = false, q9;
        for (q9 = 0; q9 < SKs.length; q9++) {
          var S9 = SKs[q9], inn = inRm(Rm, S9.x, S9.z), d9 = Math.abs(S9.x - x) + Math.abs(S9.z - z);
          if ((inn && !bIn) || (inn === bIn && d9 < bd)) { best = S9; bd = d9; bIn = inn; }
        }
        return best;
      };
      var feedTo = function (Rm, P, yAt) {
        var S9 = fromSk(Rm, P[0], P[2]); if (!S9) return -1;
        var yc = yCeil + (Rm.up ? dyUp : 0);
        return segF([S9.x, S9.y, S9.z], [S9.x, yc, S9.z]) + segF([S9.x, yc, S9.z], [P[0], yc, S9.z]) + segF([P[0], yc, S9.z], [P[0], yc, P[2]]) + segF([P[0], yc, P[2]], [P[0], yAt, P[2]]);
      };
      if (asm) asm(ctx, TWR.cable, 'side');
      for (i = 0; i < rails.length; i++) {
        var RmF = rails[i], RPf = RmF.railRP, Lf = -1;
        if (RPf) {
          var txf = RPf.nz, tzf = -RPf.nx, yRf = y0 + (RmF.up ? dyUp : 0) + RB + RH;
          Lf = feedTo(RmF, [RPf.x + txf * (RW / 2 + 0.05), 0, RPf.z + tzf * (RW / 2 + 0.05)], yRf);
        }
        if (Lf < 0) { Lf = RmF.feed; fdOld += Lf; fdNote.push(RmF.name + ' rail ' + m2(Lf) + ' (not drawn, old measure)'); }
        else fdNote.push(RmF.name + ' rail ' + m2(Lf) + ' (was ' + m2(RmF.feed) + ')');
        fdR += Lf;
      }
      for (i = 0; i < MATS.length; i++) {
        var MSf = MATS[i], RPg = MSf.R.railRP, Lg = -1;
        if (RPg) {
          var txg = RPg.nz, tzg = -RPg.nx, offg = RW / 2 + 0.25;
          Lg = feedTo(MSf.R, [RPg.x + txg * offg, 0, RPg.z + tzg * offg], y0 + (MSf.R.up ? dyUp : 0) + MAT.statY + MAT.statH / 2);
        }
        if (Lg < 0) { Lg = MSf.feed; fdOld += Lg; fdNote.push(MSf.R.name + ' mat ' + m2(Lg) + ' (not drawn, old measure)'); }
        else fdNote.push(MSf.R.name + ' mat thermostat ' + m2(Lg) + ' (was ' + m2(MSf.feed) + ')');
        MSf.feed = Lg; fdM += Lg;
      }
      if (fdR > 0) _add(LID, TWR.cable, m2(fdR * HEAT.extra));
      if (fdM > 0) _add(LID, MAT.cable, m2(fdM * HEAT.extra));
      ctx.log('HEAT rail / mat feeds drawn (mep-v49, env.heatCables): from the room\'s nearest receptacle up into the ceiling void, across, down to the rail / the thermostat -- ' + fdNote.join(', ') +
              '; billed ' + m2((fdR + fdM) * HEAT.extra) + ' m ' + TWR.cable + ' (+15 per cent)' + (SKs.length ? '' : ' -- NO receptacles handed over by the electrics'));
    }
    if (MATS.length || rails.some(function (r) { return r.matNote; })) {
      ctx.log('HEAT floor mats (mep-v31, env.floorMats): ' + MATS.map(function (M) {
        return M.R.name + ' ' + m2(M.area) + ' m2 mat (' + Math.round(M.area / 0.092903) + ' sq ft, ' + Math.round(M.area * MAT.wpm2) + ' W, ' + M.pieces + ' piece(s) kept clear, ' +
               mm(MAT.wall) + ' off the walls) ' + MAT.mat + ', thermostat ' + MAT.stat + ' + box ' + MAT.box + ', feed ' + m2(M.feed) + ' m ' + MAT.cable + ' plus 15 per cent off the bathroom circuit, ' +
               m2(M.slu) + ' m2 ' + MAT.primer + ' + ' + m2(M.slu * MAT.sluMm * MAT.sluKg) + ' kg ' + MAT.slu + ' (1/4 in. over the mat)' +
               (M.big ? ' -- CHECK: over 100 sq ft, a 20 A circuit of its own' : '');
      }).join(' | ') + rails.filter(function (r) { return r.matNote; }).map(function (r) { return ' | ' + r.matNote; }).join('') +
      '; pending (no sheet row yet): ' + MAT.mat + ', ' + MAT.stat);
    }
    if (UPR.length) ctx.log('HEAT storey 2 (env.roomsUp, mep-v23): ' + UPR.length + ' room(s), ' + nUpHeads + ' head(s) in its bedroom(s)' + (env.upLiving ? ' and living room (env.upLiving, mep-v39)' : '') + ' on the same outdoor unit, ' + nUpRails + ' towel rail(s) in its bathroom(s), ' +
                            'floor at +' + mm(dyUp) + ' over the ground floor');
    ctx.log('HEAT bodies (mep-v5): ' + nBody + ' drawn -- ' + heads.length + ' head(s), ' + (heads.length ? nOut : 0) +
            ' outdoor unit(s) with bracket pair and isolator, ' + rails.length + ' towel rail(s); ' +
            (LSON ? (lsN + ' line set(s) drawn (env.lineSets, mep-v34)' + (lsNot.length ? ('; ' + lsNot.join(', ')) : '')) : 'line sets calculated, not drawn') +
            (mag ? ' -- MAGENTA (under review)' : '') +
            (hNotes.length ? ('; ' + hNotes.join('; ')) : '') + (rNotes.length ? ('; rail: ' + rNotes.join('; ')) : ''));
    if (typeof env.devFace === 'function') ctx.log('HEAT on the finished face (mep-v58, env.devFace): ' + FCH.n + ' towel rail(s) / mat thermostat(s) stand on the board or the tile, up to ' + mm(FCH.max) + ' mm out from the frame');
  }

  /* =========================================================================
     COLD AND HOT WATER -- BY CALCULATION (mep-v6)

     WHAT IS BUILT (Marek, 2026-10-08): the supply from the entry to every
     wet point, cold and hot, the hot from an ELECTRIC STORAGE HEATER (his
     pick: HMH02501, 200 l / 53 gal). Calculated and billed; nothing drawn.

     THE WET POINTS are the fitout's pieces (the product's fixtures, the
     floorplan asset's catalogue), each with its connection:
       kitchen counter, L or U kitchen   the sink      hot + cold, angle stops
       basin                             the basin     hot + cold, angle stops
       wc                                the cistern   cold,       angle stop
       washing machine                   the box       hot + cold, angle stops
       bathtub, shower                   the mixer     hot + cold, straight on
     an angle stop has its braided hose to the piece; a mixer takes the pipe
     on its drop ears. A piece on another storey than the ground one is left
     out and logged.
     THE HEATER stands in the laundry; without one, in the closet nearest the
     bathroom that holds it (650 x 650); else in the bathroom; else in the
     wet room with most points -- at the place of that room nearest the
     middle of the wet points. The cold comes to its top through a tee with
     the expansion tank SMN00401, the hot leaves its top; a T&P relief valve
     SMN00301 with its discharge (dia 20, down to 150 and out through the
     nearest exterior wall), a seismic strap kit SMN00501, two braided hoses
     SMN00202 for its in and out. Its feed: a 30 A circuit from the board
     the electrics placed -- up to the ceiling, across, down to its top --
     10 AWG cable EEE00003 and breaker EEC00011.
     THE ENTRY is on the exterior wall nearest the middle of the wet points:
     ball valve SMB00201 and non-return valve SMN00201 at the service line's
     dia 26, then a transition SMT00206 to dia 20. The service line from the meter
     to the wall is site work, not billed.
     THE RUNS: a cold trunk dia 20 from the entry through the heater and the wet
     rooms, the nearest next first; a hot trunk dia 20 from the heater through
     the wet rooms with a hot point; from the trunk a branch dia 16 to every
     connection, from the middle of its room's points. Every run is the
     Manhattan distance times 1.2 at floor level (in the floor build-up and
     the bottom plates), plus its rise in the wall to the connection.
     FITTINGS BY COUNT: on a trunk a tee for every take-off but the last (the
     trunk ends in it); per branch a transition dia 20 / 16, an elbow dia 16 where
     it turns up into the wall and one more where it turns in plan, a drop
     ear at the top; an elbow dia 20 at every turn of a trunk in plan and at the
     heater's rise and drop. The hot pipe is insulated (HMP00202, a metre a
     metre); a clip SMC00151 every 800 on every pipe, each with a screw
     FAS50060, and two FAS50060 a drop ear into its blocking.
     Log prefix WATER.
     ========================================================================= */
  var WATER = { f: 1.2, clipEvery: 0.8, earScrews: 2,
                cold20: 'SMR00151', hot20: 'SMR00153', cold16: 'SMR00121', hot16: 'SMR00122',
                teeC: 'SMT00151', teeH: 'SMT00156', trC: 'SMT00155', trH: 'SMT00158',
                elb20C: 'SME00151', elb20H: 'SME00154', elb16C: 'SME00121', elb16H: 'SME00122',
                earC: 'SMW00201', earH: 'SMW00203',
                valve: 'SMB00201', nrv: 'SMN00201', tr26: 'SMT00206',
                heater: 'HMH02501', tp: 'SMN00301', exp: 'SMN00401', strap: 'SMN00501', hose: 'SMN00202',
                stop: 'SMB00121', ins: 'HMP00202', clip: 'SMC00151', screw: 'FAS50060',
                cable: 'EEE00003', brk: 'EEC00011',
                htrD: 0.60, htrTop: 1.55, minRoom: 0.65, tpEnd: 0.15, facade: 0.100,
                size: '200 l / 53 gal', awg: '10 AWG', amps: '30 A' };
  /* THE SMALL HEATER (mep-v13, env.heaterSmall -- the THOW): the catalogue's
     under counter heater for a kitchen sink and one bathroom, 57 l / 15 gal,
     about 450 across and 650 high, on a 16 A circuit with the socket cable */
  var WATER_SMALL = { heater: 'HMH01501', htrD: 0.45, htrTop: 0.65, minRoom: 0.50,
                      cable: 'EEE00001', brk: 'EEC00003', size: '57 l / 15 gal', awg: '3 x 2.5 / 14 AWG', amps: '16 A' };
  var WATER_CAT = {
    'SMR00151': { unit: 'm',   label: 'PEX-AL-PEX pipe 20 blue' },
    'SMR00153': { unit: 'm',   label: 'PEX-AL-PEX pipe 20 red' },
    'SMR00121': { unit: 'm',   label: 'PEX-AL-PEX pipe 16 blue' },
    'SMR00122': { unit: 'm',   label: 'PEX-AL-PEX pipe 16 red' },
    'SMT00151': { unit: 'pcs', label: 'PEX-AL tee 20 blue' },
    'SMT00156': { unit: 'pcs', label: 'PEX-AL tee 20 red' },
    'SMT00155': { unit: 'pcs', label: 'PEX-AL transition 20/16 blue' },
    'SMT00158': { unit: 'pcs', label: 'PEX-AL transition 20/16 red' },
    'SME00151': { unit: 'pcs', label: 'PEX-AL elbow 20 blue' },
    'SME00154': { unit: 'pcs', label: 'PEX-AL elbow 20 red' },
    'SME00121': { unit: 'pcs', label: 'PEX-AL elbow 16 blue' },
    'SME00122': { unit: 'pcs', label: 'PEX-AL elbow 16 red' },
    'SMW00201': { unit: 'pcs', label: 'PEX press drop ear 16 blue' },
    'SMW00203': { unit: 'pcs', label: 'PEX press drop ear 16 red' },
    'SMB00201': { unit: 'pcs', label: 'Ball valve 26' },
    'SMN00201': { unit: 'pcs', label: 'Non-return valve 26' },
    'SMT00206': { unit: 'pcs', label: 'PEX-AL transition 26/20' },
    'HMH02501': { unit: 'pcs', label: 'Storage water heater 200 l' },
    'HMH01501': { unit: 'pcs', label: 'Storage water heater 57 l under counter' },
    'SMN00301': { unit: 'pcs', label: 'T&P relief valve' },
    'SMN00401': { unit: 'pcs', label: 'Thermal expansion tank 8 l' },
    'SMN00501': { unit: 'pcs', label: 'Water heater seismic strap kit' },
    'SMN00202': { unit: 'pcs', label: 'Braided flexi hose 400' },
    'SMB00121': { unit: 'pcs', label: 'Angle stop valve' },
    'HMP00202': { unit: 'm',   label: 'Closed cell elastomeric pipe insulation 20/13' },
    'SMC00151': { unit: 'pcs', label: 'PEX pipe clip 20' },
    'FAS50060': { unit: 'pcs', label: 'Wood screw 5x60' },
    'EEE00003': { unit: 'm',   label: 'Cable 3x6 (10 AWG)' },
    'EEC00011': { unit: 'pcs', label: '30 A double pole circuit breaker' }
  };
  var WATER_NEED = ['API', 'STATE', 'CATALOG', 'FINISH', '_P', '_add', '_billReset', '_buildRect',
                    'wallThickness', '_roomKey', '_roomLabel'];
  function _waterMissing(env) {
    var out = [], i;
    if (!env) return ['env'];
    if (typeof env.layerId !== 'string' || !env.layerId) out.push('layerId');
    for (i = 0; i < WATER_NEED.length; i++) if (env[WATER_NEED[i]] == null) out.push(WATER_NEED[i]);
    return out;
  }
  /* the connection of a wet piece: what it is, whether it takes hot, angle
     stops or straight onto a mixer, its height above the finished floor, and
     where it is on the piece in the fitout's own frame (x across, z into the
     room, the back at -z) -- the sink where the fitout draws it */
  function _wetOf(kind, w, d) {
    if (/^kitchen(24|30|36)$/.test(kind)) return { what: 'kitchen sink', hot: 1, stop: 1, y: 0.50, lx: -w / 2 + 0.45, lz: -d / 2 };
    if (kind === 'kitchenL' || kind === 'kitchenU') return { what: 'kitchen sink', hot: 1, stop: 1, y: 0.50, lx: 0, lz: -d / 2 };
    if (/^basin/.test(kind)) return { what: 'basin', hot: 1, stop: 1, y: 0.55, lx: 0, lz: -d / 2 };
    if (kind === 'wc') return { what: 'WC', hot: 0, stop: 1, y: 0.20, lx: 0, lz: -d / 2 };
    if (kind === 'washer') return { what: 'washing machine', hot: 1, stop: 1, y: 1.10, lx: 0, lz: -d / 2 };
    if (/^bath/.test(kind)) return { what: 'bathtub', hot: 1, stop: 0, y: 0.75, lx: -w / 2, lz: 0 };
    if (/^shower/.test(kind)) return { what: 'shower', hot: 1, stop: 0, y: 1.00, lx: -w / 2 + 0.05, lz: -d / 2 };
    return null;
  }

  /* mep-v43: STOREY 2's RUNS DRAWN IN THE FLOOR BETWEEN (env.upDraw, opt-in).
     The product says the runs' level and its joists: { y, axis: 'x' | 'z'
     (the way they run), lines: [their centres across] }. A run from a to b
     first finds the middle of a's bay, runs along it to b's place, then
     crosses the joists there to b -- through their webs, one hole a joist
     it passes; off moves a pipe aside (cold / hot apart). */
  function _upDraw(env, key) {
    var U = null, fK = env[key || 'upDraw'];   /* mep-v52: the same for the ground floor (env.floorDraw) */
    if (typeof fK === 'function') { try { U = fK(); } catch (eU) { U = null; } }
    if (!U || typeof U.y !== 'number' || !isFinite(U.y)) return null;
    var ax = (U.axis === 'z') ? 'z' : 'x', L = (U.lines || []).filter(function (v) { return isFinite(v); }).sort(function (a, b) { return a - b; });
    function vOf(p) { return ax === 'x' ? p.z : p.x; }
    function uOf(p) { return ax === 'x' ? p.x : p.z; }
    function P(u, v) { return ax === 'x' ? { x: u, z: v } : { x: v, z: u }; }
    function bay(v) {
      for (var i = 0; i + 1 < L.length; i++) if (v >= L[i] - 1e-6 && v <= L[i + 1] + 1e-6) return (L[i] + L[i + 1]) / 2;
      return v;
    }
    function holes(va, vb) {
      var lo = Math.min(va, vb), hi = Math.max(va, vb), n = 0, i;
      for (i = 0; i < L.length; i++) if (L[i] > lo + 0.02 && L[i] < hi - 0.02) n++;
      return n;
    }
    /* U.avoid: plan rects no run may cross (a stairwell) -- the other order is
       tried (across the joists at a first, then along b's bay) */
    var AV = (U.avoid || []).filter(function (r) { return r && isFinite(r.x0) && isFinite(r.x1) && isFinite(r.z0) && isFinite(r.z1); }), nHit = 0;
    function hits(pts) {
      var q, k, pad = 0.04;
      for (q = 0; q + 1 < pts.length; q++) {
        var x0 = Math.min(pts[q].x, pts[q + 1].x), x1 = Math.max(pts[q].x, pts[q + 1].x), z0 = Math.min(pts[q].z, pts[q + 1].z), z1 = Math.max(pts[q].z, pts[q + 1].z);
        for (k = 0; k < AV.length; k++) if (x1 > AV[k].x0 - pad && x0 < AV[k].x1 + pad && z1 > AV[k].z0 - pad && z0 < AV[k].z1 + pad) return true;
      }
      return false;
    }
    function route(a, b, off) {
      off = off || 0;
      var ua = uOf(a), va = vOf(a), ub = uOf(b) + off, vb = vOf(b), vm = bay(va) + off;
      var R1 = { pts: [P(ua, va), P(ua, vm), P(ub, vm), P(ub, vb)], holes: holes(vm, vb) };
      if (!AV.length || !hits(R1.pts)) return R1;
      var ua2 = uOf(a) + off, vm2 = bay(vb) + off;
      var R2 = { pts: [P(uOf(a), va), P(ua2, va), P(ua2, vm2), P(ub, vm2), P(ub, vb)], holes: holes(va, vm2) };
      if (!hits(R2.pts)) return R2;
      nHit++; R1.hit = true; return R1;
    }
    return { y: U.y, route: route, holes: holes, ax: ax, n: L.length, hits: function () { return nHit; } };
  }

  /* mep-v40: THE ROOMS OF STOREY 2 for the water and the waste (env.roomsUp
     + env.storeyY), named as the heating names them; null without them */
  function _upRooms(env, y00) {
    if (typeof env.roomsUp !== 'function' || typeof env.storeyY !== 'function') return null;
    var yU = null, RM = null, i, j;
    try { yU = env.storeyY(1); } catch (eY) { yU = null; }
    if (!(typeof yU === 'number' && isFinite(yU) && yU > y00 + 1.0)) return null;
    try { RM = env.roomsUp() || []; } catch (eR) { RM = []; }
    var R = [];
    for (i = 0; i < RM.length; i++) {
      var rm = RM[i]; if (!rm || !rm.rects || !rm.rects.length) { R.push(null); continue; }
      var key = '', nm = '', big = null, bA = -1;
      try { key = env._roomKey(rm, i) || ''; } catch (eK) { key = ''; }
      try { nm = env._roomLabel(rm, i) || ''; } catch (eN) { nm = ''; }
      for (j = 0; j < rm.rects.length; j++) {
        var r0 = rm.rects[j], a0 = (r0.x1 - r0.x0) * (r0.z1 - r0.z0);
        if (a0 > bA) { bA = a0; big = r0; }
      }
      R.push({ i: i, name: nm || ('room ' + i), key: key, closet: !!rm.closet, rects: rm.rects, big: big,
               c: { x: (big.x0 + big.x1) / 2, z: (big.z0 + big.z1) / 2 } });
    }
    function of(x, z) {
      var r, s, t;
      for (t = 0; t <= 1; t++) {
        var tol = t ? 0.15 : 0.0;
        for (r = 0; r < R.length; r++) {
          if (!R[r]) continue;
          for (s = 0; s < R[r].rects.length; s++) {
            var c = R[r].rects[s];
            if (x >= c.x0 - tol && x <= c.x1 + tol && z >= c.z0 - tol && z <= c.z1 + tol) return r;
          }
        }
      }
      return -1;
    }
    return { R: R, of: of, dy: yU - y00, y: yU };
  }
  /* mep-v40: A POINT ON AN EXTERIOR WALL CLEAR OF ITS OPENINGS -- the walls
     of env.API and of env.segmentsUp() (the storey above) whose line passes
     the point; one inside an opening (its width + pad each side) slides
     along the wall to the nearer free end. { x, z, moved } */
  function _offOpenings(env, x, z, pad, upToo) {
    var SG = [], i, k, it, moved = 0;
    try { SG = (env.API && typeof env.API.segments === 'function') ? (env.API.segments() || []) : []; } catch (e1) { SG = []; }
    if (upToo && typeof env.segmentsUp === 'function') { try { SG = SG.concat(env.segmentsUp() || []); } catch (e2) {} }
    for (it = 0; it < 4; it++) {
      var hit = null;
      for (i = 0; i < SG.length && !hit; i++) {
        var s = SG[i]; if (!s || !(s.len > 0.3)) continue;
        var ux = (s.x1 - s.x0) / s.len, uz = (s.z1 - s.z0) / s.len;
        var a = (x - s.x0) * ux + (z - s.z0) * uz, off = Math.abs((x - s.x0) * -uz + (z - s.z0) * ux);
        if (off > 0.45 || a < -0.05 || a > s.len + 0.05) continue;
        for (k = 0; k < (s.openings || []).length; k++) {
          var o = s.openings[k]; if (!o || !(o.w > 0) || !isFinite(o.at)) continue;
          var o0 = o.at - o.w / 2 - pad, o1 = o.at + o.w / 2 + pad;
          if (a > o0 + 1e-6 && a < o1 - 1e-6) { hit = { s: s, ux: ux, uz: uz, a: a, o0: o0, o1: o1 }; break; }
        }
      }
      if (!hit) break;
      var aN = (hit.a - hit.o0 <= hit.o1 - hit.a) ? hit.o0 : hit.o1;
      if (aN < pad || aN > hit.s.len - pad) aN = (aN === hit.o0) ? hit.o1 : hit.o0;
      x += hit.ux * (aN - hit.a); z += hit.uz * (aN - hit.a); moved += Math.abs(aN - hit.a);
    }
    return { x: x, z: z, moved: moved };
  }

  function _buildWater(env, ctx) {
    var LID = env.layerId, API = env.API, STATE = env.STATE, CATALOG = env.CATALOG, FINISH = env.FINISH,
        _P = env._P, _add = env._add, _billReset = env._billReset, _buildRect = env._buildRect,
        wallThickness = env.wallThickness, _roomKey = env._roomKey, _roomLabel = env._roomLabel;
    _billReset(LID);
    LAST[LID] = null;   /* mep-v40: the pipes up through the floor, set below */
    var i, j, k, q, W = WATER;
    if (env.heaterSmall) {
      /* the small heater (mep-v13): the line's table with its own rows over it */
      var Wsm = {}, kWs;
      for (kWs in WATER) if (WATER.hasOwnProperty(kWs)) Wsm[kWs] = WATER[kWs];
      for (kWs in WATER_SMALL) if (WATER_SMALL.hasOwnProperty(kWs)) Wsm[kWs] = WATER_SMALL[kWs];
      W = Wsm;
    }
    function m2(v) { return Math.round(v * 100) / 100; }
    function mm(v) { return Math.round(v * 1000); }
    function man(a, b) { return Math.abs(a.x - b.x) + Math.abs(a.z - b.z); }
    function turns(a, b) { return (Math.abs(a.x - b.x) > 0.05 && Math.abs(a.z - b.z) > 0.05) ? 1 : 0; }
    for (k in WATER_CAT) {
      if (!WATER_CAT.hasOwnProperty(k) || CATALOG[k]) continue;
      CATALOG[k] = { code: k, unit: WATER_CAT[k].unit, label: WATER_CAT[k].label };
    }
    var PL = _P();
    if (!PL || !PL.fixtures) { ctx.log('WATER none -- floorplan asset without fixtures'); return; }
    var P = (STATE && STATE.product) || {}, FX = P.fixtures || [];
    var rooms = (PL.rooms ? PL.rooms() : null) || [];

    /* THE ROOMS, named and keyed as the heating names them */
    var R = [];
    for (i = 0; i < rooms.length; i++) {
      var rm = rooms[i]; if (!rm || !rm.rects || !rm.rects.length) { R.push(null); continue; }
      var key = '', nm = '';
      try { key = _roomKey(rm, i) || ''; } catch (eK) { key = ''; }
      try { nm = rm.closet ? _roomLabel(rm, i) : (PL.roomName ? PL.roomName(rm, i) : _roomLabel(rm, i)); } catch (eN) { nm = ''; }
      var big = null, bA = -1;
      for (j = 0; j < rm.rects.length; j++) {
        var r0 = rm.rects[j], a0 = (r0.x1 - r0.x0) * (r0.z1 - r0.z0);
        if (a0 > bA) { bA = a0; big = r0; }
      }
      R.push({ i: i, name: nm || ('room ' + i), key: key, closet: !!rm.closet, rects: rm.rects, big: big,
               c: { x: (big.x0 + big.x1) / 2, z: (big.z0 + big.z1) / 2 } });
    }
    function roomOf(x, z) {
      var r, s, t;
      for (t = 0; t <= 1; t++) {
        var tol = t ? 0.15 : 0.0;
        for (r = 0; r < R.length; r++) {
          if (!R[r]) continue;
          for (s = 0; s < R[r].rects.length; s++) {
            var c = R[r].rects[s];
            if (x >= c.x0 - tol && x <= c.x1 + tol && z >= c.z0 - tol && z <= c.z1 + tol) return r;
          }
        }
      }
      return -1;
    }

    /* THE WET POINTS */
    var cat = PL.fixtures.catalog ? PL.fixtures.catalog() : {};
    var pts = [], upper = 0, FXR = [], nUp = 0;
    /* THE UPPER STOREYS (mep-v17, env.storeyY): a piece there is fed by a
       riser from the ground floor's trunk; without env.storeyY it is left
       out as before */
    var y00 = API.storeys()[0].y0 + FINISH.dry.h;
    function upDy(st) {
      if (typeof env.storeyY !== 'function') return null;
      var yS = null;
      try { yS = env.storeyY(st); } catch (eY) { yS = null; }
      return (typeof yS === 'number' && isFinite(yS) && yS > y00) ? yS - y00 : null;
    }
    /* mep-v40: the rooms up there, when the product hands them over (env.roomsUp) */
    var UPW = _upRooms(env, y00), FXRu = [];
    for (i = 0; i < FX.length; i++) {
      var f = FX[i]; if (!f || !f.kind) continue;
      if (f.st == null || (f.st | 0) === 0) { try { var fr0 = PL.fixtures.rect ? PL.fixtures.rect(f) : null; if (fr0) FXR.push(fr0); } catch (eFr) {} }
      else if (UPW) { try { var fr1 = PL.fixtures.rect ? PL.fixtures.rect(f) : null; if (fr1) FXRu.push(fr1); } catch (eFr1) {} }
      var D = cat[f.kind] || {}, w = D.w || 0.6, d = D.d || 0.6;
      try { var SZ = PL.fixtures.size ? PL.fixtures.size(f) : null; if (SZ && SZ.w > 0 && SZ.d > 0) { w = SZ.w; d = SZ.d; } } catch (eS) {}
      var WO = _wetOf(f.kind, w, d);
      if (!WO) continue;
      var stW = (f.st != null) ? (f.st | 0) : 0, dyW = 0;
      if (stW !== 0) { dyW = upDy(stW); if (dyW == null) { upper++; continue; } nUp++; }
      var rot = (f.rot | 0) % 4, cs = Math.cos(rot * Math.PI / 2), sn = Math.sin(rot * Math.PI / 2), mir = f.mirror ? -1 : 1;
      var lx = WO.lx * mir, lz = WO.lz;
      var px = f.x + (lx * cs - lz * sn), pz = f.z + (lx * sn + lz * cs);
      var ri = roomOf(f.x, f.z), ru = (stW === 1 && UPW) ? UPW.of(f.x, f.z) : -1;
      pts.push({ what: WO.what, hot: WO.hot, stop: WO.stop, y: WO.y, x: px, z: pz, room: ri, st: stW, dy: dyW, up: ru,
                 rname: (ru >= 0) ? ('storey 2 ' + UPW.R[ru].name)
                      : stW ? ('storey ' + (stW + 1) + (ri >= 0 ? (' over ' + R[ri].name) : '')) : (ri >= 0 ? R[ri].name : 'outside any room') });
    }
    if (!pts.length) {
      ctx.log('WATER none -- no wet piece in the fitout (kitchen, basin, wc, washing machine, bath, shower)' +
              (upper ? (' on the ground storey; ' + upper + ' on another storey left out') : ''));
      return;
    }
    var nHot = 0, nCold = pts.length, C = { x: 0, z: 0 };
    for (i = 0; i < pts.length; i++) { if (pts[i].hot) nHot++; C.x += pts[i].x; C.z += pts[i].z; }
    C.x /= pts.length; C.z /= pts.length;

    /* THE PERIMETER, the inner faces the other trades use */
    var B0 = _buildRect(), wt = wallThickness();
    /* the perimeter (mep-v14): the outline as the walls run, a rectangle as it was */
    var PER = _perim(env, B0, wt), IN = PER.IN;
    var through = (typeof env.wallThrough === 'function') ? env.wallThrough() : (wt + W.facade);
    function nearestFace(x, z) { return _nearSide(PER, x, z); }
    var y0 = API.storeys()[0].y0 + FINISH.dry.h;
    var yCeil = API.wallTop() - 0.02;
    /* mep-v24: UNDER A SLAB ON GRADE (env.underSlab) -- no joint under it */
    var US = null;
    if (typeof env.underSlab === 'function') { try { US = env.underSlab(); } catch (eUS) { US = null; } }
    if (US && !(typeof US.ySub === 'number' && isFinite(US.ySub) && US.ySub < y0 - 0.05)) US = null;

    /* THE GROUPS: the points of one room, met at their middle */
    var G = {}, GL = [];
    for (i = 0; i < pts.length; i++) {
      /* mep-v40: a piece upstairs goes with its own room there (env.roomsUp) */
      var gk = (pts[i].st ? ('s' + pts[i].st) : '') + ((pts[i].up >= 0) ? ('u' + pts[i].up) : ('r' + pts[i].room));
      if (!G[gk]) { G[gk] = { name: pts[i].rname, room: pts[i].room, up: pts[i].up, pts: [], x: 0, z: 0, hot: 0, st: pts[i].st || 0, dy: pts[i].dy || 0 }; GL.push(G[gk]); }
      G[gk].pts.push(pts[i]); if (pts[i].hot) G[gk].hot++;
    }
    for (i = 0; i < GL.length; i++) {
      for (j = 0; j < GL[i].pts.length; j++) { GL[i].x += GL[i].pts[j].x; GL[i].z += GL[i].pts[j].z; }
      GL[i].x /= GL[i].pts.length; GL[i].z /= GL[i].pts.length;
      if (GL[i].up >= 0) GL[i].room = roomOf(GL[i].x, GL[i].z);   /* the ground room under its middle */
    }

    /* THE HEATER: laundry, the closet nearest the bathroom, the bathroom --
       or the heat pump's tank (mep-v17, env.dhwFrom) */
    var HT = null, htWhy = '', DHW = null, dhwNote = '';
    if (env.dhwFrom) {
      var LH = LAST[env.dhwFrom] || null;
      if (LH && LH.tank && LH.tank.x != null) DHW = LH.tank;
      else dhwNote = 'no tank from ' + env.dhwFrom + ' (its plant was not built) -- the electric heater instead';
    }
    function fits(r) { return r && r.big && Math.min(r.big.x1 - r.big.x0, r.big.z1 - r.big.z0) >= W.minRoom; }
    function nearest(list, to) {
      var b = null, bd = 1e9, s;
      for (s = 0; s < list.length; s++) { var dd = man(list[s].c, to); if (dd < bd) { bd = dd; b = list[s]; } }
      return b;
    }
    /* mep-v40: EVERY HOT PIECE UPSTAIRS (env.heaterUp + env.roomsUp) -- the
       heater goes up there with them, not into the garage under them */
    var hotUp = false, nHotU = 0, nHotG = 0;
    if (env.heaterUp && UPW && nHot && !DHW) {
      for (i = 0; i < pts.length; i++) if (pts[i].hot) { if (pts[i].st === 1 && pts[i].up >= 0) nHotU++; else nHotG++; }
      /* most of the hot pieces up there (a laundry in the garage gets its hot
         down the riser, env.riserAt) */
      hotUp = nHotU > 0 && nHotU >= nHotG && (!nHotG || typeof env.riserAt === 'function');
    }
    if (nHot && DHW) {
      HT = { room: null, x: DHW.x, z: DHW.z, name: DHW.name, why: 'the heat pump\'s tank ' + DHW.code + ', billed with the heating (' + env.dhwFrom + ')', small: [], dhw: true, top: DHW.top };
    } else if (hotUp) {
      var lauU = [], cloU = [], batU = [], smaU = [], RUw = UPW.R, Cu = { x: 0, z: 0 }, nCu = 0;
      for (i = 0; i < pts.length; i++) if (pts[i].hot) { Cu.x += pts[i].x; Cu.z += pts[i].z; nCu++; }
      Cu.x /= nCu; Cu.z /= nCu;
      for (i = 0; i < RUw.length; i++) {
        var Ru = RUw[i]; if (!Ru) continue;
        var isLu = Ru.key === 'rooms.laundry' || (!Ru.key && /laundry|utility/i.test(Ru.name));
        var isBu = Ru.key === 'rooms.bathroom' || (!Ru.key && /bath/i.test(Ru.name));
        if (isLu) { if (fits(Ru)) lauU.push(Ru); else smaU.push(Ru.name); }
        else if (Ru.closet) { if (fits(Ru)) cloU.push(Ru); else smaU.push(Ru.name); }
        else if (isBu) batU.push(Ru);
      }
      var bRu = null, bNu = -1;
      for (i = 0; i < batU.length; i++) {
        var nIu = 0; for (j = 0; j < pts.length; j++) if (pts[j].up === batU[i].i) nIu++;
        if (nIu > bNu) { bNu = nIu; bRu = batU[i]; }
      }
      var HU = null;
      if (lauU.length) { HU = nearest(lauU, Cu); htWhy = 'the laundry upstairs'; }
      else if (cloU.length) { HU = nearest(cloU, bRu ? bRu.c : Cu); htWhy = 'the closet upstairs nearest the ' + (bRu ? bRu.name : 'wet points') + ' (no laundry)'; }
      else if (bRu) { HU = bRu; htWhy = 'the bathroom upstairs (no laundry, no closet holds ' + mm(W.minRoom) + ' x ' + mm(W.minRoom) + ')'; }
      else {
        var gBu = null; for (i = 0; i < GL.length; i++) if (GL[i].up >= 0 && (!gBu || GL[i].pts.length > gBu.pts.length)) gBu = GL[i];
        HU = gBu ? RUw[gBu.up] : null; htWhy = 'the wet room upstairs with most points (no laundry, closet or bathroom)';
      }
      var hpU = { x: Cu.x, z: Cu.z };
      if (HU && HU.big) {
        /* in a corner of its room, clear of the pieces up there (as mep-v9) */
        var hbU = HU.big, hrU = W.htrD / 2 + 0.03, FU = null, cu, cv;
        try { FU = (typeof env.facesUp === 'function') ? env.facesUp((hbU.x0 + hbU.x1) / 2, (hbU.z0 + hbU.z1) / 2) : null; } catch (eFU) { FU = null; }
        FU = FU || hbU;
        var cxU = (FU.x1 - FU.x0 < 2 * hrU) ? [(FU.x0 + FU.x1) / 2] : [FU.x0 + hrU, FU.x1 - hrU];
        var czU = (FU.z1 - FU.z0 < 2 * hrU) ? [(FU.z0 + FU.z1) / 2] : [FU.z0 + hrU, FU.z1 - hrU];
        var cBu = null, cFu = null;
        for (cu = 0; cu < cxU.length; cu++) for (cv = 0; cv < czU.length; cv++) {
          var cpU = { x: cxU[cu], z: czU[cv] }, hitU = false, qU;
          cpU.d = man(cpU, Cu);
          for (qU = 0; qU < FXRu.length; qU++) {
            var frU = FXRu[qU];
            if (cpU.x + hrU > frU.x0 && cpU.x - hrU < frU.x1 && cpU.z + hrU > frU.z0 && cpU.z - hrU < frU.z1) { hitU = true; break; }
          }
          if (!cBu || cpU.d < cBu.d) cBu = cpU;
          if (!hitU && (!cFu || cpU.d < cFu.d)) cFu = cpU;
        }
        var cPu = cFu || cBu;
        hpU.x = cPu.x; hpU.z = cPu.z;
        htWhy += cFu ? ', in its corner nearest the hot pieces clear of the fitout' : ', in its corner nearest the hot pieces -- EVERY corner has a fitout piece in it';
      } else htWhy = 'the middle of the hot pieces upstairs (no room found)';
      HT = { room: null, x: hpU.x, z: hpU.z, name: 'storey 2 ' + (HU ? HU.name : '-'), why: htWhy + ' -- ' + (nHotG ? (nHotU + ' of the ' + (nHotU + nHotG) + ' hot pieces are') : 'every hot piece is') + ' on storey 2 (heaterUp)', small: smaU, up: true, dy: UPW.dy };
    } else if (nHot) {
      var laund = [], clos = [], baths = [], small = [];
      for (i = 0; i < R.length; i++) {
        var Rr = R[i]; if (!Rr) continue;
        var isL = Rr.key === 'rooms.laundry' || (!Rr.key && /laundry|utility/i.test(Rr.name));
        var isB = Rr.key === 'rooms.bathroom' || (!Rr.key && /bath/i.test(Rr.name));
        if (isL) { if (fits(Rr)) laund.push(Rr); else small.push(Rr.name); }
        else if (Rr.closet) { if (fits(Rr)) clos.push(Rr); else small.push(Rr.name); }
        else if (isB) baths.push(Rr);
      }
      /* the bathroom the closet is measured to: the one with most wet points */
      var bRef = null, bN = -1;
      for (i = 0; i < baths.length; i++) {
        var nIn = 0; for (j = 0; j < pts.length; j++) if (pts[j].room === baths[i].i) nIn++;
        if (nIn > bN) { bN = nIn; bRef = baths[i]; }
      }
      if (laund.length) { HT = nearest(laund, C); htWhy = 'the laundry'; }
      else if (clos.length) { HT = nearest(clos, bRef ? bRef.c : C); htWhy = 'the closet nearest the ' + (bRef ? bRef.name : 'wet points') + ' (no laundry)'; }
      else if (bRef) { HT = bRef; htWhy = 'the bathroom (no laundry, no closet holds ' + mm(W.minRoom) + ' x ' + mm(W.minRoom) + ')'; }
      else {
        var gBest = null; for (i = 0; i < GL.length; i++) if (GL[i].room >= 0 && (!gBest || GL[i].pts.length > gBest.pts.length)) gBest = GL[i];
        HT = gBest ? R[gBest.room] : null; htWhy = 'the wet room with most points (no laundry, closet or bathroom)';
      }
      var hp = { x: C.x, z: C.z };
      if (HT && HT.big) {
        /* IN A CORNER OF ITS ROOM (mep-v9): a tank stands against two walls,
           not in the middle of the floor -- the corner nearest the middle of
           the wet points that no fitout piece stands in, on the room's own
           faces (the floorplan asset's) */
        var hb = HT.big, hr = W.htrD / 2 + 0.03, FF = null, ci, cj;
        try { FF = PL.roomFaces ? PL.roomFaces((hb.x0 + hb.x1) / 2, (hb.z0 + hb.z1) / 2) : null; } catch (eFF) { FF = null; }
        FF = FF || hb;
        var cxs = (FF.x1 - FF.x0 < 2 * hr) ? [(FF.x0 + FF.x1) / 2] : [FF.x0 + hr, FF.x1 - hr];
        var czs = (FF.z1 - FF.z0 < 2 * hr) ? [(FF.z0 + FF.z1) / 2] : [FF.z0 + hr, FF.z1 - hr];
        var cBest = null, cFree = null;
        for (ci = 0; ci < cxs.length; ci++) for (cj = 0; cj < czs.length; cj++) {
          var cp = { x: cxs[ci], z: czs[cj] }, hit = false, q2;
          cp.d = man(cp, C);
          for (q2 = 0; q2 < FXR.length; q2++) {
            var fr = FXR[q2];
            if (cp.x + hr > fr.x0 && cp.x - hr < fr.x1 && cp.z + hr > fr.z0 && cp.z - hr < fr.z1) { hit = true; break; }
          }
          if (!cBest || cp.d < cBest.d) cBest = cp;
          if (!hit && (!cFree || cp.d < cFree.d)) cFree = cp;
        }
        var cPick = cFree || cBest;
        hp.x = cPick.x; hp.z = cPick.z;
        htWhy += cFree ? ', in its corner nearest the wet points clear of the fitout' : ', in its corner nearest the wet points -- EVERY corner has a fitout piece in it';
      } else htWhy = 'the middle of the wet points (no room found)';
      HT = { room: HT, x: hp.x, z: hp.z, name: HT ? HT.name : '-', why: htWhy, small: small };
    }

    /* THE ENTRY: the exterior wall nearest the middle of the wet points */
    var EN = nearestFace(C.x, C.z);
    /* mep-v32: on a trailer the hookup side (env.trailer) */
    var TRw = _trailerAt(env, PER, C, 'water');
    if (TRw) EN = TRw;
    /* mep-v24: the service line under the slab's edge kept clear (env.exitClear) */
    if (US && typeof env.exitClear === 'function') {
      try { var NC = env.exitClear(EN.x, EN.z, EN.k); if (NC && isFinite(NC.x) && isFinite(NC.z)) { EN.x = NC.x; EN.z = NC.z; EN.moved = NC.why || 'moved'; } } catch (eNC) {}
    }
    /* mep-v40: ONE RISER TO STOREY 2 WHERE THE PRODUCT SAYS (env.riserAt) --
       the rooms up there fed from its top by a trunk in that storey's floor;
       { entry: true }: the entry's valves at its foot */
    var RZ = null, UGL = [], i9;
    for (i9 = 0; i9 < GL.length; i9++) if (GL[i9].dy > 0) UGL.push(GL[i9]);
    if (UGL.length && typeof env.riserAt === 'function') {
      var Cr = { x: 0, z: 0 };
      for (i9 = 0; i9 < UGL.length; i9++) { Cr.x += UGL[i9].x; Cr.z += UGL[i9].z; }
      Cr.x /= UGL.length; Cr.z /= UGL.length;
      try { RZ = env.riserAt(Cr.x, Cr.z); } catch (eRZ) { RZ = null; }
      if (RZ && !(isFinite(RZ.x) && isFinite(RZ.z))) RZ = null;
      if (RZ) {
        RZ.name = 'riser';
        RZ.dy = 0; for (i9 = 0; i9 < UGL.length; i9++) RZ.dy = Math.max(RZ.dy, UGL[i9].dy);
        if (RZ.entry && !TRw) {
          var nfR = nearestFace(RZ.x, RZ.z);
          EN = { k: nfR.k, d: nfR.d, x: RZ.x, z: RZ.z, n: (isFinite(RZ.nx) && isFinite(RZ.nz)) ? [RZ.nx, RZ.nz] : nfR.n, side: nfR.side, u: nfR.u, atRiser: true };
        }
      }
    }

    /* THE TRUNKS, nearest next first */
    function chain(start, nodes) {
      var cur = start, left = nodes.slice(), out = { len: 0, turns: 0, order: [], seq: [start] };
      while (left.length) {
        var b = 0, bd = 1e9, s;
        for (s = 0; s < left.length; s++) { var dd = man(cur, left[s]); if (dd < bd) { bd = dd; b = s; } }
        out.len += bd; out.turns += turns(cur, left[b]); out.order.push(left[b].name); out.seq.push(left[b]); cur = left[b]; left.splice(b, 1);
      }
      out.len *= W.f;
      return out;
    }
    var coldNodes = GL.slice(), hotNodes = [];
    if (HT) coldNodes.push({ name: 'heater', x: HT.x, z: HT.z });
    for (i = 0; i < GL.length; i++) if (GL[i].hot) hotNodes.push(GL[i]);
    /* mep-v40 (env.riserAt): the ground trunk ends at the riser; storey 2's
       trunk starts at its top -- the cold to every room up there (and to the
       heater when it is up there), the hot from the heater up there, or up
       the riser beside the cold when the heater stays below */
    var NONE = { len: 0, turns: 0, order: [] }, TCu = NONE, THu = NONE, hotRise = false, hotDown = false, nUpC = 0, nUpH = 0, HS = HT;
    if (RZ) {
      var upHot = [];
      for (i = 0; i < UGL.length; i++) if (UGL[i].hot) upHot.push(UGL[i]);
      hotRise = !!(HT && !HT.up && upHot.length);
      coldNodes = []; hotNodes = [];
      for (i = 0; i < GL.length; i++) if (!(GL[i].dy > 0)) { coldNodes.push(GL[i]); if (GL[i].hot) hotNodes.push(GL[i]); }
      if (HT && !HT.up) coldNodes.push({ name: 'heater', x: HT.x, z: HT.z });
      coldNodes.push(RZ);
      if (hotRise) hotNodes.push(RZ);
      /* the heater up there and a hot piece below: its hot comes down the riser */
      hotDown = !!(HT && HT.up && hotNodes.length);
      if (hotDown) HS = RZ;
      var upC = UGL.slice();
      if (HT && HT.up) upC.push({ name: 'heater', x: HT.x, z: HT.z });
      TCu = chain(RZ, upC); nUpC = upC.length;
      if (HT && HT.up) { var upH2 = hotDown ? upHot.concat([RZ]) : upHot; THu = chain(HT, upH2); nUpH = upH2.length; }
      else if (hotRise) { THu = chain(RZ, upHot); nUpH = upHot.length; }
    }
    var TC = chain(EN, coldNodes), TH = HS ? chain(HS, hotNodes) : { len: 0, turns: 0, order: [] };
    /* mep-v24: UNDER THE SLAB, NO JOINT IN IT -- one run of 20 from the entry to
       each wet room's wall (its stub: the room's wall nearest the middle of its
       pieces) and to the heater, one from the heater to each room with hot;
       laid on the subgrade, bent, up through the slab at both ends */
    var SLW = null;
    function stubOf(g) {
      var Rm = g.room >= 0 ? R[g.room] : null, F = null;
      if (!Rm || !Rm.big) { var nf = nearestFace(g.x, g.z); return { x: nf.x, z: nf.z }; }
      try { F = PL.roomFaces ? PL.roomFaces((Rm.big.x0 + Rm.big.x1) / 2, (Rm.big.z0 + Rm.big.z1) / 2) : null; } catch (eF) { F = null; }
      F = F || Rm.big;
      var cx = Math.max(F.x0 + 0.15, Math.min(F.x1 - 0.15, g.x)), cz = Math.max(F.z0 + 0.15, Math.min(F.z1 - 0.15, g.z));
      var c4 = [{ x: cx, z: F.z0, d: Math.abs(g.z - F.z0) }, { x: F.x1, z: cz, d: Math.abs(F.x1 - g.x) },
                { x: cx, z: F.z1, d: Math.abs(F.z1 - g.z) }, { x: F.x0, z: cz, d: Math.abs(g.x - F.x0) }], b4 = c4[0], s4;
      for (s4 = 1; s4 < 4; s4++) if (c4[s4].d < b4.d) b4 = c4[s4];
      return { x: b4.x, z: b4.z, F: F };   /* mep-v52: its room's faces, for the branches drawn (env.waterRest) */
    }
    if (US) {
      var yWs = US.ySub + 0.02, dSl = y0 - yWs;
      SLW = { C: [], H: [], c: 0, h: 0, yW: yWs, dS: dSl };
      for (i = 0; i < GL.length; i++) {
        if (RZ && GL[i].dy > 0) continue;   /* mep-v40: up the riser instead */
        GL[i].stub = stubOf(GL[i]);
        var LcW = man(EN, GL[i].stub) * W.f + 2 * dSl;
        SLW.C.push({ to: GL[i].name, a: EN, b: GL[i].stub, L: LcW }); SLW.c += LcW; GL[i].sC = SLW.C.length - 1;
        if (GL[i].hot && HT) { var LhW = man(HS, GL[i].stub) * W.f + 2 * dSl; SLW.H.push({ to: GL[i].name, a: HS, b: GL[i].stub, L: LhW }); SLW.h += LhW; GL[i].sH = SLW.H.length - 1; }
      }
      if (HT && !HT.up) { var LtW = man(EN, HT) * W.f + 2 * dSl; SLW.C.push({ to: 'heater', a: EN, b: HT, L: LtW }); SLW.c += LtW; }
      /* mep-v40: to the riser's foot (none when the entry is at it) */
      if (RZ && man(EN, RZ) > 0.05) { var LrW = man(EN, RZ) * W.f + 2 * dSl; SLW.C.push({ to: 'the riser', a: EN, b: RZ, L: LrW }); SLW.c += LrW; }
      if (RZ && hotRise) { var LrH = man(HT, RZ) * W.f + 2 * dSl; SLW.H.push({ to: 'the riser', a: HT, b: RZ, L: LrH }); SLW.h += LrH; }
    }
    /* THE RISERS to the upper storeys (mep-v17): up a wall from the trunk to
       the storey's floor, an elbow at the foot and one at the top */
    var rise = { c: 0, h: 0, nC: 0, nH: 0, notes: [] };
    if (RZ) {
      /* mep-v40: the one riser (env.riserAt) */
      rise.c = RZ.dy; rise.nC = 1;
      if (hotRise || hotDown) { rise.h = RZ.dy; rise.nH = 1; }
      rise.notes.push('one riser ' + m2(RZ.dy) + ' m up at ' + (RZ.why || (RZ.x.toFixed(2) + ',' + RZ.z.toFixed(2))) + (hotRise ? ' (cold and hot)' : hotDown ? ' (cold up, hot down from the heater to the ground floor\'s hot pieces)' : ' (cold)') +
                      ', then ' + m2(TCu.len) + ' m of cold' + (THu.len > 0.005 ? (' and ' + m2(THu.len) + ' m of hot') : '') + ' in the floor of storey 2 (' + TCu.order.join(' -> ') + ')');
    }
    if (!RZ && HT && HT.up && nHotG) { rise.h += HT.dy; rise.nH++; rise.notes.push('the hot down from the heater ' + m2(HT.dy) + ' m to the ground floor'); }
    for (i = 0; i < GL.length && !RZ; i++) {
      if (!(GL[i].dy > 0)) continue;
      rise.c += GL[i].dy; rise.nC++;
      if (GL[i].hot && HT && !HT.up) { rise.h += GL[i].dy; rise.nH++; }
      rise.notes.push(GL[i].name + ' ' + m2(GL[i].dy) + ' m up' + ((GL[i].hot && HT) ? ' (cold and hot)' : ' (cold)'));
    }

    /* THE BRANCHES, from the room's middle to each connection, up the wall */
    var br = { c16: 0, h16: 0, elbC: 0, elbH: 0, nC: 0, nH: 0, stops: 0 };
    for (i = 0; i < GL.length; i++) {
      for (j = 0; j < GL[i].pts.length; j++) {
        /* mep-v24: under a slab the branches start at the room's stub, in its wall */
        var g0 = (SLW && GL[i].stub && !(GL[i].dy > 0)) ? GL[i].stub : GL[i];
        var pt = GL[i].pts[j], run = man(g0, pt) * W.f + pt.y, el = 1 + turns(g0, pt);
        br.c16 += run; br.elbC += el; br.nC++;
        if (pt.hot) { br.h16 += run; br.elbH += el; br.nH++; }
        if (pt.stop) br.stops += pt.hot ? 2 : 1;
      }
    }

    /* THE HEATER'S OWN: rise of the cold, drop of the hot, the T&P discharge */
    var htr = { rise: 0, drop: 0, tp: 0, tpWall: '' }, hTop = (HT && HT.dhw) ? HT.top : W.htrTop;
    var PAN = null;
    if (HT) {
      htr.rise = hTop; htr.drop = hTop;
      var TF = nearestFace(HT.x, HT.z);
      htr.tp = (hTop - W.tpEnd) + TF.d * W.f + through; htr.tpWall = TF.k;
      if (HT.up) {
        /* mep-v40: UPSTAIRS IN A PAN (IRC P2801.6) -- the T&P discharges over
           it (P2804.6.1), its drain out through the nearest exterior wall and
           down the facade to 300 over grade (P2801.6.2) */
        var yGp = (US && typeof US.yGrade === 'number' && isFinite(US.yGrade)) ? US.yGrade : (y0 - 0.15);
        var yPan = y0 + HT.dy + 0.05, PdH = TF.d * W.f + through, PdV = Math.max(0, yPan - (yGp + 0.30));
        htr.tp = hTop - W.tpEnd; htr.tpWall = 'over the pan';
        PAN = { code: 'mep.heaterPan', pipe: 'SMR00321', bend: 'SMP00321', L: PdH + PdV, h: PdH, v: PdV, wall: TF.k, n: TF.n, x: TF.x, z: TF.z, y: yPan,
                bends: 3, hang: Math.ceil(PdV / 1.2) + 1 };
      }
    }

    /* THE FEED from the board to the heater */
    var EL = LAST[env.elecId || ''] || null, feed = 0, feedNote = '';
    if (HT && HT.dhw) {
      feedNote = 'none -- the heat pump heats the tank';
    } else if (HT && HT.up && EL && EL.board && EL.board.x != null) {
      /* mep-v40: up from the board to the floor of storey 2, across in it, up to the heater's top */
      var BDu = EL.board, upB = Math.max(0, (y0 + HT.dy) - EL.yBrd);
      feed = upB + man(BDu, HT) * W.f + W.htrTop;
      feedNote = m2(feed) + ' m ' + W.cable + ' (' + W.awg + '): up from the board to the floor of storey 2 ' + m2(upB) + ', across ' +
                 m2(man(BDu, HT)) + ' x ' + W.f + ' in it, up to the heater\'s top ' + m2(W.htrTop) + '; breaker ' + W.brk + ' (' + W.amps + ') in the board';
    } else if (HT && EL && EL.board && EL.board.x != null) {
      var BD = EL.board;
      feed = Math.max(0, yCeil - EL.yBrd) + man(BD, HT) * W.f + Math.max(0, yCeil - (y0 + W.htrTop));
      feedNote = m2(feed) + ' m ' + W.cable + ' (' + W.awg + '): up from the board to the ceiling ' + m2(Math.max(0, yCeil - EL.yBrd)) + ', across ' +
                 m2(man(BD, HT)) + ' x ' + W.f + ', down to the heater\'s top ' + m2(Math.max(0, yCeil - (y0 + W.htrTop))) + '; breaker ' + W.brk + ' (' + W.amps + ')';
    } else if (HT) {
      feedNote = 'NOT BILLED -- no board from the electrics (' + (env.elecId || 'no elecId') + '), so the ' + W.amps + ' feed and its breaker wait for it';
    }

    /* THE BILL */
    /* mep-v40: storey 2's trunks (env.riserAt; none: 0) and the cold riser lagged */
    var cold20 = TC.len + htr.rise + rise.c + TCu.len, hot20 = TH.len + htr.drop + htr.tp + rise.h + THu.len, cold16 = br.c16, hot16 = br.h16;
    var takeC = br.nC + (HT ? 1 : 0), takeH = br.nH;
    var teeC = Math.max(0, takeC - 1) + (HT ? 1 : 0), teeH = Math.max(0, takeH - 1);
    var elb20C = TC.turns + TCu.turns + (HT ? 1 : 0) + 2 * rise.nC, elb20H = HT ? (TH.turns + THu.turns + 1 + 2 + 2 * rise.nH) : 0;
    var nPipe = cold20 + hot20 + cold16 + hot16, clips = Math.ceil(nPipe / W.clipEvery);
    var ears = br.nC + br.nH, screws = clips + ears * W.earScrews;
    var insL = TH.len + THu.len + htr.drop + hot16 + rise.h + (RZ ? rise.c : 0), sleeveL = 0;
    if (SLW) {
      /* mep-v24: the runs in place of the trunks; the tees above the slab -- a
         header at the entry and at the heater, the room's own in its wall */
      cold20 = SLW.c + htr.rise + rise.c + TCu.len; hot20 = SLW.h + htr.drop + htr.tp + rise.h + THu.len;
      teeC = Math.max(0, SLW.C.length - 1) + (HT ? 1 : 0); teeH = Math.max(0, SLW.H.length - 1);
      for (i = 0; i < GL.length; i++) { teeC += Math.max(0, GL[i].pts.length - 1); if (GL[i].hot) teeH += Math.max(0, GL[i].hot - 1); }
      teeC += Math.max(0, nUpC - 1); teeH += Math.max(0, nUpH - 1);   /* mep-v40: storey 2's trunks */
      elb20C = (HT ? 1 : 0) + 2 * rise.nC + TCu.turns; elb20H = HT ? (1 + 2 + 2 * rise.nH + THu.turns) : 0;
      clips = Math.ceil((cold16 + hot16 + htr.rise + htr.drop + htr.tp + rise.c + rise.h + TCu.len + THu.len) / W.clipEvery);
      screws = clips + ears * W.earScrews;
      insL = SLW.h + htr.drop + hot16 + rise.h + THu.len + (RZ ? rise.c : 0);
      sleeveL = (2 * SLW.C.length + 1) * 0.30;   /* a cold run's two ends and the service, through the slab */
    }
    /* mep-v26: HOSE BIBS (env.hoseBibs -- the barndo first). Two frost-free
       sillcocks: beside the service entry and on the opposite wall, 450 over
       the floor, each fed in 16 from the entry's header above the slab, up over
       the ceiling and down inside the wall to it, lagged all the way, a stop
       inside to winterize at, the bib through the wall sloping out and sealed. */
    var HBn = 0, HBlog = [], HBD = [];
    if (env.hoseBibs) {
      var HBW = { code: 'SMB00122', y: 0.45 };
      if (CATALOG && !CATALOG[HBW.code]) CATALOG[HBW.code] = { code: HBW.code, unit: 'pcs', label: 'Frost-free sillcock 1/2 in. x 12 in. with vacuum breaker' };
      var SH = PER.sides || [], sE = null, q8, best8 = null;
      for (q8 = 0; q8 < SH.length; q8++) if (SH[q8].k === EN.k) sE = SH[q8];
      if (!sE) { var nsE = _nearSide(PER, EN.x, EN.z); sE = SH[nsE.side || 0]; }
      for (q8 = 0; q8 < SH.length; q8++) {
        var dot8 = SH[q8].n[0] * sE.n[0] + SH[q8].n[1] * sE.n[1];
        if (dot8 < -0.9 && (!best8 || SH[q8].len > best8.len)) best8 = SH[q8];
      }
      var uE = (EN.x - sE.a[0]) * sE.u[0] + (EN.z - sE.a[1]) * sE.u[1];
      var spots = [{ s: sE, u: (uE + 0.6 <= sE.len - 0.3) ? uE + 0.6 : Math.max(0.3, uE - 0.6), why: 'beside the entry on ' + sE.k }];
      if (best8) spots.push({ s: best8, u: best8.len / 2, why: 'mid ' + best8.k + ', the opposite wall' });
      var T8 = ctx.THREE, yTopW = API.wallTop() - 0.10;
      for (q8 = 0; q8 < spots.length; q8++) {
        var sp = spots[q8], Px = sp.s.a[0] + sp.s.u[0] * sp.u, Pz = sp.s.a[1] + sp.s.u[1] * sp.u;
        /* mep-v40: not in an opening of its wall (an overhead door's middle) */
        var OO8 = _offOpenings(env, Px, Pz, 0.25, false);
        if (OO8.moved > 0.005) { Px = OO8.x; Pz = OO8.z; sp.why += ' (slid ' + mm(OO8.moved) + ' off an opening)'; }
        var Lb = man(EN, { x: Px, z: Pz }) * W.f + 2 * Math.max(0, yTopW - (y0 + HBW.y)) + through;
        _add(LID, W.cold16, m2(Lb)); _add(LID, W.ins, m2(Lb));
        _add(LID, W.teeC, 1); _add(LID, W.trC, 1); _add(LID, W.elb16C, 3); _add(LID, W.stop, 1);
        var cl8 = Math.ceil(Lb / W.clipEvery);
        _add(LID, W.clip, cl8); _add(LID, W.screw, cl8);
        _add(LID, HBW.code, 1);
        if (T8 && ctx.group) {
          try { if (env._asmCode) env._asmCode(ctx, HBW.code, 'top'); } catch (eA8) {}
          var ox = Px - sp.s.n[0] * (through + 0.04), oz = Pz - sp.s.n[1] * (through + 0.04);
          var hb = new T8.Mesh(new T8.BoxGeometry(0.07, 0.07, 0.07), new T8.MeshStandardMaterial({ color: 0xB08D57, roughness: 0.4, metalness: 0.7 }));
          hb.position.set(ox, y0 + HBW.y, oz); hb.name = 'water-hosebib'; ctx.group.add(hb);
        }
        HBn++; HBlog.push(sp.why + ' ' + m2(Lb) + ' m'); HBD.push({ x: Px, z: Pz, n: sp.s.n, L: Lb });
      }
      if (CATALOG && !CATALOG.FEC00038) CATALOG.FEC00038 = { code: 'FEC00038', unit: 'pcs', label: 'Polyurethane construction sealant' };
      if (HBn) _add(LID, 'FEC00038', Math.ceil(HBn * 0.25 - 1e-9));   /* whole cartridges, a quarter a bib */
    }
    _add(LID, W.valve, 1);
    _add(LID, W.nrv, 1);
    _add(LID, W.tr26, 1);
    _add(LID, W.cold20, m2(cold20));
    if (hot20 > 0.005) _add(LID, W.hot20, m2(hot20));
    _add(LID, W.cold16, m2(cold16));
    if (hot16 > 0.005) _add(LID, W.hot16, m2(hot16));
    if (teeC) _add(LID, W.teeC, teeC);
    if (teeH) _add(LID, W.teeH, teeH);
    _add(LID, W.trC, br.nC);
    if (br.nH) _add(LID, W.trH, br.nH);
    if (elb20C) _add(LID, W.elb20C, elb20C);
    if (elb20H) _add(LID, W.elb20H, elb20H);
    _add(LID, W.elb16C, br.elbC);
    if (br.elbH) _add(LID, W.elb16H, br.elbH);
    _add(LID, W.earC, br.nC);
    if (br.nH) _add(LID, W.earH, br.nH);
    if (br.stops) _add(LID, W.stop, br.stops);
    if (br.stops || HT) _add(LID, W.hose, br.stops + (HT ? 2 : 0));
    if (HT) {
      if (!HT.dhw) _add(LID, W.heater, 1);
      _add(LID, W.tp, 1);
      _add(LID, W.exp, 1);
      _add(LID, W.strap, 1);
    }
    if (PAN) {
      /* mep-v40: the pan (pending row) and its drain, push-fit PP: the pipe, 3
         bends 45 (out of the pan's side, down the facade, the foot turned
         out), straps on the facade, the way through the wall sealed */
      if (CATALOG && !CATALOG[PAN.code]) CATALOG[PAN.code] = { code: null, pending: true, unit: 'pcs', label: 'Water heater drain pan 26 in. with a 1 in. side drain fitting (IRC P2801.6), pending row' };
      if (CATALOG && !CATALOG[PAN.pipe]) CATALOG[PAN.pipe] = { code: PAN.pipe, unit: 'm', label: 'Pipe PP HT 32' };
      if (CATALOG && !CATALOG[PAN.bend]) CATALOG[PAN.bend] = { code: PAN.bend, unit: 'pcs', label: 'PP HT bend 45 32' };
      if (CATALOG && !CATALOG.SMC00001) CATALOG.SMC00001 = { code: 'SMC00001', unit: 'm', label: 'Pipe hanger strap 20 mm' };
      if (CATALOG && !CATALOG.FEC00038) CATALOG.FEC00038 = { code: 'FEC00038', unit: 'pcs', label: 'Polyurethane construction sealant' };
      _add(LID, PAN.code, 1);
      _add(LID, PAN.pipe, m2(PAN.L));
      _add(LID, PAN.bend, PAN.bends);
      _add(LID, 'SMC00001', m2(PAN.hang * 0.5));
      _add(LID, W.screw, PAN.hang * 2);
      if (!HBn) _add(LID, 'FEC00038', 1);   /* with the hose bibs it shares their cartridge */
    }
    if (insL + sleeveL > 0.005) _add(LID, W.ins, m2(insL + sleeveL));
    /* mep-v33: the service through the edge footing in a sleeve */
    var EGw = SLW ? _slvEdge(US) : null, slvW = 0, slvWc = '';
    if (EGw) { _slvMint(CATALOG); slvW = m2(EGw.w + 2 * SLV.past); slvWc = EGw.service || SLV.service; _add(LID, slvWc, slvW); }
    _add(LID, W.clip, clips);
    _add(LID, W.screw, screws);
    if (HT && feed > 0) { _add(LID, W.cable, m2(feed)); _add(LID, W.brk, 1); }

    /* mep-v32: the trailer's inlet, billed and drawn by the product */
    var trNote = '';
    if (TRw && typeof TRw.TR.water === 'function') {
      try { trNote = String(TRw.TR.water(EN, ctx) || ''); } catch (eTW) { trNote = 'the trailer inlet threw: ' + (eTW && eTW.message); }
    }

    /* THE LOG */
    ctx.log('WATER ' + pts.length + ' wet point(s), ' + nCold + ' cold and ' + nHot + ' hot connection(s): ' +
            pts.map(function (p) { return p.what + ' ' + (p.hot ? 'H+C' : 'C') + (p.stop ? ' on angle stops' : ' straight onto the mixer') + ' in ' + p.rname; }).join('; ') +
            (upper ? ('; ' + upper + ' piece(s) on another storey left out') : '') + (nUp ? ('; ' + nUp + ' piece(s) on an upper storey, fed by a riser') : '') + (US ? ' -- the runs under the slab drawn, the rest calculated' : ' -- calculated, nothing drawn'));
    if (dhwNote) ctx.log('WATER hot water: ' + dhwNote);
    if (HBn) ctx.log('WATER hose bibs (mep-v26, env.hoseBibs): ' + HBn + ' x SMB00122 frost-free, 450 over the floor, each in ' + W.cold16 + ' from the entry\'s header over the ceiling and down the wall, lagged ' + W.ins +
                     ', a tee ' + W.teeC + ' + ' + W.trC + ' at the header, 3 x ' + W.elb16C + ', a stop ' + W.stop + ' inside, sealed FEC00038: ' + HBlog.join('; '));
    ctx.log('WATER entry on wall ' + EN.k + ' at ' + EN.x.toFixed(2) + ',' + EN.z.toFixed(2) + ' (' + (TRw ? 'on the trailer\'s hookup side, ' : '') +
            (EN.atRiser ? ('at the riser\'s foot (env.riserAt: ' + (RZ.why || 'the product\'s') + '), the service under the slab to it; ') : '') + 'nearest the middle of the wet points ' + C.x.toFixed(2) + ',' + C.z.toFixed(2) +
            (TRw && EN.moved ? ('; ' + EN.moved) : '') + '): ' + W.valve + ' ball valve + ' + W.nrv + ' non-return valve at 26, ' + W.tr26 + ' to 20; ' +
            (TRw ? (trNote || 'the trailer inlet: nothing answered') : 'the service line from the meter is site work, not billed'));
    if (RZ) ctx.log('WATER riser (mep-v40, env.riserAt): ' + rise.notes.join('; ') + ' -- ' + W.cold20 + ((hotRise || hotDown) ? (' + ' + W.hot20) : '') + ', the cold lagged ' + W.ins +
                    ' too (it passes the unheated garage\'s side of its wall), 2 elbows 20 a pipe, the floor\'s trunks above the floor\'s wool (its warm side), ' +
                    Math.max(0, nUpC - 1) + (nUpH > 1 ? (' + ' + (nUpH - 1)) : '') + ' tee(s) 20 on them');
    if (HT && HT.dhw) {
      ctx.log('WATER hot water from ' + DHW.code + ' (the heat pump\'s 250 l tank) in ' + HT.name + ' at ' + HT.x.toFixed(2) + ',' + HT.z.toFixed(2) + ' -- billed with the heating (' + env.dhwFrom +
              '), no electric heater; ' + W.exp + ' expansion tank on a tee in the cold, ' + W.tp + ' T&P valve with ' + m2(htr.tp) + ' m discharge out through wall ' + htr.tpWall +
              ', ' + W.strap + ' straps, 2 x ' + W.hose + ' for its in and out');
      ctx.log('WATER heater feed ' + feedNote);
    } else if (HT) {
      ctx.log('WATER heater ' + W.heater + ' (' + W.size + ', electric' + (env.heaterSmall ? ', under counter (heaterSmall)' : '') + ') in ' + HT.name + ' -- ' + HT.why + ', at ' + HT.x.toFixed(2) + ',' + HT.z.toFixed(2) +
              (HT.small.length ? ('; too small for it (' + mm(W.minRoom) + ' x ' + mm(W.minRoom) + '): ' + HT.small.join(', ')) : '') +
              '; ' + W.exp + ' expansion tank on a tee in the cold, ' + W.tp + ' T&P valve with ' + m2(htr.tp) + ' m discharge ' + (PAN ? 'down to 150 over the pan (IRC P2804.6.1)' : ('out through wall ' + htr.tpWall)) +
              ', ' + W.strap + ' seismic straps, 2 x ' + W.hose + ' for its in and out');
      if (PAN) ctx.log('WATER heater pan (mep-v40, upstairs: IRC P2801.6): ' + PAN.code + ' PENDING under it, its drain ' + m2(PAN.L) + ' m ' + PAN.pipe + ' -- ' + m2(PAN.h) + ' out through wall ' + PAN.wall +
                       ', ' + m2(PAN.v) + ' down the facade to 300 over grade (P2801.6.2) -- ' + PAN.bends + ' x ' + PAN.bend + ', ' + PAN.hang + ' strap(s) SMC00001 + ' + (PAN.hang * 2) + ' x ' + W.screw + ', the way through the wall sealed FEC00038');
      ctx.log('WATER heater feed ' + feedNote);
    } else {
      ctx.log('WATER no heater -- no hot connection among the wet points');
    }
    if (SLW) ctx.log('WATER cold ' + m2(cold20) + ' m ' + W.cold20 + ' (the runs ' + m2(SLW.c) + (HT ? (' + ' + m2(htr.rise) + ' up to the heater') : '') + (rise.nC ? (' + risers ' + m2(rise.c)) : '') + (TCu.len > 0.005 ? (' + storey 2\'s trunk ' + m2(TCu.len)) : '') + ')' +
                     (HT ? ('; hot ' + m2(hot20) + ' m ' + W.hot20 + ' (the runs ' + m2(SLW.h) + ', ' + m2(htr.drop) + ' down from the heater, ' + m2(htr.tp) + ' T&P discharge' + (rise.nH ? (', risers ' + m2(rise.h)) : '') + (THu.len > 0.005 ? (', storey 2\'s trunk ' + m2(THu.len)) : '') + ')') : '') +
                     '; branches ' + m2(cold16) + ' m ' + W.cold16 + (br.nH ? (' + ' + m2(hot16) + ' m ' + W.hot16) : '') + ' (from the room\'s stub in its wall, Manhattan x ' + W.f + ' + the rise to each connection)');
    else ctx.log('WATER cold trunk ' + m2(cold20) + ' m ' + W.cold20 + ' (entry -> ' + TC.order.join(' -> ') + ', Manhattan x ' + W.f + (HT ? (' + ' + m2(htr.rise) + ' up to the heater') : '') +
            ', ' + TC.turns + ' turn(s))' + (HT ? ('; hot trunk ' + m2(hot20) + ' m ' + W.hot20 + ' (heater -> ' + TH.order.join(' -> ') + ' ' + m2(TH.len) + ', ' + m2(htr.drop) +
            ' down from the heater, ' + m2(htr.tp) + ' T&P discharge)') : '') + '; branches ' + m2(cold16) + ' m ' + W.cold16 + (br.nH ? (' + ' + m2(hot16) + ' m ' + W.hot16) : '') +
            ' (from the room\'s middle, Manhattan x ' + W.f + ' + the rise to each connection)' +
            (rise.nC ? ('; risers to the upper storey: ' + rise.notes.join(', ') + ', in the trunks, ' + (2 * rise.nC) + (rise.nH ? (' + ' + (2 * rise.nH)) : '') + ' elbow(s) 20') : ''));
    ctx.log('WATER fittings: ' + teeC + ' x ' + W.teeC + (teeH ? (' + ' + teeH + ' x ' + W.teeH) : '') + ' tees, ' + br.nC + ' x ' + W.trC + (br.nH ? (' + ' + br.nH + ' x ' + W.trH) : '') +
            ' transitions 20/16, elbows ' + elb20C + ' x ' + W.elb20C + (elb20H ? (' + ' + elb20H + ' x ' + W.elb20H) : '') + ' (20) and ' + br.elbC + ' x ' + W.elb16C +
            (br.elbH ? (' + ' + br.elbH + ' x ' + W.elb16H) : '') + ' (16), drop ears ' + br.nC + ' x ' + W.earC + (br.nH ? (' + ' + br.nH + ' x ' + W.earH) : '') +
            '; ' + br.stops + ' x ' + W.stop + ' angle stops, ' + (br.stops + (HT ? 2 : 0)) + ' x ' + W.hose + ' hoses');
    if (SLW && !SLW.C.length && !SLW.H.length) ctx.log('WATER under the slab (env.underSlab, mep-v24 / v40): no run of ours -- the service comes in under the slab to the entry at the riser\'s foot' +
                     (EN.moved ? (' (' + EN.moved + ')') : '') + ', up through the slab in a ' + m2(sleeveL) + ' m ' + W.ins + ' sleeve' +
                     (slvW ? ('; in through the edge footing (' + mm(EGw.w) + ') in a ' + slvW + ' m sleeve ' + slvWc + ', the annulus sealed (mep-v33)') : '') + '; pressure-tested before the pour (IRC P2503.7)');
    else if (SLW) ctx.log('WATER under the slab (env.underSlab, mep-v24): no joint under it -- ' + SLW.C.length + ' cold run(s) of ' + W.cold20 + ' from the entry' + (EN.moved ? (' (' + EN.moved + ')') : '') + ' (' +
                     SLW.C.map(function (c) { return c.to + ' ' + m2(c.L); }).join(', ') + ' m)' + (SLW.H.length ? (', ' + SLW.H.length + ' hot run(s) of ' + W.hot20 + ' from the heater (' +
                     SLW.H.map(function (c) { return c.to + ' ' + m2(c.L); }).join(', ') + ' m)') : '') + ', each laid on the subgrade ' + mm(SLW.dS) + ' under the floor, bent not jointed, up through the slab ' +
                     'into the room\'s wall nearest its pieces; the tees above the slab (a header at the entry' + (SLW.H.length ? ' and at the heater' : '') + ', the room\'s in its wall); ' +
                     m2(sleeveL) + ' m ' + W.ins + ' as sleeves where the cold goes through the slab (the hot is lagged all the way); ' +
                     (slvW ? ('the service in through the edge footing (' + mm(EGw.w) + ') in a ' + slvW + ' m sleeve ' + slvWc + ', the annulus sealed (mep-v33); ') : '') +
                     'clips only above the slab; pressure-tested before the pour (IRC P2503.7)');
    ctx.log('WATER insulation ' + m2(insL) + ' m ' + W.ins + ' on the hot pipe; ' + clips + ' x ' + W.clip + ' clips (' + m2(nPipe) + ' m of pipe, one every ' + mm(W.clipEvery) +
            '), ' + screws + ' x ' + W.screw + ' (a clip one, a drop ear ' + W.earScrews + ')');

    /* mep-v40: what a product reads for its fireblocking -- the pipes from the
       ground storey up through the floor between */
    LAST[LID] = { ups: rise.nC + rise.nH, riser: RZ ? { x: RZ.x, z: RZ.z } : null, heaterUp: !!(HT && HT.up) };
    /* mep-v61 (opt-in env.runsOut, no slab): THE WATER AS DATA for a product
       that draws its runs itself (THOW thow-v57: round the walls) -- the
       entry, the heater and every ground wet point (plan point, connection
       height over the floor, hot or not). Data only: nothing billed or drawn
       changes. */
    if (env.runsOut === true && !US) {
      LAST[LID].runs = { y0: y0, entry: { x: EN.x, z: EN.z, k: EN.k || null, n: EN.n || null },
                         heater: (HT && !HT.up) ? { x: HT.x, z: HT.z, top: (HT.top != null ? HT.top : W.htrTop), d: W.htrD, code: HT.dhw ? null : W.heater } : null,
                         pts: pts.filter(function (pq) { return !(pq.st > 0); }).map(function (pq) {
                           return { x: pq.x, z: pq.z, y: pq.y, hot: !!pq.hot, stop: !!pq.stop, what: pq.what, room: pq.rname };
                         }) };
    }

    /* THE BODIES (mep-v9): the heater in its corner with the expansion tank
       above it, and the entry -- its stub up from the floor, the ball valve
       and the non-return valve -- on the wall the calculation chose. Natural
       colours (a tank looks like a tank, the cold pipe is blue PEX), viz
       'water', the layer's own group, so the services view keeps them solid.
       The runs stay calculated. Nothing here changes a quantity. */
    var T3 = ctx.THREE, g3 = ctx.group;
    if (!T3 || !g3 || !T3.Mesh) { ctx.log('WATER bodies none -- no THREE or no group handed over'); return; }
    var mag = (typeof env.isNew === 'function') ? !!env.isNew(LID) : false, MAG = env.MAGENTA || 0xFF00FF;
    var asm = (typeof env._asmCode === 'function') ? env._asmCode : null, nB = 0;
    function mat(col, rough, metal) { return new T3.MeshStandardMaterial({ color: mag ? MAG : col, roughness: rough, metalness: metal }); }
    function cyl(x, y, z, r, h, m, name) {
      var c = new T3.Mesh(new T3.CylinderGeometry(r, r, h, 20), m);
      c.position.set(x, y, z); c.name = name; c.userData.viz = 'water'; g3.add(c); nB++; return c;
    }
    function box(x, y, z, w2, h2, d2, m, name) {
      var b = new T3.Mesh(new T3.BoxGeometry(w2, h2, d2), m);
      b.position.set(x, y, z); b.name = name; b.userData.viz = 'water'; g3.add(b); nB++; return b;
    }
    var mTank = mat(0xF2F2F0, 0.45, 0.05), mCap = mat(0x8F9498, 0.5, 0.4), mExp = mat(0xE8E8E6, 0.4, 0.2),
        mBrass = mat(0xB08D57, 0.35, 0.8), mCold = mat(0x3A6FB0, 0.5, 0.0);
    var bNotes = [];
    if (HT && HT.dhw) {
      if (asm) asm(ctx, W.exp, 'top');
      cyl(HT.x, y0 + hTop + 0.28, HT.z, 0.10, 0.30, mExp, 'water-expansion-tank');
      bNotes.push('the expansion tank over the heat pump\'s tank in ' + HT.name + ' (the tank is the heating\'s)');
    } else if (HT) {
      var yH = y0 + (HT.dy || 0);   /* mep-v40: on its storey's floor */
      if (asm) asm(ctx, W.heater, 'top');
      cyl(HT.x, yH + W.htrTop / 2 - 0.05, HT.z, W.htrD / 2 - 0.02, W.htrTop - 0.10, mTank, 'water-heater');
      cyl(HT.x, yH + W.htrTop - 0.03, HT.z, W.htrD / 2 - 0.04, 0.06, mCap, 'water-heater-top');
      if (asm) asm(ctx, W.exp, 'top');
      cyl(HT.x, yH + W.htrTop + 0.28, HT.z, 0.10, 0.30, mExp, 'water-expansion-tank');
      bNotes.push('heater ' + mm(W.htrD) + ' x ' + mm(W.htrTop) + ' in ' + HT.name + ' at ' + HT.x.toFixed(2) + ',' + HT.z.toFixed(2) + ' with its expansion tank above');
    }
    /* mep-v40: a straight piece of pipe between two points */
    var V3x = T3.Vector3, UPx = new V3x(0, 1, 0);
    function seg3(a, b, r, m, name) {
      var dx = b[0] - a[0], dy3 = b[1] - a[1], dz = b[2] - a[2], L = Math.sqrt(dx * dx + dy3 * dy3 + dz * dz);
      if (!(L > 0.005)) return null;
      var c = new T3.Mesh(new T3.CylinderGeometry(r, r, L, 10), m);
      c.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2);
      c.quaternion.setFromUnitVectors(UPx, new V3x(dx / L, dy3 / L, dz / L));
      c.name = name; c.userData.viz = 'water'; g3.add(c); nB++; return c;
    }
    if (PAN) {
      /* mep-v40: the pan round the heater's foot and its drain out and down the facade */
      var mPan = mat(0xD9D9D6, 0.6, 0.1), mPd = mat(0xE9E9E6, 0.5, 0.0), yPn = PAN.y, PNn = PAN.n || [0, 1];
      if (asm) asm(ctx, PAN.code, 'top');
      cyl(HT.x, yPn - 0.02, HT.z, W.htrD / 2 + 0.05, 0.06, mPan, 'water-heater-pan');
      if (asm) asm(ctx, PAN.pipe, 'side');
      var pA = [HT.x, yPn, HT.z], pW = [PAN.x, yPn, PAN.z], pO = [PAN.x - PNn[0] * (through + 0.05), yPn, PAN.z - PNn[1] * (through + 0.05)];
      var pC = (Math.abs(PNn[0]) > 0.5) ? [PAN.x, yPn, HT.z] : [HT.x, yPn, PAN.z];
      seg3(pA, pC, 0.016, mPd, 'water-pan-drain');
      seg3(pC, pW, 0.016, mPd, 'water-pan-drain');
      seg3(pW, pO, 0.016, mPd, 'water-pan-drain');
      seg3(pO, [pO[0], yPn - PAN.v, pO[2]], 0.016, mPd, 'water-pan-drain');
      bNotes.push('the pan under the heater, its drain out through wall ' + PAN.wall + ' and down the facade');
    }
    var ENn = EN.n || { z0: [0, 1], x1: [-1, 0], z1: [0, -1], x0: [1, 0] }[EN.k], ex = EN.x + ENn[0] * 0.06, ez = EN.z + ENn[1] * 0.06;
    if (asm) asm(ctx, W.valve, 'side');
    cyl(ex, y0 + 0.30, ez, 0.016, 0.60, mCold, 'water-entry-pipe');
    box(ex, y0 + 0.30, ez, 0.07, 0.06, 0.07, mBrass, 'water-entry-valve');
    box(ex, y0 + 0.48, ez, 0.06, 0.08, 0.06, mBrass, 'water-entry-nrv');
    bNotes.push('entry stub with the ball and non-return valves on wall ' + EN.k + ' at ' + EN.x.toFixed(2) + ',' + EN.z.toFixed(2));
    if (RZ) {
      /* mep-v40: the riser on its wall to the floor of storey 2 (lagged: drawn fat) */
      var RNn = (isFinite(RZ.nx) && isFinite(RZ.nz)) ? [RZ.nx, RZ.nz] : ENn, rx = RZ.x + RNn[0] * 0.06, rz = RZ.z + RNn[1] * 0.06;
      /* mep-v43: with env.upDraw on up to the runs' level in the floor between */
      var UDw = _upDraw(env), yTopR = UDw ? UDw.y : (y0 + RZ.dy - 0.10);
      if (asm) asm(ctx, W.cold20, 'side');
      seg3([rx, y0 + (EN.atRiser ? 0.60 : 0.10), rz], [rx, yTopR, rz], 0.020, mCold, 'water-riser');
      if (hotRise || hotDown) {
        if (asm) asm(ctx, W.hot20, 'side');
        seg3([rx - RNn[1] * 0.06, y0 + 0.10, rz + RNn[0] * 0.06], [rx - RNn[1] * 0.06, yTopR, rz + RNn[0] * 0.06], 0.020, mat(0xB8433A, 0.5, 0.0), 'water-riser');
      }
      bNotes.push('the riser at ' + RZ.x.toFixed(2) + ',' + RZ.z.toFixed(2) + ' up ' + m2(RZ.dy) + ((hotRise || hotDown) ? ' (cold and hot)' : ''));
    }
    /* mep-v43: STOREY 2's TRUNKS AND BRANCHES IN THE FLOOR BETWEEN (env.upDraw):
       the cold from the riser's top node to node (the rooms' middles, the
       heater), the hot from the heater (or up the riser), at the runs' level
       under the subfloor, a bay at a time, through the joists' webs where
       they cross; at the heater both up its side to its top; from each
       room's middle a branch to every piece and up through the floor to its
       connection. Drawn only -- the lengths are the calculation's above. */
    var UPH = { holes: 0, n: 0, c: 0, h: 0 };
    if (RZ && UDw) {
      var mHu = mat(0xB8433A, 0.5, 0.0), yU2 = UDw.y, yF2 = y0 + RZ.dy;
      var Cq = { x: 0, z: 0 }, nCq = 0, q7;
      for (q7 = 0; q7 < UGL.length; q7++) { Cq.x += UGL[q7].x; Cq.z += UGL[q7].z; nCq++; }
      if (nCq) { Cq.x /= nCq; Cq.z /= nCq; }
      /* the heater's side the pipes go up: toward the pieces, past its jacket */
      var hSide = null;
      if (HT && HT.up) {
        var hdx = Cq.x - HT.x, hdz = Cq.z - HT.z, hR = W.htrD / 2 + 0.04;
        hSide = (Math.abs(hdx) >= Math.abs(hdz)) ? { x: HT.x + (hdx >= 0 ? hR : -hR), z: HT.z, ax: 'x' } : { x: HT.x, z: HT.z + (hdz >= 0 ? hR : -hR), ax: 'z' };
      }
      function nodeAt(nd, hot) {
        if (nd === RZ) return hot ? { x: rx - RNn[1] * 0.06, z: rz + RNn[0] * 0.06 } : { x: rx, z: rz };
        if (nd && (nd === HT || nd.name === 'heater') && hSide) return (hSide.ax === 'x') ? { x: hSide.x, z: hSide.z + (hot ? 0.05 : -0.05) } : { x: hSide.x + (hot ? 0.05 : -0.05), z: hSide.z };
        return { x: nd.x, z: nd.z };
      }
      function runU(a, b, off, r, m, nm, tally) {
        var RT = UDw.route(a, b, off), q;
        for (q = 0; q + 1 < RT.pts.length; q++) {
          var A = RT.pts[q], B = RT.pts[q + 1], Lq = Math.abs(A.x - B.x) + Math.abs(A.z - B.z);
          if (seg3([A.x, yU2, A.z], [B.x, yU2, B.z], r, m, nm)) { UPH.n++; UPH[tally] += Lq; }
        }
        UPH.holes += RT.holes;
      }
      function trunk(CH, hot) {
        var sq = (CH && CH.seq) || [], q;
        for (q = 0; q + 1 < sq.length; q++) runU(nodeAt(sq[q], hot), nodeAt(sq[q + 1], hot), hot ? 0.03 : -0.03, 0.010, hot ? mHu : mCold, 'water-up-trunk', hot ? 'h' : 'c');
      }
      if (asm) asm(ctx, W.cold20, 'top');
      trunk(TCu, false);
      if (THu && THu.seq && THu.seq.length > 1) { if (asm) asm(ctx, W.hot20, 'top'); trunk(THu, true); }
      if (hSide) {
        /* up the heater's side: the cold in, the hot out at its top */
        var yHt = yF2 + W.htrTop + 0.04, pc = nodeAt({ name: 'heater' }, false), ph = nodeAt({ name: 'heater' }, true);
        if (asm) asm(ctx, W.cold20, 'side');
        if (seg3([pc.x, yU2, pc.z], [pc.x, yHt, pc.z], 0.010, mCold, 'water-up-heater')) UPH.n++;
        if (THu && THu.seq && THu.seq.length > 1) { if (asm) asm(ctx, W.hot20, 'side'); if (seg3([ph.x, yU2, ph.z], [ph.x, yHt, ph.z], 0.010, mHu, 'water-up-heater')) UPH.n++; }
      }
      /* the branches: the room's middle to each piece, up through the floor to it */
      for (q7 = 0; q7 < UGL.length; q7++) {
        var Gu = UGL[q7], k7;
        for (k7 = 0; k7 < Gu.pts.length; k7++) {
          var pu = Gu.pts[k7];
          if (asm) asm(ctx, W.cold16, 'top');
          runU({ x: Gu.x, z: Gu.z }, { x: pu.x - 0.025, z: pu.z }, -0.05, 0.008, mCold, 'water-up-branch', 'c');
          if (seg3([pu.x - 0.025 - 0.05 * (UDw.ax === 'x' ? 1 : 0), yU2, pu.z - 0.05 * (UDw.ax === 'z' ? 1 : 0)], [pu.x - 0.025 - 0.05 * (UDw.ax === 'x' ? 1 : 0), yF2 + pu.y, pu.z - 0.05 * (UDw.ax === 'z' ? 1 : 0)], 0.008, mCold, 'water-up-branch')) UPH.n++;
          if (pu.hot) {
            if (asm) asm(ctx, W.hot16, 'top');
            runU({ x: Gu.x, z: Gu.z }, { x: pu.x + 0.025, z: pu.z }, 0.05, 0.008, mHu, 'water-up-branch', 'h');
            if (seg3([pu.x + 0.025 + 0.05 * (UDw.ax === 'x' ? 1 : 0), yU2, pu.z + 0.05 * (UDw.ax === 'z' ? 1 : 0)], [pu.x + 0.025 + 0.05 * (UDw.ax === 'x' ? 1 : 0), yF2 + pu.y, pu.z + 0.05 * (UDw.ax === 'z' ? 1 : 0)], 0.008, mHu, 'water-up-branch')) UPH.n++;
          }
        }
      }
      LAST[LID].upHoles = UPH.holes; LAST[LID].upVoid = UDw.hits();
      bNotes.push('storey 2 (mep-v43, env.upDraw): ' + UPH.n + ' bodies -- the trunks and branches in the floor between at ' + mm(yF2 - yU2) + ' under the floor, ' +
                  m2(UPH.c) + ' m cold + ' + m2(UPH.h) + ' m hot as drawn (billed by the calculation), ' + UPH.holes + ' hole(s) through the joists\' webs where they cross' +
                  (UDw.hits() ? (' -- CHECK: ' + UDw.hits() + ' run(s) cross a void the product keeps clear (env.upDraw avoid)') : ''));
    }
    /* mep-v52 (RANCH thread, opt-in env.floorDraw): THE GROUND FLOOR'S RUNS
       DRAWN IN ITS JOIST BAYS -- a raised floor over a crawl space (no slab):
       the cold trunk from the entry's foot node to node (the rooms' middles,
       the heater, the riser), the hot from the heater, at the product's level
       in the bays, along a bay and across the joists through their webs as
       storey 2's (mep-v43); at the heater both up its side to its top; from
       each room's middle a branch to every piece and up through the floor to
       its connection. Drawn only -- the lengths are the calculation's. */
    var GPH = { holes: 0, n: 0, c: 0, h: 0 }, GDw = (!SLW) ? _upDraw(env, 'floorDraw') : null;
    if (GDw) {
      var mHg = mat(0xB8433A, 0.5, 0.0), yG = GDw.y;
      var Cg = { x: 0, z: 0 }, nCg = 0, qg;
      for (qg = 0; qg < GL.length; qg++) if (!(GL[qg].dy > 0)) { Cg.x += GL[qg].x; Cg.z += GL[qg].z; nCg++; }
      if (nCg) { Cg.x /= nCg; Cg.z /= nCg; }
      var hSg = null;
      if (HT && !HT.up) {
        var hgx = Cg.x - HT.x, hgz = Cg.z - HT.z, hRg = W.htrD / 2 + 0.04;
        hSg = (Math.abs(hgx) >= Math.abs(hgz)) ? { x: HT.x + (hgx >= 0 ? hRg : -hRg), z: HT.z, ax: 'x' } : { x: HT.x, z: HT.z + (hgz >= 0 ? hRg : -hRg), ax: 'z' };
      }
      var enG = { x: ex, z: ez };
      var nodeG = function (nd, hot) {
        if (nd === EN) return enG;
        if (RZ && nd === RZ) { var RNg = (isFinite(RZ.nx) && isFinite(RZ.nz)) ? [RZ.nx, RZ.nz] : ENn; return hot ? { x: RZ.x + RNg[0] * 0.06 - RNg[1] * 0.06, z: RZ.z + RNg[1] * 0.06 + RNg[0] * 0.06 } : { x: RZ.x + RNg[0] * 0.06, z: RZ.z + RNg[1] * 0.06 }; }
        if (nd && (nd === HT || nd.name === 'heater') && hSg) return (hSg.ax === 'x') ? { x: hSg.x, z: hSg.z + (hot ? 0.05 : -0.05) } : { x: hSg.x + (hot ? 0.05 : -0.05), z: hSg.z };
        return { x: nd.x, z: nd.z };
      };
      var runG = function (a, b, off, r, m, nm, tl) {
        var RT = GDw.route(a, b, off), q;
        for (q = 0; q + 1 < RT.pts.length; q++) {
          var A = RT.pts[q], B = RT.pts[q + 1], Lq = Math.abs(A.x - B.x) + Math.abs(A.z - B.z);
          if (seg3([A.x, yG, A.z], [B.x, yG, B.z], r, m, nm)) { GPH.n++; GPH[tl] += Lq; }
        }
        GPH.holes += RT.holes;
      };
      var trunkG = function (CH, hot) {
        var sq = (CH && CH.seq) || [], q;
        for (q = 0; q + 1 < sq.length; q++) runG(nodeG(sq[q], hot), nodeG(sq[q + 1], hot), hot ? 0.03 : -0.03, 0.010, hot ? mHg : mCold, 'water-floor-trunk', hot ? 'h' : 'c');
      };
      /* the entry's foot down into the bay */
      if (asm) asm(ctx, W.cold20, 'side');
      if (seg3([ex, y0, ez], [ex, yG, ez], 0.010, mCold, 'water-floor-trunk')) { GPH.n++; GPH.c += y0 - yG; }
      if (asm) asm(ctx, W.cold20, 'top');
      trunkG(TC, false);
      if (TH && TH.seq && TH.seq.length > 1) { if (asm) asm(ctx, W.hot20, 'top'); trunkG(TH, true); }
      if (hSg) {
        var yHg = y0 + hTop + 0.04, pcg = nodeG({ name: 'heater' }, false), phg = nodeG({ name: 'heater' }, true);
        if (asm) asm(ctx, W.cold20, 'side');
        if (seg3([pcg.x, yG, pcg.z], [pcg.x, yHg, pcg.z], 0.010, mCold, 'water-floor-heater')) { GPH.n++; GPH.c += yHg - yG; }
        if (TH && TH.seq && TH.seq.length > 1) { if (asm) asm(ctx, W.hot20, 'side'); if (seg3([phg.x, yG, phg.z], [phg.x, yHg, phg.z], 0.010, mHg, 'water-floor-heater')) { GPH.n++; GPH.h += yHg - yG; } }
      }
      /* the branches: the room's middle to each piece, up through the floor to it */
      for (qg = 0; qg < GL.length; qg++) {
        var Gg = GL[qg], kg; if (Gg.dy > 0) continue;
        for (kg = 0; kg < Gg.pts.length; kg++) {
          var pg = Gg.pts[kg], dxg = 0.05 * (GDw.ax === 'x' ? 1 : 0), dzg = 0.05 * (GDw.ax === 'z' ? 1 : 0);
          if (asm) asm(ctx, W.cold16, 'top');
          runG({ x: Gg.x, z: Gg.z }, { x: pg.x - 0.025, z: pg.z }, -0.05, 0.008, mCold, 'water-floor-branch', 'c');
          if (asm) asm(ctx, W.cold16, 'side');
          if (seg3([pg.x - 0.025 - dxg, yG, pg.z - dzg], [pg.x - 0.025 - dxg, y0 + pg.y, pg.z - dzg], 0.008, mCold, 'water-floor-branch')) { GPH.n++; GPH.c += y0 + pg.y - yG; }
          if (pg.hot) {
            if (asm) asm(ctx, W.hot16, 'top');
            runG({ x: Gg.x, z: Gg.z }, { x: pg.x + 0.025, z: pg.z }, 0.05, 0.008, mHg, 'water-floor-branch', 'h');
            if (asm) asm(ctx, W.hot16, 'side');
            if (seg3([pg.x + 0.025 + dxg, yG, pg.z + dzg], [pg.x + 0.025 + dxg, y0 + pg.y, pg.z + dzg], 0.008, mHg, 'water-floor-branch')) { GPH.n++; GPH.h += y0 + pg.y - yG; }
          }
        }
      }
      bNotes.push('the ground floor (mep-v52, env.floorDraw): ' + GPH.n + ' bodies -- the trunks and branches in the joist bays ' + mm(y0 - yG) + ' under the floor, ' +
                  m2(GPH.c) + ' m cold + ' + m2(GPH.h) + ' m hot as drawn (billed by the calculation), ' + GPH.holes + ' hole(s) through the joists where they cross');
    }
    /* mep-v24: THE RUNS UNDER THE SLAB on their plan way, up 100 over the floor */
    if (SLW) {
      var mHot = mat(0xB8433A, 0.5, 0.0), V3w = T3.Vector3, UPw = new V3w(0, 1, 0), nSw = 0, rw;
      function pipeW(a, b, r, m, name) {
        var dx = b[0] - a[0], dy2 = b[1] - a[1], dz = b[2] - a[2], L = Math.sqrt(dx * dx + dy2 * dy2 + dz * dz);
        if (!(L > 0.005)) return;
        var c = new T3.Mesh(new T3.CylinderGeometry(r, r, L, 10), m);
        c.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2);
        c.quaternion.setFromUnitVectors(UPw, new V3w(dx / L, dy2 / L, dz / L));
        c.name = name; c.userData.viz = 'water'; g3.add(c); nB++; nSw++;
      }
      function runW(Rn, m, off) {
        var a = { x: Rn.a.x + off, z: Rn.a.z + off }, b = { x: Rn.b.x + off, z: Rn.b.z + off }, yW = SLW.yW, yU = y0 + 0.10;
        var c = (Rn.a.k === 'z0' || Rn.a.k === 'z1') ? { x: a.x, z: b.z } : { x: b.x, z: a.z };   /* off the entry's wall square to it */
        pipeW([a.x, yU, a.z], [a.x, yW, a.z], 0.010, m, 'water-slab-stub');
        pipeW([a.x, yW, a.z], [c.x, yW, c.z], 0.010, m, 'water-slab-run');
        pipeW([c.x, yW, c.z], [b.x, yW, b.z], 0.010, m, 'water-slab-run');
        pipeW([b.x, yW, b.z], [b.x, yU, b.z], 0.010, m, 'water-slab-stub');
      }
      if (asm) asm(ctx, W.cold20, 'top');
      for (rw = 0; rw < SLW.C.length; rw++) runW(SLW.C[rw], mCold, -0.03 - 0.025 * rw);
      if (asm && SLW.H.length) asm(ctx, W.hot20, 'top');
      for (rw = 0; rw < SLW.H.length; rw++) runW(SLW.H[rw], mHot, 0.03 + 0.025 * rw);
      bNotes.push(nSw + ' bodies of the runs under the slab (mep-v24)');
    }
    /* mep-v52 (RANCH thread, opt-in env.waterRest): THE REST OF THE BILLED
       WATER DRAWN on the calculation's way -- the T&P valve's discharge from
       the heater's top down its side to 150 over the floor, across to the
       nearest exterior wall and out through it (over a pan: straight down);
       each hose bib's feed from the entry's header up inside the wall, over
       the ceiling, down inside the bib's wall to 450 and out to the bib; on
       a slab the heater's cold in and hot out up its side from the runs'
       stubs, and the service's sleeve through the edge footing. Drawn only:
       the lengths are the calculation's. Without the flag nothing changes. */
    var RST = { n: 0, tp: 0, hb: 0, ht: 0, slv: 0, br: 0 };
    if (env.waterRest === true) {
      var mTp = mat(0xB8433A, 0.5, 0.0), mHbF = mat(0x3A6FB0, 0.5, 0.0);
      var rst = function (a, b, r, m, nm, tl) { if (seg3(a, b, r, m, nm)) { RST.n++; RST[tl] += Math.sqrt(Math.pow(b[0] - a[0], 2) + Math.pow(b[1] - a[1], 2) + Math.pow(b[2] - a[2], 2)); } };
      if (HT && htr.tp > 0.005) {
        var TFd = nearestFace(HT.x, HT.z), TN = TFd.n || [0, 1], hRt = W.htrD / 2 + 0.04, yHb = y0 + (HT.dy || 0);
        var tx = HT.x - TN[0] * hRt, tz = HT.z - TN[1] * hRt, yTp = yHb + W.tpEnd;
        if (asm) asm(ctx, W.hot20, 'side');
        rst([tx, yHb + hTop + 0.04, tz], [tx, yTp, tz], 0.010, mTp, 'water-tp-discharge', 'tp');
        if (!PAN) {
          rst([tx, yTp, tz], [TFd.x, yTp, TFd.z], 0.010, mTp, 'water-tp-discharge', 'tp');
          rst([TFd.x, yTp, TFd.z], [TFd.x - TN[0] * through, yTp, TFd.z - TN[1] * through], 0.010, mTp, 'water-tp-discharge', 'tp');
        }
      }
      if (HBD.length) {
        var yHc = yCeil + 0.06, tgE = [ENn[1], -ENn[0]], qh;
        for (qh = 0; qh < HBD.length; qh++) {
          var hbP = HBD[qh], hn = hbP.n || [0, 1], oE = 0.08 + 0.04 * qh;
          var sx = ex + tgE[0] * oE, sz = ez + tgE[1] * oE, bx = hbP.x - hn[0] * 0.05, bz = hbP.z - hn[1] * 0.05;
          if (asm) asm(ctx, W.cold16, 'side');
          rst([sx, y0 + 0.50, sz], [sx, yHc, sz], 0.008, mHbF, 'water-hosebib-feed', 'hb');
          if (asm) asm(ctx, W.cold16, 'top');
          rst([sx, yHc, sz], [bx, yHc, sz], 0.008, mHbF, 'water-hosebib-feed', 'hb');
          rst([bx, yHc, sz], [bx, yHc, bz], 0.008, mHbF, 'water-hosebib-feed', 'hb');
          if (asm) asm(ctx, W.cold16, 'side');
          rst([bx, yHc, bz], [bx, y0 + 0.45, bz], 0.008, mHbF, 'water-hosebib-feed', 'hb');
          rst([bx, y0 + 0.45, bz], [hbP.x - hn[0] * (through + 0.04), y0 + 0.45, hbP.z - hn[1] * (through + 0.04)], 0.008, mHbF, 'water-hosebib-feed', 'hb');
        }
      }
      if (SLW && HT && !HT.up) {
        /* the heater's cold in and hot out, up its side from the stubs */
        var Cs = { x: 0, z: 0 }, nCs = 0, qs;
        for (qs = 0; qs < GL.length; qs++) if (!(GL[qs].dy > 0)) { Cs.x += GL[qs].x; Cs.z += GL[qs].z; nCs++; }
        if (nCs) { Cs.x /= nCs; Cs.z /= nCs; }
        var hsx = Cs.x - HT.x, hsz = Cs.z - HT.z, hRs = W.htrD / 2 + 0.04, axs = Math.abs(hsx) >= Math.abs(hsz);
        var hSx = axs ? HT.x + (hsx >= 0 ? hRs : -hRs) : HT.x, hSz = axs ? HT.z : HT.z + (hsz >= 0 ? hRs : -hRs);
        var yS0 = y0 + 0.10, yS1 = y0 + hTop + 0.04, ics, hcs = null, hhs = null;
        for (ics = 0; ics < SLW.C.length; ics++) if (SLW.C[ics].to === 'heater') hcs = { x: HT.x - 0.03 - 0.025 * ics, z: HT.z - 0.03 - 0.025 * ics };
        if (SLW.H.length) hhs = { x: HT.x + 0.03, z: HT.z + 0.03 };
        var pcs = axs ? { x: hSx, z: hSz - 0.05 } : { x: hSx - 0.05, z: hSz }, phs = axs ? { x: hSx, z: hSz + 0.05 } : { x: hSx + 0.05, z: hSz };
        if (hcs) {
          if (asm) asm(ctx, W.cold20, 'side');
          rst([hcs.x, yS0, hcs.z], [pcs.x, yS0, pcs.z], 0.010, mCold, 'water-heater-up', 'ht');
          rst([pcs.x, yS0, pcs.z], [pcs.x, yS1, pcs.z], 0.010, mCold, 'water-heater-up', 'ht');
        }
        if (hhs) {
          if (asm) asm(ctx, W.hot20, 'side');
          rst([hhs.x, yS0, hhs.z], [phs.x, yS0, phs.z], 0.010, mTp, 'water-heater-up', 'ht');
          rst([phs.x, yS0, phs.z], [phs.x, yS1, phs.z], 0.010, mTp, 'water-heater-up', 'ht');
        }
      }
      if (SLW) {
        /* the branches above the slab: from the room's stub up inside its wall
           to 300 (the hot 360), round the room's walls through their studs to
           the wall nearest the piece, up to its connection and out to it */
        var perim = function (F, off) {
          var x0 = F.x0 - off, x1 = F.x1 + off, z0 = F.z0 - off, z1 = F.z1 + off, Wd = x1 - x0, Dp = z1 - z0, P = 2 * (Wd + Dp);
          var tOf = function (p) {
            var x = Math.max(x0, Math.min(x1, p.x)), z = Math.max(z0, Math.min(z1, p.z));
            var e = [{ d: Math.abs(z - z0), t: x - x0 }, { d: Math.abs(x1 - x), t: Wd + (z - z0) },
                     { d: Math.abs(z1 - z), t: Wd + Dp + (x1 - x) }, { d: Math.abs(x - x0), t: 2 * Wd + Dp + (z1 - z) }], b = e[0], k;
            for (k = 1; k < 4; k++) if (e[k].d < b.d) b = e[k];
            return b.t;
          };
          var at = function (t) {
            t = ((t % P) + P) % P;
            if (t <= Wd) return { x: x0 + t, z: z0 };
            if (t <= Wd + Dp) return { x: x1, z: z0 + (t - Wd) };
            if (t <= 2 * Wd + Dp) return { x: x1 - (t - Wd - Dp), z: z1 };
            return { x: x0, z: z1 - (t - 2 * Wd - Dp) };
          };
          return function (a, b) {
            var ta = tOf(a), tb = tOf(b), fw = (((tb - ta) % P) + P) % P, dir = (fw <= P / 2) ? 1 : -1, len = (dir > 0) ? fw : P - fw;
            var Cn = [0, Wd, Wd + Dp, 2 * Wd + Dp], ts = [], out = [at(ta)], k;
            for (k = 0; k < 4; k++) { var dc = (dir > 0) ? ((((Cn[k] - ta) % P) + P) % P) : ((((ta - Cn[k]) % P) + P) % P); if (dc > 1e-6 && dc < len - 1e-6) ts.push(dc); }
            ts.sort(function (p, q) { return p - q; });
            for (k = 0; k < ts.length; k++) out.push(at(ta + dir * ts[k]));
            out.push(at(tb));
            return out;
          };
        };
        var mHb2 = mat(0xB8433A, 0.5, 0.0), qb, kb;
        for (qb = 0; qb < GL.length; qb++) {
          var Gb = GL[qb];
          if (Gb.dy > 0 || !Gb.stub || !(Gb.sC >= 0)) continue;
          /* a room with no faces (a piece outside every room): straight on the plan, x then z */
          var walkB = Gb.stub.F ? perim(Gb.stub.F, 0.05) : function (a, b) { return [{ x: a.x, z: a.z }, { x: b.x, z: a.z }, { x: b.x, z: b.z }]; };
          for (kb = 0; kb < Gb.pts.length; kb++) {
            var pb = Gb.pts[kb], side;
            for (side = 0; side < (pb.hot && Gb.sH >= 0 ? 2 : 1); side++) {
              var hotB = side === 1, offB = hotB ? (0.03 + 0.025 * Gb.sH) : (-0.03 - 0.025 * Gb.sC), yB = y0 + (hotB ? 0.36 : 0.30);
              var s0 = { x: Gb.stub.x + offB, z: Gb.stub.z + offB }, tgt = { x: pb.x + (hotB ? 0.025 : -0.025), z: pb.z }, mB = hotB ? mHb2 : mCold, nmB = 'water-wall-branch', tlB = 'br';
              var WK = walkB(s0, tgt), kw;
              if (asm) asm(ctx, hotB ? W.hot16 : W.cold16, 'side');
              rst([s0.x, y0 + 0.10, s0.z], [s0.x, yB, s0.z], 0.008, mB, nmB, tlB);
              if (asm) asm(ctx, hotB ? W.hot16 : W.cold16, 'top');
              rst([s0.x, yB, s0.z], [WK[0].x, yB, WK[0].z], 0.008, mB, nmB, tlB);
              for (kw = 0; kw + 1 < WK.length; kw++) rst([WK[kw].x, yB, WK[kw].z], [WK[kw + 1].x, yB, WK[kw + 1].z], 0.008, mB, nmB, tlB);
              var qE = WK[WK.length - 1];
              if (asm) asm(ctx, hotB ? W.hot16 : W.cold16, 'side');
              rst([qE.x, yB, qE.z], [qE.x, y0 + pb.y, qE.z], 0.008, mB, nmB, tlB);
              rst([qE.x, y0 + pb.y, qE.z], [tgt.x, y0 + pb.y, tgt.z], 0.008, mB, nmB, tlB);
            }
          }
        }
      }
      if (SLW && slvW > 0) {
        /* the service's sleeve through the edge footing, under the entry */
        var ySv = SLW.yW + 0.06, sAx = EN.x - ENn[0] * (through + SLV.past), sAz = EN.z - ENn[1] * (through + SLV.past);
        if (asm) asm(ctx, slvWc, 'side');
        rst([sAx, ySv, sAz], [sAx + ENn[0] * slvW, ySv, sAz + ENn[1] * slvW], 0.055, mat(0xC8692C, 0.6, 0.0), 'water-service-sleeve', 'slv');
      }
      if (RST.n) bNotes.push('the rest (mep-v52, env.waterRest): ' + RST.n + ' bodies -- ' +
                             (RST.tp ? ('the T&P discharge ' + m2(RST.tp) + ' m (billed ' + m2(htr.tp) + ')') : 'no T&P discharge') +
                             (RST.hb ? (', the hose bibs\' feeds ' + m2(RST.hb) + ' m over the ceiling (billed ' + m2(HBD.reduce(function (s, h) { return s + h.L; }, 0)) + ')') : '') +
                             (RST.ht ? (', the heater\'s cold in and hot out up its side ' + m2(RST.ht) + ' m') : '') +
                             (RST.br ? (', the branches above the slab ' + m2(RST.br) + ' m from the room\'s stub round its walls in the studs (billed ' + m2(cold16 + hot16) + ')') : '') +
                             (RST.slv ? (', the service\'s sleeve ' + slvWc + ' ' + m2(RST.slv) + ' m through the edge footing') : ''));
    }
    ctx.log('WATER bodies (mep-v9): ' + nB + ' drawn -- ' + bNotes.join('; ') +
            (SLW ? (RST.n ? '; every run drawn' : '; the rest of the runs calculated') : (GDw ? (RST.n ? '; every run drawn' : '; the T&P discharge calculated') : '; runs calculated, not drawn')) + (mag ? ' -- MAGENTA (under review)' : ''));
  }

  /* =========================================================================
     WASTE -- BY CALCULATION (mep-v7)

     WHAT IS BUILT (Marek, 2026-10-08, the step after the water): the drain
     of every wet piece of the fitout to a building drain that leaves the
     house, a vent stack through the roof and an air admittance valve on
     every other wet room. Calculated and billed; nothing drawn.

     THE DRAIN POINTS are the water's pieces, each with its trap and pipe:
       kitchen sink, basin     P-trap 1 1/2 in the cabinet, dia 50 into the wall
       washing machine         the outlet box with its own trap, dia 50
       bathtub                 P-trap 1 1/2 below the floor (the tub's own
                               waste and overflow set is in its row), dia 50
       shower                  shower drain on the tray + P-trap 2 below the
                               floor, dia 50
       WC                      toilet flange set (flange, wax ring, bolts),
                               dia 110 with a closet bend
     THE BUILDING DRAIN, dia 110, leaves on the exterior wall nearest the
     middle of the wet points (the water comes in on the same wall); inside,
     it runs from there through the rooms with a WC, the nearest next first
     -- every room when none has a WC. 1.0 m of buried PVC SN4 outside the
     wall to the site connection; the sewer beyond is site work, not billed.
     A cleanout where it leaves (a branch 110 and the cleanout adapter).
     THE VENT STACK, dia 75, rises from the drain's far end -- the last room
     the drain reaches -- through the roof to 300 above it (the roof's
     height there from the product's roof planes when it hands them over,
     else the ceiling + 1.2 m); a roof flashing; at its foot a branch 110, a
     reducer 110/75 and a cleanout.
     EVERY OTHER WET ROOM: its pieces join a collector dia 50 that runs to
     the nearest point of the drain (its start or a room on it) and joins it
     with a branch 110/50; it is vented by an air admittance valve on a dia
     50 pipe 1.0 m above the floor. A room on the drain other than the
     stack's gets the valve too.
     RUNS: Manhattan distance x 1.2 below the floor (300 under the finished
     floor, in the floor structure), plus the drop in the wall from a
     wall outlet (sink and basin 450, washer box 800). FITTINGS BY COUNT: a
     branch on the drain or the collector for every pipe that joins it (the
     collector's last piece is its own end); per branch from a wall outlet
     two 90 bends, from a floor outlet one; two 45 bends at every turn in
     plan. Hangers: a strap every 1.2 m of pipe indoors, 0.5 m of strap and
     two screws each. Every socket is primed and cemented: 0.006 l of each a
     joint up to dia 75, 0.012 l on dia 110 (a 0.47 l can does about 80
     joints of 2 in, 40 of 4 in). One cartridge of sealant for the
     drain's way through the wall.
     Log prefix WASTE.
     ========================================================================= */
  var WASTE = { f: 1.2, under: 0.30, outside: 1.0, aboveRoof: 0.30, roofDef: 1.20, vent: 1.00,
                hangEvery: 1.2, strapPer: 0.5, hangScrews: 2, glueS: 0.006, glueL: 0.012,
                p50: 'SMR00501', p75: 'SMR00751', p110: 'SMR01101', pOut: 'SMR01102',
                b50: 'SMP00502', b50h: 'SME00501', b110: 'SMP01103', b110h: 'SMP01106',
                y50: 'SMP00504', y110s: 'SMP01101', y110: 'SMP01102', r11075: 'SMP01105',
                trap: 'SMH00401', trap50: 'SMH00503', shDrain: 'SMH00502', box: 'SMH00501',
                flange: 'SMP01107', clean: 'SMP01108', aav: 'SMV00501', flash: 'SMV00751',
                strap: 'SMC00001', screw: 'FAS50060', seal: 'FEC00038', primer: 'FEC00041', cement: 'FEC00042' };
  /* mep-v33: AN OPENING'S SILL OVER THE FINISHED FLOOR. A masonry wall
     starts on the slab and its openings' sills are measured from there -- a
     door stands on the floor build-up at +150 (core-v396). Read as over the
     floor, no door stood on the floor: the electrics found no entrance and
     billed nothing on a block house. env.sillBase() gives how far the
     finished floor is over the base the sills count from; none, as before. */
  function _sillOf(env, o) {
    var s0 = (o && o.sill) || 0, b = 0;
    if (env && typeof env.sillBase === 'function') { try { b = +env.sillBase() || 0; } catch (eSB) { b = 0; } }
    return Math.max(0, s0 - b);
  }
  /* mep-v33: THE SLEEVES THROUGH THE EDGE FOOTING (env.underSlab().edge) */
  var SLV = { drain: 'mep.sleeve160', service: 'SMR01102', past: 0.05 };
  var SLV_CAT = { 'SMR01102': { unit: 'm', label: 'Sewer pipe PVC SN4 110' } };
  var SLV_PENDING = { 'mep.sleeve160': { unit: 'm', label: 'PVC sleeve pipe 160 SN4 through the foundation, two sizes over the 4 in. drain (pending row)' } };
  function _slvMint(CATALOG) {
    var k;
    for (k in SLV_CAT) if (SLV_CAT.hasOwnProperty(k) && !CATALOG[k]) CATALOG[k] = { code: k, unit: SLV_CAT[k].unit, label: SLV_CAT[k].label };
    for (k in SLV_PENDING) if (SLV_PENDING.hasOwnProperty(k) && !CATALOG[k]) CATALOG[k] = { code: null, pending: true, unit: SLV_PENDING[k].unit, label: SLV_PENDING[k].label };
  }
  function _slvEdge(US) { return (US && US.edge && US.edge.w > 0) ? US.edge : null; }
  var WASTE_CAT = {
    'SMR00501': { unit: 'm',   label: 'Drain pipe 50' },
    'SMR00751': { unit: 'm',   label: 'Drain pipe 75' },
    'SMR01101': { unit: 'm',   label: 'Drain pipe 110' },
    'SMR01102': { unit: 'm',   label: 'Sewer pipe PVC SN4 110' },
    'SMP00502': { unit: 'pcs', label: 'Drain bend 90 50' },
    'SME00501': { unit: 'pcs', label: 'Drain bend 45 50' },
    'SMP01103': { unit: 'pcs', label: 'Drain bend 90 110' },
    'SMP01106': { unit: 'pcs', label: 'Drain bend 45 110' },
    'SMP00504': { unit: 'pcs', label: 'Drain branch 50/50' },
    'SMP01101': { unit: 'pcs', label: 'Drain branch 110/50' },
    'SMP01102': { unit: 'pcs', label: 'Drain branch 110/110' },
    'SMP01105': { unit: 'pcs', label: 'Drain reducer 110/75' },
    'SMH00401': { unit: 'pcs', label: 'P-trap 1 1/2' },
    'SMH00503': { unit: 'pcs', label: 'P-trap 2' },
    'SMH00502': { unit: 'pcs', label: 'Shower drain' },
    'SMH00501': { unit: 'pcs', label: 'Washing machine outlet box' },
    'SMP01107': { unit: 'pcs', label: 'Toilet flange set' },
    'SMP01108': { unit: 'pcs', label: 'Cleanout adapter with plug 110' },
    'SMV00501': { unit: 'pcs', label: 'Air admittance valve' },
    'SMV00751': { unit: 'pcs', label: 'Plumbing vent roof flashing' },
    'SMC00001': { unit: 'm',   label: 'Pipe hanger strap' },
    'FAS50060': { unit: 'pcs', label: 'Wood screw 5x60' },
    'FEC00038': { unit: 'pcs', label: 'Polyurethane construction sealant 290 ml' },
    'FEC00041': { unit: 'l',   label: 'PVC primer' },
    'FEC00042': { unit: 'l',   label: 'PVC solvent cement' }
  };
  var WASTE_NEED = WATER_NEED.slice();
  function _wasteMissing(env) {
    var out = [], i;
    if (!env) return ['env'];
    if (typeof env.layerId !== 'string' || !env.layerId) out.push('layerId');
    for (i = 0; i < WASTE_NEED.length; i++) if (env[WASTE_NEED[i]] == null) out.push(WASTE_NEED[i]);
    return out;
  }
  /* the drain of a wet piece: what it is, a wall outlet (and its height) or
     a floor one, the pipe it takes, its trap, and where it is on the piece
     in the fitout's own frame (x across, z into the room, the back at -z) */
  function _drainOf(kind, w, d) {
    if (/^kitchen(24|30|36)$/.test(kind)) return { what: 'kitchen sink', wall: 1, y: 0.45, dia: 50, trap: 'p', lx: -w / 2 + 0.45, lz: -d / 2 };
    if (kind === 'kitchenL' || kind === 'kitchenU') return { what: 'kitchen sink', wall: 1, y: 0.45, dia: 50, trap: 'p', lx: 0, lz: -d / 2 };
    if (/^basin/.test(kind)) return { what: 'basin', wall: 1, y: 0.45, dia: 50, trap: 'p', lx: 0, lz: -d / 2 };
    if (kind === 'washer') return { what: 'washing machine', wall: 1, y: 0.80, dia: 50, trap: 'box', lx: 0, lz: -d / 2 };
    if (/^bath/.test(kind)) return { what: 'bathtub', wall: 0, y: 0, dia: 50, trap: 'p', lx: -w / 2 + 0.15, lz: 0 };
    if (/^shower/.test(kind)) return { what: 'shower', wall: 0, y: 0, dia: 50, trap: 'shower', lx: 0, lz: 0 };
    if (kind === 'wc') return { what: 'WC', wall: 0, y: 0, dia: 110, trap: 'wc', lx: 0, lz: -d / 2 + 0.30 };
    return null;
  }

  function _buildWaste(env, ctx) {
    var LID = env.layerId, API = env.API, STATE = env.STATE, CATALOG = env.CATALOG, FINISH = env.FINISH,
        _P = env._P, _add = env._add, _billReset = env._billReset, _buildRect = env._buildRect,
        wallThickness = env.wallThickness, _roomKey = env._roomKey, _roomLabel = env._roomLabel;
    _billReset(LID);
    LAST[LID] = null;   /* mep-v36: the runs under the floor, set below */
    var i, j, k, W = WASTE;
    function m2(v) { return Math.round(v * 100) / 100; }
    function mm(v) { return Math.round(v * 1000); }
    function man(a, b) { return Math.abs(a.x - b.x) + Math.abs(a.z - b.z); }
    function turns(a, b) { return (Math.abs(a.x - b.x) > 0.05 && Math.abs(a.z - b.z) > 0.05) ? 1 : 0; }
    for (k in WASTE_CAT) {
      if (!WASTE_CAT.hasOwnProperty(k) || CATALOG[k]) continue;
      CATALOG[k] = { code: k, unit: WASTE_CAT[k].unit, label: WASTE_CAT[k].label };
    }
    var PL = _P();
    if (!PL || !PL.fixtures) { ctx.log('WASTE none -- floorplan asset without fixtures'); return; }
    var P = (STATE && STATE.product) || {}, FX = P.fixtures || [];
    var rooms = (PL.rooms ? PL.rooms() : null) || [];

    /* THE ROOMS, as the water reads them */
    var R = [];
    for (i = 0; i < rooms.length; i++) {
      var rm = rooms[i]; if (!rm || !rm.rects || !rm.rects.length) { R.push(null); continue; }
      var nm = '';
      try { nm = rm.closet ? _roomLabel(rm, i) : (PL.roomName ? PL.roomName(rm, i) : _roomLabel(rm, i)); } catch (eN) { nm = ''; }
      var bigW = null, bAW = -1, jw;
      for (jw = 0; jw < rm.rects.length; jw++) {
        var rw = rm.rects[jw], aw = (rw.x1 - rw.x0) * (rw.z1 - rw.z0);
        if (aw > bAW) { bAW = aw; bigW = rw; }
      }
      R.push({ i: i, name: nm || ('room ' + i), rects: rm.rects, big: bigW });
    }
    function roomOf(x, z) {
      var r, s, t;
      for (t = 0; t <= 1; t++) {
        var tol = t ? 0.15 : 0.0;
        for (r = 0; r < R.length; r++) {
          if (!R[r]) continue;
          for (s = 0; s < R[r].rects.length; s++) {
            var c = R[r].rects[s];
            if (x >= c.x0 - tol && x <= c.x1 + tol && z >= c.z0 - tol && z <= c.z1 + tol) return r;
          }
        }
      }
      return -1;
    }

    /* THE DRAIN POINTS */
    var cat = PL.fixtures.catalog ? PL.fixtures.catalog() : {};
    var pts = [], upper = 0, nUp = 0;
    /* THE UPPER STOREYS (mep-v18, env.storeyY): a piece there drains down a
       drop; without env.storeyY it is left out as before */
    var y00 = API.storeys()[0].y0 + FINISH.dry.h;
    function upDy(st) {
      if (typeof env.storeyY !== 'function') return null;
      var yS = null;
      try { yS = env.storeyY(st); } catch (eY) { yS = null; }
      return (typeof yS === 'number' && isFinite(yS) && yS > y00) ? yS - y00 : null;
    }
    var UPW = _upRooms(env, y00);   /* mep-v40: the rooms up there (env.roomsUp) */
    for (i = 0; i < FX.length; i++) {
      var f = FX[i]; if (!f || !f.kind) continue;
      var D = cat[f.kind] || {}, w = D.w || 0.6, d = D.d || 0.6;
      try { var SZ = PL.fixtures.size ? PL.fixtures.size(f) : null; if (SZ && SZ.w > 0 && SZ.d > 0) { w = SZ.w; d = SZ.d; } } catch (eS) {}
      var DO = _drainOf(f.kind, w, d);
      if (!DO) continue;
      var stW = (f.st != null) ? (f.st | 0) : 0, dyW = 0;
      if (stW !== 0) { dyW = upDy(stW); if (dyW == null) { upper++; continue; } nUp++; }
      var rot = (f.rot | 0) % 4, cs = Math.cos(rot * Math.PI / 2), sn = Math.sin(rot * Math.PI / 2), mir = f.mirror ? -1 : 1;
      var lx = DO.lx * mir, lz = DO.lz;
      var ri = roomOf(f.x, f.z), ru = (stW === 1 && UPW) ? UPW.of(f.x, f.z) : -1;
      pts.push({ what: DO.what, wall: DO.wall, y: DO.y, dia: DO.dia, trap: DO.trap,
                 x: f.x + (lx * cs - lz * sn), z: f.z + (lx * sn + lz * cs), room: ri,
                 nx: -sn, nz: cs,   /* into the room, off the piece's back */
                 cx: f.x, cz: f.z, pd: d,   /* mep-v60: the piece's middle and depth, for env.runsOut */
                 st: stW, dy: dyW, up: ru,
                 rname: (ru >= 0) ? ('storey 2 ' + UPW.R[ru].name)
                      : stW ? ('storey ' + (stW + 1) + (ri >= 0 ? (' over ' + R[ri].name) : '')) : (ri >= 0 ? R[ri].name : 'outside any room') });
    }
    if (!pts.length) {
      ctx.log('WASTE none -- no wet piece in the fitout (kitchen, basin, wc, washing machine, bath, shower)' +
              (upper ? (' on the ground storey; ' + upper + ' on another storey left out') : ''));
      return;
    }
    var C = { x: 0, z: 0 };
    for (i = 0; i < pts.length; i++) { C.x += pts[i].x; C.z += pts[i].z; }
    C.x /= pts.length; C.z /= pts.length;

    /* THE PERIMETER, the inner faces the other trades use */
    var B0 = _buildRect(), wt = wallThickness();
    /* the perimeter (mep-v14): the outline as the walls run, a rectangle as it was */
    var PER = _perim(env, B0, wt), IN = PER.IN;
    function nearestFace(x, z) { return _nearSide(PER, x, z); }
    var y0 = API.storeys()[0].y0 + FINISH.dry.h;
    var yCeil = API.wallTop() - 0.02;
    /* mep-v24: UNDER A SLAB ON GRADE (env.underSlab) -- the runs in trenches */
    var US = null;
    if (typeof env.underSlab === 'function') { try { US = env.underSlab(); } catch (eUS) { US = null; } }
    if (US && !(typeof US.ySub === 'number' && isFinite(US.ySub) && US.ySub < y0 - 0.05)) US = null;
    /* mep-v53 (RANCH thread, opt-in env.crawlDrain): A RAISED FLOOR OVER A
       CRAWL SPACE TOO LOW FOR THE 110 (the ranch's joists stand 90 over
       grade, a 110 may not pass through a 240 joist -- IRC R502.8.1, a third
       of its depth): the building drain, the WC's branch and the stack's foot
       BURIED as under a slab -- the far end's crown env.crawlDrain().cover
       (300, 12 in.) under grade (IRC P2603.5.1, the local rule may ask more),
       1/8 in./ft to the exit, in a trench on a gravel bed (100 under, 150
       over the pipe), backfilled with the dug soil; the 50s in the floor
       between the joists, down to the drain at their branch (a room on the
       drain) or to a node of it (a collector). Without it nothing changes. */
    var CRW = null;
    if (!US && typeof env.crawlDrain === 'function') { try { CRW = env.crawlDrain(); } catch (eCR) { CRW = null; } }
    if (CRW && !(typeof CRW.yGrade === 'number' && isFinite(CRW.yGrade) && CRW.yGrade < y0 - 0.05)) CRW = null;
    if (CRW) {
      var cvC = (CRW.cover > 0) ? CRW.cover : 0.30;
      US = { ySub: CRW.yGrade - cvC, digTop: CRW.yGrade, yGrade: CRW.yGrade, dig: CRW.dig || '', bed: CRW.bed || '', crawl: true, cover: cvC };
    }
    var SL = { sD: 0.125 / 12, sB: 0.25 / 12, w: 0.30, bed: 0.10, dig: 0, pipeV: 0, len: 0, stubs: 0, boxes: 0, riser: 0, segs: [], bedV: 0, over: 0.15 };
    /* a trench along a run of plan length L (billed length), the pipe's centre
       at yA and yB at its ends: dug from the subgrade to 100 under the pipe */
    function dig(L, yA, yB, r) {
      var tD = (US.digTop != null) ? US.digTop : US.ySub;   /* mep-v53: a crawl space's trench from grade */
      var dA = tD - (yA - r - SL.bed), dB = tD - (yB - r - SL.bed);
      SL.dig += L * SL.w * Math.max(0, (dA + dB) / 2); SL.pipeV += Math.PI * r * r * L; SL.len += L;
      if (US.crawl) SL.bedV += Math.max(0, L * SL.w * (SL.bed + 2 * r + SL.over) - Math.PI * r * r * L);   /* mep-v53: the bed and 150 over the pipe */
    }

    /* THE GROUPS: the points of one room, met at their middle */
    var G = {}, GL = [];
    for (i = 0; i < pts.length; i++) {
      var gk = (pts[i].st ? ('s' + pts[i].st) : '') + ((pts[i].up >= 0) ? ('u' + pts[i].up) : ('r' + pts[i].room));
      if (!G[gk]) { G[gk] = { name: pts[i].rname, room: pts[i].room, up: pts[i].up, pts: [], x: 0, z: 0, wc: 0, st: pts[i].st || 0, dy: pts[i].dy || 0 }; GL.push(G[gk]); }
      G[gk].pts.push(pts[i]); if (pts[i].trap === 'wc') G[gk].wc++;
    }
    for (i = 0; i < GL.length; i++) {
      for (j = 0; j < GL[i].pts.length; j++) { GL[i].x += GL[i].pts[j].x; GL[i].z += GL[i].pts[j].z; }
      GL[i].x /= GL[i].pts.length; GL[i].z /= GL[i].pts.length;
      if (GL[i].up >= 0) GL[i].room = roomOf(GL[i].x, GL[i].z);   /* mep-v40: the ground room under its middle */
    }
    /* mep-v40: THE DROPS IN WALLS (env.dropWall) -- an upstairs room's drop
       stands in a wall of the room under it (env.stackOuter: an exterior
       wall), clear of the openings of both storeys; the room's pieces meet
       at its middle up there and run in that floor to it. The group stands
       at its drop from here on, its middle kept as .mid */
    var DWn = [], anyWc = false;
    for (i = 0; i < GL.length; i++) if (GL[i].wc) anyWc = true;
    if (env.dropWall) {
      for (i = 0; i < GL.length; i++) {
        var Gw = GL[i]; if (!(Gw.dy > 0)) continue;
        /* of the room's walls (with stackOuter: those on the outline) the one
           whose free spot -- off the openings -- is the shortest way from the
           room's middle */
        var CW4 = wallSpot(Gw.room, Gw, true), cw4, pW4 = null, OOw = null, cst4 = 1e9, outer4 = false;
        for (cw4 = 0; cw4 < CW4.length; cw4++) {
          if (env.stackOuter) { var ns4 = _nearSide(PER, CW4[cw4].x, CW4[cw4].z); if (!(ns4 && ns4.d < Math.max(0.12, wt + 0.05))) continue; }
          /* the openings of storey 2 matter only where the drop may go on up as
             the stack -- a room with a WC (or any room when none has one) */
          var up4 = !!(Gw.wc || !anyWc);
          var oo4 = _offOpenings(env, CW4[cw4].x, CW4[cw4].z, 0.20, up4), c4c = man(Gw, oo4) + oo4.moved * 0.001;
          if (c4c < cst4) { cst4 = c4c; pW4 = CW4[cw4]; OOw = oo4; outer4 = !!env.stackOuter; }
        }
        if (!pW4) {
          /* no wall of its room on the outline: the exterior wall nearest it */
          var nf4 = env.stackOuter ? nearestFace(Gw.x, Gw.z) : null;
          pW4 = nf4 ? { x: nf4.x, z: nf4.z, nx: nf4.n ? nf4.n[0] : 0, nz: nf4.n ? nf4.n[1] : 0 } : CW4[0];
          OOw = _offOpenings(env, pW4.x, pW4.z, 0.20, !!(Gw.wc || !anyWc)); outer4 = !!nf4;
        }
        Gw.mid = { x: Gw.x, z: Gw.z };
        Gw.x = OOw.x; Gw.z = OOw.z; Gw.dsp = { x: OOw.x, z: OOw.z, nx: pW4.nx, nz: pW4.nz };
        Gw.hz = man(Gw.mid, Gw) * W.f; Gw.hzT = turns(Gw.mid, Gw);
        DWn.push(Gw.name + ' at ' + Gw.x.toFixed(2) + ',' + Gw.z.toFixed(2) + ' in ' + (outer4 ? 'an exterior wall' : 'a wall') + ' of ' + (Gw.room >= 0 ? R[Gw.room].name : 'the nearest side') +
                 (OOw.moved > 0.005 ? (', slid ' + mm(OOw.moved) + ' off an opening') : '') + ', ' + m2(Gw.hz) + ' m in the floor of storey 2 to it');
      }
    }

    /* THE BUILDING DRAIN: from the exit through the rooms with a WC */
    var EX = nearestFace(C.x, C.z);
    /* mep-v32: on a trailer the hookup side (env.trailer) */
    var TRx = _trailerAt(env, PER, C, 'waste');
    if (TRx) EX = TRx;
    if (TRx && TRx.TR.under > 0.05 && TRx.TR.under < W.under) { W = Object.create(WASTE); W.under = TRx.TR.under; }
    EX.name = 'exit';
    /* mep-v24: the product may keep the way out under the wall clear of what
       stands in the ground there (env.exitClear -- the barndo's piers) */
    if (US && typeof env.exitClear === 'function') {
      try { var XC = env.exitClear(EX.x, EX.z, EX.k); if (XC && isFinite(XC.x) && isFinite(XC.z)) { EX.x = XC.x; EX.z = XC.z; EX.moved = XC.why || 'moved'; } } catch (eXC) {}
    }
    var heads = [], others = [];
    for (i = 0; i < GL.length; i++) (GL[i].wc ? heads : others).push(GL[i]);
    var noWc = !heads.length;
    if (noWc) { heads = GL.slice(); others = []; }
    var MN = { len: 0, turns: 0, order: [] }, cur = EX, left = heads.slice(), last = null, DN = [EX];
    while (left.length) {
      var bI = 0, bd = 1e9, s;
      for (s = 0; s < left.length; s++) { var dd = man(cur, left[s]); if (dd < bd) { bd = dd; bI = s; } }
      MN.len += bd; MN.turns += turns(cur, left[bI]); MN.order.push(left[bI].name);
      cur = left[bI]; last = left[bI]; DN.push(left[bI]); left.splice(bI, 1);
    }
    MN.len *= W.f;
    var nodes = [EX].concat(heads);
    /* mep-v24: the drain's fall -- its far end's crown at the subgrade, down
       at 1/8 in./ft (on the billed length) to the exit; each node's centre */
    if (US) {
      var Spl = 0, sAc = [0], q9;
      for (q9 = 1; q9 < DN.length; q9++) { Spl += man(DN[q9 - 1], DN[q9]); sAc.push(Spl); }
      for (q9 = 0; q9 < DN.length; q9++) DN[q9].yS = US.ySub - 0.055 - SL.sD * W.f * (Spl - sAc[q9]);
      for (q9 = 1; q9 < DN.length; q9++) { dig(man(DN[q9 - 1], DN[q9]) * W.f, DN[q9 - 1].yS, DN[q9].yS, 0.055); SL.segs.push({ a: DN[q9 - 1], b: DN[q9], r: 0.055, k: 'drain' }); }
    }

    /* THE TALLY */
    var T = { l50: 0, l75: 0, l110: 0, out: W.outside, b50: 0, b50h: 0, b110: 0, b110h: 0,
              y50: 0, y110s: 0, y110: 0, r11075: 0, trap: 0, trap50: 0, shDrain: 0, box: 0,
              flange: 0, clean: 0, aav: 0, flash: 0, seal: 1 };
    T.l110 += MN.len; T.b110h += 2 * MN.turns;
    /* mep-v32: the trailer's way out -- down through the floor to its outlet */
    var DRx = null;
    if (TRx && typeof TRx.TR.drain === 'function') {
      try { DRx = TRx.TR.drain(EX, ctx); } catch (eDR) { DRx = null; ctx.log('WASTE the trailer outlet threw: ' + (eDR && eDR.message)); }
      if (DRx && isFinite(DRx.len) && DRx.len >= 0) {
        T.out = DRx.len; T.b110 += (DRx.b110 > 0 ? DRx.b110 : 0); T.r11075 += (DRx.r11075 > 0 ? DRx.r11075 : 0);
      } else DRx = null;
    }
    /* the cleanout where the drain leaves, on a branch 110 */
    T.y110++; T.clean++;
    /* one piece's branch: its trap, its pipe, its bends; joined by whatever
       the caller counts */
    var hung = 0;   /* mep-v24: the pipe that hangs (above the slab) */
    var HZ = { l110: US ? 0 : MN.len, l50: 0 };   /* mep-v36: what lies flat under the floor */
    function branch(g0, p) {
      var g = (g0.mid && g0.st > 0) ? g0.mid : g0;   /* mep-v40: up there from the room's middle */
      var run = man(g, p) * W.f + (p.wall ? p.y : 0) + W.under, tn = turns(g, p);
      if (US && !(g0.st > 0) && !(CRW && p.dia !== 110)) {
        /* mep-v24: under the slab -- from the drain (or the collector) up at
           its fall to the piece, then up through the slab (mep-v53: in a crawl
           space only the WC's 110, the 50s in the floor) */
        var r9 = p.dia === 110 ? 0.055 : 0.025, Lb = man(g, p);
        var yp = Math.min(US.ySub - r9, g.yS + (p.dia === 110 ? SL.sD : SL.sB) * W.f * Lb);
        p.yS = yp;
        run = Lb * W.f + (y0 - yp) + (p.wall ? p.y : 0);
        dig(Lb * W.f, g.yS, yp, r9); SL.segs.push({ a: g, b: p, r: r9, k: 'branch' });
        SL.stubs++; hung += p.wall ? p.y : 0;
        if (!p.wall && p.trap !== 'wc') SL.boxes++;
      } else if (CRW && !(g0.st > 0)) {
        /* mep-v53: a 50 in the floor between the joists, down to the buried
           drain at the room's node (a room on the drain), else to the room's
           collector in the floor */
        var dC = (g.yS != null) ? Math.max(W.under, y0 - g.yS) : W.under;
        run = man(g, p) * W.f + (p.wall ? p.y : 0) + dC;
        hung += run; HZ.l50 += man(g, p) * W.f; p.crawl = { drop: dC };
      } else { hung += run; HZ[p.dia === 110 ? 'l110' : 'l50'] += man(g, p) * W.f; }
      if (p.dia === 110) { T.l110 += run; T.b110 += 1; T.b110h += 2 * tn; }
      else { T.l50 += run; T.b50 += p.wall ? 2 : 1; T.b50h += 2 * tn; }
      if (p.trap === 'p') T.trap++;
      else if (p.trap === 'shower') { T.shDrain++; T.trap50++; }
      else if (p.trap === 'box') T.box++;
      else if (p.trap === 'wc') T.flange++;
      return run;
    }
    var gNotes = [];
    /* the rooms on the drain: every piece joins it with its own branch */
    for (i = 0; i < heads.length; i++) {
      var H = heads[i], hRun = 0;
      for (j = 0; j < H.pts.length; j++) {
        hRun += branch(H, H.pts[j]);
        if (H.pts[j].dia === 110) T.y110++; else T.y110s++;
      }
      var isStack = (H === last);
      if (!isStack) {
        var vU = (US && !(H.st > 0)) ? (y0 - H.yS) : W.under;   /* mep-v24: from the drain under the slab */
        T.l50 += W.vent + vU; T.y50++; T.aav++; hung += W.vent + ((US && !(H.st > 0) && !CRW) ? 0 : W.under);
        H.aavL = W.vent + vU;   /* mep-v53: the valve's pipe, for its body (env.wasteRest) */
        if (US && !(H.st > 0)) SL.stubs++;
      }
      gNotes.push(H.name + ': ' + H.pts.length + ' piece(s) onto the drain, ' + m2(hRun) + ' m of branches' +
                  (isStack ? ', the vent stack rises here' : ', vented by an air admittance valve'));
    }
    /* every other wet room: a collector 50 to the nearest point of the drain */
    for (i = 0; i < others.length; i++) {
      var O = others[i], nb = null, nd = 1e9, oRun = 0;
      for (j = 0; j < nodes.length; j++) { var d2 = man(O, nodes[j]); if (d2 < nd) { nd = d2; nb = nodes[j]; } }
      var coll = nd * W.f;
      O.runNb = nb;   /* mep-v60: the node it joins, for env.runsOut */
      T.l50 += coll; T.b50h += 2 * turns(O, nb); T.y110s++;
      if (US && !CRW) {
        /* mep-v24: the collector up at 1/4 in./ft from the drain */
        O.yS = Math.min(US.ySub - 0.025, nb.yS + SL.sB * W.f * nd);
        dig(coll, nb.yS, O.yS, 0.025); SL.segs.push({ a: nb, b: O, r: 0.025, k: 'collector' });
      } else {
        hung += coll; HZ.l50 += coll;
        /* mep-v53: in the floor to the node, down there to the buried drain */
        if (CRW && nb.yS != null) { O.dnC = Math.max(0, (y0 - W.under) - nb.yS); O.nb = nb; T.l50 += O.dnC; hung += O.dnC; }
      }
      for (j = 0; j < O.pts.length; j++) oRun += branch(O, O.pts[j]);
      T.y50 += Math.max(0, O.pts.length - 1);
      var vO = (US && !CRW && !(O.st > 0)) ? (y0 - O.yS) : W.under;
      T.l50 += W.vent + vO; T.y50++; T.aav++; hung += W.vent + ((US && !CRW && !(O.st > 0)) ? 0 : W.under);
      O.aavL = W.vent + vO;
      if (US && !CRW && !(O.st > 0)) SL.stubs++;
      gNotes.push(O.name + ': ' + O.pts.length + ' piece(s) on a collector 50 of ' + m2(coll) + ' m' + (O.dnC ? (' in the floor + ' + m2(O.dnC) + ' down') : '') + ' to the drain at ' + nb.name +
                  ', ' + m2(oRun) + ' m of branches, an air admittance valve');
    }

    /* THE DROPS from the upper storeys (mep-v18): every upper room but the
       stack's own, from under its floor to the ground floor's drain, 110
       with a WC, else 50, a 90 bend at its foot */
    var drops = [];
    for (i = 0; i < GL.length; i++) {
      var Gd = GL[i];
      if (!(Gd.dy > 0) || Gd === last) continue;
      var dX = (US && Gd.yS != null) ? Math.max(0, (y0 - Gd.yS) - W.under) : 0;   /* mep-v24: on down to the drain under the slab */
      if (US && Gd.yS != null) SL.stubs++;
      hung += Gd.dy;
      if (Gd.wc) { T.l110 += Gd.dy + dX; T.b110++; } else { T.l50 += Gd.dy + dX; T.b50++; }
      drops.push(Gd.name + ' ' + (Gd.wc ? 110 : 50) + ' x ' + m2(Gd.dy) + ' m');
    }
    /* mep-v40: THE RUNS IN THE FLOOR OF STOREY 2 to the drops in their walls
       (env.dropWall): from the room's middle at 1/4 in./ft, a 90 down into its
       drop -- the stack's own room into the stack on a branch */
    var hzSum = 0;
    for (i = 0; i < GL.length; i++) {
      var Gh = GL[i]; if (!Gh.mid) continue;
      if (Gh.wc) { T.l110 += Gh.hz; T.b110h += 2 * Gh.hzT; } else { T.l50 += Gh.hz; T.b50h += 2 * Gh.hzT; }
      if (Gh !== last) { if (Gh.wc) T.b110++; else T.b50++; }
      else T.y110++;
      hung += Gh.hz; hzSum += Gh.hz;
    }

    /* A ROOM'S WALL NEAREST A POINT (mep-v9): the room's own faces (the
       floorplan asset's), the point on the nearest one and the way into the
       room -- the stack stands in that wall, an AAV hangs off it */
    function wallSpot(room, p, all) {
      var Rm = room >= 0 ? R[room] : null, F = null;
      if (!Rm || !Rm.big) { var nf = nearestFace(p.x, p.z), o1 = { x: nf.x, z: nf.z, nx: nf.n ? nf.n[0] : { z0: 0, x1: -1, z1: 0, x0: 1 }[nf.k], nz: nf.n ? nf.n[1] : { z0: 1, x1: 0, z1: -1, x0: 0 }[nf.k], d: 0 }; return all ? [o1] : o1; }
      try { F = PL.roomFaces ? PL.roomFaces((Rm.big.x0 + Rm.big.x1) / 2, (Rm.big.z0 + Rm.big.z1) / 2) : null; } catch (eF) { F = null; }
      F = F || Rm.big;
      var cx = Math.max(F.x0 + 0.15, Math.min(F.x1 - 0.15, p.x)), cz = Math.max(F.z0 + 0.15, Math.min(F.z1 - 0.15, p.z));
      var c4 = [{ x: cx, z: F.z0, nx: 0, nz: 1, d: Math.abs(p.z - F.z0) }, { x: F.x1, z: cz, nx: -1, nz: 0, d: Math.abs(F.x1 - p.x) },
                { x: cx, z: F.z1, nx: 0, nz: -1, d: Math.abs(F.z1 - p.z) }, { x: F.x0, z: cz, nx: 1, nz: 0, d: Math.abs(p.x - F.x0) }], b4 = c4[0], s4;
      if (all) return c4.slice().sort(function (c1, c2) { return c1.d - c2.d; });
      for (s4 = 1; s4 < 4; s4++) if (c4[s4].d < b4.d) b4 = c4[s4];
      return b4;
    }

    /* THE VENT STACK at the drain's far end, in the wall of its room nearest
       the middle of its pieces (mep-v9: before, the roof was read over that
       middle) */
    var ST = last, roofY = null, roofHow = '', SW = wallSpot(ST.room, ST), outerNote = '';
    /* IN AN EXTERIOR WALL (mep-v20, env.stackOuter -- two storeys): the
       room's walls nearest first, the first on the outline; none: the
       exterior wall nearest the room, the drain 110 carried on to it */
    /* A STACK IN AN EXTERIOR WALL STANDS IN THE MASONRY, NOT IN A WINDOW
       (mep-v63, T house thread 2026-10-29: the reference T house's stack came
       up through the bathroom's floor-length glazed unit). The spot on the
       face was the drain's end projected onto it; where that falls in an
       opening of that wall (any storey, 150 past each jamb) it slides along
       the face to the nearest clear point still inside the room's face; none:
       that face is passed over. Nothing moves where the spot was clear. */
    function stackClear(c, room) {
      var SGo = [], q, k, alongX = Math.abs(c.nz) > 0.5, v = alongX ? c.x : c.z, spans = [], what = [];
      try { SGo = API.segments ? (API.segments() || []) : []; } catch (eSg) { SGo = []; }
      for (q = 0; q < SGo.length; q++) {
        var g = SGo[q];
        if (!g || !g.openings || !g.openings.length || !(g.len > 0)) continue;
        var ux = (g.x1 - g.x0) / g.len, uz = (g.z1 - g.z0) / g.len;
        if (alongX ? Math.abs(uz) > 0.01 : Math.abs(ux) > 0.01) continue;
        if ((alongX ? Math.abs(g.z0 - c.z) : Math.abs(g.x0 - c.x)) > wt + 0.10) continue;
        for (k = 0; k < g.openings.length; k++) {
          var o = g.openings[k], mo = alongX ? g.x0 + ux * o.at : g.z0 + uz * o.at, hw = (o.w || 0.9) / 2 + 0.15;
          spans.push([mo - hw, mo + hw]); what.push((o.kind || 'unit') + ' ' + Math.round((o.w || 0.9) * 1000));
        }
      }
      var inside = function (u) { var j; for (j = 0; j < spans.length; j++) if (u > spans[j][0] + 1e-6 && u < spans[j][1] - 1e-6) return j; return -1; };
      var hit = inside(v);
      if (hit < 0) return { spot: c, note: '' };
      var Rm = (room >= 0 && R[room]) ? R[room].big : null;
      var lo = Rm ? (alongX ? Rm.x0 : Rm.z0) + 0.15 : -1e9, hi = Rm ? (alongX ? Rm.x1 : Rm.z1) - 0.15 : 1e9, best = null, j2;
      for (j2 = 0; j2 < spans.length; j2++) {
        var ends = [spans[j2][0], spans[j2][1]], e2;
        for (e2 = 0; e2 < 2; e2++) {
          var u = ends[e2];
          if (u < lo || u > hi || inside(u) >= 0) continue;
          if (best == null || Math.abs(u - v) < Math.abs(best - v)) best = u;
        }
      }
      if (best == null) return null;
      var c2 = { x: alongX ? best : c.x, z: alongX ? c.z : best, nx: c.nx, nz: c.nz, d: c.d };
      return { spot: c2, note: ' (slid ' + Math.round(Math.abs(best - v) * 1000) + ' off the ' + what[hit] + ' in that wall, mep-v63)' };
    }
    if (env.stackOuter) {
      var CWo = wallSpot(ST.room, ST, true), cwo, okO = null, slidO = '';
      for (cwo = 0; cwo < CWo.length && !okO; cwo++) {
        var nso = _nearSide(PER, CWo[cwo].x, CWo[cwo].z);
        if (!(nso && nso.d < Math.max(0.12, wt + 0.05))) continue;
        var clO = stackClear(CWo[cwo], ST.room);
        if (clO) { okO = clO.spot; slidO = clO.note; }
      }
      if (okO) { SW = okO; outerNote = ' -- in an exterior wall of its room (stackOuter: the outer wall runs up to the roof)' + slidO; }
      else {
        var nfo = nearestFace(ST.x, ST.z), nno = nfo.n || [0, 1], ext = nfo.d * W.f;
        SW = { x: nfo.x, z: nfo.z, nx: nno[0], nz: nno[1], d: nfo.d };
        T.l110 += ext; T.b110h += 2 * turns(ST, nfo);
        outerNote = ' -- its room has no exterior wall: in the exterior wall ' + nfo.k + ' nearest it, the drain 110 carried ' + m2(ext) + ' m on to it (stackOuter)';
      }
    }
    var SPx = SW.x - SW.nx * 0.05, SPz = SW.z - SW.nz * 0.05;
    function roofAt(x, z) {
      var yR = null;
      try { yR = (typeof env._roofPlaneYAt === 'function') ? env._roofPlaneYAt(x, z) : null; } catch (eR) { yR = null; }
      return (yR > yCeil && yR < yCeil + 8) ? yR : null;
    }
    roofY = roofAt(SPx, SPz);
    if (roofY == null) { roofY = yCeil + W.roofDef; roofHow = 'the ceiling + ' + mm(W.roofDef) + ' (no roof plane over it)'; }
    else roofHow = 'the roof plane over it';
    /* UNDER THE RIDGE (mep-v13, env.stackUnderRidge -- the THOW): the stack
       may not stand higher than the roof's ridge, or it is what decides the
       road height. The ridge is the highest roof plane over the building.
       Of the room's walls, nearest first, the first where 300 over the roof
       stays under it; none: the wall with the lowest roof, the stack cut
       at the ridge */
    var stackAbove = W.aboveRoof, ridgeNote = '';
    if (env.stackUnderRidge && typeof env._roofPlaneYAt === 'function') {
      var Bq = _buildRect(), gx, gz, ridge = null;
      for (gx = 0; gx <= 12; gx++) for (gz = 0; gz <= 12; gz++) {
        var yq = roofAt(Bq.x0 + (Bq.x1 - Bq.x0) * gx / 12, Bq.z0 + (Bq.z1 - Bq.z0) * gz / 12);
        if (yq != null && (ridge == null || yq > ridge)) ridge = yq;
      }
      if (ridge != null && roofY + W.aboveRoof > ridge + 0.001) {
        var CS4 = wallSpot(ST.room, ST, true), cq, okC = null, lowC = null;
        for (cq = 0; cq < CS4.length; cq++) {
          var cx4 = CS4[cq].x - CS4[cq].nx * 0.05, cz4 = CS4[cq].z - CS4[cq].nz * 0.05, ry4 = roofAt(cx4, cz4);
          if (ry4 == null) continue;
          if (!okC && ry4 + W.aboveRoof <= ridge + 0.001) okC = { x: cx4, z: cz4, y: ry4 };
          if (!lowC || ry4 < lowC.y) lowC = { x: cx4, z: cz4, y: ry4 };
        }
        var pick = okC || lowC;
        if (pick) { SPx = pick.x; SPz = pick.z; roofY = pick.y; }
        if (okC) ridgeNote = ' -- moved to the wall of its room where it stays under the ridge (' + mm(ridge - roofY - W.aboveRoof) + ' to spare, stackUnderRidge)';
        else { stackAbove = Math.max(0, ridge - roofY); ridgeNote = ' -- *** no wall of its room leaves 300 under the ridge: cut at the ridge, ' + mm(stackAbove) + ' above the roof (stackUnderRidge)'; }
      } else if (ridge != null) ridgeNote = ' -- under the ridge by ' + mm(ridge - roofY - W.aboveRoof) + ' (stackUnderRidge)';
    }
    /* mep-v32: OFF THE TRAILER'S HOOKUPS (env.trailer keep): a stack that
       would share the wall with the water inlet slides along that wall */
    var keepNote = '';
    if (TRx && TRx.TR.keep && TRx.TR.keep.length) {
      var kq;
      for (kq = 0; kq < TRx.TR.keep.length; kq++) {
        var KP = TRx.TR.keep[kq], knx = KP.nx || 0, knz = KP.nz || 0, ktx = -knz, ktz = knx;
        var kdx = SPx - KP.x, kdz = SPz - KP.z, kal = kdx * ktx + kdz * ktz, kac = Math.abs(kdx * knx + kdz * knz);
        if (kac < (KP.depth || 0.30) && Math.abs(kal) < KP.r) {
          var ksh = (kal >= 0 ? 1 : -1) * (KP.r - Math.abs(kal) + 0.01);
          SPx += ktx * ksh; SPz += ktz * ksh;
          var kry = roofAt(SPx, SPz);
          if (kry != null) roofY = kry;
          keepNote = ' -- slid ' + mm(Math.abs(ksh)) + ' along its wall off the trailer\'s ' + (KP.what || 'hookup') + ' (env.trailer keep)';
        }
      }
    }
    var stack = (roofY - y0) + W.under + stackAbove;
    if (US && ST.yS != null) { stack = (roofY - ST.yS) + stackAbove; SL.stubs++; }   /* mep-v24: from the drain under the slab */
    hung += (roofY + stackAbove) - y0;
    /* mep-v40 (env.dropWall): under storey 2's floor the stack is its WC's
       drop -- 110 to there, 75 on up, the reducer at that floor */
    var stDrop = 0;
    if (env.dropWall && ST.mid && ST.wc) {
      stDrop = Math.max(0, (y0 + ST.dy - W.under) - ((US && ST.yS != null) ? ST.yS : (y0 - W.under)));
      stack = Math.max(0, stack - stDrop); T.l110 += stDrop;
    }
    T.l75 += stack; T.flash++; T.y110++; T.r11075++; T.clean++;
    /* mep-v24: out under the slab's edge at its depth, the cleanout outside on
       a riser to grade */
    var yEx = null;
    if (US) {
      yEx = EX.yS - SL.sD * W.outside;
      dig(W.outside, EX.yS, yEx, 0.055);
      var EXn = EX.n || { z0: [0, 1], x1: [-1, 0], z1: [0, -1], x0: [1, 0] }[EX.k] || [0, 0];
      SL.segs.push({ a: EX, b: { x: EX.x - EXn[0] * W.outside, z: EX.z - EXn[1] * W.outside, yS: yEx }, r: 0.055, k: 'out' });
      var yGr = (typeof US.yGrade === 'number' && isFinite(US.yGrade)) ? US.yGrade : y0;
      SL.riser = Math.max(0, yGr - EX.yS) + 0.05;
      T.out += SL.riser;
    }

    /* HANGERS AND GLUE */
    var inside = US ? hung : (T.l50 + T.l75 + T.l110), hangers = Math.ceil(inside / W.hangEvery);
    var jS = 2 * T.b50 + 2 * T.b50h + 3 * T.y50 + T.y110s + T.trap + 2 * T.trap50 + T.shDrain + T.box + T.aav;
    var jL = 2 * T.b110 + 2 * T.b110h + 2 * T.y110s + 3 * T.y110 + 2 * T.r11075 + T.flange + T.clean;
    var glue = jS * W.glueS + jL * W.glueL;

    /* THE BILL */
    function add(code, q) { if (q > 0.005) _add(LID, code, q); }
    add(W.p50, m2(T.l50)); add(W.p75, m2(T.l75)); add(W.p110, m2(T.l110)); add(W.pOut, m2(T.out));
    add(W.b50, T.b50); add(W.b50h, T.b50h); add(W.b110, T.b110); add(W.b110h, T.b110h);
    add(W.y50, T.y50); add(W.y110s, T.y110s); add(W.y110, T.y110); add(W.r11075, T.r11075);
    add(W.trap, T.trap); add(W.trap50, T.trap50); add(W.shDrain, T.shDrain); add(W.box, T.box);
    add(W.flange, T.flange); add(W.clean, T.clean); add(W.aav, T.aav); add(W.flash, T.flash);
    add(W.strap, m2(hangers * W.strapPer)); add(W.screw, hangers * W.hangScrews); add(W.seal, T.seal);
    add(W.primer, m2(glue)); add(W.cement, m2(glue));
    if (US) {
      if (US.dig) add(US.dig, m2(SL.dig));
      if (US.bed) add(US.bed, m2(CRW ? SL.bedV : Math.max(0, SL.dig - SL.pipeV)));   /* mep-v53: a crawl space's trench takes only its bed */
      if (US.trapBox && SL.boxes) add(US.trapBox, SL.boxes);
      /* mep-v33: through the edge footing in a sleeve */
      var EGd = _slvEdge(US);
      if (EGd) { _slvMint(CATALOG); SL.slv = m2(EGd.w + 2 * SLV.past); SL.slvCode = EGd.drain || SLV.drain; add(SL.slvCode, SL.slv); }
    }

    /* THE LOG */
    ctx.log('WASTE ' + pts.length + ' drain point(s): ' +
            pts.map(function (p) { return p.what + ' ' + p.dia + ' (' + ({ p: 'P-trap 1 1/2', shower: 'shower drain + P-trap 2', box: 'outlet box', wc: 'toilet flange' })[p.trap] + ') in ' + p.rname; }).join('; ') +
            (upper ? ('; ' + upper + ' piece(s) on another storey left out') : '') + (nUp ? ('; ' + nUp + ' piece(s) on an upper storey, down a drop') : '') + (CRW ? ' -- the 110s buried under the crawl space (env.crawlDrain), the 50s in the floor' : US ? ' -- the runs under the slab drawn, the rest calculated' : (env.runsOut === true ? ' -- calculated; the route handed to the product, which draws it (mep-v60 env.runsOut)' : ' -- calculated, nothing drawn')));
    if (drops.length) ctx.log('WASTE drops from the upper storey (mep-v18): ' + drops.join(', ') + ' -- from under its floor to the drain, a 90 bend at the foot; vented by an air admittance valve up there');
    if (DWn.length) ctx.log('WASTE drops in walls (mep-v40, env.dropWall): ' + DWn.join('; ') + ' -- ' + m2(hzSum) + ' m in the floor of storey 2 at 1/4 in./ft (above its wool), a 90 down into each drop' +
                            (stDrop > 0.005 ? ('; the stack is its WC\'s drop, 110 x ' + m2(stDrop) + ' under that floor, 75 above, the reducer and a branch 110 there') : ''));
    ctx.log('WASTE building drain 110: leaves on wall ' + EX.k + ' at ' + EX.x.toFixed(2) + ',' + EX.z.toFixed(2) + ' (' + (TRx ? 'on the trailer\'s hookup side, ' : '') + 'nearest the middle of the wet points' +
            (TRx && EX.moved ? ('; ' + EX.moved) : '') + '), exit -> ' +
            MN.order.join(' -> ') + (noWc ? ' (no WC: every wet room on the drain)' : '') + ', ' + m2(MN.len) + ' m inside (Manhattan x ' + W.f + ', ' + MN.turns +
            ' turn(s) of 2 x 45), ' + (DRx ? (DRx.note || (m2(T.out) + ' m ' + W.pOut + ' down to the trailer\'s outlet')) :
            (m2(W.outside) + ' m ' + W.pOut + ' outside to the site connection (the sewer beyond is site work, not billed)')) + '; a cleanout at the exit');
    ctx.log('WASTE vent stack 75 at ' + ST.name + ': ' + m2(stack) + ' m ' + W.p75 + ' from under the floor to ' + mm(stackAbove) + ' above the roof (' + roofHow + ' at ' + m2(roofY - y0) +
            ' m above the floor), ' + W.flash + ' roof flashing; at its foot ' + W.y110 + ' + ' + W.r11075 + ' reducer 110/75 + ' + W.clean + ' cleanout' + ridgeNote + outerNote + keepNote);
    for (i = 0; i < gNotes.length; i++) ctx.log('WASTE ' + gNotes[i]);
    if (CRW) ctx.log('WASTE under the crawl space (env.crawlDrain, mep-v53): the joists too low over grade for a 110 (and no 110 through a 240 joist, IRC R502.8.1) -- the drain 110, the WC\'s branch and the stack\'s foot BURIED: ' +
                     'the far end\'s crown ' + mm(US.cover) + ' under grade (IRC P2603.5.1, the local rule may ask more), 1/8 in./ft to the exit, ' + mm(y0 - EX.yS) + ' under the floor there; trenches ' + mm(SL.w) + ' wide, ' + m2(SL.len) +
                     ' m, from grade: ' + m2(SL.dig) + ' m3 ' + (US.dig || '-') + ' dug, ' + m2(SL.bedV) + ' m3 ' + (US.bed || '-') + ' bed (' + mm(SL.bed) + ' under, ' + mm(SL.over) + ' over the pipe), the rest backfilled with the dug soil; ' +
                     SL.stubs + ' pipe(s) up out of the ground; the 50s in the floor between the joists at 1/4 in./ft, down to the drain at their branch; out ' + m2(W.outside) + ' m ' + W.pOut + ', the cleanout on a ' + mm(SL.riser) + ' riser to grade; hangers on the ' + m2(hung) +
                     ' m over the ground; tested before backfill -- water to 10 ft or air at 5 psi, 15 min (IRC P2503.5.1)');
    else if (US) ctx.log('WASTE under the slab (env.underSlab, mep-v24): drain 110 at 1/8 in./ft, 50s at 1/4 in./ft (IRC P3005.3), the far end\'s crown at the subgrade, ' +
                    mm(y0 - EX.yS) + ' under the floor at the exit; trenches ' + mm(SL.w) + ' wide, ' + m2(SL.len) + ' m, ' + mm(SL.bed) + ' bed under the pipe: ' + m2(SL.dig) + ' m3 ' + (US.dig || '-') +
                    ' dug, ' + m2(Math.max(0, SL.dig - SL.pipeV)) + ' m3 ' + (US.bed || '-') + ' pea gravel round the pipes to the subgrade; ' + SL.stubs + ' stub-up(s) through the slab, ' + SL.boxes + ' trap blockout box(es) ' +
                    (US.trapBox || '-') + ' at the floor drains; ' +
                    (SL.slv ? ('out through the edge footing (' + mm(_slvEdge(US).w) + ') in a ' + SL.slv + ' m sleeve ' + SL.slvCode + ' two sizes over the drain, the annulus sealed (IRC P2603.4, mep-v33)') : 'out under the slab\'s edge') + (EX.moved ? (' (the exit ' + EX.moved + ')') : '') + ', the cleanout on a ' + mm(SL.riser) + ' riser to grade (' + W.pOut + '); hangers only on the ' + m2(hung) +
                    ' m above the slab; tested before the pour -- water to 10 ft or air at 5 psi, 15 min (IRC P2503.5.1)');
    ctx.log('WASTE billed: pipe ' + m2(T.l50) + ' m ' + W.p50 + ', ' + m2(T.l75) + ' m ' + W.p75 + ', ' + m2(T.l110) + ' m ' + W.p110 + ', ' + m2(T.out) + ' m ' + W.pOut +
            '; bends ' + T.b50 + ' x ' + W.b50 + ' + ' + T.b50h + ' x ' + W.b50h + ' (50), ' + T.b110 + ' x ' + W.b110 + ' + ' + T.b110h + ' x ' + W.b110h + ' (110); branches ' +
            T.y50 + ' x ' + W.y50 + ', ' + T.y110s + ' x ' + W.y110s + ', ' + T.y110 + ' x ' + W.y110 + '; ' + T.r11075 + ' x ' + W.r11075 + '; traps ' + T.trap + ' x ' + W.trap +
            ' + ' + T.trap50 + ' x ' + W.trap50 + ', ' + T.shDrain + ' x ' + W.shDrain + ', ' + T.box + ' x ' + W.box + ', ' + T.flange + ' x ' + W.flange + '; ' + T.clean + ' x ' + W.clean +
            ', ' + T.aav + ' x ' + W.aav + ', ' + T.flash + ' x ' + W.flash);
    ctx.log('WASTE hangers and glue: ' + hangers + ' hanger(s) for ' + m2(inside) + ' m of pipe indoors (one every ' + mm(W.hangEvery) + ') = ' + m2(hangers * W.strapPer) + ' m ' + W.strap +
            ' + ' + (hangers * W.hangScrews) + ' x ' + W.screw + '; ' + (jS + jL) + ' joint(s): ' + m2(glue) + ' l ' + W.primer + ' + ' + m2(glue) + ' l ' + W.cement + '; ' + T.seal + ' x ' + W.seal + ' for the way through the ' + (DRx ? 'floor' : 'wall'));
    /* mep-v36: read by a product that keeps them from freezing */
    LAST[LID] = { under110: m2(HZ.l110), under50: m2(HZ.l50), yUnder: y0 - W.under, trailer: !!TRx,
                  /* mep-v40: the pipes up through the floor between (the drops, the stack), for the product's fireblocking */
                  ups: (nUp ? drops.length + 1 : 0), stackAt: { x: SPx, z: SPz } };
    /* mep-v60 (opt-in env.runsOut, no slab, no crawl space): THE ROUTE AS
       DATA for a product that draws the runs under its floor itself -- the
       drain's nodes from the exit in their order (the last is the stack's
       room), the stack's foot, every ground room's pieces and the node each
       room joins. Plan points only; the levels are the product's. */
    if (env.runsOut === true && !US) {
      var rNode = function (n) { return { x: n.x, z: n.z, name: n.name || '' }; };
      var RG = [], qr, kr;
      for (qr = 0; qr < GL.length; qr++) {
        var Gr = GL[qr]; if (Gr.st > 0) continue;
        var isHead = heads.indexOf(Gr) >= 0, PR = [];
        for (kr = 0; kr < Gr.pts.length; kr++) {
          var pr = Gr.pts[kr];
          PR.push({ x: pr.x, z: pr.z, dia: pr.dia, wall: !!pr.wall, y: pr.wall ? pr.y : 0, trap: pr.trap, what: pr.what, nx: pr.nx, nz: pr.nz, cx: pr.cx, cz: pr.cz, d: pr.pd });
        }
        RG.push({ name: Gr.name, x: Gr.x, z: Gr.z, head: isHead, stack: Gr === ST, wc: Gr.wc,
                  join: isHead ? DN.indexOf(Gr) : (Gr.runNb ? DN.indexOf(Gr.runNb) : 0), pts: PR });
      }
      LAST[LID].runs = { y0: y0, under: W.under, f: W.f, exit: { x: EX.x, z: EX.z, k: EX.k },
                         drain: DN.map(rNode), stack: { x: SPx, z: SPz, room: ST.name }, groups: RG, aav: [] };
    }

    /* THE BODIES (mep-v9): the vent stack standing in its wall from under
       the floor to 300 above the roof with its flashing collar where it
       leaves the roof, and every air admittance valve under its sink (the
       back of the room's first piece with a wall outlet, 550 up), else on
       the room's wall nearest its pieces at 1000. White PVC, a dark rubber
       collar, viz 'waste'. The drain, the branches and the traps stay
       calculated. Nothing here changes a quantity. */
    var T3 = ctx.THREE, g3 = ctx.group;
    if (!T3 || !g3 || !T3.Mesh) { ctx.log('WASTE bodies none -- no THREE or no group handed over'); return; }
    var mag = (typeof env.isNew === 'function') ? !!env.isNew(LID) : false, MAG = env.MAGENTA || 0xFF00FF;
    var asm = (typeof env._asmCode === 'function') ? env._asmCode : null, nB = 0;
    function mat(col, rough, metal) { return new T3.MeshStandardMaterial({ color: mag ? MAG : col, roughness: rough, metalness: metal }); }
    function cyl(x, y, z, r, h, m, name) {
      var c = new T3.Mesh(new T3.CylinderGeometry(r, r, h, 20), m);
      c.position.set(x, y, z); c.name = name; c.userData.viz = 'waste'; g3.add(c); nB++; return c;
    }
    var mPvc = mat(0xE9E9E6, 0.5, 0.0), mRub = mat(0x2E2F31, 0.8, 0.0), mCapA = mat(0x8F9498, 0.5, 0.3);
    if (asm) asm(ctx, W.p75, 'top');
    var yS0 = (US && ST.yS != null) ? ST.yS : y0 - W.under, yS1 = roofY + stackAbove;
    /* mep-v60 (opt-in env.stackFoot): the product may start the stack's body
       higher -- over a trailer's beam it cannot go down there; the product
       draws its way from that foot to the drain */
    if (!US && typeof env.stackFoot === 'function') {
      var ySF = null;
      try { ySF = env.stackFoot(SPx, SPz); } catch (eSF) { ySF = null; }
      if (typeof ySF === 'number' && isFinite(ySF) && ySF > yS0 && ySF < yS1 - 0.5) { yS0 = ySF; if (LAST[LID]) LAST[LID].stackFoot = ySF; }
    }
    if (stDrop > 0.005) {
      /* mep-v40: its WC's drop 110 under storey 2's floor, the stack 75 above */
      if (asm) asm(ctx, W.p110, 'top');
      cyl(SPx, yS0 + stDrop / 2, SPz, 0.055, stDrop, mPvc, 'waste-drop');
      if (asm) asm(ctx, W.p75, 'top');
      cyl(SPx, (yS0 + stDrop + yS1) / 2, SPz, 0.0375, yS1 - yS0 - stDrop, mPvc, 'waste-vent-stack');
    } else cyl(SPx, (yS0 + yS1) / 2, SPz, 0.0375, yS1 - yS0, mPvc, 'waste-vent-stack');
    if (asm) asm(ctx, W.flash, 'top');
    cyl(SPx, roofY + 0.04, SPz, 0.075, 0.10, mRub, 'waste-roof-flashing');
    var aNotes = [], ga, AAVP = [];
    if (asm && T.aav) asm(ctx, W.aav, 'top');
    for (ga = 0; ga < GL.length; ga++) {
      var Gg = GL[ga];
      if (Gg === ST) continue;
      var wp = null, pa;
      for (pa = 0; pa < Gg.pts.length; pa++) if (Gg.pts[pa].wall) { wp = Gg.pts[pa]; break; }
      var ax, az, ay, how;
      if (wp) { ax = wp.x + wp.nx * 0.10; az = wp.z + wp.nz * 0.10; ay = y0 + (Gg.dy || 0) + 0.55; how = 'under the ' + wp.what; }
      else { var WS = wallSpot(Gg.room, Gg); ax = WS.x + WS.nx * 0.06; az = WS.z + WS.nz * 0.06; ay = y0 + (Gg.dy || 0) + W.vent; how = 'on the wall at ' + mm(W.vent); }
      cyl(ax, ay, az, 0.035, 0.09, mPvc, 'waste-aav');
      cyl(ax, ay + 0.055, az, 0.040, 0.02, mCapA, 'waste-aav-cap');
      aNotes.push(Gg.name + ' ' + how);
      AAVP.push({ x: ax, y: ay, z: az, G: Gg });   /* mep-v53: its pipe drawn with env.wasteRest */
      /* mep-v60 (env.runsOut): the valve and the outlet it sits by */
      if (LAST[LID] && LAST[LID].runs && !(Gg.st > 0)) LAST[LID].runs.aav.push({ x: ax, y: ay, z: az, room: Gg.name, out: wp ? { x: wp.x, z: wp.z, y: y0 + (Gg.dy || 0) + wp.y } : null });
    }
    /* mep-v40: THE DROPS IN THEIR WALLS and the runs in storey 2's floor to
       them (env.dropWall) */
    var nDw = 0, V3d = T3.Vector3, UPd = new V3d(0, 1, 0);
    /* mep-v43: with env.upDraw storey 2's runs at their fall, a bay at a time,
       and every piece's branch -- drawn only */
    var UDd = env.dropWall ? _upDraw(env) : null, UPW2 = { n: 0, holes: 0, capped: 0 };
    function upFall(Gq, xq, zq, yTq, rq) {
      var fG = Gq.wc ? SL.sD : SL.sB, yCap = y0 + Gq.dy - 0.06, capped = false;
      function walk(pts, y00w, f, r, nm) {
        var sAcc = 0, q, yA = y00w, yB;
        for (q = 0; q + 1 < pts.length; q++) {
          var A = pts[q], B = pts[q + 1], Lq = Math.abs(A.x - B.x) + Math.abs(A.z - B.z);
          sAcc += Lq; yB = y00w + f * sAcc;
          if (yB > yCap - r) { yB = yCap - r; capped = true; }
          var n0 = nDw;
          segW([A.x, yA, A.z], [B.x, yB, B.z], r, nm);
          if (nDw > n0) UPW2.n++;
          yA = yB;
        }
        return yA;
      }
      var RT = UDd.route({ x: xq, z: zq }, Gq.mid, 0);
      UPW2.holes += RT.holes;
      var yMid = walk(RT.pts, yTq, fG, rq, 'waste-up-run'), k;
      for (k = 0; k < Gq.pts.length; k++) {
        var p = Gq.pts[k], rP = (p.dia === 110) ? 0.055 : 0.025, fP = (p.dia === 110) ? SL.sD : SL.sB;
        var RB = UDd.route(Gq.mid, p, 0);
        UPW2.holes += RB.holes;
        if (asm) asm(ctx, p.dia === 110 ? W.p110 : W.p50, 'top');
        var yP = walk(RB.pts, yMid, fP, rP, 'waste-up-branch'), n1 = nDw;
        segW([p.x, yP, p.z], [p.x, y0 + Gq.dy + (p.wall ? p.y : 0.0), p.z], rP, 'waste-up-branch');
        if (nDw > n1) UPW2.n++;
      }
      if (capped) UPW2.capped++;
    }
    function segW(a, b, r, name) {
      var dx = b[0] - a[0], dy4 = b[1] - a[1], dz = b[2] - a[2], L = Math.sqrt(dx * dx + dy4 * dy4 + dz * dz);
      if (!(L > 0.005)) return;
      var c = new T3.Mesh(new T3.CylinderGeometry(r, r, L, 12), mPvc);
      c.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2);
      c.quaternion.setFromUnitVectors(UPd, new V3d(dx / L, dy4 / L, dz / L));
      c.name = name; c.userData.viz = 'waste'; g3.add(c); nB++; nDw++;
    }
    for (ga = 0; ga < GL.length; ga++) {
      var Gq = GL[ga]; if (!Gq.mid) continue;
      var rq = Gq.wc ? 0.055 : 0.025, yTq = y0 + Gq.dy - W.under, isSt = (Gq === ST);
      var xq = isSt ? SPx : Gq.x - (Gq.dsp.nx || 0) * 0.05, zq = isSt ? SPz : Gq.z - (Gq.dsp.nz || 0) * 0.05;
      if (asm) asm(ctx, Gq.wc ? W.p110 : W.p50, 'top');
      if (!isSt) {
        var yBq = (US && Gq.yS != null) ? Gq.yS : (y0 - W.under);
        segW([xq, yBq, zq], [xq, yTq, zq], rq, 'waste-drop');
      }
      var Mq = Gq.mid, cq3 = (Math.abs((Gq.dsp.nx || 0)) > 0.5) ? [Mq.x, yTq, zq] : [xq, yTq, Mq.z];
      if (UDd) { upFall(Gq, xq, zq, yTq, rq); continue; }
      segW([xq, yTq, zq], cq3, rq, 'waste-up-run');
      segW(cq3, [Mq.x, yTq, Mq.z], rq, 'waste-up-run');
    }
    if (UDd && UPW2.n) {
      LAST[LID].upHoles = UPW2.holes; LAST[LID].upVoid = UDd.hits();
      ctx.log('WASTE storey 2 drawn (mep-v43, env.upDraw): ' + UPW2.n + ' bodies -- each room\'s run from its drop up at its fall (' + Math.round(SL.sB * 12 * 100) / 100 + ' in. a ft for 2 in., ' +
              Math.round(SL.sD * 12 * 1000) / 1000 + ' in. for 3 / 4 in., IRC P3005.3) to the room\'s middle, on to every piece and up to its outlet; a bay between the joists at a time, ' +
              UPW2.holes + ' hole(s) through the joists\' webs where they cross' + (UDd.hits() ? (' -- CHECK: ' + UDd.hits() + ' run(s) cross a void the product keeps clear') : '') + (UPW2.capped ? ('; ' + UPW2.capped + ' run(s) reached the subfloor -- their high end held under it (CHECK the fall)') : '') +
              '; drawing only, billed as calculated');
    }
    /* mep-v24: THE RUNS UNDER THE SLAB, drawn on their plan way (billed x 1.2):
       the pipe at its fall, the trench round it, a stub up through the slab
       at every piece, a box at a floor drain */
    var nSl = 0, SLN = CRW ? 'waste-crawl-' : 'waste-slab-', GRV = { n: 0, v: 0 };   /* mep-v53: under a crawl space its own names */
    if (US && SL.segs.length) {
      var mTr = new T3.MeshStandardMaterial({ color: mag ? MAG : 0x7A6248, roughness: 1.0, transparent: true, opacity: 0.35, depthWrite: false });
      var mBox = mat(0xC9A66B, 0.9, 0.0);
      var mGrv = new T3.MeshStandardMaterial({ color: mag ? MAG : 0xB8B0A2, roughness: 1.0, transparent: true, opacity: 0.45, depthWrite: false });
      var V3 = T3.Vector3, UP = new V3(0, 1, 0);
      function pipe(a, b, r, m, name) {
        var dx = b[0] - a[0], dy2 = b[1] - a[1], dz = b[2] - a[2], L = Math.sqrt(dx * dx + dy2 * dy2 + dz * dz);
        if (!(L > 0.005)) return null;
        var c = new T3.Mesh(new T3.CylinderGeometry(r, r, L, 12), m);
        c.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2);
        c.quaternion.setFromUnitVectors(UP, new V3(dx / L, dy2 / L, dz / L));
        c.name = name; c.userData.viz = 'waste'; g3.add(c); nB++; nSl++; return c;
      }
      function trench(a, b, r) {
        var L = Math.abs(b[0] - a[0]) + Math.abs(b[2] - a[2]); if (!(L > 0.005)) return;
        var yb = Math.min(a[1], b[1]) - r - SL.bed, h = ((US.digTop != null) ? US.digTop : US.ySub) - yb; if (!(h > 0.01)) return;
        var alongX = Math.abs(b[0] - a[0]) > Math.abs(b[2] - a[2]);
        var t = new T3.Mesh(new T3.BoxGeometry(alongX ? L + SL.w : SL.w, h, alongX ? SL.w : L + SL.w), mTr);
        t.position.set((a[0] + b[0]) / 2, yb + h / 2, (a[2] + b[2]) / 2);
        t.name = SLN + 'trench'; t.userData.viz = 'waste'; t.renderOrder = 2;
        /* mep-v38: the trench is the digging (billed as US.dig with the rest of
           the earthwork), not the 110 drain it holds -- the audit read 29 m of
           trench as drain pipe. Tagged with the dig's own code */
        t.userData.asm = { key: 'base_excavation', code: US.dig || '', def: 'Excavation', dir: 'top', byKey: !US.dig };
        g3.add(t); nB++; nSl++;
        /* mep-v54 (RANCH thread, env.wasteRest): THE PEA GRAVEL IN IT, as
           billed (US.bed) -- under a slab the whole trench round the pipe, in a
           crawl space's trench the bed (100 under, 150 over the pipe); it was
           billed with no body */
        if (env.wasteRest === true && US.bed) {
          var gH = US.crawl ? Math.min(h, SL.bed + 2 * r + SL.over) : h;
          var gv = new T3.Mesh(new T3.BoxGeometry(alongX ? L + SL.w - 0.004 : SL.w - 0.004, gH, alongX ? SL.w - 0.004 : L + SL.w - 0.004), mGrv);
          gv.position.set((a[0] + b[0]) / 2, yb + gH / 2, (a[2] + b[2]) / 2);
          gv.name = SLN + 'gravel'; gv.userData.viz = 'waste'; gv.renderOrder = 1;
          gv.userData.asm = { key: 'base_gravel', code: US.bed, def: 'Gravel bed', dir: 'top', byKey: false };
          gv.userData.qtyV = Math.max(0, (L + SL.w) * SL.w * gH - Math.PI * r * r * L);
          g3.add(gv); nB++; nSl++; GRV.n++; GRV.v += gv.userData.qtyV;
        }
      }
      if (asm) asm(ctx, W.p110, 'top');
      var sg, q8;
      for (sg = 0; sg < SL.segs.length; sg++) {
        var S8 = SL.segs[sg], A8 = S8.a, B8 = S8.b, Lp = man(A8, B8) || 1;
        /* off a wall (the exit) square to it first, so the trench leaves the wall line */
        var zF = (A8.k === 'z0' || A8.k === 'z1');
        var yM = A8.yS + (B8.yS - A8.yS) * (zF ? Math.abs(B8.z - A8.z) : Math.abs(B8.x - A8.x)) / Lp;
        var P8 = zF ? [[A8.x, A8.yS, A8.z], [A8.x, yM, B8.z], [B8.x, B8.yS, B8.z]]
                    : [[A8.x, A8.yS, A8.z], [B8.x, yM, A8.z], [B8.x, B8.yS, B8.z]];
        /* mep-v38: each run under its own billed code -- a 50 branch or
           collector as the 50 pipe, the way out as the outside pipe, the
           rest as the 110 (all were tagged as the 110) */
        if (asm) asm(ctx, S8.k === 'out' ? W.pOut : (S8.r < 0.04 ? W.p50 : W.p110), 'top');
        for (q8 = 0; q8 < 2; q8++) { pipe(P8[q8], P8[q8 + 1], S8.r, mPvc, SLN + 'pipe'); trench(P8[q8], P8[q8 + 1], S8.r); }
        if (S8.k === 'branch') {
          /* the stub up through the slab, 100 over the floor */
          pipe([B8.x, B8.yS, B8.z], [B8.x, y0 + 0.10, B8.z], S8.r, mPvc, SLN + 'stub');
          /* mep-v53 (env.wasteRest): a wall outlet's pipe on up in the wall to it */
          if (env.wasteRest === true && B8.wall && B8.y > 0.10) { if (asm) asm(ctx, W.p50, 'side'); pipe([B8.x, y0 + 0.10, B8.z], [B8.x, y0 + B8.y, B8.z], S8.r, mPvc, 'waste-wall-drop'); if (asm) asm(ctx, S8.r < 0.04 ? W.p50 : W.p110, 'top'); }
          if (!B8.wall && B8.trap !== 'wc') {
            var bx = 0.30, yB1 = (US.yTop != null) ? US.yTop : y0, yB0 = (US.yBot != null) ? US.yBot : yB1 - 0.10, by = Math.max(0.02, yB1 - yB0), yBx = (yB0 + yB1) / 2, e8;
            if (asm && US.trapBox) asm(ctx, US.trapBox, 'top');
            for (e8 = 0; e8 < 4; e8++) {
              var bw = (e8 < 2) ? bx : 0.02, bd2 = (e8 < 2) ? 0.02 : bx;
              var bb = new T3.Mesh(new T3.BoxGeometry(bw, by, bd2), mBox);
              bb.position.set(B8.x + (e8 === 2 ? -bx / 2 : e8 === 3 ? bx / 2 : 0), yBx, B8.z + (e8 === 0 ? -bx / 2 : e8 === 1 ? bx / 2 : 0));
              bb.name = 'waste-slab-box'; bb.userData.viz = 'waste'; g3.add(bb); nB++; nSl++;
            }
          }
        }
      }
      if (asm) asm(ctx, W.p110, 'top');
      /* the drain's far end over to the stack's foot in its wall; the cleanout riser outside */
      if (ST.yS != null) {
        pipe([ST.x, ST.yS, ST.z], [SPx, ST.yS, ST.z], 0.055, mPvc, SLN + 'pipe');
        pipe([SPx, ST.yS, ST.z], [SPx, ST.yS, SPz], 0.055, mPvc, SLN + 'pipe');
      }
      var Sx = SL.segs[SL.segs.length - 1];
      for (sg = 0; sg < SL.segs.length; sg++) if (SL.segs[sg].k === 'out') Sx = SL.segs[sg];
      if (asm && Sx && Sx.k === 'out') asm(ctx, W.pOut, 'top');
      if (Sx && Sx.k === 'out') pipe([Sx.b.x, Sx.b.yS, Sx.b.z], [Sx.b.x, Sx.b.yS + SL.riser, Sx.b.z], 0.055, mPvc, SLN + 'cleanout');
    }
    /* mep-v53 (env.crawlDrain): THE 50s IN THE FLOOR BETWEEN THE JOISTS --
       from where each goes down to the buried drain (a room on the drain: by
       the room's node, one a piece; a collector: by the node it joins) up at
       1/4 in./ft along a bay and across the joists through their webs, in the
       middle third of their depth (IRC R502.8.1: env.floorDraw's level +-
       40), to the room's middle and on to each piece, up to its outlet.
       And (env.wasteRest) every air admittance valve's pipe down from it to
       the runs. Drawn only -- the lengths are the calculation's. */
    var CRD = { n: 0, holes: 0, capped: 0, L: 0, aav: 0, aavL: 0 }, V3c = T3.Vector3, UPc = new V3c(0, 1, 0);
    function segC(a, b, r, name) {
      var dx = b[0] - a[0], dy5 = b[1] - a[1], dz = b[2] - a[2], L = Math.sqrt(dx * dx + dy5 * dy5 + dz * dz);
      if (!(L > 0.005)) return 0;
      var c = new T3.Mesh(new T3.CylinderGeometry(r, r, L, 12), mPvc);
      c.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2);
      c.quaternion.setFromUnitVectors(UPc, new V3c(dx / L, dy5 / L, dz / L));
      c.name = name; c.userData.viz = 'waste'; g3.add(c); nB++; return L;
    }
    var FDw = CRW ? _upDraw(env, 'floorDraw') : null, yMidF = FDw ? FDw.y : (y0 - 0.15), yLoF = yMidF - 0.04, yHiF = yMidF + 0.04;
    if (CRW) {
      var routeF = function (a, b, off) { return FDw ? FDw.route(a, b, off) : { pts: [{ x: a.x, z: a.z }, { x: b.x, z: a.z }, { x: b.x, z: b.z }], holes: 0 }; };
      var segF = function (a, b, r, nm) { var Lf = segC(a, b, r, nm); if (Lf) { CRD.n++; CRD.L += Lf; } };
      var walkF = function (pts, yA0, f, r, nm) {
        var yA = yA0, q, cap = false;
        for (q = 0; q + 1 < pts.length; q++) {
          var A = pts[q], B = pts[q + 1], yB = yA + f * (Math.abs(A.x - B.x) + Math.abs(A.z - B.z));
          if (yB > yHiF) { yB = yHiF; cap = true; }
          segF([A.x, yA, A.z], [B.x, yB, B.z], r, nm); yA = yB;
        }
        if (cap) CRD.capped++;
        return yA;
      };
      var toC = function (nd, k) { return { x: nd.x + (C.x >= nd.x ? 1 : -1) * 0.07 * k, z: nd.z + (C.z >= nd.z ? 1 : -1) * 0.07 * k }; };
      var upTo = function (pc, yE) { if (asm) asm(ctx, W.p50, 'side'); segF([pc.x, yE, pc.z], [pc.x, y0 + (pc.wall ? pc.y : 0), pc.z], 0.025, 'waste-floor-branch'); };
      var nK = 0, qc, kc;
      for (qc = 0; qc < heads.length; qc++) {
        var Hc = heads[qc]; if (Hc.st > 0 || Hc.yS == null) continue;
        for (kc = 0; kc < Hc.pts.length; kc++) {
          var pc = Hc.pts[kc]; if (!pc.crawl) continue;
          var Dc = toC(Hc, ++nK);
          if (asm) asm(ctx, W.p50, 'side');
          segF([Dc.x, Hc.yS + 0.03, Dc.z], [Dc.x, yLoF, Dc.z], 0.025, 'waste-floor-drop');
          if (asm) asm(ctx, W.p50, 'top');
          var RTc = routeF(Dc, pc, 0); CRD.holes += RTc.holes;
          upTo(pc, walkF(RTc.pts, yLoF, SL.sB, 0.025, 'waste-floor-branch'));
        }
      }
      for (qc = 0; qc < others.length; qc++) {
        var Oc = others[qc]; if (Oc.st > 0 || !Oc.nb || Oc.nb.yS == null) continue;
        var Do = toC(Oc.nb, ++nK);
        if (asm) asm(ctx, W.p50, 'side');
        segF([Do.x, Oc.nb.yS + 0.03, Do.z], [Do.x, yLoF, Do.z], 0.025, 'waste-floor-drop');
        if (asm) asm(ctx, W.p50, 'top');
        var RTo = routeF(Do, Oc, 0); CRD.holes += RTo.holes;
        var yOc = walkF(RTo.pts, yLoF, SL.sB, 0.025, 'waste-floor-run');
        for (kc = 0; kc < Oc.pts.length; kc++) {
          var po = Oc.pts[kc];
          if (asm) asm(ctx, W.p50, 'top');
          var RTp = routeF(Oc, po, 0); CRD.holes += RTp.holes;
          upTo(po, walkF(RTp.pts, yOc, SL.sB, 0.025, 'waste-floor-branch'));
        }
      }
    }
    if (env.wasteRest === true && AAVP.length) {
      /* the valve's pipe down to the runs: the floor's level, a slab's stubs, under the floor */
      var qa;
      if (asm) asm(ctx, W.p50, 'side');
      for (qa = 0; qa < AAVP.length; qa++) {
        if (AAVP[qa].G.st > 0) continue;
        /* from a buried node's level (as billed: up from the drain or the collector), else the floor's runs */
        var yAv = (AAVP[qa].G.yS != null) ? AAVP[qa].G.yS + 0.03 : (CRW ? yLoF : (US ? y0 + 0.10 : y0 - W.under));
        var La = segC([AAVP[qa].x, yAv, AAVP[qa].z], [AAVP[qa].x, AAVP[qa].y - 0.045, AAVP[qa].z], 0.025, 'waste-aav-pipe');
        if (La) { CRD.aav++; CRD.aavL += La; }
      }
    }
    ctx.log('WASTE bodies (mep-v9): ' + nB + ' drawn -- the vent stack in the wall of ' + ST.name + ' at ' + SPx.toFixed(2) + ',' + SPz.toFixed(2) + ' from ' +
            (yS0 > y0 ? (mm(yS0 - y0) + ' over the floor (env.stackFoot: the product takes it on down)') : (mm(y0 - yS0) + ' under the floor')) + ' to ' + mm(stackAbove) + ' above the roof with its flashing' + (aNotes.length ? ('; air admittance valve(s): ' + aNotes.join('; ')) : '') +
            (nSl ? ('; ' + (CRW ? 'buried under the crawl space ' : 'under the slab ') + nSl + ' bodies -- the drain, branches, collectors, trenches, stubs, trap boxes, the cleanout riser (mep-v24' + (CRW ? ', mep-v53' : '') + ')' +
                     (GRV.n ? (', the pea gravel in ' + GRV.n + ' trench piece(s) ' + m2(GRV.v) + ' m3 ' + US.bed + ' (mep-v54)') : '')) : ((LAST[LID] && LAST[LID].runs) ? '; the drain and branches drawn by the product from the route handed over (mep-v60 env.runsOut), the traps calculated' : '; drain, branches and traps calculated, not drawn')) +
            (nDw ? ('; ' + nDw + ' bodies of the drops in their walls and the runs in storey 2\'s floor (mep-v40)') : '') +
            (CRD.n ? ('; the 50s in the floor (mep-v53, env.crawlDrain): ' + CRD.n + ' bodies, ' + m2(CRD.L) + ' m -- down to the buried drain, along the bays and through the joists (' + CRD.holes + ' hole(s), middle third), up to the outlets' +
                      (CRD.capped ? ('; CHECK: ' + CRD.capped + ' run(s) reach the top of the joists\' middle third -- flat from there') : '')) : '') +
            (CRD.aav ? ('; ' + CRD.aav + ' air admittance valve pipe(s) ' + m2(CRD.aavL) + ' m (env.wasteRest)') : '') + (mag ? ' -- MAGENTA (under review)' : ''));
  }


  /* =========================================================================
     UNDERFLOOR HEATING -- MepLib.ufh (mep-v15, Marek 2026-10-08/09: the T
     house heats its ground floor by underfloor loops from an air to water
     heat pump; the loops and the manifold are what is modelled early,
     status/mep.md). By calculation, and drawn.

     THE RULES (the catalogue's own rows give them):
       every room of the ground floor but a closet is heated: a loop of PE-Xa
       16 x 2 HMP00161 at 150 -- 6.7 m of pipe a m2 -- laid in the screed over
       the room inside its walls, 100 off them, on the tacker foil HMU00001
       (the heated area +5 per cent), held by tacker clips HMU00002, two a
       metre of pipe;
       a room takes one loop per 12 m2 begun, and one more while a loop with
       its leads would run over 100 m; every loop goes from the manifold and
       back with no joint in the floor -- its leads 2 x the Manhattan way from
       the manifold to the nearest corner of the room, in the build-up;
       THE MANIFOLD HMH00001 (7 circuits), one per 7 loops begun: in the
       technical room, else the laundry, a closet, the storage or the hall
       nearest the middle of the heated floor, else the room nearest it -- on
       that room's wall nearest the middle, its centre 600 over the floor;
       with it a ball valve HMB00251 on the flow and on the return, an
       automatic air vent HMA00001 and a dew point sensor HMT00002 (the floor
       cools too);
       THE CONTROLS: an actuator HMU00003 on every loop, a room thermostat
       with humidity HMT00001 in every heated room.
     A room's floor is its rects drawn in: by the wall where a rect's edge
     lies on the outline, by half a partition where one runs along it, not
     at all where the room goes on. Drawn: each room's meander (one mesh a
     room, in the screed at env.ufhY), the leads as one run each way, the
     manifold cabinet; viz 'heat'. Log prefix UFH.
     ========================================================================= */
  var UFH = { pipe: 'HMP00161', foil: 'HMU00001', clip: 'HMU00002', man: 'HMH00001', act: 'HMU00003', stat: 'HMT00001', dew: 'HMT00002',
              valve: 'HMB00251', vent: 'HMA00001',
              perM2: 6.7, spacing: 0.150, margin: 0.10, perLoopM2: 12, maxLoop: 100, circuits: 7, clipsPerM: 2, foilWaste: 1.05,
              manW: 0.80, manH: 0.60, manT: 0.12, manY: 0.60, pipeR: 0.008, col: 0xD9502E, manCol: 0xF2F0EA };
  var UFH_CAT = {
    'HMP00161': { unit: 'm',   label: 'PE-Xa heating pipe 16x2' },
    'HMU00001': { unit: 'm2',  label: 'Tacker foil with grid' },
    'HMU00002': { unit: 'pcs', label: 'Tacker clip 16' },
    'HMH00001': { unit: 'pcs', label: 'Heating manifold 7 circuits' },
    'HMU00003': { unit: 'pcs', label: 'Thermal actuator for manifold' },
    'HMT00001': { unit: 'pcs', label: 'Room thermostat with humidity sensor' },
    'HMT00002': { unit: 'pcs', label: 'Dew point sensor' },
    'HMB00251': { unit: 'pcs', label: 'Ball shut-off valve DN25' },
    'HMA00001': { unit: 'pcs', label: 'Automatic air vent DN15' }
  };
  /* mep-v65 (TWO STORY thread, Marek 2026-11-03: floor heating on both
     storeys from one heat pump): THE DRY SYSTEM on storey 2's timber floor
     (env.ufhDry) -- 25 mm EPS panels grooved for the 16 pipe with aluminium
     spreaders, a fibre gypsum floor element 2 x 10 over them (glued in its
     step joint, screwed at about 15 a m2, adhesive about 50 g a m2), +5 %.
     Four rows the catalogue has not got yet: pending. */
  var UFH_DRY = { panel: 'mep.ufhDryPanel', board: 'mep.ufhDryBoard', screw: 'mep.ufhDryScrew', glue: 'mep.ufhDryGlue',
                  waste: 1.05, screwsPerM2: 15, glueKgM2: 0.05, panelT: 0.025, boardT: 0.020 };
  var UFH_DRY_PENDING = {
    'mep.ufhDryPanel': { unit: 'm2',  label: 'Dry underfloor heating panel 25 mm, EPS grooved for a 16 mm pipe with aluminium heat spreaders (pending row)' },
    'mep.ufhDryBoard': { unit: 'm2',  label: 'Fibre gypsum floor element 2 x 10 mm over the heating panels (pending row)' },
    'mep.ufhDryScrew': { unit: 'pcs', label: 'Screw for fibre gypsum floor elements 3.9 x 19 (pending row)' },
    'mep.ufhDryGlue':  { unit: 'kg',  label: 'Joint adhesive for fibre gypsum floor elements (pending row)' }
  };
  var UFH_NEED = ['API', 'STATE', 'CATALOG', '_P', '_add', '_billReset', '_buildRect', 'wallThickness', '_roomKey', '_roomLabel'];
  function _ufhMissing(env) {
    var out = [], i;
    if (!env) return ['env'];
    if (typeof env.layerId !== 'string' || !env.layerId) out.push('layerId');
    for (i = 0; i < UFH_NEED.length; i++) if (env[UFH_NEED[i]] == null) out.push(UFH_NEED[i]);
    return out;
  }
  function _buildUfh(env, ctx) {
    var LID = env.layerId, API = env.API, STATE = env.STATE, CATALOG = env.CATALOG,
        _P = env._P, _add = env._add, _billReset = env._billReset, _buildRect = env._buildRect,
        wallThickness = env.wallThickness, _roomKey = env._roomKey, _roomLabel = env._roomLabel;
    if (!env.ufhKeep) _billReset(LID);   /* mep-v65: storey 2's loops join the ground floor's bill */
    var i, j, k, q;
    function m2(v) { return Math.round(v * 100) / 100; }
    function mm(v) { return Math.round(v * 1000); }
    for (k in UFH_CAT) {
      if (!UFH_CAT.hasOwnProperty(k) || CATALOG[k]) continue;
      CATALOG[k] = { code: k, unit: UFH_CAT[k].unit, label: UFH_CAT[k].label };
    }
    var PL = _P();
    if (!PL || !PL.rooms) { ctx.log('UFH  none -- floorplan asset without rooms'); return; }
    var rooms = PL.rooms() || [];
    if (!rooms.length) { ctx.log('UFH  none -- no room'); return; }
    var B0 = _buildRect(), wt = wallThickness(), PER = _perim(env, B0, wt), sides = PER.sides;
    var half = ((env.PART && env.PART.d) ? env.PART.d : 0.10) / 2;
    var parts = (STATE && STATE.parts) || [];
    /* mep-v65 (opt-in): env.ufhY0 the floor the loops heat (storey 2's
       finished floor), env.ufhWhere its name in the log, env.ufhDry the dry
       system on a timber floor instead of the foil and clips in a screed */
    var y0 = (typeof env.ufhY0 === 'function') ? env.ufhY0() : API.storeys()[0].y0;
    var yP = (typeof env.ufhY === 'function') ? env.ufhY() : (y0 - 0.05);
    var WHERE = env.ufhWhere || 'the ground floor', DRY = env.ufhDry ? UFH_DRY : null;
    if (DRY) for (k in UFH_DRY_PENDING) if (UFH_DRY_PENDING.hasOwnProperty(k) && !CATALOG[k]) CATALOG[k] = { code: null, pending: true, unit: UFH_DRY_PENDING[k].unit, label: UFH_DRY_PENDING[k].label };
    /* how far a rect's edge is drawn in: the wall, half a partition, nothing */
    function onOutline(ax, az, bx, bz) {
      var s9;
      for (s9 = 0; s9 < sides.length; s9++) {
        var S = sides[s9];
        /* the outline's axis lies wt outside the side's face */
        var dA = (ax - S.a[0]) * S.n[0] + (az - S.a[1]) * S.n[1], dB = (bx - S.a[0]) * S.n[0] + (bz - S.a[1]) * S.n[1];
        if (Math.abs(dA + wt) > 0.05 || Math.abs(dB + wt) > 0.05) continue;
        /* and most of the edge along that side, not only on its line (the
           bar's edge where it opens into the wing) */
        var uA = (ax - S.a[0]) * S.u[0] + (az - S.a[1]) * S.u[1], uB = (bx - S.a[0]) * S.u[0] + (bz - S.a[1]) * S.u[1];
        var ov = Math.min(Math.max(uA, uB), S.len + wt) - Math.max(Math.min(uA, uB), -wt);
        if (ov > 0.5 * Math.abs(uB - uA)) return true;
      }
      return false;
    }
    function onPart(horiz, c, lo, hi) {
      var p9;
      for (p9 = 0; p9 < parts.length; p9++) {
        var P = parts[p9];
        if (!P || P.sep || (((P.dir || P.o) === 'h') !== horiz)) continue;
        var pc = (typeof P.at === 'number') ? P.at : P.c, sp = null;
        try { sp = API.partSpan ? API.partSpan(P) : null; } catch (eS) { sp = null; }
        var a = sp ? sp[0] : Math.min(P.a, P.b), b = sp ? sp[1] : Math.max(P.a, P.b);
        if (Math.abs(pc - c) < 0.05 && Math.min(b, hi) - Math.max(a, lo) > 0.3) return true;
      }
      return false;
    }
    function inset(r) {
      var dz0 = onOutline(r.x0, r.z0, r.x1, r.z0) ? wt : (onPart(true, r.z0, r.x0, r.x1) ? half : 0);
      var dz1 = onOutline(r.x0, r.z1, r.x1, r.z1) ? wt : (onPart(true, r.z1, r.x0, r.x1) ? half : 0);
      var dx0 = onOutline(r.x0, r.z0, r.x0, r.z1) ? wt : (onPart(false, r.x0, r.z0, r.z1) ? half : 0);
      var dx1 = onOutline(r.x1, r.z0, r.x1, r.z1) ? wt : (onPart(false, r.x1, r.z0, r.z1) ? half : 0);
      /* which of its edges are walls: the manifold hangs on one */
      return { x0: r.x0 + dx0, x1: r.x1 - dx1, z0: r.z0 + dz0, z1: r.z1 - dz1, wz0: dz0 > 0, wz1: dz1 > 0, wx0: dx0 > 0, wx1: dx1 > 0 };
    }
    /* mep-v68 (opt-in env.ufhKeepOut: rects, or a function giving them): no
       loop where there is no floor -- a stairwell's hole cut out of the rooms
       (the pieces left keep the walls they had) */
    var KO = [];
    try { KO = (typeof env.ufhKeepOut === 'function') ? (env.ufhKeepOut() || []) : (env.ufhKeepOut || []); } catch (eKO) { KO = []; }
    var nKO = 0;
    function koMinus(Rk, Hk) {
      if (!Hk || Hk.x1 <= Rk.x0 || Hk.x0 >= Rk.x1 || Hk.z1 <= Rk.z0 || Hk.z0 >= Rk.z1) return [Rk];
      nKO++;
      var out = [], ix0 = Math.max(Rk.x0, Hk.x0), ix1 = Math.min(Rk.x1, Hk.x1), mz0 = Math.max(Rk.z0, Hk.z0), mz1 = Math.min(Rk.z1, Hk.z1);
      function pc(x0, x1, z0, z1) { return { x0: x0, x1: x1, z0: z0, z1: z1, wx0: Rk.wx0 && x0 === Rk.x0, wx1: Rk.wx1 && x1 === Rk.x1, wz0: Rk.wz0 && z0 === Rk.z0, wz1: Rk.wz1 && z1 === Rk.z1 }; }
      if (Hk.z0 > Rk.z0) out.push(pc(Rk.x0, Rk.x1, Rk.z0, Hk.z0));
      if (Hk.z1 < Rk.z1) out.push(pc(Rk.x0, Rk.x1, Hk.z1, Rk.z1));
      if (ix0 > Rk.x0) out.push(pc(Rk.x0, ix0, mz0, mz1));
      if (ix1 < Rk.x1) out.push(pc(ix1, Rk.x1, mz0, mz1));
      return out;
    }
    function koCut(r0) { var outK = [r0], k, q; for (k = 0; k < KO.length; k++) { var nx = []; for (q = 0; q < outK.length; q++) nx = nx.concat(koMinus(outK[q], KO[k])); outK = nx; } return outK; }
    /* THE ROOMS: heated, or a closet */
    var R = [], cold = [], cx = 0, cz = 0, aT = 0;
    for (i = 0; i < rooms.length; i++) {
      var rm = rooms[i]; if (!rm || !rm.rects || !rm.rects.length) continue;
      var key = '', nm = '';
      try { key = _roomKey(rm, i) || ''; } catch (eK) { key = ''; }
      try { nm = rm.closet ? _roomLabel(rm, i) : (PL.roomName ? PL.roomName(rm, i) : _roomLabel(rm, i)); } catch (eN) { nm = ''; }
      nm = nm || ('room ' + (i + 1));
      var IR = [], A = 0;
      for (j = 0; j < rm.rects.length; j++) {
        var irs = KO.length ? koCut(inset(rm.rects[j])) : [inset(rm.rects[j])], jk;
        for (jk = 0; jk < irs.length; jk++) {
          var ir = irs[jk];
          if (ir.x1 - ir.x0 > 0.05 && ir.z1 - ir.z0 > 0.05) { IR.push(ir); A += (ir.x1 - ir.x0) * (ir.z1 - ir.z0); }
        }
      }
      if (!IR.length) continue;
      var Rr = { i: i, key: key, name: nm, rects: IR, area: A, closet: !!rm.closet };
      if (rm.closet) { cold.push(nm); Rr.skip = true; }
      else { for (j = 0; j < IR.length; j++) { var a9 = (IR[j].x1 - IR[j].x0) * (IR[j].z1 - IR[j].z0); cx += a9 * (IR[j].x0 + IR[j].x1) / 2; cz += a9 * (IR[j].z0 + IR[j].z1) / 2; } aT += A; }
      R.push(Rr);
    }
    if (!(aT > 0.5)) { ctx.log('UFH  none -- no heated room on ' + WHERE + (cold.length ? (' (' + cold.length + ' closet(s))') : '')); return { none: true, R: R, aT: 0, PER: PER, wt: wt, y0: y0, env: env }; }
    cx /= aT; cz /= aT;
    /* THE MANIFOLD: its room, then the wall of that room nearest the middle */
    function man(a, b) { return Math.abs(a.x - b.x) + Math.abs(a.z - b.z); }
    function midOf(Rm) { var x = 0, z = 0, a = 0, t; for (t = 0; t < Rm.rects.length; t++) { var r = Rm.rects[t], w = (r.x1 - r.x0) * (r.z1 - r.z0); x += w * (r.x0 + r.x1) / 2; z += w * (r.z0 + r.z1) / 2; a += w; } return { x: x / a, z: z / a }; }
    var C = { x: cx, z: cz }, MR = null, why = '', tiers = [
      [/container_room_6|technical/i, 'the technical room'], [/laundry|utility/i, 'the laundry'], ['closet', 'a closet'],
      [/storage|pantry/i, 'the storage'], [/hall|entry/i, 'the hall']], tq;
    for (tq = 0; tq < tiers.length && !MR; tq++) {
      var best = null, bd = 1e9;
      for (i = 0; i < R.length; i++) {
        var hit = (tiers[tq][0] === 'closet') ? R[i].closet : tiers[tq][0].test(R[i].key + ' ' + R[i].name);
        if (!hit) continue;
        var dm = man(midOf(R[i]), C);
        if (dm < bd) { bd = dm; best = R[i]; }
      }
      if (best) { MR = best; why = tiers[tq][1] + ' nearest the middle of the heated floor'; }
    }
    if (!MR) {
      var bd2 = 1e9;
      for (i = 0; i < R.length; i++) { if (R[i].skip) continue; var d2 = man(midOf(R[i]), C); if (d2 < bd2) { bd2 = d2; MR = R[i]; } }
      why = 'the room nearest the middle of the heated floor (no technical room, laundry, closet, storage or hall)';
    }
    var MP = null, mbd = 1e9;
    for (j = 0; j < MR.rects.length; j++) {
      var r8 = MR.rects[j], px = Math.max(r8.x0, Math.min(r8.x1, C.x)), pz = Math.max(r8.z0, Math.min(r8.z1, C.z));
      var cand = [{ x: px, z: r8.z0, nx: 0, nz: 1, w: r8.wz0 }, { x: px, z: r8.z1, nx: 0, nz: -1, w: r8.wz1 }, { x: r8.x0, z: pz, nx: 1, nz: 0, w: r8.wx0 }, { x: r8.x1, z: pz, nx: -1, nz: 0, w: r8.wx1 }], c8;
      /* a wall first: a few metres of open edge is no place for a cabinet */
      for (c8 = 0; c8 < 4; c8++) { var d8 = man(cand[c8], C) + (cand[c8].w ? 0 : 1000); if (d8 < mbd) { mbd = d8; MP = cand[c8]; } }
    }
    /* THE LOOPS, room by room */
    var loops = 0, pipeRoom = 0, pipeLead = 0, notes = [], heated = 0, longest = 0;
    for (i = 0; i < R.length; i++) {
      var H = R[i];
      if (H.skip) continue;
      heated++;
      /* the lead: to the nearest corner of the room's floor */
      var ld = 1e9;
      for (j = 0; j < H.rects.length; j++) {
        var rr = H.rects[j], ccs = [[rr.x0, rr.z0], [rr.x1, rr.z0], [rr.x0, rr.z1], [rr.x1, rr.z1]], c9;
        for (c9 = 0; c9 < 4; c9++) { var d9 = Math.abs(ccs[c9][0] - MP.x) + Math.abs(ccs[c9][1] - MP.z); if (d9 < ld) { ld = d9; H.lead = { x: ccs[c9][0], z: ccs[c9][1] }; } }
      }
      var inRoom = H.area * UFH.perM2, nL = Math.max(1, Math.ceil(H.area / UFH.perLoopM2 - 1e-9));
      while (inRoom / nL + 2 * ld > UFH.maxLoop && nL < 12) nL++;
      H.loops = nL; H.leadM = ld; H.pipe = inRoom + nL * 2 * ld;
      loops += nL; pipeRoom += inRoom; pipeLead += nL * 2 * ld;
      longest = Math.max(longest, inRoom / nL + 2 * ld);
      notes.push(H.name + ' ' + m2(H.area) + ' m2: ' + nL + ' loop(s), ' + m2(inRoom) + ' m in the floor + ' + m2(nL * 2 * ld) + ' m of leads (' + m2(ld) + ' m each way)');
    }
    var nMan = Math.max(1, Math.ceil(loops / UFH.circuits)), pipe = pipeRoom + pipeLead;
    /* THE BILL */
    _add(LID, UFH.pipe, m2(pipe));
    if (DRY) {
      /* mep-v65: THE DRY SYSTEM on a timber floor -- the grooved panels with
         their spreaders hold the pipe (no foil, no clips), a fibre gypsum
         floor element over them, glued in its step joint and screwed */
      var aD = aT * DRY.waste;
      _add(LID, DRY.panel, m2(aD));
      _add(LID, DRY.board, m2(aD));
      _add(LID, DRY.screw, Math.ceil(aD * DRY.screwsPerM2));
      _add(LID, DRY.glue, m2(aD * DRY.glueKgM2));
    } else {
      _add(LID, UFH.foil, m2(aT * UFH.foilWaste));
      _add(LID, UFH.clip, Math.ceil(pipe * UFH.clipsPerM));
    }
    _add(LID, UFH.man, nMan);
    _add(LID, UFH.valve, 2 * nMan);
    _add(LID, UFH.vent, nMan);
    _add(LID, UFH.dew, nMan);
    _add(LID, UFH.act, loops);
    _add(LID, UFH.stat, heated);
    ctx.log('UFH  ' + heated + ' heated room(s), ' + m2(aT) + ' m2 on ' + WHERE + (nKO ? ' (the stairwell kept out, env.ufhKeepOut)' : '') + '; ' + loops + ' loop(s) of ' + UFH.pipe + ' at ' + mm(UFH.spacing) + ': ' + m2(pipe) + ' m (' + m2(pipeRoom) + ' in the floors at ' + UFH.perM2 +
            ' m a m2 + ' + m2(pipeLead) + ' of leads), the longest ' + m2(longest) + ' m; ' +
            (DRY ? ('the dry system (mep-v65): ' + DRY.panel + ' ' + m2(aT * DRY.waste) + ' m2 PENDING (25 mm grooved panels with spreaders), ' + DRY.board + ' ' + m2(aT * DRY.waste) + ' m2 PENDING (fibre gypsum floor element over them), ' +
                    Math.ceil(aT * DRY.waste * DRY.screwsPerM2) + ' x ' + DRY.screw + ' PENDING, ' + m2(aT * DRY.waste * DRY.glueKgM2) + ' kg ' + DRY.glue + ' PENDING (+5 %); the finished floor ' + mm(DRY.panelT + DRY.boardT) +
                    ' mm over the subfloor' + (env.ufhDryNote ? ('; ' + env.ufhDryNote + ' (mep-v68 env.ufhDryNote)') : ' -- CHECK the floor build-up and the stair\'s top riser'))
                 : ('foil ' + UFH.foil + ' ' + m2(aT * UFH.foilWaste) + ' m2 (+5 %), ' + Math.ceil(pipe * UFH.clipsPerM) + ' x ' + UFH.clip)) +
            (cold.length ? ('; not heated: ' + cold.join(', ')) : ''));
    ctx.log('UFH  manifold ' + nMan + ' x ' + UFH.man + ' (' + UFH.circuits + ' circuits) in ' + MR.name + ' -- ' + why + ', on its wall at ' + MP.x.toFixed(2) + ',' + MP.z.toFixed(2) + '; with ' + (2 * nMan) + ' x ' + UFH.valve +
            ', ' + nMan + ' x ' + UFH.vent + ', ' + nMan + ' x ' + UFH.dew + ' (dew point); ' + loops + ' x ' + UFH.act + ' (a loop each), ' + heated + ' x ' + UFH.stat + ' (a room each)');
    for (i = 0; i < notes.length; i++) ctx.log('UFH  ' + notes[i]);

    /* THE BODIES: a meander a room in one mesh, the leads, the cabinet */
    var T3 = ctx.THREE, g3 = ctx.group;
    var U = { R: R, MR: MR, MP: MP, C: C, aT: aT, heated: heated, loops: loops, nMan: nMan, PER: PER, wt: wt, y0: y0, yP: yP, env: env };
    if (!T3 || !g3 || !T3.Mesh) { ctx.log('UFH  bodies none -- no THREE or no group handed over'); return U; }
    var mag = (typeof env.isNew === 'function') ? !!env.isNew(LID) : false, MAG = env.MAGENTA || 0xFF00FF;
    var asm = (typeof env._asmCode === 'function') ? env._asmCode : null, nB = 0, nRuns = 0;
    var mPipe = new T3.MeshStandardMaterial({ color: mag ? MAG : UFH.col, roughness: 0.5, metalness: 0.0 });
    var mMan = new T3.MeshStandardMaterial({ color: mag ? MAG : UFH.manCol, roughness: 0.5, metalness: 0.2 });
    function runsMesh(runs, name) {
      var pos = [], idx = [], r = UFH.pipeR, t;
      for (t = 0; t < runs.length; t++) {
        var a = runs[t][0], b = runs[t][1];
        var x0 = Math.min(a[0], b[0]) - r, x1 = Math.max(a[0], b[0]) + r, y0b = Math.min(a[1], b[1]) - r, y1b = Math.max(a[1], b[1]) + r, z0 = Math.min(a[2], b[2]) - r, z1 = Math.max(a[2], b[2]) + r;
        var o = pos.length / 3;
        pos.push(x0, y0b, z0, x1, y0b, z0, x1, y1b, z0, x0, y1b, z0, x0, y0b, z1, x1, y0b, z1, x1, y1b, z1, x0, y1b, z1);
        idx.push(o, o + 2, o + 1, o, o + 3, o + 2, o + 4, o + 5, o + 6, o + 4, o + 6, o + 7, o, o + 1, o + 5, o, o + 5, o + 4,
                 o + 3, o + 7, o + 6, o + 3, o + 6, o + 2, o, o + 4, o + 7, o, o + 7, o + 3, o + 1, o + 2, o + 6, o + 1, o + 6, o + 5);
        nRuns++;
      }
      if (!pos.length) return;
      var geo = new T3.BufferGeometry();
      geo.setAttribute('position', new T3.Float32BufferAttribute(pos, 3));
      geo.setIndex(idx);
      geo.computeVertexNormals();
      var me = new T3.Mesh(geo, mPipe);
      me.name = name; me.userData.viz = 'heat'; g3.add(me); nB++;
    }
    if (asm) asm(ctx, UFH.pipe, 'top');
    for (i = 0; i < R.length; i++) {
      var Hm = R[i];
      if (Hm.skip) continue;
      var RU = [];
      for (j = 0; j < Hm.rects.length; j++) {
        var rq = Hm.rects[j], ax0 = rq.x0 + UFH.margin, ax1 = rq.x1 - UFH.margin, az0 = rq.z0 + UFH.margin, az1 = rq.z1 - UFH.margin;
        if (!(ax1 - ax0 > 0.1) || !(az1 - az0 > 0.1)) continue;
        var alongX = (ax1 - ax0) >= (az1 - az0), n9 = Math.max(1, Math.floor(((alongX ? az1 - az0 : ax1 - ax0)) / UFH.spacing) + 1), w9, prev = null;
        for (w9 = 0; w9 < n9; w9++) {
          var c0 = (alongX ? az0 : ax0) + Math.min(w9 * UFH.spacing, (alongX ? az1 - az0 : ax1 - ax0));
          var e0 = alongX ? [((w9 % 2) ? ax1 : ax0), yP, c0] : [c0, yP, ((w9 % 2) ? az1 : az0)];
          var e1 = alongX ? [((w9 % 2) ? ax0 : ax1), yP, c0] : [c0, yP, ((w9 % 2) ? az0 : az1)];
          RU.push([e0, e1]);
          if (prev) RU.push([prev, e0]);
          prev = e1;
        }
      }
      /* the leads, flow and return as one run each way along the floor */
      if (Hm.lead) {
        var L0 = [MP.x + MP.nx * 0.05, yP, MP.z + MP.nz * 0.05], L1 = [Hm.lead.x, yP, MP.z + MP.nz * 0.05], L2 = [Hm.lead.x, yP, Hm.lead.z];
        RU.push([L0, L1]); RU.push([L1, L2]);
      }
      runsMesh(RU, 'ufh-loops-' + (Hm.name || i));
    }
    /* the manifold cabinet on its wall, centre 600 over the floor; the
       leads rise into it from the floor */
    if (asm) asm(ctx, UFH.man, 'top');
    var cab = new T3.Mesh(new T3.BoxGeometry(UFH.manW, UFH.manH, UFH.manT), mMan);
    cab.position.set(MP.x + MP.nx * UFH.manT / 2, y0 + UFH.manY, MP.z + MP.nz * UFH.manT / 2);
    cab.rotation.y = Math.atan2(MP.nx, MP.nz);
    cab.name = 'ufh-manifold'; cab.userData.viz = 'heat'; g3.add(cab); nB++;
    runsMesh([[[MP.x + MP.nx * 0.05, yP, MP.z + MP.nz * 0.05], [MP.x + MP.nx * 0.05, y0 + UFH.manY - UFH.manH / 2, MP.z + MP.nz * 0.05]]], 'ufh-manifold-rise');
    ctx.log('UFH  bodies (mep-v15): ' + nB + ' drawn -- ' + heated + ' room meander(s) and their leads in ' + nRuns + ' run(s) at ' + yP.toFixed(3) + ', the manifold cabinet ' + mm(UFH.manW) + ' x ' + mm(UFH.manH) +
            ' on the wall of ' + MR.name + (mag ? ' -- MAGENTA (under review)' : ''));
    return U;
  }

  /* =========================================================================
     THE PLANT AND THE FAN COILS -- MepLib.hydro (mep-v16; Marek 2026-09-28:
     one air to water heat pump for the whole house, a monobloc; a fan coil
     on every gallery of 10 m2 or more instead of underfloor heating
     upstairs; the floor and the coils also cool in summer).

     THE HEAT PUMP: the catalogue's monobloc rows by the heated area at about
     40 W a m2 (the ground floor's loops and the galleries with a coil):
     HM400006 6 kW up to 150 m2, HM400008 8 kW up to 200, HM400012 12 kW up
     to 300, beyond that two. It hangs on a bracket pair HMW00001 on the
     outside of the exterior wall nearest the plant room, walked along the
     outside off a doorway (500), off a window whose sill is below its top
     (200), off an inside corner (the other wing's facade 100 off) and off
     the terrace; 600 over the ground floor's level (clear of snow, the
     defrost water dripping away), four concrete screw anchors FAS10075
     into the block; its outdoor run, down the wall, along it and through
     it, in the pre insulated twin pipe HMP00323 (it would freeze bare).
     Drawn at the catalogue's size (12 kW 1300 x 550 x 1400, else 1100 x
     450 x 900).
     THE PLANT ROOM: the technical room, else the laundry, a closet, the
     storage, the bathroom, the manifold's room, else the biggest room --
     the first whose floor takes the tank and the buffer side by side
     (1300 x 900; mep-v17: the bathroom before the manifold's room, which
     may be the living room). In it: the hot water tank with its coil HMH02502
     (250 l), the 50 l buffer HMS00501, the motorised diverting valve
     HMA00003 (heating or hot water), the mixing valve HMA00002 on the hot
     water (thermal disinfection), the magnetic filter HMF00251, four ball
     valves HMB00251 and an air vent HMA00001 at the buffer. Flow and return
     in multilayer 32 HMP00322, insulated HMP00321: from the wall to the
     tank, and from the plant to each manifold (Manhattan x 1.2 + 1.2 up and
     down the walls), two reducing couplings HMM00321 at each manifold.
     ITS FEED: 16 A heat pump breaker EEC00010 (type C), the isolator
     EEI00001 beside the unit, cable EEE00001 from the board the electrics
     placed -- up to the ceiling, across x 1.2, down to the isolator, through
     the wall, x 1.15.
     THE FAN COILS: a floor console HMV00001 on every gallery the product
     hands over (env.galleries) of 10 m2 or more, against its outer wall; its
     flow and return in multilayer 20 HMP00201 from the plant (Manhattan x
     1.2 + the rise to the gallery), insulated with the closed cell sleeve
     HMP00202 (it carries chilled water), two press tees HMM00203 where it
     leaves the 32; its condensate through a siphon SMH00322 into the hose
     HMC00161 down to the ground floor's waste (the rise + 2 m); a
     thermostat HMT00001 a coil; two screws FAS50060 a coil.
     THE CLOSED CIRCUIT'S SAFETY (rows made 2026-10-09, mep-v16): the 18 l
     expansion vessel HMN00181 on the return beside the buffer and the
     safety group HMN00301 (3 bar valve, gauge, air vent) on the flow, one
     each a plant.
     Drawn: the outdoor unit and its brackets, the tank, the buffer, the
     vessel, the coils; the pipes are calculated. Log prefix HYD.
     ========================================================================= */
  var HYD = { hp6: 'HM400006', hp8: 'HM400008', hp12: 'HM400012', wPerM2: 40, brac: 'HMW00001', anchor: 'FAS10075', twin: 'HMP00323',
              tank: 'HMH02502', buffer: 'HMS00501', divert: 'HMA00003', mix: 'HMA00002', filter: 'HMF00251', valve: 'HMB00251', vent: 'HMA00001',
              p32: 'HMP00322', ins32: 'HMP00321', red: 'HMM00321', brk: 'EEC00010', iso: 'EEI00001', cable: 'EEE00001',
              vessel: 'HMN00181', safety: 'HMN00301',
              coil: 'HMV00001', p20: 'HMP00201', ins20: 'HMP00202', tee: 'HMM00203', siphon: 'SMH00322', cond: 'HMC00161', stat: 'HMT00001', screw: 'FAS50060',
              coilMin: 10, f: 1.2, extra: 1.15, facade: 0.15, outW: 1.10, outH: 0.90, outD: 0.45, outY: 0.60,
              tankD: 0.60, tankH: 1.70, bufD: 0.40, bufH: 0.60, coilW: 1.00, coilH: 0.60, coilD: 0.22 };
  var HYD_CAT = {
    'HM400006': { unit: 'pcs', label: 'Air to water heat pump 6 kW' },
    'HM400008': { unit: 'pcs', label: 'Air to water heat pump 8 kW' },
    'HM400012': { unit: 'pcs', label: 'Air to water heat pump 12 kW' },
    'HMW00001': { unit: 'pcs', label: 'Outdoor unit wall bracket pair' },
    'FAS10075': { unit: 'pcs', label: 'Concrete screw anchor 10x75' },
    'HMP00323': { unit: 'm',   label: 'Pre insulated twin pipe 2x32' },
    'HMH02502': { unit: 'pcs', label: 'Hot water tank 250 l with coil' },
    'HMS00501': { unit: 'pcs', label: 'Buffer tank 50 l' },
    'HMA00003': { unit: 'pcs', label: 'Motorised diverting valve DN25' },
    'HMA00002': { unit: 'pcs', label: 'Three-way mixing valve DN20' },
    'HMF00251': { unit: 'pcs', label: 'Magnetic filter DN25' },
    'HMP00322': { unit: 'm',   label: 'PEX-AL-PEX pipe 32' },
    'HMP00321': { unit: 'm',   label: 'Pipe insulation 32' },
    'HMM00321': { unit: 'pcs', label: 'PEX-AL-PEX reducing coupling 32/26' },
    'EEC00010': { unit: 'pcs', label: '16 A heat pump breaker' },
    'EEI00001': { unit: 'pcs', label: 'Outdoor isolator IP65' },
    'EEE00001': { unit: 'm',   label: 'Cable 3x2.5' },
    'HMV00001': { unit: 'pcs', label: 'Hydronic fan coil unit' },
    'HMP00201': { unit: 'm',   label: 'PEX-AL-PEX pipe 20' },
    'HMP00202': { unit: 'm',   label: 'Closed cell elastomeric pipe insulation 20/13' },
    'HMM00203': { unit: 'pcs', label: 'Press tee 20' },
    'SMH00322': { unit: 'pcs', label: 'Concealed drainage siphon (AC)' },
    'HMC00161': { unit: 'm',   label: 'Condensate drain hose 16' },
    'HMT00001': { unit: 'pcs', label: 'Room thermostat with humidity sensor' },
    'FAS50060': { unit: 'pcs', label: 'Wood screw 5x60' },
    'HMN00181': { unit: 'pcs', label: 'Expansion vessel for heating 18 l' },
    'HMN00301': { unit: 'pcs', label: 'Safety group for heating 3 bar' }
  };
  function _buildPlant(env, ctx, U) {
    var LID = env.layerId, API = env.API, CATALOG = env.CATALOG, _add = env._add, H = HYD, i, k;
    function m2(v) { return Math.round(v * 100) / 100; }
    function mm(v) { return Math.round(v * 1000); }
    function man(a, b) { return Math.abs(a.x - b.x) + Math.abs(a.z - b.z); }
    for (k in HYD_CAT) {
      if (!HYD_CAT.hasOwnProperty(k) || CATALOG[k]) continue;
      CATALOG[k] = { code: k, unit: HYD_CAT[k].unit, label: HYD_CAT[k].label };
    }
    var y0 = U.y0, wt = U.wt, PER = U.PER;
    var through = (typeof env.wallThrough === 'function') ? env.wallThrough() : (wt + H.facade);
    /* THE GALLERIES with a coil */
    var GAL = [], gArea = 0, small = [];
    try { GAL = (typeof env.galleries === 'function') ? (env.galleries() || []) : []; } catch (eG) { GAL = []; }
    var coils = [];
    for (i = 0; i < GAL.length; i++) {
      if (!(GAL[i] && GAL[i].area > 0)) continue;
      if (GAL[i].area + 1e-9 >= H.coilMin && GAL[i].coil) { coils.push(GAL[i]); gArea += GAL[i].area; }
      else small.push((GAL[i].name || ('gallery ' + (i + 1))) + ' ' + m2(GAL[i].area) + ' m2');
    }
    /* mep-v65: storey 2's loops (U.up, env.ufhUp) on the same heat pump */
    var UP = (U.up && !U.up.none && U.up.aT > 0) ? U.up : null, upA = UP ? UP.aT : 0;
    var area = (U.aT || 0) + gArea + upA;
    if (!(area > 0.5)) { ctx.log('HYD  none -- nothing heated'); return; }
    /* THE HEAT PUMP by the area */
    var hp = [], kW = area * H.wPerM2 / 1000, left = area;
    while (left > 0.5 && hp.length < 4) {
      var c = (left <= 150) ? H.hp6 : ((left <= 200) ? H.hp8 : H.hp12);
      hp.push(c); left -= (c === H.hp6) ? 150 : ((c === H.hp8) ? 200 : 300);
    }
    /* THE PLANT ROOM */
    /* a room takes the tank and the buffer side by side when its biggest
       floor rect is at least 1300 x 900 */
    var R = U.R || [], PR = null, why = '', tq;
    function bigR(Rm) { var b = null, bA2 = -1, t; for (t = 0; t < Rm.rects.length; t++) { var q2 = Rm.rects[t], a2 = (q2.x1 - q2.x0) * (q2.z1 - q2.z0); if (a2 > bA2) { bA2 = a2; b = q2; } } return b; }
    function fits(Rm) { var b = Rm && Rm.rects && Rm.rects.length ? bigR(Rm) : null; if (!b) return false; var w = b.x1 - b.x0, d = b.z1 - b.z0; return Math.max(w, d) >= 1.3 && Math.min(w, d) >= 0.9; }
    var tiers = [[/container_room_6|technical/i, 'the technical room'], [/laundry|utility/i, 'the laundry'], ['closet', 'a closet'], [/storage|pantry/i, 'the storage'],
                 [/bath/i, 'the bathroom'], ['MR', 'the manifold\'s room']], tooSmall = [];
    for (tq = 0; tq < tiers.length && !PR; tq++) {
      for (i = 0; i < R.length && !PR; i++) {
        var hit2 = (tiers[tq][0] === 'MR') ? (R[i] === U.MR) : ((tiers[tq][0] === 'closet') ? !!R[i].closet : tiers[tq][0].test((R[i].key || '') + ' ' + (R[i].name || '')));
        if (!hit2) continue;
        if (fits(R[i])) { PR = R[i]; why = tiers[tq][1]; } else tooSmall.push(R[i].name);
      }
    }
    if (!PR) { for (i = 0; i < R.length; i++) if (!R[i].skip && fits(R[i]) && (!PR || R[i].area > PR.area)) PR = R[i]; why = 'the biggest room -- no technical room, laundry, closet, storage, bathroom or manifold room that takes the tank'; }
    if (tooSmall.length && PR) why += '; too small for the tank and the buffer (1300 x 900): ' + tooSmall.join(', ');
    if (!PR || !PR.rects || !PR.rects.length) { ctx.log('HYD  none -- no room on the ground floor for the plant'); return; }
    var nM = U.none ? 0 : Math.max(1, U.nMan || 1);
    var big = bigR(PR);
    var PC = { x: (big.x0 + big.x1) / 2, z: (big.z0 + big.z1) / 2 };
    /* THE UNIT: outside the exterior wall nearest the plant room, walked
       along the outside off a doorway, off a window it would stand in front
       of, off an inside corner (the other wing's facade) and off the terrace */
    var hp0 = (area <= 150) ? H.hp6 : ((area <= 200) ? H.hp8 : H.hp12);
    var oW = (hp0 === H.hp12) ? 1.30 : H.outW, oH = (hp0 === H.hp12) ? 1.40 : H.outH, oD = (hp0 === H.hp12) ? 0.55 : H.outD;
    var SD = PER.sides, NS = SD.length, OPS = [], SEG = [], q9, j9;
    for (q9 = 0; q9 < NS; q9++) OPS.push([]);
    function onSideI(x, z) {
      var b = null, q;
      for (q = 0; q < NS; q++) {
        var S = SD[q], u = Math.max(0, Math.min(S.len, (x - S.a[0]) * S.u[0] + (z - S.a[1]) * S.u[1]));
        var px = S.a[0] + S.u[0] * u, pz = S.a[1] + S.u[1] * u, d = Math.hypot(px - x, pz - z);
        if (!b || d < b.d) b = { side: q, u: u, d: d };
      }
      return b;
    }
    try { SEG = API.segments ? (API.segments() || []) : []; } catch (eSg) { SEG = []; }
    for (q9 = 0; q9 < SEG.length; q9++) {
      var sg = SEG[q9]; if (!sg || !sg.openings || !(sg.len > 0)) continue;
      var sux = (sg.x1 - sg.x0) / sg.len, suz = (sg.z1 - sg.z0) / sg.len;
      for (j9 = 0; j9 < sg.openings.length; j9++) {
        var o9 = sg.openings[j9], ps9 = onSideI(sg.x0 + sux * o9.at, sg.z0 + suz * o9.at), sl9 = _sillOf(env, o9);
        /* a door, or a window whose sill is below the unit's top */
        if (sl9 < H.outY + oH + 0.05) OPS[ps9.side].push({ u: ps9.u, w: o9.w || 0.9, door: sl9 < 0.05 });
      }
    }
    var DK = null;
    try { DK = (typeof env._terraceRect === 'function') ? env._terraceRect() : null; } catch (eDK) { DK = null; }
    function unitAt(s5, u5) { var S = SD[s5], off = through + oD / 2; return { x: S.a[0] + S.u[0] * u5 - S.n[0] * off, z: S.a[1] + S.u[1] * u5 - S.n[1] * off }; }
    var outFace = Math.max(0, through - wt);   /* the outer face, off the outline's axis */
    function unitClear(s5, u5) {
      var S = SD[s5], o5;
      if (u5 < oW / 2 + 0.10 || u5 > S.len - oW / 2 - 0.10) return false;
      if (!PER.rect && PER.outline) {
        /* all of it outside the outline, and the other wing's facade 100 off */
        var c5 = unitAt(s5, u5), hw5 = oW / 2 + outFace + 0.10, k5;
        var dn = [-(oD / 2) + 0.02, oD / 2], du = [-hw5, hw5];
        for (k5 = 0; k5 < 4; k5++) {
          var pu = du[k5 & 1], pn = dn[k5 >> 1];
          if (_ptInPoly(PER.outline, c5.x + S.u[0] * pu - S.n[0] * pn, c5.z + S.u[1] * pu - S.n[1] * pn)) return false;
        }
      }
      for (o5 = 0; o5 < OPS[s5].length; o5++) if (Math.abs(u5 - OPS[s5][o5].u) < OPS[s5][o5].w / 2 + oW / 2 + (OPS[s5][o5].door ? 0.50 : 0.20)) return false;
      if (DK) {
        var c6 = unitAt(s5, u5), alx = Math.abs(S.u[0]) >= Math.abs(S.u[1]), hw6 = alx ? oW / 2 : oD / 2, hd6 = alx ? oD / 2 : oW / 2, m6 = 0.30;
        if (c6.x + hw6 > DK.x0 - m6 && c6.x - hw6 < DK.x1 + m6 && c6.z + hd6 > DK.z0 - m6 && c6.z - hd6 < DK.z1 + m6) return false;
      }
      return true;
    }
    var st0 = onSideI(PC.x, PC.z), UQ = null, d5;
    for (d5 = 0; d5 < 2; d5++) {
      var dir5 = d5 ? -1 : 1, s7 = st0.side, u7 = st0.u, trav = 0, guard = 0;
      while (guard++ < 600 && trav <= 30) {
        if (unitClear(s7, u7)) { if (!UQ || trav < UQ.trav) UQ = { side: s7, u: u7, trav: trav }; break; }
        u7 += dir5 * 0.10; trav += 0.10;
        if (u7 > SD[s7].len || u7 < 0) { s7 = ((s7 + dir5) % NS + NS) % NS; u7 = dir5 > 0 ? 0 : SD[s7].len; }
      }
    }
    var forced = !UQ;
    if (!UQ) UQ = { side: st0.side, u: st0.u, trav: 0 };
    var SQ = SD[UQ.side], En = SQ.n;
    var EP = { k: SQ.k, x: SQ.a[0] + SQ.u[0] * UQ.u, z: SQ.a[1] + SQ.u[1] * UQ.u };
    var UNIT = unitAt(UQ.side, UQ.u);
    /* THE TANK AND THE BUFFER (mep-v17): side by side against a wall of the
       plant room's biggest floor rect, clear of every fitout piece of the
       ground floor (50 off), as near as they get to where the pipes come in */
    var FXR2 = [], i7;
    try {
      var PLf = env._P ? env._P() : null, FXl = (env.STATE && env.STATE.product && env.STATE.product.fixtures) || [];
      for (i7 = 0; i7 < FXl.length; i7++) {
        var fq = FXl[i7]; if (!fq || (fq.st | 0) !== 0) continue;
        var rq = (PLf && PLf.fixtures && PLf.fixtures.rect) ? PLf.fixtures.rect(fq) : null;
        if (rq) FXR2.push(rq);
      }
    } catch (eFx) { FXR2 = []; }
    var pw = H.tankD + 0.10 + H.bufD, pd = H.tankD, TK = null, AW = [1, 0], tkNote = '', w7, u7b;
    var W4 = [{ k: 'z0', c: big.z0, h: true, n: [0, 1] }, { k: 'z1', c: big.z1, h: true, n: [0, -1] }, { k: 'x0', c: big.x0, h: false, n: [1, 0] }, { k: 'x1', c: big.x1, h: false, n: [-1, 0] }];
    var bestP = null;
    for (w7 = 0; w7 < 4; w7++) {
      var Wq = W4[w7], lo7 = Wq.h ? big.x0 : big.z0, hi7 = Wq.h ? big.x1 : big.z1;
      if (hi7 - lo7 < pw + 0.10) continue;
      for (u7b = lo7 + pw / 2 + 0.05; u7b <= hi7 - pw / 2 - 0.05 + 1e-9; u7b += 0.10) {
        var a0 = Wq.c + Wq.n[Wq.h ? 1 : 0] * 0.05, a1 = Wq.c + Wq.n[Wq.h ? 1 : 0] * (pd + 0.05);
        var bx = Wq.h ? { x0: u7b - pw / 2, x1: u7b + pw / 2, z0: Math.min(a0, a1), z1: Math.max(a0, a1) } : { x0: Math.min(a0, a1), x1: Math.max(a0, a1), z0: u7b - pw / 2, z1: u7b + pw / 2 };
        var hitF = false, f7;
        for (f7 = 0; f7 < FXR2.length && !hitF; f7++) {
          var fr7 = FXR2[f7];
          if (bx.x1 > fr7.x0 - 0.05 && bx.x0 < fr7.x1 + 0.05 && bx.z1 > fr7.z0 - 0.05 && bx.z0 < fr7.z1 + 0.05) hitF = true;
        }
        if (hitF) continue;
        var cx7 = (bx.x0 + bx.x1) / 2, cz7 = (bx.z0 + bx.z1) / 2, sc = Math.abs(cx7 - EP.x) + Math.abs(cz7 - EP.z);
        if (!bestP || sc < bestP.sc) bestP = { sc: sc, w: Wq, u: u7b, cx: cx7, cz: cz7 };
      }
    }
    if (bestP) {
      var Wb = bestP.w, ua = [Wb.h ? 1 : 0, Wb.h ? 0 : 1], off = pw / 2 - H.tankD / 2;
      var e1 = { x: bestP.cx - ua[0] * off, z: bestP.cz - ua[1] * off }, e2 = { x: bestP.cx + ua[0] * off, z: bestP.cz + ua[1] * off };
      /* the tank at the end nearer the pipes, the buffer at the other */
      var nearE1 = (Math.abs(e1.x - EP.x) + Math.abs(e1.z - EP.z)) <= (Math.abs(e2.x - EP.x) + Math.abs(e2.z - EP.z));
      TK = nearE1 ? e1 : e2; AW = nearE1 ? ua : [-ua[0], -ua[1]];
      tkNote = 'tank and buffer side by side against its wall ' + Wb.k + ' at ' + TK.x.toFixed(2) + ',' + TK.z.toFixed(2) + ' clear of the fitout';
    } else {
      TK = { x: Math.max(big.x0 + H.tankD / 2 + 0.05, Math.min(big.x1 - H.tankD / 2 - 0.05, EP.x + En[0] * (H.tankD / 2 + 0.05))),
             z: Math.max(big.z0 + H.tankD / 2 + 0.05, Math.min(big.z1 - H.tankD / 2 - 0.05, EP.z + En[1] * (H.tankD / 2 + 0.05))) };
      AW = (Math.abs(En[0]) > 0.5) ? [0, 1] : [1, 0];
      tkNote = '*** NO WALL of the room takes the tank and the buffer clear of the fitout -- put by the wall the pipes come in by, at ' + TK.x.toFixed(2) + ',' + TK.z.toFixed(2);
    }
    var twin = (H.outY + oH / 2) + through + UQ.trav;           /* down the wall from the unit's connections, along it to the plant room, and through it */
    var inWall = 2 * (man(EP, TK) * H.f + 1.0);                  /* flow and return from the wall to the tank */
    var toMan = (nM && U.MP) ? 2 * (man(TK, U.MP) * H.f + 1.2) * nM : 0;
    /* mep-v65: and to storey 2's manifold(s) -- across x 1.2, up the storey, 1.2 up and down the walls */
    var nMU = UP ? Math.max(1, UP.nMan || 1) : 0, riseU = UP ? Math.max(0, UP.y0 - y0) : 0;
    var toUp = (UP && UP.MP) ? 2 * (man(TK, UP.MP) * H.f + riseU + 1.2) * nMU : 0;
    toMan += toUp;
    var p32 = inWall + toMan;
    /* THE COILS: their pipes from the plant */
    var p20 = 0, condL = 0, cNotes = [];
    for (i = 0; i < coils.length; i++) {
      var G = coils[i], rise = Math.max(0, (G.y || y0) - y0);
      var run = 2 * (man(TK, G.coil) * H.f + rise + 0.5);
      p20 += run; condL += rise + 2.0;
      cNotes.push((G.name || ('gallery ' + (i + 1))) + ' ' + m2(G.area) + ' m2: coil at ' + G.coil.x.toFixed(2) + ',' + G.coil.z.toFixed(2) + ', ' + m2(run) + ' m of 20 there and back');
    }
    /* ITS FEED */
    var EL = LAST[env.elecId || ''] || null, feed = 0, feedNote = '';
    if (EL && EL.board && EL.board.x != null) {
      var yCeil = API.wallTop() - 0.02;
      feed = (Math.max(0, yCeil - EL.yBrd) + man(EL.board, EP) * H.f + Math.max(0, yCeil - (y0 + 1.4)) + through + 0.6) * H.extra;
      feedNote = m2(feed) + ' m ' + H.cable + ' from the board (up, across x ' + H.f + ', down to the isolator at 1400, through the wall, +15 %), ' + H.brk + ' 16 A type C, ' + H.iso + ' beside the unit';
    } else feedNote = 'NOT BILLED -- no board from the electrics (' + (env.elecId || 'no elecId') + '), the feed waits for it';
    /* THE BILL */
    var hpN = {}, q;
    for (q = 0; q < hp.length; q++) hpN[hp[q]] = (hpN[hp[q]] || 0) + 1;
    for (q in hpN) if (hpN.hasOwnProperty(q)) _add(LID, q, hpN[q]);
    _add(LID, H.brac, hp.length);
    _add(LID, H.anchor, 4 * hp.length);
    _add(LID, H.twin, m2(twin * hp.length));
    _add(LID, H.tank, 1);
    _add(LID, H.buffer, 1);
    _add(LID, H.divert, 1);
    _add(LID, H.mix, 1);
    _add(LID, H.filter, 1);
    _add(LID, H.valve, 4);
    _add(LID, H.vent, 1);
    _add(LID, H.vessel, 1);
    _add(LID, H.safety, 1);
    _add(LID, H.p32, m2(p32));
    _add(LID, H.ins32, m2(p32));
    if (nM + nMU) _add(LID, H.red, 2 * (nM + nMU));
    if (feed > 0) { _add(LID, H.cable, m2(feed)); _add(LID, H.brk, hp.length); _add(LID, H.iso, hp.length); }
    if (coils.length) {
      _add(LID, H.coil, coils.length);
      _add(LID, H.p20, m2(p20));
      _add(LID, H.ins20, m2(p20));
      _add(LID, H.tee, 2 * coils.length);
      _add(LID, H.siphon, coils.length);
      _add(LID, H.cond, m2(condL));
      _add(LID, H.stat, coils.length);
      _add(LID, H.screw, 2 * coils.length);
    }
    /* THE LOG */
    ctx.log('HYD  heat pump ' + hp.join(' + ') + ' for ' + m2(area) + ' m2 heated (' + m2(U.aT || 0) + ' ground floor loops + ' + (UP ? (m2(upA) + ' storey 2 loops + ') : '') + m2(gArea) + ' galleries with a coil) at ' + H.wPerM2 + ' W a m2 = ' + (Math.round(kW * 10) / 10) +
            ' kW; on ' + H.brac + ' outside wall ' + EP.k + ' by ' + PR.name + ' at ' + UNIT.x.toFixed(2) + ',' + UNIT.z.toFixed(2) + (UQ.trav > 0.05 ? (' (' + m2(UQ.trav) + ' m along the wall, clear of a doorway, a window, an inside corner or the terrace)') : '') + (forced ? ' -- NO CLEAR PLACE within 30 m, put by the plant room all the same' : '') +
            ', ' + (4 * hp.length) + ' x ' + H.anchor + ', ' + m2(twin * hp.length) + ' m ' + H.twin + ' down the wall' + (UQ.trav > 0.05 ? ', along it' : '') + ' and through it');
    ctx.log('HYD  plant in ' + PR.name + ' (' + why + '), ' + tkNote + ': ' + H.tank + ' 250 l tank with coil, ' + H.buffer + ' 50 l buffer, ' + H.divert + ' diverting valve, ' + H.mix + ' mixing valve on the hot water, ' + H.filter + ' filter, 4 x ' + H.valve +
            ', ' + H.vent + ', ' + H.vessel + ' 18 l expansion vessel, ' + H.safety + ' safety group 3 bar; ' + m2(p32) + ' m ' + H.p32 + ' + ' + H.ins32 + ' (' + m2(inWall) + ' wall to tank, ' + m2(toMan - toUp) + ' tank to ' + nM + ' manifold(s)' + (UP ? (', ' + m2(toUp) + ' up to storey 2\'s ' + nMU + ' manifold(s), ' + m2(riseU) + ' m up') : '') + '), ' + (2 * (nM + nMU)) + ' x ' + H.red);
    ctx.log('HYD  feed ' + feedNote);
    ctx.log('HYD  fan coils: ' + (coils.length ? (coils.length + ' x ' + H.coil + ', ' + m2(p20) + ' m ' + H.p20 + ' + ' + H.ins20 + ', ' + (2 * coils.length) + ' x ' + H.tee + ', ' + coils.length + ' x ' + H.siphon + ', ' +
            m2(condL) + ' m ' + H.cond + ', ' + coils.length + ' x ' + H.stat + ' -- ' + cNotes.join('; ')) : 'none') +
            (small.length ? (' | under ' + H.coilMin + ' m2, no coil: ' + small.join(', ')) : '') + (GAL.length ? '' : ' (no gallery handed over)'));

    /* the hot water tank, for the water (mep-v17, env.dhwFrom) */
    LAST[LID] = { tank: { x: TK.x, z: TK.z, name: PR.name, top: H.tankH, d: H.tankD, code: H.tank } };

    /* THE BODIES */
    var T3 = ctx.THREE, g3 = ctx.group;
    if (!T3 || !g3 || !T3.Mesh) return;
    var mag = (typeof env.isNew === 'function') ? !!env.isNew(LID) : false, MAG = env.MAGENTA || 0xFF00FF;
    var asm = (typeof env._asmCode === 'function') ? env._asmCode : null, nB = 0;
    function mat(col, ro, me) { return new T3.MeshStandardMaterial({ color: mag ? MAG : col, roughness: ro, metalness: me }); }
    var mUnit = mat(0xE6E7E8, 0.5, 0.2), mDark = mat(0x3A3D40, 0.6, 0.3), mTank = mat(0xF2F2F0, 0.4, 0.1), mCoil = mat(0xF4F4F2, 0.5, 0.1);
    function box(w, h, d, x, y, z, ry, m, name) {
      var b = new T3.Mesh(new T3.BoxGeometry(w, h, d), m);
      b.position.set(x, y, z); b.rotation.y = ry || 0; b.name = name; b.userData.viz = 'heat'; g3.add(b); nB++; return b;
    }
    function cyl(r, h, x, y, z, m, name) {
      var c3 = new T3.Mesh(new T3.CylinderGeometry(r, r, h, 24), m);
      c3.position.set(x, y, z); c3.name = name; c3.userData.viz = 'heat'; g3.add(c3); nB++; return c3;
    }
    var ry = Math.atan2(En[0], En[1]);
    /* the catalogue's sizes: 6 and 8 kW 1100 x 450 deep x 900 high, 12 kW 1300 x 550 x 1400 */
    var oc = through + oD / 2;
    if (asm) asm(ctx, hp[0], 'top');
    box(oW, oH, oD, EP.x - En[0] * oc, y0 + H.outY + oH / 2, EP.z - En[1] * oc, ry, mUnit, 'hyd-heat-pump');
    box(oW * 0.9, 0.04, oD + 0.05, EP.x - En[0] * oc, y0 + H.outY - 0.02, EP.z - En[1] * oc, ry, mDark, 'hyd-bracket');
    if (asm) asm(ctx, H.tank, 'top');
    cyl(H.tankD / 2, H.tankH, TK.x, y0 + H.tankH / 2, TK.z, mTank, 'hyd-tank');
    var BF = { x: TK.x + AW[0] * (H.tankD / 2 + H.bufD / 2 + 0.10), z: TK.z + AW[1] * (H.tankD / 2 + H.bufD / 2 + 0.10) };
    cyl(H.bufD / 2, H.bufH, BF.x, y0 + 1.2, BF.z, mTank, 'hyd-buffer');
    /* the expansion vessel, red, on the wall over the buffer */
    cyl(0.14, 0.40, BF.x, y0 + 1.75, BF.z, mat(0xC8302C, 0.5, 0.2), 'hyd-vessel');
    if (coils.length && asm) asm(ctx, H.coil, 'top');
    for (i = 0; i < coils.length; i++) {
      var Gc = coils[i].coil;
      box(H.coilW, H.coilH, H.coilD, Gc.x + (Gc.nx || 0) * H.coilD / 2, (coils[i].y || y0) + H.coilH / 2 + 0.10, Gc.z + (Gc.nz || 0) * H.coilD / 2, Math.atan2(Gc.nx || 0, (Gc.nz != null) ? Gc.nz : 1), mCoil, 'hyd-fan-coil');
    }
    ctx.log('HYD  bodies (mep-v16): ' + nB + ' drawn -- the heat pump on its brackets, the tank, the buffer, the red expansion vessel' + (coils.length ? (', ' + coils.length + ' fan coil(s)') : '') + '; the pipes calculated' + (mag ? ' -- MAGENTA (under review)' : ''));
  }

  /* ONLY WITH A BATHROOM (mep-v11, Marek 2026-10-09: "tam kde je koupelna
     room by mely dostat toto vsechno") -- env.onlyWithBath: the shed, the
     sauna and the THOW get the heating, the water and the waste when the
     plan has a bathroom, and none of the three without one. A bathroom is a
     room keyed bathroom, shower or WC (by its name where it has no key) --
     the electrics' wet room. The ADU and RANCH do not set it. */
  function _bathRooms(env) {
    var out = [], PL = null, rooms = [], i;
    try { PL = env._P(); rooms = (PL && PL.rooms) ? (PL.rooms() || []) : []; } catch (eP) { rooms = []; }
    for (i = 0; i < rooms.length; i++) {
      var rm = rooms[i], key = '', nm = '';
      if (!rm || rm.closet) continue;
      try { key = env._roomKey(rm, i) || ''; } catch (eK) { key = ''; }
      try { nm = (PL.roomName ? PL.roomName(rm, i) : env._roomLabel(rm, i)) || ''; } catch (eN) { nm = ''; }
      if (key === 'rooms.bathroom' || key === 'rooms.shower' || key === 'rooms.wc' || (!key && /bath|shower|toilet|wc/i.test(nm))) out.push(nm || key);
    }
    return out;
  }
  /* =========================================================================
     VENTILATION -- BY CALCULATION, ON THE HEATING'S LAYER (mep-v26; the
     barndo first, Marek 2026-10-11: do posledniho sroubku). A product calls
     MepLib.vent(env, ctx) after MepLib.heat with the same env (plus
     _roofPlaneYAt, wallThrough): nothing is reset, the rows join the heating's.
     US practice and the IRC:
       M1505.4.4 / R303.3 EVERY BATHROOM an exhaust fan (80 cfm, ceiling,
         backdraft damper) on its own switch beside the light's, its duct to
         OUTSIDE (M1501.1, never into the attic or a soffit vent): 5 in.
         insulated flex up to a roof cap with a metal-roof flashing boot --
         or, under a lower ceiling (a loft over it, env.ceilLowAt), across the
         joist bay to a wall hood on the nearest exterior wall; foil tape at
         each end, a hanger strap every 4 ft;
       M1503 THE KITCHEN HOOD vented outside: 6 in. rigid galvanized from the
         hood's top straight up to a roof cap (a wall hood under a lower
         ceiling), wrapped in duct insulation where it crosses the attic,
         taped joints, straps;
       M1502 THE DRYER: 4 in. rigid metal duct, joints taped (no screws into
         the airstream), a listed foil transition duct to the dryer, the
         nearest exterior wall to a wall hood with a backdraft damper; the
         developed length (35 ft less 5 ft an elbow) checked;
       R303.4 / M1505.4 WHOLE-HOUSE VENTILATION: exhaust-only, the largest
         bathroom's fan run continuously at the rate of Table M1505.4.3(1)
         (conditioned floor area and bedrooms) on a ventilation control
         instead of its plain switch; where the frost depth says a cold
         climate an HRV is the better pick (a CHECK line).
     Drawn: fans, ducts, caps. Rows the sheet lacks: mep.* pending. Log
     prefix VENT. ========================================================= */
  var VENT = { fan: 'VMM00003', flex: 'VMF01251', r4: 'VMR01001', e4: 'VMR01005', r6: 'VMR01601', e6: 'VMR01602',
               ins: 'VMR00301', tape: 'FEC00033', strap: 'SMC00001', seal: 'FEC00038', screw: 'FAS00225',
               roofCap: 'VMG01002', roofCap6: 'VMG01602', wallCap: 'VMG01001', wallCap6: 'VMG01601', boot: 'VMG01003', dryFlex: 'VMF01001', ctrl: 'VMM00004',
               sw: 'EEL00001', cable: 'EEE00001',
               hang: 4 * 0.3048, strapPer: 0.6, tapeJoint: 0.35, tape6: 0.55, bootScrews: 8, sealPer: 0.25,
               dryMax: 35 * 0.3048, dryElb: 5 * 0.3048, dryFlexM: 1.2, fanCable: 3.5, slack: 1.15,
               hoodY: 2.10, fanOff: 0.50, rFlex: 0.0635, r4R: 0.0508, r6R: 0.0762, coldFrost: 0.60 };
  var VENT_CAT = {
    'VMF01251': { unit: 'm',   label: 'Flexible round duct' },
    'VMR01001': { unit: 'm',   label: 'Round duct' },
    'VMR01005': { unit: 'pcs', label: 'Round elbow BU-100-90' },
    'VMR01601': { unit: 'm',   label: 'Round duct' },
    'VMR01602': { unit: 'pcs', label: 'Round elbow BKU-160-90' },
    'VMR00301': { unit: 'm2',  label: 'Rubber ST thermal insulation' },
    'FEC00033': { unit: 'm',   label: 'Aluminium foil tape' },
    'SMC00001': { unit: 'm',   label: 'Pipe hanger strap' },
    'FEC00038': { unit: 'pcs', label: 'Polyurethane construction sealant' },
    'FAS00225': { unit: 'pcs', label: 'Sealing screws' },
    'EEL00001': { unit: 'pcs', label: 'Light switch' },
    'EEE00001': { unit: 'm',   label: 'Electric cable' }
  };
  var VENT_MADE = {
    'VMM00003':   { unit: 'pcs', label: 'Bathroom exhaust fan 80 cfm, ceiling, with backdraft damper' },
    'VMG01002': { unit: 'pcs', label: 'Exhaust roof cap 4 in. with damper' },
    'VMG01602': { unit: 'pcs', label: 'Exhaust roof cap 6 in. with damper' },
    'VMG01003': { unit: 'pcs', label: 'Metal roof pipe flashing 3-6 in. (EPDM)' },
    'VMG01001': { unit: 'pcs', label: 'Exhaust wall hood 4 in. with damper' },
    'VMG01601': { unit: 'pcs', label: 'Exhaust wall hood 6 in. with damper' },
    'VMF01001': { unit: 'm',   label: 'Dryer transition duct 4 in., listed foil' },
    'VMM00004':  { unit: 'pcs', label: 'Continuous ventilation fan control (whole-house exhaust)' }
  };
  /* IRC Table M1505.4.3(1): cfm by conditioned floor area (sq ft, up to) and bedrooms 0-1, 2-3, 4-5, 6-7, more */
  var VENT_RATE = [[1500, [30, 45, 60, 75, 90]], [3000, [45, 60, 75, 90, 105]], [4500, [60, 75, 90, 105, 120]],
                   [6000, [75, 90, 105, 120, 135]], [7500, [90, 105, 120, 135, 150]], [1e9, [105, 120, 135, 150, 165]]];
  var VENT_NEED = ['API', 'STATE', '_P', '_add', '_buildRect', 'wallThickness'];
  function _buildVent(env, ctx) {
    var LID = env.layerId, API = env.API, STATE = env.STATE, _add = env._add, V = VENT;
    var T = ctx.THREE, g = ctx.group, i, j, k;
    var PL = env._P();
    if (!PL || !PL.rooms) { ctx.log('VENT none -- floorplan asset without rooms'); return; }
    var CAT = env.CATALOG || null, kc;
    if (CAT) {
      for (kc in VENT_CAT) if (VENT_CAT.hasOwnProperty(kc) && !CAT[kc]) CAT[kc] = { code: kc, unit: VENT_CAT[kc].unit, label: VENT_CAT[kc].label };
      for (kc in VENT_MADE) if (VENT_MADE.hasOwnProperty(kc) && !CAT[kc]) CAT[kc] = { code: kc, unit: VENT_MADE[kc].unit, label: VENT_MADE[kc].label };
    }
    var B0 = env._buildRect(), wt = env.wallThickness(), PER = _perim(env, B0, wt);
    var y0 = API.storeys()[0].y0 + ((env.FINISH && env.FINISH.dry) ? env.FINISH.dry.h : 0);
    var yCeil = API.wallTop() - 0.02;
    var through = wt + 0.15;
    try { if (typeof env.wallThrough === 'function') { var tW = +env.wallThrough(); if (tW > 0 && tW < 1) through = tW; } } catch (eTW) {}
    var mag = (typeof env.isNew === 'function') ? env.isNew(LID) : false, MAG = env.MAGENTA;
    function mat(col, rough, metal) { return new T.MeshStandardMaterial({ color: mag ? MAG : col, roughness: rough, metalness: metal }); }
    var mFan = mat(0xF7F7F5, 0.5, 0.0), mFlex = mat(0xC9CCD0, 0.7, 0.2), mRig = mat(0xB8BCC0, 0.4, 0.6), mCap = mat(0x3A3D40, 0.5, 0.3);
    var bill = {}, said = [], warn = [];
    function add(code, n) { if (n) bill[code] = (bill[code] || 0) + n; }
    function m1(v) { return Math.round(v * 10) / 10; }
    function mm(v) { return Math.round(v * 1000); }
    function asm(code) { try { if (env._asmCode) env._asmCode(ctx, code, 'top'); } catch (eA) {} }
    function tube(a, b, r, m, nm) {
      var dx = b[0] - a[0], dy = b[1] - a[1], dz = b[2] - a[2], L = Math.hypot(dx, dy, dz);
      if (!(L > 0.005)) return 0;
      var me = new T.Mesh(new T.CylinderGeometry(r, r, L, 14), m);
      me.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), new T.Vector3(dx / L, dy / L, dz / L));
      me.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2);
      me.name = nm; me.userData.viz = 'heat'; g.add(me);
      return L;
    }
    function path(P, r, m, nm) { var L = 0, q; for (q = 0; q + 1 < P.length; q++) L += tube(P[q], P[q + 1], r, m, nm); return L; }
    function box(cx, cy, cz, w, h, d, m, nm) {
      var me = new T.Mesh(new T.BoxGeometry(w, h, d), m);
      me.position.set(cx, cy, cz); me.name = nm; me.userData.viz = 'heat'; g.add(me);
      return me;
    }
    function roofY(x, z) {
      var y = null;
      try { y = (typeof env._roofPlaneYAt === 'function') ? env._roofPlaneYAt(x, z) : null; } catch (eR) { y = null; }
      return (typeof y === 'number' && isFinite(y) && y > yCeil - 0.5) ? y : (yCeil + 1.2);
    }
    function lowAt(x, z) {
      if (typeof env.ceilLowAt !== 'function') return null;
      var yL = null;
      try { yL = env.ceilLowAt(x, z); } catch (eL) { yL = null; }
      return (typeof yL === 'number' && isFinite(yL) && yL < yCeil - 0.05 && yL > y0 + 1.8) ? yL : null;
    }
    function label(rm, ix) {
      try { return rm.closet ? env._roomLabel(rm, ix) : (PL.roomName ? PL.roomName(rm, ix) : env._roomLabel(rm, ix)); } catch (eN) { return 'room ' + ix; }
    }
    function centroid(rects) {
      var cx = 0, cz = 0, aa = 0, q;
      for (q = 0; q < rects.length; q++) { var r = rects[q], a = (r.x1 - r.x0) * (r.z1 - r.z0); cx += a * (r.x0 + r.x1) / 2; cz += a * (r.z0 + r.z1) / 2; aa += a; }
      return { x: cx / (aa || 1), z: cz / (aa || 1), a: aa };
    }
    /* THE ROOMS: the ground storey's, and the loft's (env.roomsUp + env.storeyY) */
    var RR = [], rooms = PL.rooms() || [];
    for (i = 0; i < rooms.length; i++) {
      var rm = rooms[i]; if (!rm || !rm.rects || !rm.rects.length) continue;
      var nm = label(rm, i), C = centroid(rm.rects);
      var kRR = '';
      try { kRR = (env._roomKey ? env._roomKey(rm, i) : '') || ''; } catch (eKR) { kRR = ''; }
      RR.push({ name: nm, key: kRR, rects: rm.rects, c: C, area: C.a, st: 0, yF: y0, closet: !!rm.closet });
    }
    var yUp = null, upR = [];
    try { yUp = (typeof env.storeyY === 'function') ? env.storeyY(1) : null; } catch (eY) { yUp = null; }
    try { upR = (typeof env.roomsUp === 'function' && yUp != null) ? (env.roomsUp() || []) : []; } catch (eU) { upR = []; }
    for (i = 0; i < upR.length; i++) {
      var ru = upR[i]; if (!ru || !ru.rects || !ru.rects.length) continue;
      var nu = ''; try { nu = env._roomLabel ? env._roomLabel(ru, i) : ''; } catch (eNu) { nu = ''; }
      var Cu = centroid(ru.rects);
      RR.push({ name: nu || ru.name || 'loft room', rects: ru.rects, c: Cu, area: Cu.a, st: 1, yF: yUp, closet: !!ru.closet });
    }
    function wet(r) { return !r.closet && /bath|shower|toilet|wc/i.test(r.name); }
    function cond(r) { return !/garage|workshop|\bshop\b|carport|porch|terrace|deck|patio/i.test(r.name); }

    /* where a duct leaves: up to the roof (a cap and its boot), or -- under a
       lower ceiling -- across the joist bay to the nearest exterior wall (a hood) */
    var TERM = [];   /* mep-v66: the wall hoods placed so far (the HRV's keep off them) */
    function outlet(x, z, yStart, r, m, nm, codeDuct) {
      var yLow = lowAt(x, z), L = 0, kind;
      if (yLow != null && yStart <= yLow + 0.02) {
        var ns = _nearSide(PER, x, z), ex = ns.x - ns.n[0] * through, ez = ns.z - ns.n[1] * through, yB = yLow + 0.15;
        asm(codeDuct);
        L = path([[x, yStart, z], [x, yB, z], [ns.x, yB, z], [ns.x, yB, ns.z], [ex, yB, ez]], r, m, nm);
        var wCap = (r >= V.r6R - 0.001) ? V.wallCap6 : V.wallCap;   /* mep-v29: the hood of the duct's size */
        asm(wCap);
        box(ex - ns.n[0] * 0.04, yB, ez - ns.n[1] * 0.04, 0.22, 0.22, 0.22, mCap, nm + '-hood');
        add(wCap, 1); add(V.seal, V.sealPer); TERM.push([ex, yB, ez]);
        kind = 'a wall hood on ' + ns.k + ' (under the lower ceiling)';
        return { L: L, kind: kind, elb: 3, cap: 'wall' };
      }
      var yR = roofY(x, z);
      asm(codeDuct);
      L = path([[x, yStart, z], [x, yR + V.rFlex, z]], r, m, nm);
      var rCap = (r >= V.r6R - 0.001) ? V.roofCap6 : V.roofCap;   /* mep-v29: the cap of the duct's size on its boot */
      asm(rCap);
      var cap = new T.Mesh(new T.CylinderGeometry(r * 1.6, r * 1.6, 0.16, 16), mCap);
      cap.position.set(x, yR + 0.20, z); cap.name = nm + '-cap'; cap.userData.viz = 'heat'; g.add(cap);
      add(rCap, 1); add(V.boot, 1); add(V.screw, V.bootScrews); add(V.seal, V.sealPer);
      return { L: L, kind: 'a roof cap ' + mm(yR - yStart) + ' above', elb: 0, cap: 'roof', attic: Math.max(0, yR - Math.max(yStart, yCeil)) };
    }

    /* 1. A FAN IN EVERY BATHROOM */
    var fans = [];
    for (i = 0; i < RR.length; i++) {
      var R = RR[i];
      if (!wet(R)) continue;
      var fx = R.c.x + V.fanOff, fz = R.c.z, yF = R.st ? Math.min(roofY(fx, fz) - 0.35, R.yF + 2.40) : (lowAt(fx, fz) != null ? lowAt(fx, fz) : yCeil);
      asm(V.fan);
      box(fx, yF - 0.015, fz, 0.30, 0.03, 0.30, mFan, 'vent-fan');
      /* mep-v55 (RANCH thread, opt-in env.fanLeg): THE 300 THE BILL ADDS FOR
         THE FAN'S COLLAR, DRAWN -- the collar is on the housing's side, so the
         duct leaves it across, over the ceiling toward the room's middle, and
         rises from there (the audit read 2.2 m drawn for 2.8 billed with two
         short ducts). Without it nothing changes. */
      var fxD = fx;
      if (env.fanLeg === true) {
        var sgL = (R.c.x >= fx) ? 1 : -1;
        asm(V.flex);
        tube([fx, yF, fz], [fx + sgL * 0.30, yF, fz], V.rFlex, mFlex, 'vent-bath-duct');
        fxD = fx + sgL * 0.30;
      }
      var O = outlet(fxD, fz, yF, V.rFlex, mFlex, 'vent-bath-duct', V.flex);
      var Lf = O.L + 0.30;
      add(V.fan, 1); add(V.flex, Lf); add(V.tape, 2 * V.tapeJoint);
      add(V.strap, Math.ceil(Lf / V.hang) * V.strapPer);
      add(V.sw, 1); add(V.cable, V.fanCable * V.slack);
      fans.push({ room: R, L: Lf, kind: O.kind, area: R.area });
    }
    if (fans.length) said.push(fans.length + ' bathroom fan(s) VMM00003 (80 cfm, M1505.4.4: 50 needed), each on a switch ' + V.sw + ' beside the light\'s: ' +
                                fans.map(function (f) { return f.room.name + (f.room.st ? (' (' + (env.upName || 'loft') + ')') : '') + ' ' + m1(f.L) + ' m ' + V.flex + ' to ' + f.kind; }).join('; '));
    else warn.push('no bathroom in the plan -- no exhaust fan, and the whole-house ventilation has no fan to run (R303.4)');

    /* 2. THE KITCHEN HOOD */
    /* mep-v39 (env.fxUp): the pieces of storey 2 too, each from its own floor */
    var FXUP = !!env.fxUp && yUp != null;
    var FX = ((STATE.product && STATE.product.fixtures) || []).filter(function (f) { return f && f.kind && (f.st == null || (f.st | 0) === 0 || (FXUP && (f.st | 0) === 1)); });
    function fxY(f) { return (FXUP && f && (f.st | 0) === 1) ? yUp : y0; }
    var catF = (PL.fixtures && PL.fixtures.catalog) ? (PL.fixtures.catalog() || {}) : {};
    function fxSize(f) {
      var D = catF[f.kind] || {}, w = D.w || 0.6, d = D.d || 0.6;
      try { var SZ = PL.fixtures.size ? PL.fixtures.size(f) : null; if (SZ && SZ.w > 0 && SZ.d > 0) { w = SZ.w; d = SZ.d; } } catch (eS) {}
      return { w: w, d: d };
    }
    function fxPt(f, lx, lz) {
      var ro = (f.rot | 0) % 4, cs = Math.cos(ro * Math.PI / 2), sn = Math.sin(ro * Math.PI / 2), mir = f.mirror ? -1 : 1;
      lx *= mir;
      return { x: f.x + (lx * cs - lz * sn), z: f.z + (lx * sn + lz * cs) };
    }
    var hoods = [];
    for (i = 0; i < FX.length; i++) {
      var f = FX[i];
      if (!/^kitchen/.test(f.kind)) continue;
      var S = fxSize(f), LU = (f.kind === 'kitchenL' || f.kind === 'kitchenU'), leg = 0.6;
      var Ph = LU ? fxPt(f, -S.w / 2 + 0.15, S.d / 2 - 0.5) : fxPt(f, S.w / 2 - 0.55, -S.d / 2 + 0.15);
      var yH = fxY(f) + V.hoodY;
      var OH = outlet(Ph.x, Ph.z, yH, V.r6R, mRig, 'vent-hood-duct', V.r6);
      var Lh = OH.L + 0.10, att = OH.attic || 0;
      add(V.r6, Lh); add(V.e6, OH.elb);
      add(V.tape, (Math.ceil(Lh / 1.5) + 1 + OH.elb) * V.tape6);
      add(V.strap, Math.ceil(Lh / V.hang) * V.strapPer);
      if (att > 0.05) add(V.ins, Math.round(att * Math.PI * (2 * V.r6R + 0.05) * 1.10 * 100) / 100);
      hoods.push({ L: Lh, kind: OH.kind, att: att });
    }
    if (hoods.length) said.push(hoods.length + ' kitchen hood duct(s) (M1503) ' + V.r6 + ' 6 in. rigid from the hood\'s top: ' +
                                hoods.map(function (h) { return m1(h.L) + ' m to ' + h.kind + (h.att > 0.05 ? (', ' + m1(h.att) + ' m in the attic wrapped in ' + V.ins) : ''); }).join('; '));

    /* 3. THE DRYER */
    var dryers = [];
    for (i = 0; i < FX.length; i++) {
      var fd = FX[i];
      if (!(fd.kind === 'dryer' || (fd.kind === 'washer' && fd.stack === 'dryer'))) continue;
      var Sd = fxSize(fd), Pd = fxPt(fd, 0, -Sd.d / 2), yD = fxY(fd) + ((fd.kind === 'washer') ? 1.55 : 0.30);
      var ns2 = _nearSide(PER, Pd.x, Pd.z), elb = 1, Ld, kindD;
      if (ns2.d < 4.0) {
        /* to the nearest exterior wall: along the wall it stands at, then out */
        var ex2 = ns2.x - ns2.n[0] * through, ez2 = ns2.z - ns2.n[1] * through;
        asm(V.r4);
        Ld = path([[Pd.x, yD, Pd.z], [ns2.x, yD, Pd.z], [ns2.x, yD, ns2.z], [ex2, yD, ez2]], V.r4R, mRig, 'vent-dryer-duct');
        elb = (Math.abs(ns2.x - Pd.x) > 0.05 && Math.abs(ns2.z - Pd.z) > 0.05) ? 2 : 1;
        asm(V.wallCap);
        box(ex2 - ns2.n[0] * 0.04, yD, ez2 - ns2.n[1] * 0.04, 0.18, 0.18, 0.18, mCap, 'vent-dryer-hood');
        add(V.wallCap, 1); add(V.seal, V.sealPer); TERM.push([ex2, yD, ez2]);
        kindD = 'a wall hood on ' + ns2.k;
      } else {
        var OD = outlet(Pd.x, Pd.z, yD, V.r4R, mRig, 'vent-dryer-duct', V.r4);
        Ld = OD.L; elb = 2 + OD.elb; kindD = OD.kind;
      }
      var dev = Ld + elb * V.dryElb;
      add(V.r4, Ld); add(V.e4, elb); add(V.dryFlex, V.dryFlexM);
      add(V.tape, (Math.ceil(Ld / 1.5) + 1 + 2 * elb) * V.tapeJoint);
      dryers.push({ L: Ld, elb: elb, dev: dev, kind: kindD });
      if (dev > V.dryMax) warn.push('the dryer\'s duct develops ' + m1(dev) + ' m, more than the ' + m1(V.dryMax) + ' m of M1502.4.5.1 -- move the dryer to an exterior wall or use a booster fan');
    }
    if (dryers.length) said.push(dryers.length + ' dryer vent(s) (M1502) ' + V.r4 + ' 4 in. rigid, joints taped, ' + V.dryFlexM + ' m VMF01001 to the dryer: ' +
                                 dryers.map(function (d) { return m1(d.L) + ' m + ' + d.elb + ' x ' + V.e4 + ' to ' + d.kind + ' (developed ' + m1(d.dev) + ' of ' + m1(V.dryMax) + ' m)'; }).join('; '));

    /* 4. WHOLE-HOUSE VENTILATION (R303.4, M1505.4) */
    var aC = 0, nBed = 0;
    for (i = 0; i < RR.length; i++) { if (cond(RR[i])) aC += RR[i].area; if (/bed|kid|guest|nursery|sleep/i.test(RR[i].name)) nBed++; }
    var ft2 = aC / 0.09290304, row = VENT_RATE[0][1];
    for (i = 0; i < VENT_RATE.length; i++) if (ft2 <= VENT_RATE[i][0]) { row = VENT_RATE[i][1]; break; }
    var cfm = row[Math.min(4, Math.floor(nBed / 2))];
    /* mep-v27 (env.hrvCold, BARNDO thread): A COLD CLIMATE GETS A BALANCED
       HEAT RECOVERY VENTILATOR in place of exhaust-only -- where the product
       asks for it and the ground freezes V.coldFrost deep or more (the
       IECC's cold zones, where exhaust-only pulls -20 deg air through the
       envelope). The unit VMM00001 high in the laundry (else the largest
       service room); fresh air in and stale air out through two hoods
       VME01602 on the nearest exterior wall 3 m apart, 6 in. ducts VMR01601
       insulated; from it, in the attic over the ceiling, a 4 in. branch
       VMR01001 to a ceiling diffuser VMA01002 in every bedroom and living
       room and from an extract valve VME01001 in every bathroom, the
       kitchen and the laundry -- each branch off its side's 6 in. header on
       a branch tee VMR01608 and a reducer VMR01254, two elbows VMR01005; a
       silencer VMS01601 on each side; every duct in the attic insulated
       VMR00301; the condensate to the laundry's drain (HMC00161); a 120 V
       feed and its wall control (VMM00004). The bathroom fans stay as
       the local exhaust, on their switches. */
    var frH = null;
    try { frH = (typeof env.frostDepth === 'function') ? env.frostDepth() : null; } catch (eFH) { frH = null; }
    var HRV = !!env.hrvCold && frH != null && frH >= V.coldFrost;
    /* mep-v66 (TWO STORY thread, opt-in): env.hrvAlways -- the HRV in every
       climate (a European house has it as a matter of course); env.hrvBetween
       -- a house lived in on both storeys: the unit in the ground floor's
       technical room (else laundry / utility), its two ducts out through
       that room's wall, every branch in the floor between: down through the
       ground ceiling to a diffuser / valve, up through storey 2's floor to a
       floor outlet; inside the envelope, so not lagged */
    var HRVA = !HRV && !!env.hrvAlways;
    if (HRVA) HRV = true;
    var BTW = HRV && !!env.hrvBetween && yUp != null;
    /* mep-v42 (env.hrvUp, GARAGE APARTMENT thread): the dwelling is storey 2
       -- the unit goes into a room up there (its laundry first), its two 6 in.
       ducts straight out through that room's nearest exterior wall at the
       unit's height, the branches in the attic over storey 2's ceiling to its
       rooms only (the garage below is no part of it) */
    var HRVUP = HRV && !BTW && !!env.hrvUp && yUp != null;
    if (HRV) {
      var hU = null, hS = 0, rq;
      for (rq = 0; rq < RR.length; rq++) {
        var Rq = RR[rq];
        if (BTW) {
          /* mep-v66: the service room on either storey (the ground's first),
             a store next, the stair hall the last resort (its hole) */
          if (Rq.closet) continue;
          var scB = /technic|container_room_6|laundry|utility|mechanical|mud/i.test(Rq.name + ' ' + (Rq.key || '')) ? 3 : (/pantry|storage/i.test(Rq.name) ? 2 : (/hall/i.test(Rq.name) ? 1 : 0));
          if (scB && !Rq.st) scB += 0.5;
          if (scB > hS || (scB === hS && scB > 0 && hU && Rq.area > hU.area)) { hS = scB; hU = Rq; }
          continue;
        }
        if ((HRVUP ? !Rq.st : Rq.st) || (Rq.closet && !HRVUP)) continue;
        var sc = /laundry|utility|mechanical|mud/i.test(Rq.name) ? 3 : (/pantry|storage|hall/i.test(Rq.name) ? 2 : 0);
        if (sc > hS || (sc === hS && sc > 0 && hU && Rq.area > hU.area)) { hS = sc; hU = Rq; }
      }
      if (!hU) for (rq = 0; rq < RR.length; rq++) if ((HRVUP ? RR[rq].st : !RR[rq].st) && !RR[rq].closet && cond(RR[rq]) && (!hU || RR[rq].area > hU.area)) hU = RR[rq];
      if (!hU) warn.push('no room for the heat recovery ventilator -- exhaust-only kept');
      else {
        var ux = hU.c.x, uz = hU.c.z, yU = yCeil - 0.30, yD = yCeil + 0.25, mHrv = mat(0xE8E8E4, 0.6, 0.1), mIns = mat(0x9AA0A6, 0.8, 0.0);
        if (HRVUP) { var yCu = Math.min(roofY(ux, uz) - 0.35, hU.yF + 2.40); yU = yCu - 0.30; yD = yCu + 0.25; }
        /* mep-v66: in the floor between -- the unit 300 under the ground ceiling,
           300 off the room's exterior wall, the branches 120 into the floor's depth */
        var yGB = null, hT0 = null, hT1 = null, uW = 0.76, uD = 0.46;
        if (BTW) {
          var nsU = _nearSide(PER, ux, uz);
          ux = nsU.x + nsU.n[0] * 0.30; uz = nsU.z + nsU.n[1] * 0.30;
          yGB = lowAt(ux, uz); if (yGB == null) yGB = (yUp != null) ? yUp - 0.30 : yCeil;
          /* on the ground: hung 300 under its ceiling; upstairs (a laundry
             there): on its wall, its centre 1.60 over the floor, the branches
             down into the floor between */
          yU = hU.st ? hU.yF + 1.60 : yGB - 0.30; yD = yGB + 0.12;
          /* the room's reach along that wall (its rects on the wall): the two
             hoods go straight out of the room where they land on its wall */
          var tU0 = -nsU.n[1], tU1 = nsU.n[0], qT;
          for (qT = 0; qT < (hU.rects || []).length; qT++) {
            var rT = hU.rects[qT], cT = [[rT.x0, rT.z0], [rT.x1, rT.z0], [rT.x0, rT.z1], [rT.x1, rT.z1]], dMin = 1e9, tA = 1e9, tB = -1e9, cq;
            for (cq = 0; cq < 4; cq++) {
              var dxT = cT[cq][0] - nsU.x, dzT = cT[cq][1] - nsU.z;
              dMin = Math.min(dMin, dxT * nsU.n[0] + dzT * nsU.n[1]);
              var tT = dxT * tU0 + dzT * tU1; tA = Math.min(tA, tT); tB = Math.max(tB, tT);
            }
            if (dMin > 0.30) continue;
            hT0 = (hT0 == null) ? tA : Math.min(hT0, tA); hT1 = (hT1 == null) ? tB : Math.max(hT1, tB);
          }
          if (Math.abs(nsU.n[0]) > 0.5) { uW = 0.46; uD = 0.76; }   /* its long side along the wall */
        }
        asm('VMM00001');
        box(ux, yU, uz, uW, 0.40, uD, mHrv, 'vent-hrv');
        add('VMM00001', 1); add('VMS01601', 2);
        /* the two hoods on the nearest exterior wall, 3 m apart along it */
        var nsH = _nearSide(PER, ux, uz), tx = -nsH.n[1], tz = nsH.n[0], LH = 0, hq, nOutB = 0, shP = [-1.5, 1.5], dTm = null;
        if (BTW) {
          /* mep-v66: the pair 3 m apart along the wall that keeps 3 m off the
             other wall hoods (the hood, the dryer, a fan), nearest the unit
             first; else the one farthest from them */
          var wT0 = -1e9, wT1 = 1e9;
          if (PER.rect) {
            var INw = PER.IN, eW0, eW1;
            if (Math.abs(nsH.n[0]) > 0.5) { eW0 = (INw.z0 - nsH.z) * tz; eW1 = (INw.z1 - nsH.z) * tz; }
            else { eW0 = (INw.x0 - nsH.x) * tx; eW1 = (INw.x1 - nsH.x) * tx; }
            wT0 = Math.min(eW0, eW1); wT1 = Math.max(eW0, eW1);
          } else if (nsH.side != null && PER.sides[nsH.side]) {
            var Sw = PER.sides[nsH.side], eS0 = (Sw.a[0] - nsH.x) * tx + (Sw.a[1] - nsH.z) * tz, eS1 = eS0 + (Sw.u[0] * tx + Sw.u[1] * tz) * Sw.len;
            wT0 = Math.min(eS0, eS1); wT1 = Math.max(eS0, eS1);
          }
          var CAND = [[-1.5, 1.5], [0, 3], [-3, 0], [1.5, 4.5], [-4.5, -1.5], [3, 6], [-6, -3]], bS = -1, cq2;
          for (cq2 = 0; cq2 < CAND.length; cq2++) {
            var Cc = CAND[cq2];
            if (Cc[0] < wT0 + 0.45 || Cc[1] > wT1 - 0.45) continue;
            var dH = [1e9, 1e9], hc, tq;
            for (hc = 0; hc < 2; hc++) {
              var inR = hT0 != null && Cc[hc] > hT0 + 0.30 && Cc[hc] < hT1 - 0.30, yHc = inR ? yU : yGB + 0.28;
              for (tq = 0; tq < TERM.length; tq++) dH[hc] = Math.min(dH[hc], Math.hypot(nsH.x + tx * Cc[hc] - TERM[tq][0], yHc - TERM[tq][1], nsH.z + tz * Cc[hc] - TERM[tq][2]));
            }
            /* the intake the hood farther off them, 3 m; the exhaust clear of them */
            var scC = (Math.min(dH[0], dH[1]) >= 0.6) ? Math.max(dH[0], dH[1]) : Math.min(dH[0], dH[1]) - 10;
            if (scC >= 3.0) { shP = Cc; dTm = scC; break; }
            if (scC > bS) { bS = scC; shP = Cc; dTm = scC; }
          }
          if (dTm != null && dTm < 3.0) warn.push('the heat recovery ventilator\'s fresh air intake ' + (dTm > 0 ? m1(dTm) : 'under 0.6') + ' m off the nearest other wall hood (the kitchen\'s, the dryer\'s or a fan\'s) -- CHECK: 3 m (10 ft, R303.5.1)');
        }
        for (hq = 0; hq < 2; hq++) {
          var sh = shP[hq], hx = nsH.x + tx * sh, hz = nsH.z + tz * sh, ex3 = hx - nsH.n[0] * through, ez3 = hz - nsH.n[1] * through;
          var yH9 = (HRVUP || BTW) ? yU : yD;   /* mep-v42: out through the room's wall at the unit's height (mep-v66: and from the technical room) */
          asm('VMR01601');
          if (BTW && !(hT0 != null && sh > hT0 + 0.30 && sh < hT1 - 0.30)) {
            /* mep-v66: a hood beyond the room's own wall (3 m apart, the
               room's wall shorter): its duct up / down into the floor between,
               over the branches, and out through the wall there -- the hood on
               the facade between the storeys */
            var yO = yGB + 0.28, hxI = hx + nsH.n[0] * 0.30, hzI = hz + nsH.n[1] * 0.30;
            yH9 = yO; nOutB++;
            LH += path([[ux, hU.st ? yU - 0.20 : yU + 0.20, uz], [ux, yO, uz], [hxI, yO, hzI], [ex3, yO, ez3]], V.r6R + 0.03, mIns, 'vent-hrv-outside');
          } else
          LH += (HRVUP || BTW) ? path([[ux, yU, uz], [hx, yU, uz], [hx, yU, hz], [ex3, yU, ez3]], V.r6R + 0.03, mIns, 'vent-hrv-outside')
                      : path([[ux, yU + 0.20, uz], [ux, yD, uz], [hx, yD, uz], [hx, yD, hz], [ex3, yD, ez3]], V.r6R + 0.03, mIns, 'vent-hrv-outside');
          asm('VME01602');
          box(ex3 - nsH.n[0] * 0.05, yH9, ez3 - nsH.n[1] * 0.05, 0.24, 0.24, 0.12, mCap, 'vent-hrv-hood');
          add('VME01602', 1); add(V.seal, V.sealPer);
        }
        add('VMR01601', LH); add(V.e6, 6);
        /* the branches */
        var sup = [], ext = [], kitR = null;
        for (rq = 0; rq < FX.length; rq++) if (/^kitchen/.test(FX[rq].kind)) { kitR = FX[rq]; break; }
        for (rq = 0; rq < RR.length; rq++) {
          var Rb = RR[rq];
          if (Rb.closet || !cond(Rb) || Rb === hU) continue;
          if (HRVUP && !Rb.st) {
            /* mep-v47: a lived-in room of the ground floor (env.headRoom) gets
               its supply down through the floor between */
            var HRv = false;
            try { HRv = (typeof env.headRoom === 'function') && !!env.headRoom(Rb.key || '', Rb.name); } catch (eHv) { HRv = false; }
            if (HRv && !wet(Rb)) { Rb.down = true; sup.push(Rb); }
            continue;   /* mep-v42: the dwelling's rooms only */
          }
          if (wet(Rb) || /kitchen|laundry/i.test(Rb.name)) ext.push(Rb);
          else if (/bed|kid|guest|nursery|living|family|great|dining|office|den|media|loft|study/i.test(Rb.name)) sup.push(Rb);
        }
        if (kitR && !ext.some(function (r) { return /kitchen/i.test(r.name); })) ext.push({ name: 'the kitchen', c: { x: kitR.x, z: kitR.z }, st: (FXUP && (kitR.st | 0) === 1) ? 1 : 0, yF: fxY(kitR), kitchen: true });
        if (hU && (/laundry/i.test(hU.name) || (BTW && /technic|container_room_6/i.test(hU.name + ' ' + (hU.key || ''))))) ext.push(hU);
        var Lb = 0, nB = 0, att = LH;
        var nDown = 0, LDown = 0;
        var nUpB = 0, nRiseB = 0, nHoleB = 0;
        /* mep-v66: a branch in the floor between keeps off the stair's hole
           (no ceiling there: env.ceilLowAt null) -- x first or z first,
           whichever crosses it less */
        function holeHits(P) {
          if (typeof env.ceilLowAt !== 'function') return 0;
          var hN = 0, qh, k;
          for (qh = 1; qh + 1 < P.length; qh++) {
            var a = P[qh], b = P[qh + 1];
            if (Math.abs(a[1] - b[1]) > 0.01) continue;
            var Lh = Math.hypot(b[0] - a[0], b[2] - a[2]), nS = Math.max(1, Math.ceil(Lh / 0.20));
            for (k = 0; k <= nS; k++) { var xh = a[0] + (b[0] - a[0]) * k / nS, zh = a[2] + (b[2] - a[2]) * k / nS; if (lowAt(xh, zh) == null) hN++; }
          }
          return hN;
        }
        function btwPath(x2, z2, yEnd) {
          var yS = hU.st ? yU - 0.20 : yU + 0.20,
              PA = [[ux, yS, uz], [ux, yD, uz], [x2, yD, uz], [x2, yD, z2], [x2, yEnd, z2]],
              PB = [[ux, yS, uz], [ux, yD, uz], [ux, yD, z2], [x2, yD, z2], [x2, yEnd, z2]];
          var hA = holeHits(PA), hB = hA ? holeHits(PB) : 0;
          if (hA && hB < hA) { if (hB) nHoleB++; return PB; }
          if (hA) nHoleB++;
          return PA;
        }
        function branch(Rr, code, nmB) {
          var bx = Rr.c.x, bz = Rr.c.z, yE = Rr.st ? Math.min(roofY(bx, bz) - 0.35, Rr.yF + 2.40) : (lowAt(bx, bz) != null ? lowAt(bx, bz) : yCeil);
          if (BTW) {
            /* mep-v66: in the floor between -- down to the ground room's
               ceiling, or up to a floor outlet in storey 2's room */
            asm('VMR01001');
            var yLo = lowAt(bx, bz), yT = Rr.st ? Rr.yF : (yLo != null ? yLo : yGB), LB;
            if (Rr.st && code === 'VME01001' && Rr.rects && Rr.rects.length) {
              /* an extract upstairs (a bathroom, a WC): up in the room's corner
                 nearest the unit (boxed in) to a valve on its ceiling */
              var rK = Rr.rects[0], qK, cxK, czK, dK = 1e9;
              for (qK = 0; qK < Rr.rects.length; qK++) {
                var rr = Rr.rects[qK], xs = [rr.x0 + 0.12, rr.x1 - 0.12], zs = [rr.z0 + 0.12, rr.z1 - 0.12], a1, b1;
                for (a1 = 0; a1 < 2; a1++) for (b1 = 0; b1 < 2; b1++) {
                  var dd = Math.abs(xs[a1] - ux) + Math.abs(zs[b1] - uz);
                  if (dd < dK) { dK = dd; cxK = xs[a1]; czK = zs[b1]; }
                }
              }
              LB = path(btwPath(cxK, czK, yE), V.r4R, mFlex, nmB);
              asm(code);
              box(cxK, yE - 0.012, czK, 0.20, 0.025, 0.20, mFan, nmB + '-grille');
              add(code, 1); Lb += LB; nB++; nRiseB++;
              return;
            }
            var gW = 0.30, gD = 0.12;
            if (Rr.st && Rr.rects) {
              /* a floor outlet up there by the room's exterior wall (under its
                 window), 250 off it -- where it lands in the room */
              var nsF = _nearSide(PER, bx, bz), fxF = nsF.x + nsF.n[0] * 0.25, fzF = nsF.z + nsF.n[1] * 0.25, inF = false, qF;
              for (qF = 0; qF < Rr.rects.length; qF++) { var rF = Rr.rects[qF]; if (fxF > rF.x0 + 0.15 && fxF < rF.x1 - 0.15 && fzF > rF.z0 + 0.15 && fzF < rF.z1 - 0.15) inF = true; }
              if (inF) { bx = fxF; bz = fzF; if (Math.abs(nsF.n[0]) > 0.5) { gW = 0.12; gD = 0.30; } }
            }
            LB = path(btwPath(bx, bz, yT), V.r4R, mFlex, nmB);
            asm(code);
            if (Rr.st) { box(bx, yT + 0.004, bz, gW, 0.008, gD, mFan, nmB + '-floor-grille'); nUpB++; }
            else box(bx, yT - 0.012, bz, 0.20, 0.025, 0.20, mFan, nmB + '-grille');
            /* the floor outlet is no ceiling diffuser: its own row, pending */
            add((Rr.st && code === 'VMA01002') ? 'mep.floorOutlet' : code, 1); Lb += LB; nB++;
            return;
          }
          asm('VMR01001');
          if (Rr.down && HRVUP) {
            /* mep-v47: down from the unit through storey 2's floor, across in the
               floor between (inside the envelope: no attic, no lagging), out of
               the ground room's ceiling */
            var yFb = hU.yF - 0.22;
            var L8 = path([[ux, yU - 0.20, uz], [ux, yFb, uz], [bx, yFb, uz], [bx, yFb, bz], [bx, yE, bz]], V.r4R, mFlex, nmB);
            asm(code);
            box(bx, yE - 0.012, bz, 0.20, 0.025, 0.20, mFan, nmB + '-grille');
            add(code, 1); Lb += L8; nB++; nDown++; LDown += L8;
            return;
          }
          var L9 = path([[ux, yU + 0.20, uz], [ux, yD, uz], [bx, yD, uz], [bx, yD, bz], [bx, yE, bz]], V.r4R, mFlex, nmB);
          asm(code);
          box(bx, yE - 0.012, bz, 0.20, 0.025, 0.20, mFan, nmB + '-grille');
          add(code, 1); Lb += L9; nB++; att += Math.max(0, L9 - Math.max(0, yE - yU));
        }
        for (rq = 0; rq < sup.length; rq++) branch(sup[rq], 'VMA01002', 'vent-hrv-supply');
        for (rq = 0; rq < ext.length; rq++) branch(ext[rq], 'VME01001', 'vent-hrv-extract');
        if (BTW && nHoleB) warn.push(nHoleB + ' heat recovery branch(es) in the floor between cross the stair\'s hole either way round -- CHECK their route');
        add('VMR01001', Lb); add('VMR01005', 2 * nB); add('VMR01608', nB); add('VMR01254', nB);
        add(V.tape, (nB * 4 + 8) * V.tapeJoint);
        add(V.strap, Math.ceil((Lb + LH) / V.hang) * V.strapPer);
        add(V.ins, Math.round(att * Math.PI * (2 * V.r4R + 0.06) * 1.10 * 100) / 100);
        add('HMC00161', 2.0);
        add(V.ctrl, 1); add(V.cable, (V.fanCable + 3.0) * V.slack);
        said.push('whole-house ventilation (R303.4, M1505.4): a balanced heat recovery ventilator VMM00001 ' + (HRVA ? 'in every climate (env.hrvAlways, mep-v66)' : ('for a cold climate (frost ' + mm(frH) + ' mm, env.hrvCold)')) + ' in ' + hU.name +
                  (BTW ? (' (env.hrvBetween, mep-v66: ' + (hU.st ? 'storey 2, on its exterior wall 1.60 over the floor' : '300 under the ground ceiling on its exterior wall') + ', the two ducts out through that wall, every branch in the floor between -- ' + nUpB + ' up through storey 2\'s floor to a floor outlet by the exterior wall, ' + nRiseB + ' extract(s) up there up a riser in the room\'s corner to a ceiling valve (CHECK: the riser boxed in, not billed), the rest down to the ground ceiling; inside the envelope, not lagged; CHECK the holes through the joists\' webs and the floor outlets\' grille)') : '') +
                  (HRVUP ? (' (storey 2, env.hrvUp: high on its wall ' + mm(yU - hU.yF) + ' over its floor, the ducts out through its wall, the branches in the attic over its ceiling)') : '') +
                  ' -- ' + cfm + ' cfm continuous needed (Table M1505.4.3(1): ' + Math.round(ft2) + ' sq ft, ' + nBed + ' bedroom(s)); 2 x VME01602 on ' + nsH.k + ' 3 m apart' + ((BTW && dTm != null && dTm < 1e8) ? (', the fresh air intake the one ' + m1(Math.max(0, dTm)) + ' m off the other wall hoods') : '') + (nOutB ? (' (' + nOutB + ' beyond ' + hU.name + '\'s own wall: its duct in the floor between, the hood between the storeys, mep-v66)') : '') + ', ' + m1(LH) + ' m VMR01601 6 in. insulated to them; ' +
                  sup.length + ' supply diffuser(s) VMA01002' + (nUpB ? (' (' + nUpB + ' of them floor outlets, mep.floorOutlet PENDING)') : '') + ' (' + sup.map(function (r) { return r.name; }).join(', ') + '), ' + ext.length + ' extract valve(s) VME01001 (' + ext.map(function (r) { return r.name; }).join(', ') + '), ' +
                  m1(Lb) + ' m VMR01001 4 in. ' + (BTW ? 'in the floor between' : 'in the attic') + (nDown ? (' (of it ' + m1(LDown) + ' m down through the floor between to ' + nDown + ' ground room(s), env.headRoom, mep-v47)') : '') + ', ' + nB + ' x VMR01608 + VMR01254, ' + (2 * nB) + ' x VMR01005, 2 x VMS01601; insulation ' + V.ins + ' on ' + m1(att) + ' m; condensate 2 m HMC00161; control VMM00004');
        if (CAT) {
          var HC = { 'VMM00001': ['pcs', 'Ventilation unit with heat recovery'], 'VME01602': ['pcs', 'Exhaust / fresh air intake device 160'], 'VMA01002': ['pcs', 'Air diffuser 100'],
                     'VME01001': ['pcs', 'Extract valve 100'], 'VMR01608': ['pcs', 'Round branch 160 / 125'], 'VMR01254': ['pcs', 'Round reducer 125 / 100'],
                     'VMS01601': ['pcs', 'Silencer 160'], 'HMC00161': ['m', 'Condensate drain hose 16'] }, kh;
          for (kh in HC) if (HC.hasOwnProperty(kh) && !CAT[kh]) CAT[kh] = { code: kh, unit: HC[kh][0], label: HC[kh][1] };
          if (BTW && nUpB && !CAT['mep.floorOutlet']) CAT['mep.floorOutlet'] = { code: null, pending: true, unit: 'pcs', label: 'Floor air outlet 100 with its plenum box and a walk-on linear grille (pending row)' };
        }
      }
    }
    if (fans.length && !(HRV && bill.VMM00001)) {
      var big = fans.slice().sort(function (a, b) { return b.area - a.area; })[0];
      add(V.ctrl, 1); add(V.sw, -1); big.ctrl = true;
      said.push('whole-house ventilation (R303.4, M1505.4): exhaust-only, ' + cfm + ' cfm continuous (Table M1505.4.3(1): ' + Math.round(ft2) + ' sq ft conditioned, ' + nBed + ' bedroom(s)) through the ' +
                big.room.name + ' fan on a control VMM00004 instead of its switch');
      var fr = null;
      try { fr = (typeof env.frostDepth === 'function') ? env.frostDepth() : null; } catch (eF) { fr = null; }
      if (fr != null && fr >= V.coldFrost) warn.push('a cold climate (frost ' + mm(fr) + '): a heat recovery ventilator (VMM00001) is the better pick than exhaust-only -- the owner\'s call');
    }
    /* mep-v57 (RANCH thread, opt-in env.pieceTags): EVERY FAN'S SWITCH DRAWN
       as billed -- beside the light's, the bathroom's switch box's next gang
       (the electrics hand their switches on); the fan on the whole-house
       control has the control there instead */
    if (env.pieceTags === true && fans.length) {
      var ELs = LAST[env.elecId || ''] || null, SWs = (ELs && ELs.switches) || null, nG = 0, noG = [];
      for (i = 0; i < fans.length; i++) {
        var Fg = fans[i], Sg = _swAt(SWs, Fg.room.c.x, Fg.room.c.z, true);
        if (!Sg || Fg.room.st) { noG.push(Fg.room.name); continue; }
        asm(Fg.ctrl ? V.ctrl : V.sw);
        _gang(T, g, Sg, mFan, Fg.ctrl ? 'vent-fan-control' : 'vent-fan-switch', 'heat');
        nG++;
      }
      said.push('the fans\' switches drawn (mep-v57): ' + nG + ' gang(s) in the bathrooms\' switch boxes' + (noG.length ? ('; not drawn (no switch of the electrics to share): ' + noG.join(', ')) : ''));
    }
    if (bill[V.seal]) bill[V.seal] = Math.ceil(bill[V.seal] - 1e-9);   /* whole cartridges */
    for (kc in bill) if (bill.hasOwnProperty(kc)) _add(LID, kc, Math.round(bill[kc] * 100) / 100);
    ctx.log('VENT ventilation (mep-v27): ' + said.length + ' group(s), drawn (fans, ducts, caps), quantities by calculation');
    for (i = 0; i < said.length; i++) ctx.log('VENT ' + said[i]);
    var pend = Object.keys(bill).filter(function (k9) { return /^mep\./.test(k9); });
    if (pend.length) ctx.log('VENT pending (no sheet row yet): ' + pend.join(', '));
    for (i = 0; i < warn.length; i++) ctx.log('VENT CHECK ' + warn[i]);
  }

  function _bathGate(env, ctx, tag, what) {
    if (!env.onlyWithBath) return true;
    var B = _bathRooms(env);
    if (B.length) {
      ctx.log(tag + ' ' + B.length + ' bathroom(s) in the plan (' + B.join(', ') + '): this product gets the ' + what + ' with one (onlyWithBath)');
      return true;
    }
    ctx.log(tag + ' none -- no bathroom, shower or WC in the plan: this product gets heating, water and waste only with one (onlyWithBath, Marek 2026-10-09)');
    env._billReset(env.layerId);
    return false;
  }

  /* mep-v65 (TWO STORY thread): THE TOWEL RAILS OF A HYDRONIC HOUSE
     (env.hydroRails). The floor heats every bathroom; each also gets the
     electric towel rail TWR (as the multi-split gives it), on the longest
     stretch of its walls clear of its doors by 200 and of the corners,
     600 over its floor; its feed half the room's perimeter off the bathroom
     circuit (+15 %), four screws. Rooms are the floor loops' own (U.R,
     U.up.R), so a closet is never one. */
  function _hydroRails(env, ctx, U) {
    var LID = env.layerId, _add = env._add, CATALOG = env.CATALOG, i, j, k;
    function m2(v) { return Math.round(v * 100) / 100; }
    function mm(v) { return Math.round(v * 1000); }
    if (CATALOG && !CATALOG[TWR.code]) CATALOG[TWR.code] = { code: TWR.code, unit: 'pcs', label: 'Electric towel rail 400 W' };
    var RW = 0.50, RH = 1.10, RB = 0.60, RD = 0.07, out = [], feed = 0, n = 0;
    var T3 = ctx.THREE, g3 = ctx.group, mRail = null;
    if (T3 && g3 && T3.Mesh) mRail = new T3.MeshStandardMaterial({ color: (typeof env.isNew === 'function' && env.isNew(LID)) ? (env.MAGENTA || 0xFF00FF) : 0xF4F4F2, roughness: 0.35, metalness: 0.4 });
    var sets = [{ U: U, st: 1 }];
    if (U.up && !U.up.none) sets.push({ U: U.up, st: 2 });
    for (k = 0; k < sets.length; k++) {
      var UX = sets[k].U, E = UX.env || env, ST = E.STATE || {}, parts = ST.parts || [], drs = ST.doors || [], DO = [];
      for (i = 0; i < drs.length; i++) {
        var d = drs[i], pp = null;
        for (j = 0; j < parts.length; j++) if (parts[j] && parts[j].id === d.pid) pp = parts[j];
        if (!pp) continue;
        var vv = (pp.dir || pp.o) === 'v', pc = (pp.at != null) ? pp.at : pp.c;
        DO.push({ vert: vv, c: pc, u: d.u, w: d.w || 0.9 });
      }
      for (i = 0; i < (UX.R || []).length; i++) {
        var Rm = UX.R[i];
        if (!Rm || Rm.skip || Rm.closet || !/bath|shower/i.test((Rm.key || '') + ' ' + (Rm.name || ''))) continue;
        var b = null, bA = -1;
        for (j = 0; j < Rm.rects.length; j++) { var q = Rm.rects[j], a = (q.x1 - q.x0) * (q.z1 - q.z0); if (a > bA) { bA = a; b = q; } }
        if (!b) continue;
        n++;
        var half = (b.x1 - b.x0) + (b.z1 - b.z0);
        feed += half;
        var E4 = [{ h: true, c: b.z0, lo: b.x0, hi: b.x1, nx: 0, nz: 1, w: b.wz0 }, { h: true, c: b.z1, lo: b.x0, hi: b.x1, nx: 0, nz: -1, w: b.wz1 },
                  { h: false, c: b.x0, lo: b.z0, hi: b.z1, nx: 1, nz: 0, w: b.wx0 }, { h: false, c: b.x1, lo: b.z0, hi: b.z1, nx: -1, nz: 0, w: b.wx1 }], best = null, e;
        for (e = 0; e < 4; e++) {
          var ed = E4[e];
          if (!ed.w) continue;
          var free = [{ a: ed.lo + 0.20, b: ed.hi - 0.20 }], dq;
          for (dq = 0; dq < DO.length; dq++) {
            var D = DO[dq];
            if (D.vert === ed.h || Math.abs(D.c - ed.c) > 0.15) continue;
            var oa = D.u - D.w / 2 - 0.20, ob = D.u + D.w / 2 + 0.20, kept = [], f;
            for (f = 0; f < free.length; f++) {
              if (ob <= free[f].a || oa >= free[f].b) { kept.push(free[f]); continue; }
              if (oa > free[f].a) kept.push({ a: free[f].a, b: oa });
              if (ob < free[f].b) kept.push({ a: ob, b: free[f].b });
            }
            free = kept;
          }
          for (dq = 0; dq < free.length; dq++) { var L = free[dq].b - free[dq].a; if (L >= RW + 0.10 && (!best || L > best.len)) best = { len: L, mid: (free[dq].a + free[dq].b) / 2, ed: ed }; }
        }
        if (!best) { out.push(Rm.name + ' (storey ' + sets[k].st + '): NOT DRAWN -- no wall holds ' + mm(RW + 0.10) + ' mm clear of its doors (still billed)'); continue; }
        var ex = best.ed.h ? best.mid : best.ed.c, ez = best.ed.h ? best.ed.c : best.mid;
        out.push(Rm.name + ' (storey ' + sets[k].st + '): on its wall at ' + ex.toFixed(2) + ',' + ez.toFixed(2) + ', ' + mm(best.len) + ' mm clear');
        if (!mRail) continue;
        var cx = ex + best.ed.nx * RD / 2, cz = ez + best.ed.nz * RD / 2, yb0 = UX.y0 + RB, tx = best.ed.h ? 1 : 0, tz = best.ed.h ? 0 : 1, s9, bar;
        for (s9 = -1; s9 <= 1; s9 += 2) {
          var post = new T3.Mesh(new T3.BoxGeometry(0.028, RH, 0.028), mRail);
          post.position.set(cx + tx * s9 * (RW / 2 - 0.02), yb0 + RH / 2, cz + tz * s9 * (RW / 2 - 0.02));
          post.name = 'heat-rail-post'; post.userData.viz = 'heat'; g3.add(post);
        }
        for (bar = 0; bar < 11; bar++) {
          var bm = new T3.Mesh(new T3.BoxGeometry(tx ? RW - 0.04 : 0.018, 0.018, tz ? RW - 0.04 : 0.018), mRail);
          bm.position.set(cx, yb0 + 0.05 + bar * ((RH - 0.10) / 10), cz);
          bm.name = 'heat-rail-bar'; bm.userData.viz = 'heat'; g3.add(bm);
        }
      }
    }
    if (!n) { ctx.log('HYD  rails none -- no bathroom on either storey'); return; }
    _add(LID, TWR.code, n);
    _add(LID, TWR.cable, m2(feed * HEAT.extra));
    _add(LID, HEAT.screw, n * TWR.screws);
    ctx.log('HYD  rails (mep-v65): ' + n + ' x ' + TWR.code + ' ' + TWR.what + ', their feeds ' + m2(feed * HEAT.extra) + ' m ' + TWR.cable + ' (half each room\'s perimeter off the bathroom circuit, +15 %), ' +
            (n * TWR.screws) + ' x ' + HEAT.screw + ' -- ' + out.join('; '));
  }

  var MepLib = {
    VERSION: VERSION,
    NEED: NEED.slice(),
    ELEC: ELEC,
    /* the surface variant's table (mep-v10): env.elecVariant 'surface' */
    ELEC_SURF: ELEC_SURF,
    /* THE ELECTRICS for one product layer: board, socket circuits, lights and
       switches, billed into env.layerId. Returns what the body returns. */
    HEAT: HEAT,
    /* what each trade left for the next on the last build (read-only, debug) */
    _last: LAST,
    HEAT_NEED: HEAT_NEED.slice(),
    /* THE HEATING for one product layer (mep-v2): a multi-split by
       calculation, billed into env.layerId; env.elecId names the product's
       electrics layer, whose board the feed starts from. */
    heat: function (env, ctx) {
      var miss = _heatMissing(env);
      if (miss.length) {
        try { ctx.log('MEP  heat SKIPPED -- the product did not hand over: ' + miss.join(', ') + ' -- nothing billed for the heating'); } catch (eL) {}
        if (env && typeof env._billReset === 'function' && env.layerId) env._billReset(env.layerId);
        return;
      }
      if (!_bathGate(env, ctx, 'HEAT', 'heating')) return;
      return _buildHeat(env, ctx);
    },
    /* VENTILATION (mep-v26): bathroom fans, the hood's and the dryer's ducts,
       whole-house exhaust -- called after heat() with the same env, billed
       into env.layerId without a reset */
    VENT: VENT,
    vent: function (env, ctx) {
      var miss = [], q;
      if (!env || !env.layerId) miss.push('layerId');
      for (q = 0; q < VENT_NEED.length; q++) if (!env || env[VENT_NEED[q]] == null) miss.push(VENT_NEED[q]);
      if (miss.length) { try { ctx.log('MEP  vent SKIPPED -- the product did not hand over: ' + miss.join(', ')); } catch (eL) {} return; }
      try { return _buildVent(env, ctx); } catch (eV) { try { ctx.log('VENT THREW ' + ((eV && eV.message) || eV)); } catch (eL2) {} }
    },
    WATER: WATER,
    WATER_NEED: WATER_NEED.slice(),
    /* COLD AND HOT WATER for one product layer (mep-v6): wet points from the
       fitout, an electric storage heater, runs by calculation, billed into
       env.layerId; env.elecId names the electrics layer for the heater's feed. */
    water: function (env, ctx) {
      var miss = _waterMissing(env);
      if (miss.length) {
        try { ctx.log('MEP  water SKIPPED -- the product did not hand over: ' + miss.join(', ') + ' -- nothing billed for the water'); } catch (eL) {}
        if (env && typeof env._billReset === 'function' && env.layerId) env._billReset(env.layerId);
        return;
      }
      if (!_bathGate(env, ctx, 'WATER', 'water')) return;
      return _buildWater(env, ctx);
    },
    UFH: UFH,
    UFH_NEED: UFH_NEED.slice(),
    /* THE WHOLE HYDRONIC HEATING (mep-v16): the underfloor loops, then the
       heat pump, the plant and the fan coils on env.galleries */
    hydro: function (env, ctx) {
      var miss = _ufhMissing(env);
      if (miss.length) {
        try { ctx.log('MEP  hydro SKIPPED -- the product did not hand over: ' + miss.join(', ') + ' -- nothing billed for the heating'); } catch (eL) {}
        if (env && typeof env._billReset === 'function' && env.layerId) env._billReset(env.layerId);
        return;
      }
      LAST[env.layerId] = null;   /* mep-v17: the tank for the water, set by the plant */
      var U = _buildUfh(env, ctx), UU = null;
      /* mep-v65 (opt-in env.ufhUp): STOREY 2's LOOPS on the same plant --
         the product hands an env of storey 2 (its API / STATE / plan, its
         floor env.ufhY0, the pipes' level env.ufhY, env.ufhDry); billed into
         the same layer, its log lines "UFH  up" */
      if (U && typeof env.ufhUp === 'function') {
        var EU = null;
        try { EU = env.ufhUp(); } catch (eEU) { EU = null; ctx.log('UFH  up THREW ' + ((eEU && eEU.message) || eEU)); }
        if (EU) {
          EU.layerId = env.layerId; EU.ufhKeep = true; EU.ufhWhere = EU.ufhWhere || 'storey 2';
          var ctxU = Object.create(ctx);
          ctxU.log = function (t) { ctx.log(String(t).replace(/^UFH  /, 'UFH  up ')); };
          var missU = _ufhMissing(EU);
          if (missU.length) ctx.log('UFH  up SKIPPED -- the product did not hand over: ' + missU.join(', '));
          else UU = _buildUfh(EU, ctxU);
        }
      }
      if (U) { U.up = UU; _buildPlant(env, ctx, U); }
      /* mep-v65 (opt-in env.hydroRails): an electric towel rail in every bathroom of both storeys */
      if (U && env.hydroRails) { try { _hydroRails(env, ctx, U); } catch (eHR) { ctx.log('HYD  rails THREW ' + ((eHR && eHR.message) || eHR)); } }
      return U;
    },
    HYD: HYD,
    /* UNDERFLOOR HEATING for one product layer (mep-v15): loops on the
       ground floor, the manifold and the controls, billed into env.layerId;
       env.ufhY (optional) is the loops' height in the screed */
    ufh: function (env, ctx) {
      var miss = _ufhMissing(env);
      if (miss.length) {
        try { ctx.log('MEP  ufh SKIPPED -- the product did not hand over: ' + miss.join(', ') + ' -- nothing billed for the underfloor heating'); } catch (eL) {}
        if (env && typeof env._billReset === 'function' && env.layerId) env._billReset(env.layerId);
        return;
      }
      return _buildUfh(env, ctx);
    },
    WASTE: WASTE,
    WASTE_NEED: WASTE_NEED.slice(),
    /* THE WASTE for one product layer (mep-v7): traps and branches from the
       fitout, a building drain, a vent stack, air admittance valves, by
       calculation, billed into env.layerId; env._roofPlaneYAt (optional)
       gives the roof's height over the stack. */
    waste: function (env, ctx) {
      var miss = _wasteMissing(env);
      if (miss.length) {
        try { ctx.log('MEP  waste SKIPPED -- the product did not hand over: ' + miss.join(', ') + ' -- nothing billed for the waste'); } catch (eL) {}
        if (env && typeof env._billReset === 'function' && env.layerId) env._billReset(env.layerId);
        return;
      }
      if (!_bathGate(env, ctx, 'WASTE', 'waste')) return;
      return _buildWaste(env, ctx);
    },
    elec: function (env, ctx) {
      var miss = _missing(env);
      if (miss.length) {
        try { ctx.log('MEP  elec SKIPPED -- the product did not hand over: ' + miss.join(', ') + ' -- nothing billed for the electrics'); } catch (eL) {}
        if (env && typeof env._billReset === 'function' && env.layerId) env._billReset(env.layerId);
        return;
      }
      return _buildElec(env, ctx);
    }
  };
  global.MepLib = MepLib;

  /* A LIB THAT BUILT BEFORE THIS FILE ARRIVED is waiting for it: run what it
     queued (a rebuild) once, then take the queue away. */
  var wait = global.__mepWait;
  global.__mepWait = null;
  if (wait && wait.length) {
    var w;
    for (w = 0; w < wait.length; w++) { try { wait[w](MepLib); } catch (eW) {} }
  }

  try {
    if (global.Configurator && global.Configurator.log) global.Configurator.log.log('[mep] loaded ' + VERSION);
  } catch (e) {}
})(window);
